// Define multipliers for Mietvariante B
var plzListB = {
  1000: 1.1,
  1004: 1.1,
  1006: 1.1,
  1010: 1.1,
  1011: 1.1,
  1015: 1.1,
  1016: 1.1,
  1020: 1.1,
  1021: 1.1,
  1024: 1.1,
  1025: 1.1,
  1029: 1.1,
  1030: 1.1,
  1031: 1.1,
  1032: 1.1,
  1035: 1.1,
  1037: 1.1,
  1038: 1.1,
  1040: 1.1,
  1041: 1.1,
  1042: 1.1,
  1043: 1.1,
  1045: 1.1,
  1050: 1.1,
  1051: 1.1,
  1052: 1.1,
  1053: 1.1,
  1060: 1.1,
  1061: 1.1,
  1063: 1.1,
  1065: 1.1,
  1070: 1.1,
  1071: 1.1,
  1072: 1.1,
  1080: 1.1,
  1081: 1.1,
  1082: 1.1,
  1090: 1.1,
  1091: 1.1,
  1092: 1.1,
  1095: 1.1,
  1097: 1.1,
  1100: 1.1,
  1101: 1.1,
  1103: 1.1,
  1104: 1.1,
  1105: 1.1,
  1106: 1.1,
  1107: 1.1,
  1108: 1.1,
  1109: 1.1,
  1110: 1.1,
  1111: 1.1,
  1114: 1.1,
  1115: 1.1,
  1120: 1.1,
  1121: 1.1,
  1122: 1.1,
  1124: 1.1,
  1125: 1.1,
  1127: 1.1,
  1128: 1.1,
  1130: 1.1,
  1131: 1.1,
  1132: 1.1,
  1134: 1.1,
  1136: 1.1,
  1140: 1.1,
  1141: 1.1,
  1142: 1.1,
  1143: 1.1,
  1147: 1.1,
  1148: 1.1,
  1150: 1.1,
  1151: 1.1,
  1152: 1.1,
  1153: 1.1,
  1155: 1.1,
  1156: 1.1,
  1160: 1.1,
  1161: 1.1,
  1163: 1.1,
  1165: 1.1,
  1166: 1.1,
  1170: 1.1,
  1171: 1.1,
  1172: 1.1,
  1180: 1.1,
  1181: 1.1,
  1182: 1.1,
  1183: 1.1,
  1190: 1.1,
  1191: 1.1,
  1192: 1.1,
  1193: 1.1,
  1195: 1.1,
  1196: 1.1,
  1200: 1.1,
  1201: 1.1,
  1203: 1.1,
  1205: 1.1,
  1206: 1.1,
  1208: 1.1,
  1210: 1.1,
  1211: 1.1,
  1213: 1.1,
  1215: 1.1,
  1217: 1.1,
  1218: 1.1,
  1219: 1.1,
  1220: 1.1,
  1221: 1.1,
  1222: 1.1,
  1223: 1.1,
  1224: 1.1,
  1225: 1.1,
  1228: 1.1,
  1229: 1.1,
  1230: 1.1,
  1231: 1.1,
  1233: 1.1,
  1235: 1.1,
  1236: 1.1,
  1238: 1.1,
  1239: 1.1,
  1254: 1.1,
  1300: 1.1,
  1310: 1.1,
  1400: 1.1,
  1423: 1.1,
  1500: 1.1,
  1502: 1.1,
  1503: 1.1,
  1504: 1.1,
  1600: 1.1,
  1610: 1.1,
  2000: 1.2,
  2002: 1.2,
  2003: 1.2,
  2004: 1.2,
  2011: 1.2,
  2013: 1.2,
  2014: 1.2,
  2020: 1.2,
  2022: 1.2,
  2023: 1.2,
  2024: 1.2,
  2031: 1.2,
  2032: 1.2,
  2033: 1.2,
  2034: 1.2,
  2041: 1.2,
  2042: 1.2,
  2051: 1.2,
  2052: 1.2,
  2053: 1.2,
  2054: 1.2,
  2061: 1.2,
  2062: 1.2,
  2063: 1.2,
  2064: 1.2,
  2070: 1.2,
  2073: 1.2,
  2074: 1.2,
  2081: 1.2,
  2082: 1.2,
  2083: 1.2,
  2084: 1.2,
  2091: 1.2,
  2092: 1.2,
  2093: 1.2,
  2094: 1.2,
  2095: 1.2,
  2100: 1.2,
  2102: 1.2,
  2103: 1.2,
  2104: 1.2,
  2105: 1.2,
  2106: 1.2,
  2111: 1.2,
  2112: 1.2,
  2113: 1.2,
  2114: 1.2,
  2115: 1.2,
  2116: 1.2,
  2120: 1.2,
  2122: 1.2,
  2123: 1.2,
  2124: 1.2,
  2125: 1.2,
  2126: 1.2,
  2127: 1.2,
  2130: 1.2,
  2132: 1.2,
  2133: 1.2,
  2134: 1.2,
  2135: 1.2,
  2136: 1.2,
  2141: 1.2,
  2143: 1.2,
  2144: 1.2,
  2145: 1.2,
  2151: 1.2,
  2152: 1.2,
  2153: 1.2,
  2154: 1.2,
  2161: 1.2,
  2162: 1.2,
  2163: 1.2,
  2164: 1.2,
  2165: 1.2,
  2170: 1.2,
  2171: 1.2,
  2172: 1.2,
  2181: 1.2,
  2182: 1.2,
  2183: 1.2,
  2184: 1.2,
  2185: 1.2,
  2191: 1.2,
  2192: 1.2,
  2193: 1.2,
  2201: 1.2,
  2202: 1.2,
  2203: 1.2,
  2211: 1.2,
  2212: 1.2,
  2213: 1.2,
  2214: 1.2,
  2215: 1.2,
  2221: 1.2,
  2222: 1.2,
  2223: 1.2,
  2224: 1.2,
  2225: 1.2,
  2230: 1.2,
  2231: 1.2,
  2232: 1.2,
  2241: 1.2,
  2242: 1.2,
  2243: 1.2,
  2244: 1.2,
  2245: 1.2,
  2251: 1.2,
  2252: 1.2,
  2253: 1.2,
  2261: 1.2,
  2262: 1.2,
  2263: 1.2,
  2264: 1.2,
  2265: 1.2,
  2272: 1.2,
  2273: 1.2,
  2274: 1.2,
  2275: 1.2,
  2276: 1.2,
  2280: 1.2,
  2281: 1.2,
  2282: 1.2,
  2283: 1.2,
  2284: 1.2,
  2285: 1.2,
  2286: 1.2,
  2291: 1.2,
  2292: 1.2,
  2293: 1.2,
  2294: 1.2,
  2295: 1.2,
  2301: 1.2,
  2304: 1.2,
  2305: 1.2,
  2320: 1.2,
  2322: 1.2,
  2325: 1.2,
  2326: 1.2,
  2327: 1.2,
  2331: 1.2,
  2332: 1.2,
  2333: 1.2,
  2334: 1.2,
  2340: 1.2,
  2344: 1.2,
  2345: 1.2,
  2346: 1.2,
  2349: 1.2,
  2351: 1.2,
  2352: 1.2,
  2353: 1.2,
  2355: 1.2,
  2356: 1.2,
  2361: 1.2,
  2362: 1.2,
  2371: 1.2,
  2372: 1.2,
  2380: 1.2,
  2381: 1.2,
  2384: 1.2,
  2391: 1.2,
  2392: 1.2,
  2393: 1.2,
  2401: 1.2,
  2402: 1.2,
  2403: 1.2,
  2404: 1.2,
  2405: 1.2,
  2410: 1.2,
  2412: 1.2,
  2413: 1.2,
  2421: 1.2,
  2422: 1.2,
  2423: 1.2,
  2424: 1.2,
  2425: 1.2,
  2431: 1.2,
  2432: 1.2,
  2433: 1.2,
  2434: 1.2,
  2435: 1.2,
  2440: 1.2,
  2441: 1.2,
  2442: 1.2,
  2443: 1.2,
  2444: 1.2,
  2445: 1.2,
  2451: 1.2,
  2452: 1.2,
  2453: 1.2,
  2454: 1.2,
  2460: 1.2,
  2462: 1.2,
  2463: 1.2,
  2464: 1.2,
  2465: 1.2,
  2471: 1.2,
  2472: 1.2,
  2473: 1.2,
  2474: 1.2,
  2475: 1.2,
  2481: 1.2,
  2482: 1.2,
  2483: 1.2,
  2484: 1.2,
  2485: 1.2,
  2491: 1.2,
  2492: 1.2,
  2493: 1.2,
  2500: 1.2,
  2504: 1.2,
  2505: 1.2,
  2511: 1.2,
  2512: 1.2,
  2513: 1.2,
  2514: 1.2,
  2521: 1.2,
  2522: 1.2,
  2523: 1.2,
  2524: 1.2,
  2525: 1.2,
  2531: 1.2,
  2532: 1.2,
  2533: 1.2,
  2534: 1.2,
  2540: 1.2,
  2542: 1.2,
  2544: 1.2,
  2551: 1.2,
  2552: 1.2,
  2560: 1.2,
  2561: 1.2,
  2563: 1.2,
  2564: 1.2,
  2565: 1.2,
  2571: 1.2,
  2572: 1.2,
  2601: 1.2,
  2602: 1.2,
  2603: 1.2,
  2604: 1.2,
  2620: 1.2,
  2624: 1.2,
  2625: 1.2,
  2630: 1.2,
  2631: 1.2,
  2632: 1.2,
  2640: 1.2,
  2641: 1.2,
  2642: 1.2,
  2650: 1.2,
  2651: 1.2,
  2654: 1.2,
  2661: 1.2,
  2662: 1.2,
  2663: 1.2,
  2671: 1.2,
  2673: 1.2,
  2680: 1.2,
  2700: 1.2,
  2703: 1.2,
  2705: 1.2,
  2706: 1.2,
  2707: 1.2,
  2721: 1.2,
  2722: 1.2,
  2723: 1.2,
  2724: 1.2,
  2731: 1.2,
  2732: 1.2,
  2733: 1.2,
  2734: 1.2,
  2751: 1.2,
  2752: 1.2,
  2753: 1.2,
  2754: 1.2,
  2755: 1.2,
  2761: 1.2,
  2763: 1.2,
  2770: 1.2,
  2801: 1.2,
  2802: 1.2,
  2803: 1.2,
  2811: 1.2,
  2812: 1.2,
  2813: 1.2,
  2820: 1.2,
  2821: 1.2,
  2822: 1.2,
  2823: 1.2,
  2824: 1.2,
  2831: 1.2,
  2832: 1.2,
  2833: 1.2,
  2840: 1.2,
  2842: 1.2,
  2851: 1.2,
  2852: 1.2,
  2853: 1.2,
  2860: 1.2,
  2870: 1.2,
  2871: 1.2,
  2872: 1.2,
  2873: 1.2,
  2880: 1.2,
  2881: 1.2,
  3001: 1.2,
  3002: 1.2,
  3003: 1.2,
  3004: 1.2,
  3011: 1.2,
  3012: 1.2,
  3013: 1.2,
  3021: 1.2,
  3031: 1.2,
  3032: 1.2,
  3033: 1.2,
  3034: 1.2,
  3040: 1.2,
  3041: 1.2,
  3042: 1.2,
  3051: 1.2,
  3052: 1.2,
  3053: 1.2,
  3061: 1.2,
  3062: 1.2,
  3071: 1.2,
  3072: 1.2,
  3073: 1.2,
  3074: 1.2,
  3100: 1.2,
  3101: 1.2,
  3104: 1.2,
  3105: 1.2,
  3106: 1.2,
  3107: 1.2,
  3108: 1.2,
  3109: 1.2,
  3110: 1.2,
  3121: 1.2,
  3122: 1.2,
  3123: 1.2,
  3124: 1.2,
  3125: 1.2,
  3130: 1.2,
  3131: 1.2,
  3133: 1.2,
  3134: 1.2,
  3140: 1.2,
  3141: 1.2,
  3142: 1.2,
  3143: 1.2,
  3144: 1.2,
  3150: 1.2,
  3151: 1.2,
  3153: 1.2,
  3160: 1.2,
  3161: 1.2,
  3162: 1.2,
  3163: 1.2,
  3170: 1.2,
  3171: 1.2,
  3172: 1.2,
  3180: 1.2,
  3182: 1.2,
  3183: 1.2,
  3184: 1.2,
  3192: 1.2,
  3193: 1.2,
  3195: 1.2,
  3200: 1.2,
  3202: 1.2,
  3203: 1.2,
  3204: 1.2,
  3205: 1.2,
  3211: 1.2,
  3212: 1.2,
  3213: 1.2,
  3214: 1.2,
  3221: 1.2,
  3222: 1.2,
  3223: 1.2,
  3224: 1.2,
  3231: 1.2,
  3232: 1.2,
  3233: 1.2,
  3240: 1.2,
  3241: 1.2,
  3242: 1.2,
  3243: 1.2,
  3244: 1.2,
  3250: 1.2,
  3251: 1.2,
  3252: 1.2,
  3253: 1.2,
  3254: 1.2,
  3261: 1.2,
  3262: 1.2,
  3263: 1.2,
  3264: 1.2,
  3270: 1.2,
  3281: 1.2,
  3282: 1.2,
  3283: 1.2,
  3291: 1.2,
  3292: 1.2,
  3293: 1.2,
  3294: 1.2,
  3295: 1.2,
  3300: 1.2,
  3304: 1.2,
  3311: 1.2,
  3312: 1.2,
  3313: 1.2,
  3314: 1.2,
  3321: 1.2,
  3322: 1.2,
  3323: 1.2,
  3324: 1.2,
  3325: 1.2,
  3331: 1.2,
  3332: 1.2,
  3333: 1.2,
  3334: 1.2,
  3335: 1.2,
  3340: 1.2,
  3341: 1.2,
  3342: 1.2,
  3343: 1.2,
  3344: 1.2,
  3345: 1.2,
  3350: 1.2,
  3351: 1.2,
  3352: 1.2,
  3353: 1.2,
  3354: 1.2,
  3355: 1.2,
  3356: 1.2,
  3361: 1.2,
  3362: 1.2,
  3363: 1.2,
  3364: 1.2,
  3365: 1.2,
  3366: 1.2,
  3370: 1.2,
  3371: 1.2,
  3372: 1.2,
  3373: 1.2,
  3374: 1.2,
  3375: 1.2,
  3376: 1.2,
  3380: 1.2,
  3381: 1.2,
  3382: 1.2,
  3383: 1.2,
  3384: 1.2,
  3385: 1.2,
  3386: 1.2,
  3387: 1.2,
  3388: 1.2,
  3390: 1.2,
  3392: 1.2,
  3393: 1.2,
  3394: 1.2,
  3400: 1.2,
  3402: 1.2,
  3404: 1.2,
  3413: 1.2,
  3420: 1.2,
  3421: 1.2,
  3422: 1.2,
  3423: 1.2,
  3424: 1.2,
  3425: 1.2,
  3426: 1.2,
  3430: 1.2,
  3433: 1.2,
  3434: 1.2,
  3435: 1.2,
  3441: 1.2,
  3442: 1.2,
  3443: 1.2,
  3451: 1.2,
  3452: 1.2,
  3454: 1.2,
  3462: 1.2,
  3463: 1.2,
  3464: 1.2,
  3465: 1.2,
  3470: 1.2,
  3471: 1.2,
  3472: 1.2,
  3473: 1.2,
  3474: 1.2,
  3481: 1.2,
  3482: 1.2,
  3483: 1.2,
  3484: 1.2,
  3485: 1.2,
  3491: 1.2,
  3492: 1.2,
  3493: 1.2,
  3494: 1.2,
  3495: 1.2,
  3500: 1.2,
  3502: 1.2,
  3504: 1.2,
  3505: 1.2,
  3506: 1.2,
  3508: 1.2,
  3511: 1.2,
  3512: 1.2,
  3521: 1.2,
  3522: 1.2,
  3524: 1.2,
  3525: 1.2,
  3531: 1.2,
  3532: 1.2,
  3533: 1.2,
  3541: 1.2,
  3542: 1.2,
  3543: 1.2,
  3544: 1.2,
  3550: 1.2,
  3552: 1.2,
  3553: 1.2,
  3561: 1.2,
  3562: 1.2,
  3564: 1.2,
  3571: 1.2,
  3572: 1.2,
  3573: 1.2,
  3580: 1.2,
  3591: 1.2,
  3592: 1.2,
  3593: 1.2,
  3594: 1.2,
  3595: 1.2,
  3601: 1.2,
  3602: 1.2,
  3610: 1.2,
  3611: 1.2,
  3613: 1.2,
  3620: 1.2,
  3621: 1.2,
  3622: 1.2,
  3623: 1.2,
  3631: 1.2,
  3632: 1.2,
  3633: 1.2,
  3641: 1.2,
  3642: 1.2,
  3643: 1.2,
  3644: 1.2,
  3650: 1.2,
  3652: 1.2,
  3653: 1.2,
  3654: 1.2,
  3660: 1.2,
  3661: 1.2,
  3662: 1.2,
  3663: 1.2,
  3664: 1.2,
  3665: 1.2,
  3671: 1.2,
  3672: 1.2,
  3680: 1.2,
  3681: 1.2,
  3683: 1.2,
  3684: 1.2,
  3691: 1.2,
  3701: 1.2,
  3702: 1.2,
  3704: 1.2,
  3710: 1.2,
  3711: 1.2,
  3712: 1.2,
  3713: 1.2,
  3714: 1.2,
  3720: 1.2,
  3721: 1.2,
  3722: 1.2,
  3730: 1.2,
  3741: 1.2,
  3742: 1.2,
  3743: 1.2,
  3744: 1.2,
  3751: 1.2,
  3752: 1.2,
  3753: 1.2,
  3754: 1.2,
  3761: 1.2,
  3762: 1.2,
  3763: 1.2,
  3800: 1.2,
  3804: 1.2,
  3811: 1.2,
  3812: 1.2,
  3813: 1.2,
  3814: 1.2,
  3820: 1.2,
  3822: 1.2,
  3823: 1.2,
  3824: 1.2,
  3830: 1.2,
  3834: 1.2,
  3841: 1.2,
  3842: 1.2,
  3843: 1.2,
  3844: 1.2,
  3851: 1.2,
  3852: 1.2,
  3860: 1.2,
  3861: 1.2,
  3862: 1.2,
  3863: 1.2,
  3871: 1.2,
  3872: 1.2,
  3873: 1.2,
  3874: 1.2,
  3900: 1.2,
  3902: 1.2,
  3903: 1.2,
  3910: 1.2,
  3911: 1.2,
  3912: 1.2,
  3913: 1.2,
  3914: 1.2,
  3920: 1.2,
  3921: 1.2,
  3922: 1.2,
  3923: 1.2,
  3924: 1.2,
  3925: 1.2,
  3931: 1.2,
  3932: 1.2,
  3942: 1.2,
  3943: 1.2,
  3944: 1.2,
  3945: 1.2,
  3950: 1.2,
  3961: 1.2,
  3962: 1.2,
  3970: 1.2,
  3971: 1.2,
  3972: 1.2,
  3973: 1.2,
  4000: 1.1,
  4010: 1.1,
  4016: 1.1,
  4018: 1.1,
  4020: 1.1,
  4021: 1.1,
  4024: 1.1,
  4025: 1.1,
  4030: 1.1,
  4031: 1.1,
  4032: 1.1,
  4033: 1.1,
  4036: 1.1,
  4040: 1.1,
  4041: 1.1,
  4046: 1.1,
  4048: 1.1,
  4050: 1.1,
  4052: 1.1,
  4053: 1.1,
  4055: 1.1,
  4056: 1.1,
  4059: 1.1,
  4060: 1.1,
  4061: 1.1,
  4062: 1.1,
  4063: 1.1,
  4064: 1.1,
  4066: 1.1,
  4070: 1.1,
  4072: 1.1,
  4073: 1.1,
  4074: 1.1,
  4075: 1.1,
  4076: 1.1,
  4077: 1.1,
  4081: 1.1,
  4082: 1.1,
  4083: 1.1,
  4084: 1.1,
  4085: 1.1,
  4090: 1.1,
  4091: 1.1,
  4092: 1.1,
  4100: 1.1,
  4101: 1.1,
  4102: 1.1,
  4111: 1.1,
  4112: 1.1,
  4113: 1.1,
  4114: 1.1,
  4115: 1.1,
  4116: 1.1,
  4120: 1.1,
  4121: 1.1,
  4122: 1.1,
  4131: 1.1,
  4132: 1.1,
  4133: 1.1,
  4134: 1.1,
  4141: 1.1,
  4142: 1.1,
  4143: 1.1,
  4144: 1.1,
  4150: 1.1,
  4151: 1.1,
  4152: 1.1,
  4153: 1.1,
  4154: 1.1,
  4155: 1.1,
  4160: 1.1,
  4161: 1.1,
  4162: 1.1,
  4163: 1.1,
  4164: 1.1,
  4170: 1.1,
  4171: 1.1,
  4172: 1.1,
  4173: 1.1,
  4174: 1.1,
  4175: 1.1,
  4180: 1.1,
  4181: 1.1,
  4182: 1.1,
  4183: 1.1,
  4184: 1.1,
  4190: 1.1,
  4191: 1.1,
  4192: 1.1,
  4193: 1.1,
  4201: 1.1,
  4202: 1.1,
  4203: 1.1,
  4204: 1.1,
  4205: 1.1,
  4209: 1.1,
  4210: 1.1,
  4211: 1.1,
  4212: 1.1,
  4213: 1.1,
  4221: 1.1,
  4222: 1.1,
  4223: 1.1,
  4224: 1.1,
  4225: 1.1,
  4230: 1.1,
  4231: 1.1,
  4232: 1.1,
  4240: 1.1,
  4242: 1.1,
  4251: 1.1,
  4252: 1.1,
  4261: 1.1,
  4262: 1.1,
  4263: 1.1,
  4264: 1.1,
  4271: 1.1,
  4272: 1.1,
  4273: 1.1,
  4274: 1.1,
  4280: 1.1,
  4281: 1.1,
  4282: 1.1,
  4283: 1.1,
  4284: 1.1,
  4291: 1.1,
  4292: 1.1,
  4293: 1.1,
  4294: 1.1,
  4300: 1.1,
  4303: 1.1,
  4310: 1.1,
  4311: 1.1,
  4312: 1.1,
  4320: 1.1,
  4322: 1.1,
  4323: 1.1,
  4324: 1.1,
  4331: 1.1,
  4332: 1.1,
  4341: 1.1,
  4342: 1.1,
  4343: 1.1,
  4351: 1.1,
  4352: 1.1,
  4360: 1.1,
  4362: 1.1,
  4363: 1.1,
  4364: 1.1,
  4371: 1.1,
  4372: 1.1,
  4381: 1.1,
  4382: 1.1,
  4391: 1.1,
  4392: 1.1,
  4400: 1.1,
  4401: 1.1,
  4403: 1.1,
  4405: 1.1,
  4407: 1.1,
  4410: 1.1,
  4421: 1.1,
  4431: 1.1,
  4432: 1.1,
  4441: 1.1,
  4442: 1.1,
  4443: 1.1,
  4451: 1.1,
  4452: 1.1,
  4453: 1.1,
  4460: 1.1,
  4461: 1.1,
  4462: 1.1,
  4463: 1.1,
  4464: 1.1,
  4470: 1.1,
  4481: 1.1,
  4482: 1.1,
  4483: 1.1,
  4484: 1.1,
  4490: 1.1,
  4491: 1.1,
  4492: 1.1,
  4493: 1.1,
  4501: 1.1,
  4502: 1.1,
  4511: 1.1,
  4521: 1.1,
  4522: 1.1,
  4523: 1.1,
  4531: 1.1,
  4532: 1.1,
  4533: 1.1,
  4540: 1.1,
  4541: 1.1,
  4542: 1.1,
  4550: 1.1,
  4551: 1.1,
  4552: 1.1,
  4553: 1.1,
  4554: 1.1,
  4560: 1.1,
  4562: 1.1,
  4563: 1.1,
  4564: 1.1,
  4565: 1.1,
  4571: 1.1,
  4572: 1.1,
  4573: 1.1,
  4574: 1.1,
  4575: 1.1,
  4580: 1.1,
  4581: 1.1,
  4582: 1.1,
  4591: 1.1,
  4592: 1.1,
  4593: 1.1,
  4594: 1.1,
  4595: 1.1,
  4596: 1.1,
  4600: 1.1,
  4601: 1.1,
  4602: 1.1,
  4603: 1.1,
  4605: 1.1,
  4606: 1.1,
  4609: 1.1,
  4610: 1.1,
  4611: 1.1,
  4612: 1.1,
  4613: 1.1,
  4614: 1.1,
  4615: 1.1,
  4616: 1.1,
  4618: 1.1,
  4619: 1.1,
  4621: 1.1,
  4622: 1.1,
  4623: 1.1,
  4624: 1.1,
  4625: 1.1,
  4631: 1.1,
  4632: 1.1,
  4633: 1.1,
  4641: 1.1,
  4642: 1.1,
  4643: 1.1,
  4644: 1.1,
  4645: 1.1,
  4650: 1.1,
  4651: 1.1,
  4652: 1.1,
  4653: 1.1,
  4654: 1.1,
  4655: 1.1,
  4656: 1.1,
  4659: 1.1,
  4661: 1.1,
  4662: 1.1,
  4663: 1.1,
  4664: 1.1,
  4671: 1.1,
  4672: 1.1,
  4673: 1.1,
  4674: 1.1,
  4675: 1.1,
  4676: 1.1,
  4680: 1.1,
  4681: 1.1,
  4682: 1.1,
  4690: 1.1,
  4691: 1.1,
  4692: 1.1,
  4693: 1.1,
  4694: 1.1,
  4701: 1.1,
  4702: 1.1,
  4707: 1.1,
  4710: 1.1,
  4712: 1.1,
  4713: 1.1,
  4714: 1.1,
  4715: 1.1,
  4716: 1.1,
  4720: 1.1,
  4721: 1.1,
  4722: 1.1,
  4723: 1.1,
  4724: 1.1,
  4725: 1.1,
  4730: 1.1,
  4731: 1.1,
  4732: 1.1,
  4733: 1.1,
  4741: 1.1,
  4742: 1.1,
  4743: 1.1,
  4751: 1.1,
  4752: 1.1,
  4753: 1.1,
  4754: 1.1,
  4755: 1.1,
  4760: 1.1,
  4761: 1.1,
  4762: 1.1,
  4770: 1.1,
  4771: 1.1,
  4772: 1.1,
  4773: 1.1,
  4774: 1.1,
  4775: 1.1,
  4776: 1.1,
  4777: 1.1,
  4780: 1.1,
  4782: 1.1,
  4783: 1.1,
  4784: 1.1,
  4785: 1.1,
  4786: 1.1,
  4791: 1.1,
  4792: 1.1,
  4793: 1.1,
  4794: 1.1,
  4800: 1.1,
  4801: 1.1,
  4802: 1.1,
  4810: 1.1,
  4812: 1.1,
  4813: 1.1,
  4814: 1.1,
  4816: 1.1,
  4817: 1.1,
  4820: 1.1,
  4821: 1.1,
  4822: 1.1,
  4823: 1.1,
  4824: 1.1,
  4825: 1.1,
  4829: 1.1,
  4830: 1.1,
  4831: 1.1,
  4840: 1.1,
  4841: 1.1,
  4842: 1.1,
  4843: 1.1,
  4844: 1.1,
  4845: 1.1,
  4846: 1.1,
  4847: 1.1,
  4849: 1.1,
  4850: 1.1,
  4851: 1.1,
  4852: 1.1,
  4853: 1.1,
  4854: 1.1,
  4860: 1.1,
  4861: 1.1,
  4863: 1.1,
  4864: 1.1,
  4865: 1.1,
  4866: 1.1,
  4870: 1.1,
  4871: 1.1,
  4872: 1.1,
  4873: 1.1,
  4874: 1.1,
  4875: 1.1,
  4880: 1.1,
  4881: 1.1,
  4882: 1.1,
  4890: 1.1,
  4891: 1.1,
  4892: 1.1,
  4893: 1.1,
  4894: 1.1,
  4901: 1.1,
  4902: 1.1,
  4903: 1.1,
  4904: 1.1,
  4905: 1.1,
  4906: 1.1,
  4910: 1.1,
  4911: 1.1,
  4912: 1.1,
  4920: 1.1,
  4921: 1.1,
  4922: 1.1,
  4923: 1.1,
  4924: 1.1,
  4925: 1.1,
  4926: 1.1,
  4931: 1.1,
  4932: 1.1,
  4933: 1.1,
  4941: 1.1,
  4942: 1.1,
  4943: 1.1,
  4950: 1.1,
  4951: 1.1,
  4952: 1.1,
  4961: 1.1,
  4962: 1.1,
  4963: 1.1,
  4970: 1.1,
  4971: 1.1,
  4972: 1.1,
  4973: 1.1,
  4974: 1.1,
  4975: 1.1,
  4980: 1.1,
  4981: 1.1,
  4982: 1.1,
  4983: 1.1,
  4984: 1.1,
  4985: 1.1,
  5000: 1.3,
  5010: 1.3,
  5013: 1.3,
  5014: 1.3,
  5015: 1.3,
  5016: 1.3,
  5017: 1.3,
  5018: 1.3,
  5020: 1.3,
  5021: 1.3,
  5023: 1.3,
  5025: 1.3,
  5026: 1.3,
  5027: 1.3,
  5033: 1.3,
  5061: 1.3,
  5071: 1.3,
  5072: 1.3,
  5081: 1.3,
  5082: 1.3,
  5083: 1.3,
  5084: 1.3,
  5089: 1.3,
  5090: 1.3,
  5091: 1.3,
  5092: 1.3,
  5093: 1.3,
  5101: 1.3,
  5102: 1.3,
  5110: 1.3,
  5111: 1.3,
  5112: 1.3,
  5113: 1.3,
  5114: 1.3,
  5120: 1.3,
  5121: 1.3,
  5122: 1.3,
  5123: 1.3,
  5124: 1.3,
  5131: 1.3,
  5132: 1.3,
  5133: 1.3,
  5134: 1.3,
  5141: 1.3,
  5142: 1.3,
  5143: 1.3,
  5144: 1.3,
  5145: 1.3,
  5151: 1.3,
  5152: 1.3,
  5161: 1.3,
  5162: 1.3,
  5163: 1.3,
  5164: 1.3,
  5165: 1.3,
  5166: 1.3,
  5201: 1.3,
  5202: 1.3,
  5203: 1.3,
  5204: 1.3,
  5205: 1.3,
  5211: 1.3,
  5212: 1.3,
  5221: 1.3,
  5222: 1.3,
  5223: 1.3,
  5224: 1.3,
  5225: 1.3,
  5230: 1.3,
  5231: 1.3,
  5232: 1.3,
  5233: 1.3,
  5241: 1.3,
  5242: 1.3,
  5251: 1.3,
  5252: 1.3,
  5261: 1.3,
  5270: 1.3,
  5271: 1.3,
  5272: 1.3,
  5273: 1.3,
  5274: 1.3,
  5280: 1.3,
  5282: 1.3,
  5283: 1.3,
  5300: 1.3,
  5301: 1.3,
  5302: 1.3,
  5303: 1.3,
  5310: 1.3,
  5311: 1.3,
  5321: 1.3,
  5322: 1.3,
  5323: 1.3,
  5324: 1.3,
  5325: 1.3,
  5330: 1.3,
  5340: 1.3,
  5342: 1.3,
  5350: 1.3,
  5351: 1.3,
  5360: 1.3,
  5400: 1.3,
  5411: 1.3,
  5412: 1.3,
  5421: 1.3,
  5422: 1.3,
  5423: 1.3,
  5424: 1.3,
  5425: 1.3,
  5431: 1.3,
  5440: 1.3,
  5441: 1.3,
  5442: 1.3,
  5450: 1.3,
  5451: 1.3,
  5452: 1.3,
  5453: 1.3,
  5500: 1.3,
  5505: 1.3,
  5511: 1.3,
  5521: 1.3,
  5522: 1.3,
  5523: 1.3,
  5524: 1.3,
  5531: 1.3,
  5532: 1.3,
  5541: 1.3,
  5542: 1.3,
  5550: 1.3,
  5552: 1.3,
  5561: 1.3,
  5562: 1.3,
  5563: 1.3,
  5570: 1.3,
  5571: 1.3,
  5572: 1.3,
  5573: 1.3,
  5574: 1.3,
  5575: 1.3,
  5580: 1.3,
  5581: 1.3,
  5582: 1.3,
  5583: 1.3,
  5584: 1.3,
  5585: 1.3,
  5591: 1.3,
  5592: 1.3,
  5600: 1.3,
  5602: 1.3,
  5603: 1.3,
  5611: 1.3,
  5612: 1.3,
  5620: 1.3,
  5621: 1.3,
  5622: 1.3,
  5623: 1.3,
  5630: 1.3,
  5632: 1.3,
  5640: 1.3,
  5645: 1.3,
  5651: 1.3,
  5652: 1.3,
  5660: 1.3,
  5661: 1.3,
  5662: 1.3,
  5671: 1.3,
  5672: 1.3,
  5700: 1.3,
  5710: 1.3,
  5721: 1.3,
  5722: 1.3,
  5723: 1.3,
  5724: 1.3,
  5730: 1.3,
  5731: 1.3,
  5732: 1.3,
  5733: 1.3,
  5741: 1.3,
  5742: 1.3,
  5743: 1.3,
  5751: 1.3,
  5752: 1.3,
  5753: 1.3,
  5754: 1.3,
  5760: 1.3,
  5761: 1.3,
  5771: 1.3,
  6000: 1.5,
  6010: 1.5,
  6013: 1.5,
  6019: 1.5,
  6020: 1.5,
  6021: 1.5,
  6022: 1.5,
  6023: 1.5,
  6026: 1.5,
  6029: 1.5,
  6033: 1.5,
  6050: 1.5,
  6060: 1.5,
  6063: 1.5,
  6065: 1.5,
  6067: 1.5,
  6068: 1.5,
  6069: 1.5,
  6070: 1.5,
  6071: 1.5,
  6072: 1.5,
  6073: 1.5,
  6074: 1.5,
  6075: 1.5,
  6080: 1.5,
  6082: 1.5,
  6083: 1.5,
  6091: 1.5,
  6092: 1.5,
  6094: 1.5,
  6095: 1.5,
  6100: 1.5,
  6103: 1.5,
  6105: 1.5,
  6108: 1.5,
  6111: 1.5,
  6112: 1.5,
  6113: 1.5,
  6114: 1.5,
  6115: 1.5,
  6116: 1.5,
  6121: 1.5,
  6122: 1.5,
  6123: 1.5,
  6130: 1.5,
  6133: 1.5,
  6134: 1.5,
  6135: 1.5,
  6136: 1.5,
  6138: 1.5,
  6141: 1.5,
  6142: 1.5,
  6143: 1.5,
  6145: 1.5,
  6150: 1.5,
  6151: 1.5,
  6152: 1.5,
  6154: 1.5,
  6156: 1.5,
  6157: 1.5,
  6161: 1.5,
  6162: 1.5,
  6165: 1.5,
  6166: 1.5,
  6167: 1.5,
  6170: 1.5,
  6173: 1.5,
  6175: 1.5,
  6176: 1.5,
  6178: 1.5,
  6179: 1.5,
  6181: 1.5,
  6182: 1.5,
  6183: 1.5,
  6184: 1.5,
  6200: 1.5,
  6210: 1.5,
  6212: 1.5,
  6213: 1.5,
  6215: 1.5,
  6220: 1.5,
  6222: 1.5,
  6230: 1.5,
  6232: 1.5,
  6233: 1.5,
  6234: 1.5,
  6235: 1.5,
  6236: 1.5,
  6240: 1.5,
  6241: 1.5,
  6250: 1.5,
  6252: 1.5,
  6260: 1.5,
  6261: 1.5,
  6262: 1.5,
  6263: 1.5,
  6264: 1.5,
  6265: 1.5,
  6271: 1.5,
  6272: 1.5,
  6273: 1.5,
  6274: 1.5,
  6275: 1.5,
  6276: 1.5,
  6277: 1.5,
  6278: 1.5,
  6280: 1.5,
  6281: 1.5,
  6283: 1.5,
  6284: 1.5,
  6290: 1.5,
  6292: 1.5,
  6293: 1.5,
  6294: 1.5,
  6295: 1.5,
  6300: 1.5,
  6305: 1.5,
  6306: 1.5,
  6311: 1.5,
  6313: 1.5,
  6314: 1.5,
  6320: 1.5,
  6321: 1.5,
  6322: 1.5,
  6323: 1.5,
  6324: 1.5,
  6330: 1.5,
  6332: 1.5,
  6334: 1.5,
  6335: 1.5,
  6336: 1.5,
  6341: 1.5,
  6342: 1.5,
  6343: 1.5,
  6344: 1.5,
  6345: 1.5,
  6346: 1.5,
  6347: 1.5,
  6351: 1.5,
  6352: 1.5,
  6353: 1.5,
  6361: 1.5,
  6362: 1.5,
  6363: 1.5,
  6364: 1.5,
  6365: 1.5,
  6370: 1.5,
  6371: 1.5,
  6372: 1.5,
  6373: 1.5,
  6380: 1.5,
  6382: 1.5,
  6383: 1.5,
  6384: 1.5,
  6385: 1.5,
  6391: 1.5,
  6392: 1.5,
  6393: 1.5,
  6395: 1.5,
  6401: 1.5,
  6402: 1.5,
  6403: 1.5,
  6404: 1.5,
  6405: 1.5,
  6406: 1.5,
  6408: 1.5,
  6410: 1.5,
  6412: 1.5,
  6413: 1.5,
  6414: 1.5,
  6416: 1.5,
  6421: 1.5,
  6422: 1.5,
  6423: 1.5,
  6424: 1.5,
  6425: 1.5,
  6426: 1.5,
  6430: 1.5,
  6432: 1.5,
  6433: 1.5,
  6441: 1.5,
  6444: 1.5,
  6450: 1.5,
  6452: 1.5,
  6456: 1.5,
  6458: 1.5,
  6460: 1.5,
  6462: 1.5,
  6463: 1.5,
  6464: 1.5,
  6465: 1.5,
  6471: 1.5,
  6473: 1.5,
  6474: 1.5,
  6481: 1.5,
  6491: 1.5,
  6492: 1.5,
  6493: 1.5,
  6500: 1.5,
  6511: 1.5,
  6521: 1.5,
  6522: 1.5,
  6524: 1.5,
  6525: 1.5,
  6526: 1.5,
  6527: 1.5,
  6528: 1.5,
  6531: 1.5,
  6532: 1.5,
  6533: 1.5,
  6534: 1.5,
  6541: 1.5,
  6542: 1.5,
  6543: 1.5,
  6544: 1.5,
  6551: 1.5,
  6552: 1.5,
  6553: 1.5,
  6555: 1.5,
  6561: 1.5,
  6562: 1.5,
  6563: 1.5,
  6571: 1.5,
  6572: 1.5,
  6574: 1.5,
  6580: 1.5,
  6591: 1.5,
  6600: 1.5,
  6604: 1.5,
  6610: 1.5,
  6611: 1.5,
  6621: 1.5,
  6622: 1.5,
  6623: 1.5,
  6631: 1.5,
  6632: 1.5,
  6633: 1.5,
  6642: 1.5,
  6644: 1.5,
  6645: 1.5,
  6646: 1.5,
  6647: 1.5,
  6650: 1.5,
  6651: 1.5,
  6652: 1.5,
  6653: 1.5,
  6654: 1.5,
  6655: 1.5,
  6670: 1.5,
  6671: 1.5,
  6672: 1.5,
  6673: 1.5,
  6675: 1.5,
  6677: 1.5,
  6682: 1.5,
  6691: 1.5,
  6700: 1.5,
  6701: 1.5,
  6706: 1.5,
  6707: 1.5,
  6708: 1.5,
  6710: 1.5,
  6712: 1.5,
  6713: 1.5,
  6714: 1.5,
  6719: 1.5,
  6721: 1.5,
  6722: 1.5,
  6723: 1.5,
  6731: 1.5,
  6733: 1.5,
  6741: 1.5,
  6751: 1.5,
  6752: 1.5,
  6754: 1.5,
  6762: 1.5,
  6763: 1.5,
  6764: 1.5,
  6767: 1.5,
  6771: 1.5,
  6773: 1.5,
  6774: 1.5,
  6780: 1.5,
  6781: 1.5,
  6782: 1.5,
  6787: 1.5,
  6791: 1.5,
  6793: 1.5,
  6794: 1.5,
  6800: 1.5,
  6801: 1.5,
  6803: 1.5,
  6805: 1.5,
  6808: 1.5,
  6811: 1.5,
  6812: 1.5,
  6820: 1.5,
  6822: 1.5,
  6824: 1.5,
  6830: 1.5,
  6832: 1.5,
  6833: 1.5,
  6834: 1.5,
  6835: 1.5,
  6836: 1.5,
  6837: 1.5,
  6840: 1.5,
  6841: 1.5,
  6842: 1.5,
  6844: 1.5,
  6845: 1.5,
  6850: 1.5,
  6851: 1.5,
  6854: 1.5,
  6855: 1.5,
  6857: 1.5,
  6858: 1.5,
  6861: 1.5,
  6863: 1.5,
  6866: 1.5,
  6867: 1.5,
  6870: 1.5,
  6874: 1.5,
  6881: 1.5,
  6882: 1.5,
  6883: 1.5,
  6884: 1.5,
  6886: 1.5,
  6888: 1.5,
  6890: 1.5,
  6900: 1.5,
  6901: 1.5,
  6904: 1.5,
  6911: 1.5,
  6912: 1.5,
  6914: 1.5,
  6921: 1.5,
  6922: 1.5,
  6923: 1.5,
  6932: 1.5,
  6933: 1.5,
  6934: 1.5,
  6941: 1.5,
  6942: 1.5,
  6943: 1.5,
  6951: 1.5,
  6952: 1.5,
  6953: 1.5,
  6960: 1.5,
  6961: 1.5,
  6971: 1.5,
  6972: 1.5,
  6973: 1.5,
  6974: 1.5,
  6991: 1.5,
  6992: 1.5,
  6993: 1.5,
  7000: 1.0,
  7001: 1.0,
  7002: 1.0,
  7011: 1.0,
  7012: 1.0,
  7013: 1.0,
  7020: 1.0,
  7021: 1.0,
  7022: 1.0,
  7023: 1.0,
  7024: 1.0,
  7025: 1.0,
  7031: 1.0,
  7032: 1.0,
  7033: 1.0,
  7034: 1.0,
  7035: 1.0,
  7041: 1.0,
  7042: 1.0,
  7051: 1.0,
  7052: 1.0,
  7053: 1.0,
  7061: 1.0,
  7062: 1.0,
  7063: 1.0,
  7064: 1.0,
  7071: 1.0,
  7072: 1.0,
  7081: 1.0,
  7082: 1.0,
  7083: 1.0,
  7091: 1.0,
  7092: 1.0,
  7093: 1.0,
  7100: 1.0,
  7111: 1.0,
  7121: 1.0,
  7122: 1.0,
  7123: 1.0,
  7131: 1.0,
  7132: 1.0,
  7141: 1.0,
  7142: 1.0,
  7143: 1.0,
  7151: 1.0,
  7152: 1.0,
  7161: 1.0,
  7162: 1.0,
  7163: 1.0,
  7201: 1.0,
  7202: 1.0,
  7203: 1.0,
  7210: 1.0,
  7212: 1.0,
  7221: 1.0,
  7222: 1.0,
  7223: 1.0,
  7301: 1.0,
  7302: 1.0,
  7304: 1.0,
  7311: 1.0,
  7312: 1.0,
  7321: 1.0,
  7322: 1.0,
  7323: 1.0,
  7331: 1.0,
  7332: 1.0,
  7341: 1.0,
  7342: 1.0,
  7343: 1.0,
  7344: 1.0,
  7350: 1.0,
  7361: 1.0,
  7371: 1.0,
  7372: 1.0,
  7373: 1.0,
  7374: 1.0,
  7400: 1.0,
  7410: 1.0,
  7411: 1.0,
  7412: 1.0,
  7420: 1.0,
  7421: 1.0,
  7422: 1.0,
  7423: 1.0,
  7424: 1.0,
  7425: 1.0,
  7431: 1.0,
  7432: 1.0,
  7433: 1.0,
  7434: 1.0,
  7435: 1.0,
  7441: 1.0,
  7442: 1.0,
  7443: 1.0,
  7444: 1.0,
  7451: 1.0,
  7452: 1.0,
  7453: 1.0,
  7461: 1.0,
  7463: 1.0,
  7464: 1.0,
  7471: 1.0,
  7472: 1.0,
  7473: 1.0,
  7474: 1.0,
  7501: 1.0,
  7502: 1.0,
  7503: 1.0,
  7511: 1.0,
  7512: 1.0,
  7521: 1.0,
  7522: 1.0,
  7531: 1.0,
  7532: 1.0,
  7533: 1.0,
  7534: 1.0,
  7535: 1.0,
  7536: 1.0,
  7537: 1.0,
  7540: 1.0,
  7542: 1.0,
  7543: 1.0,
  7544: 1.0,
  7545: 1.0,
  7546: 1.0,
  7550: 1.0,
  7551: 1.0,
  7552: 1.0,
  7553: 1.0,
  7554: 1.0,
  7561: 1.0,
  7562: 1.0,
  7563: 1.0,
  7564: 1.0,
  7571: 1.0,
  7572: 1.0,
  7574: 1.0,
  8000: 1.0,
  8006: 1.0,
  8010: 1.0,
  8011: 1.0,
  8012: 1.0,
  8014: 1.0,
  8015: 1.0,
  8016: 1.0,
  8017: 1.0,
  8019: 1.0,
  8020: 1.0,
  8021: 1.0,
  8025: 1.0,
  8026: 1.0,
  8035: 1.0,
  8036: 1.0,
  8041: 1.0,
  8042: 1.0,
  8043: 1.0,
  8044: 1.0,
  8045: 1.0,
  8046: 1.0,
  8047: 1.0,
  8049: 1.0,
  8050: 1.0,
  8051: 1.0,
  8052: 1.0,
  8053: 1.0,
  8054: 1.0,
  8055: 1.0,
  8056: 1.0,
  8057: 1.0,
  8061: 1.0,
  8062: 1.0,
  8063: 1.0,
  8071: 1.0,
  8072: 1.0,
  8073: 1.0,
  8074: 1.0,
  8075: 1.0,
  8076: 1.0,
  8077: 1.0,
  8081: 1.0,
  8082: 1.0,
  8083: 1.0,
  8091: 1.0,
  8092: 1.0,
  8093: 1.0,
  8101: 1.0,
  8102: 1.0,
  8103: 1.0,
  8111: 1.0,
  8112: 1.0,
  8113: 1.0,
  8114: 1.0,
  8120: 1.0,
  8121: 1.0,
  8122: 1.0,
  8124: 1.0,
  8130: 1.0,
  8131: 1.0,
  8132: 1.0,
  8141: 1.0,
  8142: 1.0,
  8143: 1.0,
  8144: 1.0,
  8151: 1.0,
  8152: 1.0,
  8153: 1.0,
  8160: 1.0,
  8162: 1.0,
  8163: 1.0,
  8164: 1.0,
  8171: 1.0,
  8172: 1.0,
  8181: 1.0,
  8182: 1.0,
  8183: 1.0,
  8184: 1.0,
  8190: 1.0,
  8191: 1.0,
  8192: 1.0,
  8193: 1.0,
  8194: 1.0,
  8200: 1.0,
  8211: 1.0,
  8212: 1.0,
  8213: 1.0,
  8221: 1.0,
  8222: 1.0,
  8223: 1.0,
  8224: 1.0,
  8225: 1.0,
  8226: 1.0,
  8230: 1.0,
  8232: 1.0,
  8233: 1.0,
  8234: 1.0,
  8240: 1.0,
  8241: 1.0,
  8242: 1.0,
  8243: 1.0,
  8244: 1.0,
  8250: 1.0,
  8251: 1.0,
  8252: 1.0,
  8253: 1.0,
  8254: 1.0,
  8255: 1.0,
  8261: 1.0,
  8262: 1.0,
  8263: 1.0,
  8264: 1.0,
  8265: 1.0,
  8271: 1.0,
  8272: 1.0,
  8273: 1.0,
  8274: 1.0,
  8280: 1.0,
  8282: 1.0,
  8283: 1.0,
  8291: 1.0,
  8292: 1.0,
  8293: 1.0,
  8294: 1.0,
  8295: 1.0,
  8301: 1.0,
  8302: 1.0,
  8311: 1.0,
  8312: 1.0,
  8313: 1.0,
  8321: 1.0,
  8322: 1.0,
  8323: 1.0,
  8324: 1.0,
  8330: 1.0,
  8332: 1.0,
  8333: 1.0,
  8334: 1.0,
  8341: 1.0,
  8342: 1.0,
  8343: 1.0,
  8344: 1.0,
  8345: 1.0,
  8350: 1.0,
  8352: 1.0,
  8353: 1.0,
  8354: 1.0,
  8355: 1.0,
  8361: 1.0,
  8362: 1.0,
  8380: 1.0,
  8382: 1.0,
  8383: 1.0,
  8384: 1.0,
  8385: 1.0,
  8401: 1.0,
  8402: 1.0,
  8403: 1.0,
  8404: 1.0,
  8410: 1.0,
  8411: 1.0,
  8412: 1.0,
  8413: 1.0,
  8421: 1.0,
  8422: 1.0,
  8423: 1.0,
  8424: 1.0,
  8430: 1.0,
  8431: 1.0,
  8432: 1.0,
  8434: 1.0,
  8435: 1.0,
  8441: 1.0,
  8442: 1.0,
  8443: 1.0,
  8444: 1.0,
  8451: 1.0,
  8452: 1.0,
  8453: 1.0,
  8454: 1.0,
  8455: 1.0,
  8461: 1.0,
  8462: 1.0,
  8463: 1.0,
  8471: 1.0,
  8472: 1.0,
  8473: 1.0,
  8480: 1.0,
  8481: 1.0,
  8482: 1.0,
  8483: 1.0,
  8484: 1.0,
  8490: 1.0,
  8492: 1.0,
  8493: 1.0,
  8501: 1.0,
  8502: 1.0,
  8503: 1.0,
  8504: 1.0,
  8505: 1.0,
  8510: 1.0,
  8511: 1.0,
  8521: 1.0,
  8522: 1.0,
  8523: 1.0,
  8524: 1.0,
  8530: 1.0,
  8541: 1.0,
  8542: 1.0,
  8543: 1.0,
  8544: 1.0,
  8551: 1.0,
  8552: 1.0,
  8553: 1.0,
  8554: 1.0,
  8555: 1.0,
  8561: 1.0,
  8562: 1.0,
  8563: 1.0,
  8564: 1.0,
  8565: 1.0,
  8570: 1.0,
  8571: 1.0,
  8572: 1.0,
  8573: 1.0,
  8580: 1.0,
  8582: 1.0,
  8583: 1.0,
  8584: 1.0,
  8591: 1.0,
  8592: 1.0,
  8593: 1.0,
  8600: 1.0,
  8605: 1.0,
  8607: 1.0,
  8611: 1.0,
  8612: 1.0,
  8614: 1.0,
  8616: 1.0,
  8621: 1.0,
  8622: 1.0,
  8623: 1.0,
  8624: 1.0,
  8625: 1.0,
  8630: 1.0,
  8632: 1.0,
  8634: 1.0,
  8635: 1.0,
  8636: 1.0,
  8641: 1.0,
  8642: 1.0,
  8643: 1.0,
  8644: 1.0,
  8650: 1.0,
  8652: 1.0,
  8653: 1.0,
  8654: 1.0,
  8661: 1.0,
  8662: 1.0,
  8663: 1.0,
  8664: 1.0,
  8665: 1.0,
  8670: 1.0,
  8671: 1.0,
  8672: 1.0,
  8673: 1.0,
  8674: 1.0,
  8680: 1.0,
  8682: 1.0,
  8684: 1.0,
  8685: 1.0,
  8691: 1.0,
  8692: 1.0,
  8693: 1.0,
  8694: 1.0,
  8700: 1.0,
  8704: 1.0,
  8707: 1.0,
  8709: 1.0,
  8712: 1.0,
  8713: 1.0,
  8714: 1.0,
  8715: 1.0,
  8720: 1.0,
  8723: 1.0,
  8724: 1.0,
  8731: 1.0,
  8732: 1.0,
  8733: 1.0,
  8734: 1.0,
  8740: 1.0,
  8741: 1.0,
  8742: 1.0,
  8743: 1.0,
  8750: 1.0,
  8751: 1.0,
  8753: 1.0,
  8754: 1.0,
  8755: 1.0,
  8756: 1.0,
  8761: 1.0,
  8762: 1.0,
  8763: 1.0,
  8764: 1.0,
  8765: 1.0,
  8770: 1.0,
  8772: 1.0,
  8773: 1.0,
  8774: 1.0,
  8775: 1.0,
  8781: 1.0,
  8782: 1.0,
  8783: 1.0,
  8784: 1.0,
  8785: 1.0,
  8786: 1.0,
  8790: 1.0,
  8792: 1.0,
  8793: 1.0,
  8794: 1.0,
  8795: 1.0,
  8800: 1.0,
  8811: 1.0,
  8812: 1.0,
  8813: 1.0,
  8820: 1.0,
  8822: 1.0,
  8831: 1.0,
  8832: 1.0,
  8833: 1.0,
  8841: 1.0,
  8842: 1.0,
  8843: 1.0,
  8844: 1.0,
  8850: 1.0,
  8852: 1.0,
  8853: 1.0,
  8854: 1.0,
  8861: 1.0,
  8862: 1.0,
  8863: 1.0,
  8864: 1.0,
  8900: 1.0,
  8903: 1.0,
  8904: 1.0,
  8911: 1.0,
  8912: 1.0,
  8913: 1.0,
  8920: 1.0,
  8921: 1.0,
  8922: 1.0,
  8923: 1.0,
  8924: 1.0,
  8931: 1.0,
  8932: 1.0,
  8933: 1.0,
  8934: 1.0,
  8940: 1.0,
  8942: 1.0,
  8943: 1.0,
  8950: 1.0,
  8951: 1.0,
  8952: 1.0,
  8953: 1.0,
  8954: 1.0,
  8960: 1.0,
  8961: 1.0,
  8962: 1.0,
  8965: 1.0,
  8966: 1.0,
  8967: 1.0,
  8970: 1.0,
  8971: 1.0,
  8972: 1.0,
  8973: 1.0,
  8974: 1.0,
  8982: 1.0,
  8983: 1.0,
  8984: 1.0,
  8990: 1.0,
  8992: 1.0,
  8993: 1.0,
  9000: 1.3,
  9010: 1.3,
  9020: 1.3,
  9021: 1.3,
  9022: 1.3,
  9025: 1.3,
  9026: 1.3,
  9027: 1.3,
  9028: 1.3,
  9033: 1.3,
  9034: 1.3,
  9061: 1.3,
  9062: 1.3,
  9063: 1.3,
  9064: 1.3,
  9065: 1.3,
  9071: 1.3,
  9072: 1.3,
  9073: 1.3,
  9074: 1.3,
  9081: 1.3,
  9082: 1.3,
  9100: 1.3,
  9102: 1.3,
  9103: 1.3,
  9104: 1.3,
  9111: 1.3,
  9112: 1.3,
  9113: 1.3,
  9121: 1.3,
  9122: 1.3,
  9123: 1.3,
  9125: 1.3,
  9130: 1.3,
  9131: 1.3,
  9132: 1.3,
  9133: 1.3,
  9135: 1.3,
  9141: 1.3,
  9142: 1.3,
  9143: 1.3,
  9150: 1.3,
  9155: 1.3,
  9161: 1.3,
  9162: 1.3,
  9163: 1.3,
  9170: 1.3,
  9171: 1.3,
  9172: 1.3,
  9173: 1.3,
  9181: 1.3,
  9182: 1.3,
  9183: 1.3,
  9184: 1.3,
  9201: 1.3,
  9210: 1.3,
  9212: 1.3,
  9220: 1.3,
  9231: 1.3,
  9232: 1.3,
  9241: 1.3,
  9300: 1.3,
  9311: 1.3,
  9312: 1.3,
  9313: 1.3,
  9314: 1.3,
  9321: 1.3,
  9322: 1.3,
  9323: 1.3,
  9330: 1.3,
  9334: 1.3,
  9335: 1.3,
  9341: 1.3,
  9342: 1.3,
  9343: 1.3,
  9344: 1.3,
  9345: 1.3,
  9346: 1.3,
  9360: 1.3,
  9361: 1.3,
  9362: 1.3,
  9363: 1.3,
  9371: 1.3,
  9372: 1.3,
  9373: 1.3,
  9374: 1.3,
  9375: 1.3,
  9376: 1.3,
  9400: 1.3,
  9402: 1.3,
  9411: 1.3,
  9412: 1.3,
  9413: 1.3,
  9421: 1.3,
  9422: 1.3,
  9423: 1.3,
  9431: 1.3,
  9433: 1.3,
  9441: 1.3,
  9451: 1.3,
  9461: 1.3,
  9462: 1.3,
  9463: 1.3,
  9470: 1.3,
  9472: 1.3,
  9473: 1.3,
  9500: 1.3,
  9501: 1.3,
  9503: 1.3,
  9504: 1.3,
  9507: 1.3,
  9509: 1.3,
  9520: 1.3,
  9521: 1.3,
  9523: 1.3,
  9524: 1.3,
  9530: 1.3,
  9531: 1.3,
  9535: 1.3,
  9536: 1.3,
  9541: 1.3,
  9542: 1.3,
  9543: 1.3,
  9544: 1.3,
  9545: 1.3,
  9546: 1.3,
  9551: 1.3,
  9552: 1.3,
  9554: 1.3,
  9555: 1.3,
  9556: 1.3,
  9560: 1.3,
  9562: 1.3,
  9563: 1.3,
  9564: 1.3,
  9565: 1.3,
  9570: 1.3,
  9571: 1.3,
  9572: 1.3,
  9580: 1.3,
  9581: 1.3,
  9582: 1.3,
  9583: 1.3,
  9584: 1.3,
  9585: 1.3,
  9586: 1.3,
  9587: 1.3,
  9601: 1.3,
  9602: 1.3,
  9611: 1.3,
  9612: 1.3,
  9613: 1.3,
  9614: 1.3,
  9615: 1.3,
  9620: 1.3,
  9622: 1.3,
  9623: 1.3,
  9624: 1.3,
  9631: 1.3,
  9632: 1.3,
  9633: 1.3,
  9634: 1.3,
  9635: 1.3,
  9640: 1.3,
  9651: 1.3,
  9652: 1.3,
  9653: 1.3,
  9654: 1.3,
  9655: 1.3,
  9701: 1.3,
  9702: 1.3,
  9710: 1.3,
  9711: 1.3,
  9712: 1.3,
  9713: 1.3,
  9714: 1.3,
  9721: 1.3,
  9722: 1.3,
  9751: 1.3,
  9753: 1.3,
  9754: 1.3,
  9761: 1.3,
  9762: 1.3,
  9771: 1.3,
  9772: 1.3,
  9773: 1.3,
  9781: 1.3,
  9782: 1.3,
  9800: 1.3,
  9802: 1.3,
  9803: 1.3,
  9805: 1.3,
  9811: 1.3,
  9812: 1.3,
  9813: 1.3,
  9814: 1.3,
  9815: 1.3,
  9816: 1.3,
  9821: 1.3,
  9822: 1.3,
  9831: 1.3,
  9832: 1.3,
  9833: 1.3,
  9841: 1.3,
  9842: 1.3,
  9843: 1.3,
  9844: 1.3,
  9851: 1.3,
  9852: 1.3,
  9853: 1.3,
  9854: 1.3,
  9861: 1.3,
  9862: 1.3,
  9863: 1.3,
  9871: 1.3,
  9872: 1.3,
  9873: 1.3,
  9900: 1.3,
  9903: 1.3,
  9904: 1.3,
  9905: 1.3,
  9906: 1.3,
  9907: 1.3,
  9908: 1.3,
  9909: 1.3,
  9911: 1.3,
  9912: 1.3,
  9913: 1.3,
  9918: 1.3,
  9919: 1.3,
  9920: 1.3,
  9931: 1.3,
  9932: 1.3,
  9941: 1.3,
  9942: 1.3,
  9943: 1.3,
  9951: 1.3,
  9952: 1.3,
  9953: 1.3,
  9954: 1.3,
  9961: 1.3,
  9962: 1.3,
  9963: 1.3,
  9971: 1.3,
  9972: 1.3,
  9974: 1.3,
  9981: 1.3,
  9990: 1.3,
  9991: 1.3,
  9992: 1.3,
  01067: 2.00,
  01069: 2.00,
  01097: 2.00,
  01099: 2.00,
  01108: 2.00,
  01109: 2.00,
  01127: 2.00,
  01129: 2.00,
  01139: 2.00,
  01156: 2.00,
  01157: 2.00,
  01159: 2.00,
  01169: 2.00,
  01187: 2.00,
  01189: 2.00,
  01217: 2.00,
  01219: 2.00,
  01237: 2.00,
  01239: 2.00,
  01257: 2.00,
  01259: 2.00,
  01277: 2.00,
  01279: 2.00,
  01307: 2.00,
  01309: 2.00,
  01324: 2.00,
  01326: 2.00,
  01328: 2.00,
  01445: 2.00,
  01454: 2.00,
  01458: 2.00,
  01465: 2.00,
  01468: 2.00,
  01471: 2.00,
  01477: 2.00,
  01558: 2.00,
  01561: 2.00,
  01587: 2.00,
  01589: 2.00,
  01591: 2.00,
  01594: 2.00,
  01609: 2.00,
  01612: 2.00,
  01616: 2.00,
  01619: 2.00,
  01623: 2.00,
  01640: 2.00,
  01662: 2.00,
  01665: 2.00,
  01683: 2.00,
  01689: 2.00,
  01705: 2.00,
  01723: 2.00,
  01728: 2.00,
  01731: 2.00,
  01734: 2.00,
  01737: 2.00,
  01738: 2.00,
  01744: 2.00,
  01762: 2.00,
  01768: 2.00,
  01773: 2.00,
  01774: 2.00,
  01776: 2.00,
  01778: 2.00,
  01796: 2.00,
  01809: 2.00,
  01814: 2.00,
  01816: 2.00,
  01819: 2.00,
  01824: 2.00,
  01825: 2.00,
  01829: 2.00,
  01833: 2.00,
  01844: 2.00,
  01847: 2.00,
  01848: 2.00,
  01855: 2.00,
  01877: 2.00,
  01896: 2.00,
  01900: 2.00,
  01904: 2.00,
  01906: 2.00,
  01909: 2.00,
  01917: 2.00,
  01920: 2.00,
  01936: 2.00,
  01945: 2.00,
  01968: 2.00,
  01979: 2.00,
  01983: 2.00,
  01987: 2.00,
  01990: 2.00,
  01993: 2.00,
  01994: 2.00,
  01996: 2.00,
  01998: 2.00,
  02625: 2.00,
  02627: 2.00,
  02633: 2.00,
  02681: 2.00,
  02689: 2.00,
  02692: 2.00,
  02694: 2.00,
  02699: 2.00,
  02708: 2.00,
  02727: 2.00,
  02730: 2.00,
  02733: 2.00,
  02736: 2.00,
  02739: 2.00,
  02742: 2.00,
  02747: 2.00,
  02748: 2.00,
  02763: 2.00,
  02779: 2.00,
  02782: 2.00,
  02785: 2.00,
  02788: 2.00,
  02791: 2.00,
  02794: 2.00,
  02796: 2.00,
  02797: 2.00,
  02799: 2.00,
  02826: 2.00,
  02827: 2.00,
  02828: 2.00,
  02829: 2.00,
  02894: 2.00,
  02899: 2.00,
  02906: 2.00,
  02923: 2.00,
  02929: 2.00,
  02943: 2.00,
  02953: 2.00,
  02956: 2.00,
  02957: 2.00,
  02959: 2.00,
  02977: 2.00,
  02979: 2.00,
  02991: 2.00,
  02994: 2.00,
  02997: 2.00,
  02999: 2.00,
  03042: 2.00,
  03044: 2.00,
  03046: 2.00,
  03048: 2.00,
  03050: 2.00,
  03051: 2.00,
  03052: 2.00,
  03053: 2.00,
  03054: 2.00,
  03055: 2.00,
  03058: 2.00,
  03096: 2.00,
  03099: 2.00,
  03103: 2.00,
  03116: 2.00,
  03119: 2.00,
  03130: 2.00,
  03149: 2.00,
  03159: 2.00,
  03172: 2.00,
  03185: 2.00,
  03197: 2.00,
  03205: 2.00,
  03222: 2.00,
  03226: 2.00,
  03229: 2.00,
  03238: 2.00,
  03246: 2.00,
  03249: 2.00,
  03253: 2.00,
  04103: 2.00,
  04105: 2.00,
  04107: 2.00,
  04109: 2.00,
  04129: 2.08,
  04155: 2.08,
  04157: 2.08,
  04158: 2.08,
  04159: 2.08,
  04177: 2.08,
  04178: 2.08,
  04179: 2.08,
  04205: 2.08,
  04207: 2.08,
  04209: 2.08,
  04229: 2.08,
  04249: 2.08,
  04275: 2.08,
  04277: 2.08,
  04279: 2.08,
  04288: 2.08,
  04289: 2.08,
  04299: 2.08,
  04315: 2.08,
  04316: 2.08,
  04317: 2.08,
  04318: 2.08,
  04319: 2.08,
  04328: 2.08,
  04329: 2.08,
  04347: 2.08,
  04349: 2.08,
  04356: 2.08,
  04357: 2.08,
  04416: 2.08,
  04420: 2.08,
  04425: 2.08,
  04435: 2.08,
  04442: 2.08,
  04451: 2.08,
  04463: 2.08,
  04509: 2.08,
  04519: 2.08,
  04523: 2.08,
  04539: 2.08,
  04552: 2.08,
  04564: 2.08,
  04565: 2.08,
  04567: 2.08,
  04571: 2.08,
  04575: 2.08,
  04600: 2.08,
  04603: 2.08,
  04610: 2.08,
  04613: 2.08,
  04617: 2.08,
  04618: 2.08,
  04626: 2.08,
  04639: 2.08,
  04643: 2.08,
  04651: 2.08,
  04654: 2.08,
  04668: 2.08,
  04680: 2.08,
  04683: 2.08,
  04687: 2.08,
  04703: 2.08,
  04720: 2.08,
  04736: 2.08,
  04741: 2.08,
  04746: 2.08,
  04749: 2.08,
  04758: 2.08,
  04769: 2.08,
  04774: 2.08,
  04779: 2.08,
  04808: 2.08,
  04821: 2.08,
  04824: 2.08,
  04827: 2.08,
  04828: 2.08,
  04838: 2.08,
  04849: 2.08,
  04860: 2.08,
  04861: 2.08,
  04862: 2.08,
  04874: 2.08,
  04880: 2.08,
  04886: 2.08,
  04889: 2.08,
  04895: 2.08,
  04910: 2.08,
  04916: 2.08,
  04924: 2.08,
  04928: 2.08,
  04931: 2.08,
  04932: 2.08,
  04934: 2.08,
  04936: 2.08,
  04938: 2.08,
  06108: 2.08,
  06110: 2.08,
  06112: 2.08,
  06114: 2.08,
  06116: 2.08,
  06118: 2.08,
  06120: 2.08,
  06122: 2.08,
  06124: 2.08,
  06126: 2.08,
  06128: 2.08,
  06130: 2.08,
  06132: 2.08,
  06179: 2.08,
  06184: 2.08,
  06188: 2.08,
  06193: 2.08,
  06198: 2.08,
  06217: 2.08,
  06231: 2.08,
  06237: 2.08,
  06242: 2.08,
  06246: 2.08,
  06249: 2.08,
  06255: 2.08,
  06258: 2.08,
  06259: 2.08,
  06268: 2.08,
  06279: 2.08,
  06295: 2.08,
  06308: 2.08,
  06311: 2.08,
  06313: 2.08,
  06317: 2.08,
  06333: 2.08,
  06343: 2.08,
  06347: 2.08,
  06366: 2.08,
  06369: 2.08,
  06385: 2.08,
  06386: 2.08,
  06388: 2.08,
  06406: 2.08,
  06408: 2.08,
  06420: 2.08,
  06425: 2.08,
  06429: 2.08,
  06449: 2.08,
  06456: 2.08,
  06458: 2.08,
  06463: 2.08,
  06464: 2.08,
  06466: 2.08,
  06467: 2.08,
  06469: 2.08,
  06484: 2.08,
  06485: 2.08,
  06493: 2.08,
  06502: 2.08,
  06526: 2.08,
  06528: 2.08,
  06536: 2.08,
  06537: 2.08,
  06542: 2.08,
  06543: 2.08,
  06556: 2.08,
  06567: 2.08,
  06571: 2.08,
  06577: 2.08,
  06618: 2.08,
  06628: 2.08,
  06632: 2.08,
  06636: 2.08,
  06638: 2.08,
  06642: 2.08,
  06647: 2.08,
  06648: 2.08,
  06667: 2.08,
  06679: 2.08,
  06682: 2.08,
  06686: 2.08,
  06688: 2.08,
  06711: 2.08,
  06712: 2.08,
  06721: 2.08,
  06722: 2.08,
  06729: 2.08,
  06749: 2.08,
  06766: 2.08,
  06772: 2.08,
  06773: 2.08,
  06774: 2.08,
  06779: 2.08,
  06780: 2.08,
  06785: 2.08,
  06792: 2.08,
  06794: 2.08,
  06796: 2.08,
  06800: 2.08,
  06803: 2.08,
  06808: 2.08,
  06809: 2.08,
  06842: 2.08,
  06844: 2.08,
  06846: 2.08,
  06847: 2.08,
  06849: 2.08,
  06861: 2.08,
  06862: 2.08,
  06868: 2.08,
  06869: 2.08,
  06886: 2.08,
  06888: 2.08,
  06889: 2.08,
  06895: 2.08,
  06901: 2.08,
  06905: 2.08,
  06917: 2.08,
  06925: 2.08,
  07318: 2.08,
  07330: 2.08,
  07333: 2.08,
  07338: 2.08,
  07343: 2.08,
  07349: 2.08,
  07356: 2.08,
  07366: 2.08,
  07368: 2.08,
  07381: 2.08,
  07387: 2.08,
  07389: 2.08,
  07407: 2.08,
  07422: 2.08,
  07426: 2.08,
  07427: 2.08,
  07429: 2.08,
  07545: 2.08,
  07546: 2.08,
  07548: 2.08,
  07549: 2.08,
  07551: 2.08,
  07552: 2.08,
  07554: 2.08,
  07557: 2.08,
  07570: 2.08,
  07580: 2.08,
  07586: 2.08,
  07589: 2.08,
  07607: 2.08,
  07613: 2.08,
  07616: 2.08,
  07619: 2.08,
  07629: 2.08,
  07639: 2.08,
  07646: 2.08,
  07743: 2.08,
  07745: 2.08,
  07747: 2.08,
  07749: 2.08,
  07751: 2.08,
  07768: 2.08,
  07774: 2.08,
  07778: 2.08,
  07806: 2.08,
  07819: 2.08,
  07907: 2.08,
  07919: 2.08,
  07922: 2.08,
  07924: 2.08,
  07926: 2.08,
  07927: 2.08,
  07929: 2.08,
  07937: 2.08,
  07950: 2.08,
  07952: 2.08,
  07955: 2.08,
  07957: 2.08,
  07958: 2.08,
  07973: 2.08,
  07980: 2.08,
  07985: 2.08,
  07987: 2.08,
  08056: 2.08,
  08058: 2.08,
  08060: 2.08,
  08062: 2.08,
  08064: 2.08,
  08066: 2.08,
  08107: 2.08,
  08112: 2.08,
  08115: 2.08,
  08118: 2.08,
  08132: 2.08,
  08134: 2.08,
  08141: 2.08,
  08144: 2.08,
  08147: 2.08,
  08209: 2.08,
  08223: 2.08,
  08228: 2.08,
  08233: 2.08,
  08236: 2.08,
  08237: 2.08,
  08239: 2.08,
  08248: 2.08,
  08258: 2.08,
  08261: 2.08,
  08262: 2.08,
  08267: 2.08,
  08280: 2.08,
  08289: 2.08,
  08294: 2.08,
  08297: 2.08,
  08304: 2.08,
  08309: 2.08,
  08315: 2.08,
  08321: 2.08,
  08324: 2.08,
  08328: 2.08,
  08340: 2.08,
  08344: 2.08,
  08349: 2.08,
  08352: 2.08,
  08359: 2.08,
  08371: 2.08,
  08373: 2.08,
  08393: 2.08,
  08396: 2.08,
  08412: 2.08,
  08427: 2.08,
  08428: 2.08,
  08451: 2.08,
  08459: 2.08,
  08468: 2.08,
  08485: 2.08,
  08491: 2.08,
  08496: 2.08,
  08499: 2.08,
  08523: 2.08,
  08525: 2.08,
  08527: 2.08,
  08529: 2.08,
  08538: 2.08,
  08539: 2.08,
  08541: 2.08,
  08543: 2.08,
  08547: 2.08,
  08548: 2.08,
  08606: 2.08,
  08626: 2.08,
  08645: 2.08,
  08648: 2.08,
  09111: 2.08,
  09112: 2.08,
  09113: 2.08,
  09114: 2.08,
  09116: 2.08,
  09117: 2.08,
  09119: 2.08,
  09120: 2.08,
  09122: 2.08,
  09123: 2.08,
  09125: 2.08,
  09126: 2.08,
  09127: 2.08,
  09128: 2.08,
  09130: 2.08,
  09131: 2.08,
  09212: 2.08,
  09217: 2.08,
  09221: 2.08,
  09224: 2.08,
  09228: 2.08,
  09232: 2.08,
  09235: 2.08,
  09236: 2.08,
  09241: 2.08,
  09243: 2.08,
  09244: 2.08,
  09247: 2.08,
  09249: 2.08,
  09306: 2.08,
  09322: 2.08,
  09326: 2.08,
  09328: 2.08,
  09337: 2.08,
  09350: 2.08,
  09353: 2.08,
  09355: 2.08,
  09356: 2.08,
  09366: 2.08,
  09376: 2.08,
  09380: 2.08,
  09385: 2.08,
  09387: 2.08,
  09390: 2.08,
  09392: 2.08,
  09394: 2.08,
  09399: 2.08,
  09405: 2.08,
  09419: 2.08,
  09423: 2.08,
  09427: 2.08,
  09429: 2.08,
  09430: 2.08,
  09432: 2.08,
  09434: 2.08,
  09437: 2.08,
  09439: 2.08,
  09456: 2.08,
  09465: 2.08,
  09468: 2.08,
  09471: 2.08,
  09474: 2.08,
  09477: 2.08,
  09481: 2.08,
  09484: 2.08,
  09487: 2.08,
  09488: 2.08,
  09496: 2.08,
  09509: 2.08,
  09514: 2.08,
  09518: 2.08,
  09526: 2.08,
  09544: 2.08,
  09548: 2.08,
  09557: 2.08,
  09569: 2.08,
  09573: 2.08,
  09575: 2.08,
  09577: 2.08,
  09579: 2.08,
  09599: 2.08,
  09600: 2.08,
  09603: 2.08,
  09618: 2.08,
  09619: 2.08,
  09623: 2.08,
  09627: 2.08,
  09629: 2.08,
  09633: 2.08,
  09634: 2.08,
  09638: 2.08,
  09648: 2.08,
  09661: 2.08,
  09669: 2.08,
  10115: 2.08,
  10117: 2.08,
  10119: 2.15,
  10178: 2.22,
  10179: 2.22,
  10243: 2.22,
  10245: 2.22,
  10247: 2.22,
  10249: 2.22,
  10315: 2.22,
  10317: 2.22,
  10318: 2.22,
  10319: 2.22,
  10365: 2.22,
  10367: 2.22,
  10369: 2.22,
  10405: 2.22,
  10407: 2.22,
  10409: 2.22,
  10435: 2.22,
  10437: 2.22,
  10439: 2.22,
  10551: 2.22,
  10553: 2.22,
  10555: 2.22,
  10557: 2.22,
  10559: 2.22,
  10585: 2.22,
  10587: 2.22,
  10589: 2.22,
  10623: 2.22,
  10625: 2.22,
  10627: 2.22,
  10629: 2.22,
  10707: 2.22,
  10709: 2.22,
  10711: 2.22,
  10713: 2.22,
  10715: 2.22,
  10717: 2.22,
  10719: 2.22,
  10777: 2.22,
  10779: 2.22,
  10781: 2.22,
  10783: 2.22,
  10785: 2.22,
  10787: 2.22,
  10789: 2.22,
  10823: 2.22,
  10825: 2.22,
  10827: 2.22,
  10829: 2.22,
  10961: 2.22,
  10963: 2.22,
  10965: 2.22,
  10967: 2.22,
  10969: 2.22,
  10997: 2.22,
  10999: 2.22,
  12043: 2.22,
  12045: 2.22,
  12047: 2.22,
  12049: 2.22,
  12051: 2.22,
  12053: 2.22,
  12055: 2.22,
  12057: 2.22,
  12059: 2.22,
  12099: 2.22,
  12101: 2.22,
  12103: 2.22,
  12105: 2.22,
  12107: 2.22,
  12109: 2.22,
  12157: 2.22,
  12159: 2.22,
  12161: 2.22,
  12163: 2.22,
  12165: 2.22,
  12167: 2.22,
  12169: 2.22,
  12203: 2.22,
  12205: 2.22,
  12207: 2.22,
  12209: 2.22,
  12247: 2.22,
  12249: 2.22,
  12277: 2.22,
  12279: 2.22,
  12305: 2.22,
  12307: 2.22,
  12309: 2.22,
  12347: 2.22,
  12349: 2.22,
  12351: 2.22,
  12353: 2.22,
  12355: 2.22,
  12357: 2.22,
  12359: 2.22,
  12435: 2.22,
  12437: 2.22,
  12439: 2.22,
  12459: 2.22,
  12487: 2.22,
  12489: 2.22,
  12524: 2.22,
  12526: 2.22,
  12527: 2.22,
  12529: 2.22,
  12555: 2.22,
  12557: 2.22,
  12559: 2.22,
  12587: 2.22,
  12589: 2.22,
  12619: 2.22,
  12621: 2.22,
  12623: 2.22,
  12627: 2.22,
  12629: 2.22,
  12679: 2.22,
  12681: 2.22,
  12683: 2.22,
  12685: 2.22,
  12687: 2.22,
  12689: 2.22,
  13051: 2.22,
  13053: 2.22,
  13055: 2.22,
  13057: 2.22,
  13059: 2.22,
  13086: 2.22,
  13088: 2.22,
  13089: 2.22,
  13125: 2.22,
  13127: 2.22,
  13129: 2.22,
  13156: 2.22,
  13158: 2.22,
  13159: 2.22,
  13187: 2.22,
  13189: 2.22,
  13347: 2.22,
  13349: 2.22,
  13351: 2.22,
  13353: 2.22,
  13355: 2.22,
  13357: 2.22,
  13359: 2.22,
  13403: 2.22,
  13405: 2.22,
  13407: 2.22,
  13409: 2.22,
  13435: 2.22,
  13437: 2.22,
  13439: 2.22,
  13465: 2.22,
  13467: 2.22,
  13469: 2.22,
  13503: 2.22,
  13505: 2.22,
  13507: 2.22,
  13509: 2.22,
  13581: 2.22,
  13583: 2.22,
  13585: 2.22,
  13587: 2.22,
  13589: 2.22,
  13591: 2.22,
  13593: 2.22,
  13595: 2.22,
  13597: 2.22,
  13599: 2.22,
  13627: 2.22,
  13629: 2.22,
  14050: 2.22,
  14052: 2.22,
  14053: 2.22,
  14055: 2.22,
  14057: 2.22,
  14059: 2.22,
  14089: 2.22,
  14109: 2.22,
  14129: 2.22,
  14163: 2.22,
  14165: 2.22,
  14167: 2.22,
  14169: 2.22,
  14193: 2.22,
  14195: 2.22,
  14197: 2.22,
  14199: 2.22,
  14467: 2.22,
  14469: 2.22,
  14471: 2.22,
  14473: 2.22,
  14476: 2.22,
  14478: 2.22,
  14480: 2.22,
  14482: 2.22,
  14513: 2.22,
  14532: 2.22,
  14542: 2.22,
  14547: 2.22,
  14548: 2.22,
  14550: 2.22,
  14552: 2.22,
  14554: 2.22,
  14558: 2.22,
  14612: 2.22,
  14621: 2.22,
  14624: 2.22,
  14641: 2.22,
  14656: 2.22,
  14662: 2.22,
  14669: 2.22,
  14712: 2.22,
  14715: 2.22,
  14727: 2.22,
  14728: 2.22,
  14770: 2.22,
  14772: 2.22,
  14774: 2.22,
  14776: 2.22,
  14778: 2.22,
  14789: 2.22,
  14793: 2.22,
  14797: 2.22,
  14798: 2.22,
  14806: 2.22,
  14822: 2.22,
  14823: 2.22,
  14827: 2.22,
  14828: 2.22,
  14913: 2.22,
  14929: 2.22,
  14943: 2.22,
  14947: 2.22,
  14959: 2.22,
  14974: 2.22,
  14979: 2.22,
  15230: 2.22,
  15232: 2.22,
  15234: 2.22,
  15236: 2.22,
  15295: 2.22,
  15299: 2.22,
  15306: 2.22,
  15320: 2.22,
  15324: 2.22,
  15326: 2.22,
  15328: 2.22,
  15344: 2.22,
  15345: 2.22,
  15366: 2.22,
  15370: 2.22,
  15374: 2.22,
  15377: 2.22,
  15378: 2.22,
  15517: 2.22,
  15518: 2.22,
  15526: 2.22,
  15528: 2.22,
  15537: 2.22,
  15562: 2.22,
  15566: 2.22,
  15569: 2.22,
  15711: 2.22,
  15712: 2.22,
  15713: 2.22,
  15732: 2.22,
  15738: 2.22,
  15741: 2.22,
  15745: 2.22,
  15746: 2.22,
  15748: 2.22,
  15749: 2.22,
  15754: 2.22,
  15755: 2.22,
  15757: 2.22,
  15806: 2.22,
  15827: 2.22,
  15831: 2.22,
  15834: 2.22,
  15837: 2.22,
  15838: 2.22,
  15848: 2.22,
  15859: 2.22,
  15864: 2.22,
  15868: 2.22,
  15890: 2.22,
  15898: 2.22,
  15907: 2.22,
  15910: 2.22,
  15913: 2.22,
  15926: 2.22,
  15936: 2.22,
  15938: 2.22,
  16225: 2.22,
  16227: 2.22,
  16230: 2.22,
  16244: 2.22,
  16247: 2.22,
  16248: 2.22,
  16259: 2.22,
  16269: 2.22,
  16278: 2.22,
  16303: 2.22,
  16306: 2.22,
  16307: 2.22,
  16321: 2.22,
  16341: 2.22,
  16348: 2.22,
  16356: 2.22,
  16359: 2.22,
  16515: 2.22,
  16540: 2.22,
  16547: 2.22,
  16548: 2.22,
  16552: 2.22,
  16556: 2.22,
  16559: 2.22,
  16562: 2.22,
  16567: 2.22,
  16727: 2.22,
  16761: 2.22,
  16766: 2.22,
  16767: 2.22,
  16775: 2.22,
  16792: 2.22,
  16798: 2.22,
  16816: 2.22,
  16818: 2.22,
  16827: 2.22,
  16831: 2.22,
  16833: 2.22,
  16835: 2.22,
  16837: 2.22,
  16845: 2.22,
  16866: 2.22,
  16868: 2.22,
  16909: 2.22,
  16928: 2.22,
  16945: 2.22,
  16949: 2.22,
  17033: 2.22,
  17034: 2.22,
  17036: 2.22,
  17039: 2.22,
  17087: 2.22,
  17089: 2.22,
  17091: 2.22,
  17094: 2.22,
  17098: 2.22,
  17099: 2.22,
  17109: 2.22,
  17111: 2.22,
  17121: 2.22,
  17126: 2.22,
  17129: 2.22,
  17139: 2.22,
  17153: 2.22,
  17154: 2.22,
  17159: 2.22,
  17166: 2.22,
  17168: 2.22,
  17179: 2.22,
  17192: 2.22,
  17194: 2.22,
  17207: 2.22,
  17209: 2.22,
  17213: 2.22,
  17214: 2.22,
  17217: 2.22,
  17219: 2.22,
  17235: 2.22,
  17237: 2.22,
  17248: 2.22,
  17252: 2.22,
  17255: 2.22,
  17258: 2.22,
  17268: 2.22,
  17279: 2.22,
  17291: 2.22,
  17309: 2.22,
  17321: 2.22,
  17322: 2.22,
  17326: 2.22,
  17328: 2.22,
  17329: 2.22,
  17335: 2.22,
  17337: 2.22,
  17348: 2.22,
  17349: 2.22,
  17358: 2.22,
  17367: 2.22,
  17373: 2.22,
  17375: 2.22,
  17379: 2.22,
  17389: 2.22,
  17390: 2.22,
  17391: 2.22,
  17392: 2.22,
  17398: 2.22,
  17406: 2.22,
  17419: 2.22,
  17424: 2.22,
  17429: 2.22,
  17438: 2.22,
  17440: 2.22,
  17449: 2.22,
  17454: 2.22,
  17459: 2.22,
  17489: 2.22,
  17491: 2.22,
  17493: 2.22,
  17495: 2.22,
  17498: 2.22,
  17506: 2.22,
  17509: 2.22,
  18055: 2.22,
  18057: 2.22,
  18059: 2.22,
  18069: 2.22,
  18106: 2.22,
  18107: 2.22,
  18109: 2.22,
  18119: 2.22,
  18146: 2.22,
  18147: 2.22,
  18181: 2.22,
  18182: 2.22,
  18184: 2.22,
  18190: 2.22,
  18195: 2.22,
  18196: 2.22,
  18198: 2.22,
  18209: 2.22,
  18211: 2.22,
  18225: 2.22,
  18230: 2.22,
  18233: 2.22,
  18236: 2.22,
  18239: 2.22,
  18246: 2.22,
  18249: 2.22,
  18258: 2.22,
  18273: 2.22,
  18276: 2.22,
  18279: 2.22,
  18292: 2.22,
  18299: 2.22,
  18311: 2.22,
  18314: 2.22,
  18317: 2.22,
  18320: 2.22,
  18334: 2.22,
  18337: 2.22,
  18347: 2.22,
  18356: 2.22,
  18374: 2.22,
  18375: 2.22,
  18435: 2.22,
  18437: 2.22,
  18439: 2.22,
  18442: 2.22,
  18445: 2.22,
  18461: 2.22,
  18465: 2.22,
  18469: 2.22,
  18507: 2.22,
  18510: 2.22,
  18513: 2.22,
  18516: 2.22,
  18519: 2.22,
  18528: 2.22,
  18546: 2.22,
  18551: 2.22,
  18556: 2.22,
  18569: 2.22,
  18573: 2.22,
  18574: 2.22,
  18581: 2.22,
  18586: 2.22,
  18609: 2.22,
  19053: 2.22,
  19055: 2.22,
  19057: 2.22,
  19059: 2.22,
  19061: 2.22,
  19063: 2.22,
  19065: 2.22,
  19067: 2.22,
  19069: 2.22,
  19071: 2.22,
  19073: 2.22,
  19075: 2.22,
  19077: 2.22,
  19079: 2.22,
  19086: 2.22,
  19089: 2.22,
  19205: 2.22,
  19209: 2.22,
  19217: 2.22,
  19230: 2.22,
  19243: 2.22,
  19246: 2.22,
  19249: 2.22,
  19258: 2.22,
  19260: 2.22,
  19273: 2.22,
  19288: 2.22,
  19294: 2.22,
  19300: 2.22,
  19303: 2.22,
  19306: 2.22,
  19309: 2.22,
  19322: 2.22,
  19336: 2.22,
  19339: 2.22,
  19348: 2.22,
  19357: 2.22,
  19370: 2.22,
  19372: 2.22,
  19374: 2.22,
  19376: 2.22,
  19386: 2.22,
  19395: 2.22,
  19399: 2.22,
  19406: 2.22,
  19412: 2.22,
  19417: 2.22,
  20095: 2.22,
  20097: 2.22,
  20099: 2.22,
  20144: 2.22,
  20146: 2.22,
  20148: 2.22,
  20149: 2.22,
  20249: 2.22,
  20251: 2.22,
  20253: 2.22,
  20255: 2.22,
  20257: 2.22,
  20259: 2.22,
  20354: 2.22,
  20355: 2.22,
  20357: 2.22,
  20359: 2.30,
  20457: 2.42,
  20459: 2.42,
  20535: 2.42,
  20537: 2.42,
  20539: 2.42,
  21029: 2.42,
  21031: 2.42,
  21033: 2.42,
  21035: 2.42,
  21037: 2.42,
  21039: 2.42,
  21073: 2.42,
  21075: 2.42,
  21077: 2.42,
  21079: 2.42,
  21107: 2.42,
  21109: 2.42,
  21129: 2.42,
  21147: 2.42,
  21149: 2.42,
  21217: 2.42,
  21218: 2.42,
  21220: 2.42,
  21224: 2.42,
  21227: 2.42,
  21228: 2.42,
  21244: 2.42,
  21255: 2.42,
  21256: 2.42,
  21258: 2.42,
  21259: 2.42,
  21261: 2.42,
  21266: 2.42,
  21271: 2.42,
  21272: 2.42,
  21274: 2.42,
  21279: 2.42,
  21335: 2.42,
  21337: 2.42,
  21339: 2.42,
  21354: 2.42,
  21357: 2.42,
  21358: 2.42,
  21360: 2.42,
  21365: 2.42,
  21368: 2.42,
  21369: 2.42,
  21371: 2.42,
  21376: 2.42,
  21379: 2.42,
  21380: 2.42,
  21382: 2.42,
  21385: 2.42,
  21386: 2.42,
  21388: 2.42,
  21391: 2.42,
  21394: 2.42,
  21395: 2.42,
  21397: 2.42,
  21398: 2.42,
  21400: 2.42,
  21401: 2.42,
  21403: 2.42,
  21406: 2.42,
  21407: 2.42,
  21409: 2.42,
  21423: 2.42,
  21435: 2.42,
  21436: 2.42,
  21438: 2.42,
  21439: 2.42,
  21441: 2.42,
  21442: 2.42,
  21444: 2.42,
  21445: 2.42,
  21447: 2.42,
  21449: 2.42,
  21465: 2.42,
  21481: 2.42,
  21483: 2.42,
  21493: 2.42,
  21502: 2.42,
  21509: 2.42,
  21514: 2.42,
  21516: 2.42,
  21521: 2.42,
  21522: 2.42,
  21524: 2.42,
  21526: 2.42,
  21527: 2.42,
  21529: 2.42,
  21614: 2.42,
  21629: 2.42,
  21635: 2.42,
  21640: 2.42,
  21641: 2.42,
  21643: 2.42,
  21644: 2.42,
  21646: 2.42,
  21647: 2.42,
  21649: 2.42,
  21680: 2.42,
  21682: 2.42,
  21683: 2.42,
  21684: 2.42,
  21698: 2.42,
  21702: 2.42,
  21706: 2.42,
  21709: 2.42,
  21710: 2.42,
  21712: 2.42,
  21714: 2.42,
  21717: 2.42,
  21720: 2.42,
  21723: 2.42,
  21726: 2.42,
  21727: 2.42,
  21729: 2.42,
  21730: 2.42,
  21732: 2.42,
  21734: 2.42,
  21737: 2.42,
  21739: 2.42,
  21745: 2.42,
  21755: 2.42,
  21756: 2.42,
  21762: 2.42,
  21763: 2.42,
  21765: 2.42,
  21769: 2.42,
  21770: 2.42,
  21772: 2.42,
  21775: 2.42,
  21776: 2.42,
  21781: 2.42,
  21782: 2.42,
  21785: 2.42,
  21787: 2.42,
  21789: 2.42,
  22041: 2.42,
  22043: 2.42,
  22045: 2.42,
  22047: 2.42,
  22049: 2.42,
  22081: 2.42,
  22083: 2.42,
  22085: 2.42,
  22087: 2.42,
  22089: 2.42,
  22111: 2.42,
  22113: 2.42,
  22115: 2.42,
  22117: 2.42,
  22119: 2.42,
  22143: 2.42,
  22145: 2.42,
  22147: 2.42,
  22149: 2.42,
  22159: 2.42,
  22175: 2.42,
  22177: 2.42,
  22179: 2.42,
  22297: 2.42,
  22299: 2.42,
  22301: 2.42,
  22303: 2.42,
  22305: 2.42,
  22307: 2.42,
  22309: 2.42,
  22335: 2.42,
  22337: 2.42,
  22339: 2.42,
  22359: 2.42,
  22391: 2.42,
  22393: 2.42,
  22395: 2.42,
  22397: 2.42,
  22399: 2.42,
  22415: 2.42,
  22417: 2.42,
  22419: 2.42,
  22453: 2.42,
  22455: 2.42,
  22457: 2.42,
  22459: 2.42,
  22523: 2.42,
  22525: 2.42,
  22527: 2.42,
  22529: 2.42,
  22547: 2.42,
  22549: 2.42,
  22559: 2.42,
  22587: 2.42,
  22589: 2.42,
  22605: 2.42,
  22607: 2.42,
  22609: 2.42,
  22761: 2.42,
  22763: 2.42,
  22765: 2.42,
  22767: 2.42,
  22769: 2.42,
  22844: 2.42,
  22846: 2.42,
  22848: 2.42,
  22850: 2.42,
  22851: 2.42,
  22869: 2.42,
  22880: 2.42,
  22885: 2.42,
  22889: 2.42,
  22926: 2.42,
  22927: 2.42,
  22929: 2.42,
  22941: 2.42,
  22946: 2.42,
  22949: 2.42,
  22952: 2.42,
  22955: 2.42,
  22956: 2.42,
  22958: 2.42,
  22959: 2.42,
  22961: 2.42,
  22962: 2.42,
  22964: 2.42,
  22965: 2.42,
  22967: 2.42,
  22969: 2.42,
  23552: 2.42,
  23554: 2.42,
  23556: 2.42,
  23558: 2.42,
  23560: 2.42,
  23562: 2.42,
  23564: 2.42,
  23566: 2.42,
  23568: 2.42,
  23569: 2.42,
  23570: 2.42,
  23611: 2.42,
  23617: 2.42,
  23619: 2.42,
  23623: 2.42,
  23626: 2.42,
  23627: 2.42,
  23628: 2.42,
  23629: 2.42,
  23669: 2.42,
  23683: 2.42,
  23684: 2.42,
  23689: 2.42,
  23701: 2.42,
  23714: 2.42,
  23715: 2.42,
  23717: 2.42,
  23719: 2.42,
  23730: 2.42,
  23738: 2.42,
  23743: 2.42,
  23744: 2.42,
  23746: 2.42,
  23747: 2.42,
  23749: 2.42,
  23758: 2.42,
  23769: 2.42,
  23774: 2.42,
  23775: 2.42,
  23777: 2.42,
  23779: 2.42,
  23795: 2.42,
  23812: 2.42,
  23813: 2.42,
  23815: 2.42,
  23816: 2.42,
  23818: 2.42,
  23820: 2.42,
  23821: 2.42,
  23823: 2.42,
  23824: 2.42,
  23826: 2.42,
  23827: 2.42,
  23829: 2.42,
  23843: 2.42,
  23845: 2.42,
  23847: 2.42,
  23858: 2.42,
  23860: 2.42,
  23863: 2.42,
  23866: 2.42,
  23867: 2.42,
  23869: 2.42,
  23879: 2.42,
  23881: 2.42,
  23883: 2.42,
  23896: 2.42,
  23898: 2.42,
  23899: 2.42,
  23909: 2.42,
  23911: 2.42,
  23919: 2.42,
  23923: 2.42,
  23936: 2.42,
  23942: 2.42,
  23946: 2.42,
  23948: 2.42,
  23966: 2.42,
  23968: 2.42,
  23970: 2.42,
  23972: 2.42,
  23974: 2.42,
  23992: 2.42,
  23996: 2.42,
  23999: 2.42,
  24103: 2.42,
  24105: 2.42,
  24106: 2.42,
  24107: 2.42,
  24109: 2.42,
  24111: 2.42,
  24113: 2.42,
  24114: 2.42,
  24116: 2.42,
  24118: 2.42,
  24119: 2.42,
  24143: 2.42,
  24145: 2.42,
  24146: 2.42,
  24147: 2.42,
  24148: 2.42,
  24149: 2.42,
  24159: 2.42,
  24161: 2.42,
  24211: 2.42,
  24214: 2.42,
  24217: 2.42,
  24220: 2.42,
  24222: 2.42,
  24223: 2.42,
  24226: 2.42,
  24229: 2.42,
  24232: 2.42,
  24235: 2.42,
  24238: 2.42,
  24239: 2.42,
  24241: 2.42,
  24242: 2.42,
  24244: 2.42,
  24245: 2.42,
  24247: 2.42,
  24248: 2.42,
  24250: 2.42,
  24251: 2.42,
  24253: 2.42,
  24254: 2.42,
  24256: 2.42,
  24257: 2.42,
  24259: 2.42,
  24306: 2.42,
  24321: 2.42,
  24326: 2.42,
  24327: 2.42,
  24329: 2.42,
  24340: 2.42,
  24351: 2.42,
  24354: 2.42,
  24357: 2.42,
  24358: 2.42,
  24360: 2.42,
  24361: 2.42,
  24363: 2.42,
  24364: 2.42,
  24366: 2.42,
  24367: 2.42,
  24369: 2.42,
  24376: 2.42,
  24392: 2.42,
  24395: 2.42,
  24398: 2.42,
  24399: 2.42,
  24401: 2.42,
  24402: 2.42,
  24404: 2.42,
  24405: 2.42,
  24407: 2.42,
  24409: 2.42,
  24534: 2.42,
  24536: 2.42,
  24537: 2.42,
  24539: 2.42,
  24558: 2.42,
  24568: 2.42,
  24576: 2.42,
  24582: 2.42,
  24589: 2.42,
  24594: 2.42,
  24598: 2.42,
  24601: 2.42,
  24610: 2.42,
  24613: 2.42,
  24616: 2.42,
  24619: 2.42,
  24620: 2.42,
  24622: 2.42,
  24623: 2.42,
  24625: 2.42,
  24626: 2.42,
  24628: 2.42,
  24629: 2.42,
  24631: 2.42,
  24632: 2.42,
  24634: 2.42,
  24635: 2.42,
  24637: 2.42,
  24638: 2.42,
  24640: 2.42,
  24641: 2.42,
  24643: 2.42,
  24644: 2.42,
  24646: 2.42,
  24647: 2.42,
  24649: 2.42,
  24768: 2.42,
  24782: 2.42,
  24783: 2.42,
  24784: 2.42,
  24787: 2.42,
  24790: 2.42,
  24791: 2.42,
  24793: 2.42,
  24794: 2.42,
  24796: 2.42,
  24797: 2.42,
  24799: 2.42,
  24800: 2.42,
  24802: 2.42,
  24803: 2.42,
  24805: 2.42,
  24806: 2.42,
  24808: 2.42,
  24809: 2.42,
  24811: 2.42,
  24813: 2.42,
  24814: 2.42,
  24816: 2.42,
  24817: 2.42,
  24819: 2.42,
  24837: 2.42,
  24848: 2.42,
  24850: 2.42,
  24852: 2.42,
  24855: 2.42,
  24857: 2.42,
  24860: 2.42,
  24861: 2.42,
  24863: 2.42,
  24864: 2.42,
  24866: 2.42,
  24867: 2.42,
  24869: 2.42,
  24870: 2.42,
  24872: 2.42,
  24873: 2.42,
  24876: 2.42,
  24878: 2.42,
  24879: 2.42,
  24881: 2.42,
  24882: 2.42,
  24884: 2.42,
  24885: 2.42,
  24887: 2.42,
  24888: 2.42,
  24890: 2.42,
  24891: 2.42,
  24893: 2.42,
  24894: 2.42,
  24896: 2.42,
  24897: 2.42,
  24899: 2.42,
  24937: 2.42,
  24939: 2.54,
  24941: 2.34,
  24943: 2.34,
  24944: 2.34,
  24955: 2.34,
  24960: 2.34,
  24963: 2.34,
  24966: 2.34,
  24969: 2.34,
  24972: 2.34,
  24975: 2.34,
  24976: 2.34,
  24977: 2.34,
  24980: 2.34,
  24983: 2.34,
  24986: 2.34,
  24988: 2.34,
  24989: 2.34,
  24991: 2.34,
  24992: 2.34,
  24994: 2.34,
  24996: 2.34,
  24997: 2.34,
  24999: 2.34,
  25335: 2.34,
  25336: 2.34,
  25337: 2.34,
  25348: 2.34,
  25355: 2.34,
  25358: 2.34,
  25361: 2.34,
  25364: 2.34,
  25365: 2.34,
  25368: 2.34,
  25370: 2.34,
  25371: 2.34,
  25373: 2.34,
  25376: 2.34,
  25377: 2.34,
  25379: 2.34,
  25421: 2.34,
  25436: 2.34,
  25451: 2.34,
  25462: 2.34,
  25469: 2.34,
  25474: 2.34,
  25479: 2.34,
  25482: 2.34,
  25485: 2.34,
  25486: 2.34,
  25488: 2.34,
  25489: 2.34,
  25491: 2.34,
  25492: 2.34,
  25494: 2.34,
  25495: 2.34,
  25497: 2.34,
  25499: 2.34,
  25524: 2.34,
  25541: 2.34,
  25548: 2.34,
  25551: 2.34,
  25554: 2.34,
  25557: 2.34,
  25560: 2.34,
  25563: 2.34,
  25566: 2.34,
  25569: 2.34,
  25572: 2.34,
  25573: 2.34,
  25575: 2.34,
  25576: 2.34,
  25578: 2.34,
  25579: 2.34,
  25581: 2.34,
  25582: 2.34,
  25584: 2.34,
  25585: 2.34,
  25587: 2.34,
  25588: 2.34,
  25590: 2.34,
  25591: 2.34,
  25593: 2.34,
  25594: 2.34,
  25596: 2.34,
  25597: 2.34,
  25599: 2.34,
  25693: 2.34,
  25704: 2.34,
  25709: 2.34,
  25712: 2.34,
  25715: 2.34,
  25718: 2.34,
  25719: 2.34,
  25721: 2.34,
  25724: 2.34,
  25725: 2.34,
  25727: 2.34,
  25729: 2.34,
  25746: 2.34,
  25761: 2.34,
  25764: 2.34,
  25767: 2.34,
  25770: 2.34,
  25774: 2.34,
  25776: 2.34,
  25779: 2.34,
  25782: 2.34,
  25785: 2.34,
  25786: 2.34,
  25788: 2.34,
  25791: 2.34,
  25792: 2.34,
  25794: 2.34,
  25795: 2.34,
  25797: 2.34,
  25799: 2.34,
  25813: 2.34,
  25821: 2.34,
  25826: 2.34,
  25832: 2.34,
  25836: 2.34,
  25840: 2.34,
  25842: 2.34,
  25845: 2.34,
  25849: 2.34,
  25850: 2.34,
  25852: 2.34,
  25853: 2.34,
  25855: 2.34,
  25856: 2.34,
  25858: 2.34,
  25859: 2.34,
  25860: 2.34,
  25862: 2.34,
  25863: 2.34,
  25864: 2.34,
  25866: 2.34,
  25869: 2.34,
  25870: 2.34,
  25872: 2.34,
  25873: 2.34,
  25876: 2.34,
  25878: 2.34,
  25879: 2.34,
  25881: 2.34,
  25882: 2.34,
  25884: 2.34,
  25885: 2.34,
  25887: 2.34,
  25889: 2.34,
  25899: 2.34,
  25917: 2.34,
  25920: 2.34,
  25923: 2.34,
  25924: 2.34,
  25926: 2.34,
  25927: 2.34,
  25938: 2.34,
  25946: 2.34,
  25980: 2.34,
  25992: 2.34,
  25996: 2.34,
  25997: 2.34,
  25999: 2.34,
  26121: 2.34,
  26122: 2.34,
  26123: 2.34,
  26125: 2.34,
  26127: 2.34,
  26129: 2.34,
  26131: 2.34,
  26133: 2.34,
  26135: 2.34,
  26160: 2.34,
  26169: 2.34,
  26180: 2.34,
  26188: 2.34,
  26197: 2.34,
  26203: 2.34,
  26209: 2.34,
  26215: 2.34,
  26219: 2.34,
  26316: 2.34,
  26340: 2.34,
  26345: 2.34,
  26349: 2.34,
  26382: 2.34,
  26384: 2.34,
  26386: 2.34,
  26388: 2.34,
  26389: 2.34,
  26409: 2.34,
  26419: 2.34,
  26427: 2.34,
  26434: 2.34,
  26441: 2.34,
  26446: 2.34,
  26452: 2.34,
  26487: 2.34,
  26489: 2.34,
  26506: 2.34,
  26524: 2.34,
  26529: 2.34,
  26532: 2.34,
  26548: 2.34,
  26553: 2.34,
  26556: 2.34,
  26603: 2.34,
  26605: 2.34,
  26607: 2.34,
  26624: 2.34,
  26629: 2.34,
  26632: 2.34,
  26639: 2.34,
  26655: 2.34,
  26670: 2.34,
  26676: 2.34,
  26683: 2.34,
  26689: 2.34,
  26721: 2.34,
  26723: 2.34,
  26725: 2.34,
  26736: 2.34,
  26757: 2.34,
  26759: 2.34,
  26789: 2.34,
  26802: 2.34,
  26810: 2.34,
  26817: 2.34,
  26826: 2.34,
  26831: 2.34,
  26835: 2.34,
  26842: 2.34,
  26844: 2.34,
  26845: 2.34,
  26847: 2.34,
  26849: 2.34,
  26871: 2.34,
  26892: 2.34,
  26897: 2.34,
  26899: 2.34,
  26901: 2.34,
  26903: 2.34,
  26904: 2.34,
  26906: 2.34,
  26907: 2.34,
  26909: 2.34,
  26919: 2.34,
  26931: 2.34,
  26935: 2.34,
  26936: 2.34,
  26937: 2.34,
  26939: 2.34,
  26954: 2.34,
  26969: 2.34,
  27211: 2.34,
  27232: 2.34,
  27239: 2.34,
  27243: 2.34,
  27245: 2.34,
  27246: 2.34,
  27248: 2.34,
  27249: 2.34,
  27251: 2.34,
  27252: 2.34,
  27254: 2.34,
  27257: 2.34,
  27259: 2.34,
  27283: 2.34,
  27299: 2.34,
  27305: 2.34,
  27308: 2.34,
  27313: 2.34,
  27318: 2.34,
  27321: 2.34,
  27324: 2.34,
  27327: 2.34,
  27330: 2.34,
  27333: 2.34,
  27336: 2.34,
  27337: 2.34,
  27339: 2.34,
  27356: 2.34,
  27367: 2.34,
  27374: 2.34,
  27383: 2.34,
  27386: 2.34,
  27389: 2.34,
  27404: 2.34,
  27412: 2.34,
  27419: 2.34,
  27432: 2.34,
  27442: 2.34,
  27446: 2.34,
  27449: 2.34,
  27472: 2.34,
  27474: 2.34,
  27476: 2.34,
  27478: 2.34,
  27568: 2.34,
  27570: 2.34,
  27572: 2.34,
  27574: 2.34,
  27576: 2.34,
  27578: 2.34,
  27580: 2.34,
  27607: 2.34,
  27612: 2.34,
  27616: 2.34,
  27619: 2.34,
  27624: 2.34,
  27628: 2.34,
  27639: 2.34,
  27711: 2.34,
  27721: 2.34,
  27726: 2.34,
  27729: 2.34,
  27749: 2.34,
  27751: 2.34,
  27753: 2.34,
  27755: 2.34,
  27777: 2.34,
  27793: 2.34,
  27798: 2.34,
  27801: 2.34,
  27804: 2.34,
  27809: 2.34,
  28195: 2.34,
  28197: 2.34,
  28199: 2.34,
  28201: 2.34,
  28203: 2.34,
  28205: 2.34,
  28207: 2.34,
  28209: 2.34,
  28211: 2.34,
  28213: 2.34,
  28215: 2.34,
  28217: 2.34,
  28219: 2.34,
  28237: 2.34,
  28239: 2.34,
  28259: 2.34,
  28277: 2.34,
  28279: 2.34,
  28307: 2.34,
  28309: 2.34,
  28325: 2.34,
  28327: 2.34,
  28329: 2.34,
  28355: 2.34,
  28357: 2.34,
  28359: 2.34,
  28717: 2.34,
  28719: 2.34,
  28755: 2.34,
  28757: 2.34,
  28759: 2.34,
  28777: 2.34,
  28779: 2.34,
  28790: 2.34,
  28816: 2.34,
  28832: 2.34,
  28844: 2.34,
  28857: 2.34,
  28865: 2.34,
  28870: 2.34,
  28876: 2.34,
  28879: 2.34,
  29221: 2.34,
  29223: 2.34,
  29225: 2.34,
  29227: 2.34,
  29229: 2.34,
  29303: 2.34,
  29308: 2.34,
  29313: 2.34,
  29320: 2.34,
  29323: 2.34,
  29328: 2.34,
  29331: 2.34,
  29336: 2.34,
  29339: 2.34,
  29342: 2.34,
  29345: 2.34,
  29348: 2.34,
  29351: 2.34,
  29352: 2.34,
  29353: 2.34,
  29355: 2.34,
  29356: 2.34,
  29358: 2.34,
  29359: 2.34,
  29361: 2.34,
  29362: 2.34,
  29364: 2.34,
  29365: 2.34,
  29367: 2.34,
  29369: 2.34,
  29378: 2.34,
  29379: 2.34,
  29386: 2.34,
  29389: 2.34,
  29392: 2.34,
  29393: 2.34,
  29394: 2.34,
  29396: 2.34,
  29399: 2.34,
  29410: 2.34,
  29413: 2.34,
  29416: 2.34,
  29439: 2.34,
  29451: 2.34,
  29456: 2.34,
  29459: 2.34,
  29462: 2.34,
  29465: 2.34,
  29468: 2.34,
  29471: 2.34,
  29472: 2.34,
  29473: 2.34,
  29475: 2.34,
  29476: 2.34,
  29478: 2.34,
  29479: 2.34,
  29481: 2.34,
  29482: 2.34,
  29484: 2.34,
  29485: 2.34,
  29487: 2.34,
  29488: 2.34,
  29490: 2.34,
  29491: 2.34,
  29493: 2.34,
  29494: 2.34,
  29496: 2.34,
  29497: 2.34,
  29499: 2.34,
  29525: 2.34,
  29549: 2.34,
  29553: 2.34,
  29556: 2.34,
  29559: 2.34,
  29562: 2.34,
  29565: 2.34,
  29571: 2.34,
  29574: 2.34,
  29575: 2.34,
  29576: 2.34,
  29578: 2.34,
  29579: 2.34,
  29581: 2.34,
  29582: 2.34,
  29584: 2.34,
  29585: 2.34,
  29587: 2.34,
  29588: 2.34,
  29590: 2.34,
  29591: 2.34,
  29593: 2.34,
  29594: 2.34,
  29597: 2.34,
  29599: 2.34,
  29614: 2.34,
  29633: 2.34,
  29640: 2.34,
  29643: 2.34,
  29646: 2.34,
  29649: 2.34,
  29664: 2.34,
  29683: 2.34,
  29690: 2.34,
  29693: 2.34,
  29699: 2.34,
  30159: 2.34,
  30161: 2.34,
  30163: 2.34,
  30165: 2.15,
  30167: 2.12,
  30169: 2.12,
  30171: 2.12,
  30173: 2.12,
  30175: 2.12,
  30177: 2.12,
  30179: 2.12,
  30419: 2.12,
  30449: 2.12,
  30451: 2.12,
  30453: 2.12,
  30455: 2.12,
  30457: 2.12,
  30459: 2.12,
  30519: 2.12,
  30521: 2.12,
  30539: 2.12,
  30559: 2.12,
  30625: 2.12,
  30627: 2.12,
  30629: 2.12,
  30655: 2.12,
  30657: 2.12,
  30659: 2.12,
  30669: 2.12,
  30823: 2.12,
  30826: 2.12,
  30827: 2.12,
  30851: 2.12,
  30853: 2.12,
  30855: 2.12,
  30880: 2.12,
  30890: 2.12,
  30900: 2.12,
  30916: 2.12,
  30926: 2.12,
  30938: 2.12,
  30952: 2.12,
  30966: 2.12,
  30974: 2.12,
  30982: 2.12,
  30989: 2.12,
  31008: 2.12,
  31020: 2.12,
  31028: 2.12,
  31036: 2.12,
  31061: 2.12,
  31073: 2.12,
  31079: 2.12,
  31084: 2.12,
  31089: 2.12,
  31134: 2.12,
  31135: 2.12,
  31137: 2.12,
  31139: 2.12,
  31141: 2.12,
  31157: 2.12,
  31162: 2.12,
  31167: 2.12,
  31171: 2.12,
  31174: 2.12,
  31177: 2.12,
  31180: 2.12,
  31185: 2.12,
  31188: 2.12,
  31191: 2.12,
  31195: 2.12,
  31199: 2.12,
  31224: 2.12,
  31226: 2.12,
  31228: 2.12,
  31234: 2.12,
  31241: 2.12,
  31246: 2.12,
  31249: 2.12,
  31275: 2.12,
  31303: 2.12,
  31311: 2.12,
  31319: 2.12,
  31515: 2.12,
  31535: 2.12,
  31542: 2.12,
  31547: 2.12,
  31552: 2.12,
  31553: 2.12,
  31555: 2.12,
  31556: 2.12,
  31558: 2.12,
  31559: 2.12,
  31582: 2.12,
  31592: 2.12,
  31595: 2.12,
  31600: 2.12,
  31603: 2.12,
  31604: 2.12,
  31606: 2.12,
  31608: 2.12,
  31609: 2.12,
  31613: 2.12,
  31618: 2.12,
  31619: 2.12,
  31621: 2.12,
  31622: 2.12,
  31623: 2.12,
  31626: 2.12,
  31627: 2.12,
  31628: 2.12,
  31629: 2.12,
  31632: 2.12,
  31633: 2.12,
  31634: 2.12,
  31636: 2.12,
  31637: 2.12,
  31638: 2.12,
  31655: 2.12,
  31675: 2.12,
  31683: 2.12,
  31688: 2.12,
  31691: 2.12,
  31693: 2.12,
  31698: 2.12,
  31699: 2.12,
  31700: 2.12,
  31702: 2.12,
  31707: 2.12,
  31708: 2.12,
  31710: 2.12,
  31711: 2.12,
  31712: 2.12,
  31714: 2.12,
  31715: 2.12,
  31717: 2.12,
  31718: 2.12,
  31719: 2.12,
  31737: 2.12,
  31749: 2.12,
  31785: 2.12,
  31787: 2.12,
  31789: 2.12,
  31812: 2.12,
  31832: 2.12,
  31840: 2.12,
  31848: 2.12,
  31855: 2.12,
  31860: 2.12,
  31863: 2.12,
  31867: 2.12,
  31868: 2.12,
  32049: 2.12,
  32051: 2.12,
  32052: 2.12,
  32105: 2.12,
  32107: 2.12,
  32108: 2.12,
  32120: 2.12,
  32130: 2.12,
  32139: 2.12,
  32257: 2.12,
  32278: 2.12,
  32289: 2.12,
  32312: 2.12,
  32339: 2.12,
  32351: 2.12,
  32361: 2.12,
  32369: 2.12,
  32423: 2.12,
  32425: 2.12,
  32427: 2.12,
  32429: 2.12,
  32457: 2.12,
  32469: 2.12,
  32479: 2.12,
  32545: 2.12,
  32547: 2.12,
  32549: 2.12,
  32584: 2.12,
  32602: 2.12,
  32609: 2.12,
  32657: 2.12,
  32676: 2.12,
  32683: 2.12,
  32689: 2.12,
  32694: 2.12,
  32699: 2.12,
  32756: 2.12,
  32758: 2.12,
  32760: 2.12,
  32791: 2.12,
  32805: 2.12,
  32816: 2.12,
  32825: 2.12,
  32832: 2.12,
  32839: 2.12,
  33014: 2.12,
  33034: 2.12,
  33039: 2.12,
  33098: 2.12,
  33100: 2.12,
  33102: 2.12,
  33104: 2.12,
  33106: 2.12,
  33129: 2.12,
  33142: 2.12,
  33154: 2.12,
  33161: 2.12,
  33165: 2.12,
  33175: 2.12,
  33178: 2.12,
  33181: 2.12,
  33184: 2.12,
  33189: 2.12,
  33330: 2.12,
  33332: 2.12,
  33333: 2.12,
  33334: 2.12,
  33335: 2.12,
  33378: 2.12,
  33397: 2.12,
  33415: 2.12,
  33428: 2.12,
  33442: 2.12,
  33449: 2.12,
  33602: 2.12,
  33604: 2.12,
  33605: 2.12,
  33607: 2.12,
  33609: 2.12,
  33611: 2.12,
  33613: 2.12,
  33615: 2.12,
  33617: 2.12,
  33619: 2.12,
  33647: 2.12,
  33649: 2.12,
  33659: 2.12,
  33689: 2.12,
  33699: 2.12,
  33719: 2.12,
  33729: 2.12,
  33739: 2.12,
  33758: 2.12,
  33775: 2.12,
  33790: 2.12,
  33803: 2.12,
  33813: 2.12,
  33818: 2.12,
  33824: 2.12,
  33829: 2.12,
  34117: 2.12,
  34119: 2.12,
  34121: 2.12,
  34123: 2.10,
  34125: 2.12,
  34127: 2.12,
  34128: 2.12,
  34130: 2.12,
  34131: 2.12,
  34132: 2.12,
  34134: 2.12,
  34212: 2.12,
  34225: 2.12,
  34233: 2.12,
  34246: 2.12,
  34253: 2.12,
  34260: 2.12,
  34266: 2.12,
  34270: 2.12,
  34277: 2.12,
  34281: 2.12,
  34286: 2.12,
  34289: 2.12,
  34292: 2.12,
  34295: 2.12,
  34298: 2.12,
  34302: 2.12,
  34305: 2.12,
  34308: 2.12,
  34311: 2.12,
  34314: 2.12,
  34317: 2.12,
  34320: 2.12,
  34323: 2.12,
  34326: 2.12,
  34327: 2.12,
  34329: 2.12,
  34346: 2.12,
  34355: 2.12,
  34359: 2.12,
  34369: 2.12,
  34376: 2.12,
  34379: 2.12,
  34385: 2.12,
  34388: 2.12,
  34393: 2.12,
  34396: 2.12,
  34399: 2.12,
  34414: 2.12,
  34431: 2.12,
  34434: 2.12,
  34439: 2.12,
  34454: 2.12,
  34466: 2.12,
  34471: 2.12,
  34474: 2.12,
  34477: 2.12,
  34479: 2.12,
  34497: 2.12,
  34508: 2.12,
  34513: 2.12,
  34516: 2.12,
  34519: 2.12,
  34537: 2.12,
  34549: 2.12,
  34560: 2.12,
  34576: 2.12,
  34582: 2.12,
  34587: 2.12,
  34590: 2.12,
  34593: 2.12,
  34596: 2.12,
  34599: 2.12,
  34613: 2.12,
  34621: 2.12,
  34626: 2.12,
  34628: 2.12,
  34630: 2.12,
  34632: 2.12,
  34633: 2.12,
  34637: 2.12,
  34639: 2.12,
  35037: 2.12,
  35039: 2.12,
  35041: 2.12,
  35043: 2.12,
  35066: 2.12,
  35075: 2.12,
  35080: 2.12,
  35083: 2.12,
  35085: 2.12,
  35088: 2.12,
  35091: 2.12,
  35094: 2.12,
  35096: 2.12,
  35099: 2.12,
  35102: 2.12,
  35104: 2.12,
  35108: 2.12,
  35110: 2.12,
  35112: 2.12,
  35114: 2.12,
  35116: 2.12,
  35117: 2.12,
  35119: 2.12,
  35216: 2.12,
  35232: 2.12,
  35236: 2.12,
  35239: 2.12,
  35260: 2.12,
  35274: 2.12,
  35279: 2.12,
  35282: 2.12,
  35285: 2.12,
  35287: 2.12,
  35288: 2.12,
  35305: 2.12,
  35315: 2.12,
  35321: 2.12,
  35325: 2.12,
  35327: 2.12,
  35329: 2.12,
  35390: 2.12,
  35392: 2.12,
  35394: 2.12,
  35396: 2.12,
  35398: 2.12,
  35410: 2.12,
  35415: 2.12,
  35418: 2.12,
  35423: 2.12,
  35428: 2.12,
  35435: 2.12,
  35440: 2.12,
  35444: 2.12,
  35447: 2.12,
  35452: 2.12,
  35457: 2.12,
  35460: 2.12,
  35463: 2.12,
  35466: 2.12,
  35469: 2.12,
  35510: 2.12,
  35516: 2.12,
  35519: 2.12,
  35576: 2.12,
  35578: 2.12,
  35579: 2.12,
  35580: 2.12,
  35581: 2.12,
  35582: 2.12,
  35583: 2.12,
  35584: 2.12,
  35585: 2.12,
  35586: 2.12,
  35606: 2.12,
  35614: 2.12,
  35619: 2.12,
  35625: 2.12,
  35630: 2.12,
  35633: 2.12,
  35638: 2.12,
  35641: 2.12,
  35644: 2.12,
  35647: 2.12,
  35649: 2.12,
  35683: 2.12,
  35684: 2.12,
  35685: 2.12,
  35686: 2.12,
  35687: 2.12,
  35688: 2.12,
  35689: 2.12,
  35690: 2.12,
  35708: 2.12,
  35713: 2.12,
  35716: 2.12,
  35719: 2.12,
  35745: 2.12,
  35753: 2.12,
  35756: 2.12,
  35759: 2.12,
  35764: 2.12,
  35767: 2.12,
  35768: 2.12,
  35781: 2.12,
  35789: 2.12,
  35792: 2.12,
  35794: 2.12,
  35796: 2.12,
  35799: 2.12,
  36037: 2.12,
  36039: 2.12,
  36041: 2.12,
  36043: 2.12,
  36088: 2.12,
  36093: 2.12,
  36100: 2.12,
  36103: 2.12,
  36110: 2.12,
  36115: 2.12,
  36119: 2.12,
  36124: 2.12,
  36129: 2.12,
  36132: 2.12,
  36137: 2.12,
  36142: 2.12,
  36145: 2.12,
  36148: 2.12,
  36151: 2.12,
  36154: 2.12,
  36157: 2.12,
  36160: 2.12,
  36163: 2.12,
  36166: 2.12,
  36167: 2.12,
  36169: 2.12,
  36179: 2.12,
  36199: 2.12,
  36205: 2.12,
  36208: 2.12,
  36211: 2.12,
  36214: 2.12,
  36217: 2.12,
  36219: 2.12,
  36251: 2.12,
  36266: 2.12,
  36269: 2.12,
  36272: 2.12,
  36275: 2.12,
  36277: 2.12,
  36280: 2.12,
  36282: 2.12,
  36284: 2.12,
  36286: 2.12,
  36287: 2.12,
  36289: 2.12,
  36304: 2.12,
  36318: 2.12,
  36320: 2.12,
  36323: 2.12,
  36325: 2.12,
  36326: 2.12,
  36329: 2.12,
  36341: 2.12,
  36355: 2.12,
  36358: 2.12,
  36364: 2.12,
  36367: 2.12,
  36369: 2.12,
  36381: 2.12,
  36391: 2.12,
  36396: 2.12,
  36399: 2.12,
  36404: 2.12,
  36414: 2.12,
  36419: 2.12,
  36433: 2.12,
  36448: 2.12,
  36452: 2.12,
  36456: 2.12,
  36457: 2.12,
  36460: 2.12,
  36466: 2.12,
  36469: 2.12,
  37073: 2.12,
  37075: 2.12,
  37077: 2.12,
  37079: 2.12,
  37081: 2.12,
  37083: 2.12,
  37085: 2.12,
  37115: 2.12,
  37120: 2.12,
  37124: 2.12,
  37127: 2.12,
  37130: 2.12,
  37133: 2.12,
  37136: 2.12,
  37139: 2.12,
  37154: 2.12,
  37170: 2.12,
  37176: 2.12,
  37181: 2.12,
  37186: 2.12,
  37191: 2.12,
  37194: 2.12,
  37197: 2.12,
  37199: 2.12,
  37213: 2.12,
  37214: 2.12,
  37215: 2.12,
  37216: 2.12,
  37217: 2.12,
  37218: 2.12,
  37235: 2.12,
  37242: 2.12,
  37247: 2.12,
  37249: 2.12,
  37269: 2.12,
  37276: 2.12,
  37281: 2.12,
  37284: 2.12,
  37287: 2.12,
  37290: 2.12,
  37293: 2.12,
  37296: 2.12,
  37297: 2.12,
  37299: 2.12,
  37308: 2.12,
  37318: 2.12,
  37327: 2.12,
  37339: 2.12,
  37345: 2.12,
  37351: 2.12,
  37355: 2.12,
  37359: 2.12,
  37412: 2.12,
  37431: 2.12,
  37434: 2.12,
  37441: 2.12,
  37444: 2.12,
  37445: 2.12,
  37520: 2.12,
  37539: 2.12,
  37574: 2.12,
  37581: 2.12,
  37586: 2.12,
  37589: 2.12,
  37603: 2.12,
  37619: 2.12,
  37620: 2.12,
  37627: 2.12,
  37632: 2.12,
  37633: 2.12,
  37635: 2.12,
  37639: 2.12,
  37640: 2.12,
  37642: 2.12,
  37643: 2.12,
  37647: 2.12,
  37649: 2.12,
  37671: 2.12,
  37688: 2.12,
  37691: 2.12,
  37696: 2.12,
  37697: 2.12,
  37699: 2.12,
  38100: 2.12,
  38102: 2.12,
  38104: 2.12,
  38106: 2.12,
  38108: 2.12,
  38110: 2.12,
  38112: 2.12,
  38114: 2.12,
  38116: 2.12,
  38118: 2.12,
  38120: 2.12,
  38122: 2.12,
  38124: 2.12,
  38126: 2.12,
  38154: 2.12,
  38159: 2.12,
  38162: 2.12,
  38165: 2.12,
  38170: 2.12,
  38173: 2.12,
  38176: 2.12,
  38179: 2.12,
  38226: 2.12,
  38228: 2.12,
  38229: 2.12,
  38239: 2.12,
  38259: 2.12,
  38268: 2.12,
  38271: 2.12,
  38272: 2.12,
  38274: 2.12,
  38275: 2.12,
  38277: 2.12,
  38279: 2.12,
  38300: 2.12,
  38302: 2.12,
  38304: 2.12,
  38312: 2.12,
  38315: 2.12,
  38319: 2.12,
  38321: 2.12,
  38322: 2.12,
  38324: 2.12,
  38325: 2.12,
  38327: 2.12,
  38329: 2.12,
  38350: 2.12,
  38364: 2.12,
  38368: 2.12,
  38372: 2.12,
  38373: 2.12,
  38375: 2.12,
  38376: 2.12,
  38378: 2.12,
  38379: 2.12,
  38381: 2.12,
  38382: 2.12,
  38384: 2.12,
  38387: 2.12,
  38440: 2.12,
  38442: 2.12,
  38444: 2.12,
  38446: 2.12,
  38448: 2.12,
  38458: 2.12,
  38459: 2.12,
  38461: 2.12,
  38462: 2.12,
  38464: 2.12,
  38465: 2.12,
  38467: 2.12,
  38468: 2.12,
  38470: 2.12,
  38471: 2.12,
  38473: 2.12,
  38474: 2.12,
  38476: 2.12,
  38477: 2.12,
  38479: 2.12,
  38486: 2.12,
  38489: 2.12,
  38518: 2.12,
  38524: 2.12,
  38527: 2.12,
  38528: 2.12,
  38530: 2.12,
  38531: 2.12,
  38533: 2.12,
  38536: 2.12,
  38539: 2.12,
  38542: 2.12,
  38543: 2.12,
  38547: 2.12,
  38550: 2.12,
  38551: 2.12,
  38553: 2.12,
  38554: 2.12,
  38556: 2.12,
  38557: 2.12,
  38559: 2.12,
  38640: 2.12,
  38642: 2.12,
  38644: 2.12,
  38667: 2.12,
  38678: 2.12,
  38685: 2.12,
  38690: 2.12,
  38700: 2.12,
  38704: 2.12,
  38707: 2.12,
  38709: 2.12,
  38723: 2.12,
  38729: 2.12,
  38820: 2.12,
  38822: 2.12,
  38828: 2.12,
  38829: 2.12,
  38835: 2.12,
  38836: 2.12,
  38838: 2.12,
  38855: 2.12,
  38871: 2.12,
  38875: 2.12,
  38877: 2.12,
  38879: 2.12,
  38889: 2.12,
  38895: 2.12,
  38899: 2.12,
  39104: 2.12,
  39106: 2.12,
  39108: 2.12,
  39110: 2.12,
  39112: 2.12,
  39114: 2.12,
  39116: 2.12,
  39118: 2.12,
  39120: 2.12,
  39122: 2.12,
  39124: 2.12,
  39126: 2.12,
  39128: 2.12,
  39130: 2.12,
  39164: 2.12,
  39167: 2.12,
  39171: 2.12,
  39175: 2.12,
  39179: 2.12,
  39217: 2.12,
  39218: 2.12,
  39221: 2.12,
  39240: 2.12,
  39245: 2.12,
  39249: 2.12,
  39261: 2.12,
  39264: 2.12,
  39279: 2.12,
  39288: 2.12,
  39291: 2.12,
  39307: 2.12,
  39317: 2.12,
  39319: 2.12,
  39326: 2.12,
  39340: 2.12,
  39343: 2.12,
  39345: 2.12,
  39356: 2.12,
  39359: 2.12,
  39365: 2.12,
  39387: 2.12,
  39393: 2.12,
  39397: 2.12,
  39418: 2.12,
  39435: 2.12,
  39439: 2.12,
  39443: 2.12,
  39444: 2.12,
  39446: 2.12,
  39448: 2.12,
  39517: 2.12,
  39524: 2.12,
  39539: 2.12,
  39576: 2.12,
  39579: 2.12,
  39590: 2.12,
  39596: 2.12,
  39606: 2.12,
  39615: 2.12,
  39619: 2.12,
  39624: 2.12,
  39628: 2.12,
  39629: 2.12,
  39638: 2.12,
  39646: 2.12,
  39649: 2.12,
  40210: 2.12,
  40211: 2.12,
  40212: 2.12,
  40213: 2.12,
  40215: 2.12,
  40217: 2.12,
  40219: 2.12,
  40221: 2.12,
  40223: 2.12,
  40225: 2.12,
  40227: 2.12,
  40229: 2.12,
  40231: 2.12,
  40233: 2.12,
  40235: 2.12,
  40237: 2.12,
  40239: 2.12,
  40468: 2.12,
  40470: 2.12,
  40472: 2.12,
  40474: 2.12,
  40476: 2.12,
  40477: 2.12,
  40479: 2.12,
  40489: 2.12,
  40545: 2.12,
  40547: 2.12,
  40549: 2.12,
  40589: 2.12,
  40591: 2.12,
  40593: 2.12,
  40595: 2.12,
  40597: 2.12,
  40599: 2.12,
  40625: 2.12,
  40627: 2.12,
  40629: 2.12,
  40667: 2.12,
  40668: 2.12,
  40670: 2.12,
  40699: 2.12,
  40721: 2.12,
  40723: 2.12,
  40724: 2.12,
  40764: 2.12,
  40789: 2.12,
  40822: 2.12,
  40878: 2.12,
  40880: 2.12,
  40882: 2.12,
  40883: 2.12,
  40885: 2.12,
  41061: 2.12,
  41063: 2.12,
  41065: 2.12,
  41066: 2.12,
  41068: 2.12,
  41069: 2.12,
  41169: 2.12,
  41179: 2.12,
  41189: 2.12,
  41199: 2.12,
  41236: 2.12,
  41238: 2.12,
  41239: 2.12,
  41334: 2.12,
  41352: 2.12,
  41363: 2.12,
  41366: 2.12,
  41372: 2.12,
  41379: 2.12,
  41460: 2.12,
  41462: 2.12,
  41464: 2.12,
  41466: 2.12,
  41468: 2.12,
  41469: 2.12,
  41470: 2.12,
  41472: 2.12,
  41515: 2.12,
  41516: 2.12,
  41517: 2.12,
  41539: 2.12,
  41540: 2.12,
  41541: 2.12,
  41542: 2.12,
  41564: 2.12,
  41569: 2.12,
  41747: 2.12,
  41748: 2.12,
  41749: 2.12,
  41751: 2.12,
  41812: 2.12,
  41836: 2.12,
  41844: 2.12,
  41849: 2.12,
  42103: 2.12,
  42105: 2.12,
  42107: 2.12,
  42109: 2.12,
  42111: 2.12,
  42113: 2.12,
  42115: 2.12,
  42117: 2.12,
  42119: 2.12,
  42275: 2.12,
  42277: 2.12,
  42279: 2.12,
  42281: 2.12,
  42283: 2.12,
  42285: 2.12,
  42287: 2.12,
  42289: 2.12,
  42327: 2.12,
  42329: 2.12,
  42349: 2.12,
  42369: 2.12,
  42389: 2.12,
  42399: 2.12,
  42477: 2.12,
  42489: 2.12,
  42499: 2.12,
  42549: 2.12,
  42551: 2.12,
  42553: 2.12,
  42555: 2.12,
  42579: 2.12,
  42651: 2.12,
  42653: 2.12,
  42655: 2.12,
  42657: 2.12,
  42659: 2.12,
  42697: 2.12,
  42699: 2.12,
  42719: 2.12,
  42781: 2.12,
  42799: 2.12,
  42853: 2.12,
  42855: 2.12,
  42857: 2.12,
  42859: 2.12,
  42897: 2.12,
  42899: 2.12,
  42929: 2.12,
  44135: 2.12,
  44137: 2.12,
  44139: 2.12,
  44141: 2.12,
  44143: 2.12,
  44145: 2.12,
  44147: 2.12,
  44149: 2.12,
  44225: 2.12,
  44227: 2.12,
  44229: 2.12,
  44263: 2.12,
  44265: 2.12,
  44267: 2.12,
  44269: 2.12,
  44287: 2.12,
  44289: 2.12,
  44309: 2.12,
  44319: 2.12,
  44328: 2.12,
  44329: 2.12,
  44339: 2.12,
  44357: 2.12,
  44359: 2.12,
  44369: 2.12,
  44379: 2.12,
  44388: 2.12,
  44532: 2.12,
  44534: 2.12,
  44536: 2.12,
  44575: 2.12,
  44577: 2.12,
  44579: 2.12,
  44581: 2.12,
  44623: 2.12,
  44625: 2.12,
  44627: 2.12,
  44628: 2.12,
  44629: 2.12,
  44649: 2.12,
  44651: 2.12,
  44652: 2.12,
  44653: 2.12,
  44787: 2.12,
  44789: 2.12,
  44791: 2.12,
  44793: 2.12,
  44795: 2.12,
  44797: 2.12,
  44799: 2.12,
  44801: 2.12,
  44803: 2.12,
  44805: 2.12,
  44807: 2.12,
  44809: 2.12,
  44866: 2.12,
  44867: 2.12,
  44869: 2.12,
  44879: 2.12,
  44892: 2.12,
  44894: 2.12,
  45127: 2.12,
  45128: 2.12,
  45130: 2.12,
  45131: 2.15,
  45133: 2.04,
  45134: 2.04,
  45136: 2.04,
  45138: 2.04,
  45139: 2.04,
  45141: 2.04,
  45143: 2.04,
  45144: 2.04,
  45145: 2.04,
  45147: 2.04,
  45149: 2.04,
  45219: 2.04,
  45239: 2.04,
  45257: 2.04,
  45259: 2.04,
  45276: 2.04,
  45277: 2.04,
  45279: 2.04,
  45289: 2.04,
  45307: 2.04,
  45309: 2.04,
  45326: 2.04,
  45327: 2.04,
  45329: 2.04,
  45355: 2.04,
  45356: 2.04,
  45357: 2.04,
  45359: 2.04,
  45468: 2.04,
  45470: 2.04,
  45472: 2.04,
  45473: 2.04,
  45475: 2.04,
  45476: 2.04,
  45478: 2.04,
  45479: 2.04,
  45481: 2.04,
  45525: 2.04,
  45527: 2.04,
  45529: 2.04,
  45549: 2.04,
  45657: 2.04,
  45659: 2.04,
  45661: 2.04,
  45663: 2.04,
  45665: 2.04,
  45699: 2.04,
  45701: 2.04,
  45711: 2.04,
  45721: 2.04,
  45731: 2.04,
  45739: 2.04,
  45768: 2.04,
  45770: 2.04,
  45772: 2.04,
  45879: 2.04,
  45881: 2.04,
  45883: 2.04,
  45884: 2.04,
  45886: 2.04,
  45888: 2.04,
  45889: 2.04,
  45891: 2.04,
  45892: 2.04,
  45894: 2.04,
  45896: 2.04,
  45897: 2.04,
  45899: 2.04,
  45964: 2.04,
  45966: 2.04,
  45968: 2.04,
  46045: 2.04,
  46047: 2.04,
  46049: 2.04,
  46117: 2.04,
  46119: 2.04,
  46145: 2.04,
  46147: 2.04,
  46149: 2.04,
  46236: 2.04,
  46238: 2.04,
  46240: 2.04,
  46242: 2.04,
  46244: 2.04,
  46282: 2.04,
  46284: 2.04,
  46286: 2.04,
  46325: 2.04,
  46342: 2.04,
  46348: 2.04,
  46354: 2.04,
  46359: 2.04,
  46395: 2.04,
  46397: 2.04,
  46399: 2.04,
  46414: 2.04,
  46419: 2.04,
  46446: 2.04,
  46459: 2.04,
  46483: 2.04,
  46485: 2.04,
  46487: 2.04,
  46499: 2.04,
  46509: 2.04,
  46514: 2.04,
  46519: 2.04,
  46535: 2.04,
  46537: 2.04,
  46539: 2.04,
  46562: 2.04,
  46569: 2.04,
  47051: 2.04,
  47053: 2.04,
  47055: 2.04,
  47057: 2.04,
  47058: 2.04,
  47059: 2.04,
  47119: 2.04,
  47137: 2.04,
  47138: 2.04,
  47139: 2.04,
  47166: 2.04,
  47167: 2.04,
  47169: 2.04,
  47178: 2.04,
  47179: 2.04,
  47198: 2.04,
  47199: 2.04,
  47226: 2.04,
  47228: 2.04,
  47229: 2.04,
  47239: 2.04,
  47249: 2.04,
  47259: 2.04,
  47269: 2.04,
  47279: 2.04,
  47441: 2.04,
  47443: 2.04,
  47445: 2.04,
  47447: 2.04,
  47475: 2.04,
  47495: 2.04,
  47506: 2.04,
  47509: 2.04,
  47533: 2.04,
  47546: 2.04,
  47551: 2.04,
  47559: 2.04,
  47574: 2.04,
  47589: 2.04,
  47608: 2.04,
  47623: 2.04,
  47624: 2.04,
  47625: 2.04,
  47626: 2.04,
  47627: 2.04,
  47638: 2.04,
  47647: 2.04,
  47652: 2.04,
  47661: 2.04,
  47665: 2.04,
  47669: 2.04,
  47798: 2.04,
  47799: 2.04,
  47800: 2.04,
  47802: 2.04,
  47803: 2.04,
  47804: 2.04,
  47805: 2.04,
  47807: 2.04,
  47809: 2.04,
  47829: 2.04,
  47839: 2.04,
  47877: 2.04,
  47906: 2.04,
  47918: 2.04,
  47929: 2.04,
  48143: 2.04,
  48145: 2.04,
  48147: 2.04,
  48149: 2.04,
  48151: 2.04,
  48153: 2.04,
  48155: 2.04,
  48157: 2.04,
  48159: 2.04,
  48161: 2.04,
  48163: 2.04,
  48165: 2.04,
  48167: 2.04,
  48231: 2.04,
  48249: 2.04,
  48268: 2.04,
  48282: 2.04,
  48291: 2.04,
  48301: 2.04,
  48308: 2.04,
  48317: 2.04,
  48324: 2.04,
  48329: 2.04,
  48336: 2.04,
  48341: 2.04,
  48346: 2.04,
  48351: 2.04,
  48356: 2.04,
  48361: 2.04,
  48366: 2.04,
  48369: 2.04,
  48429: 2.04,
  48431: 2.04,
  48432: 2.04,
  48455: 2.04,
  48465: 2.04,
  48477: 2.04,
  48480: 2.04,
  48485: 2.04,
  48488: 2.04,
  48493: 2.04,
  48496: 2.04,
  48499: 2.04,
  48527: 2.04,
  48529: 2.04,
  48531: 2.04,
  48565: 2.04,
  48599: 2.04,
  48607: 2.04,
  48612: 2.04,
  48619: 2.04,
  48624: 2.04,
  48629: 2.04,
  48653: 2.04,
  48683: 2.04,
  48691: 2.04,
  48703: 2.04,
  48712: 2.04,
  48720: 2.04,
  48727: 2.04,
  48734: 2.04,
  48739: 2.04,
  49074: 2.04,
  49076: 2.04,
  49078: 2.04,
  49080: 2.04,
  49082: 2.04,
  49084: 2.04,
  49086: 2.04,
  49088: 2.04,
  49090: 2.04,
  49124: 2.04,
  49134: 2.04,
  49143: 2.04,
  49152: 2.04,
  49163: 2.04,
  49170: 2.04,
  49176: 2.04,
  49179: 2.04,
  49186: 2.04,
  49191: 2.04,
  49196: 2.04,
  49201: 2.04,
  49205: 2.04,
  49214: 2.04,
  49219: 2.04,
  49324: 2.04,
  49326: 2.04,
  49328: 2.04,
  49356: 2.04,
  49377: 2.04,
  49393: 2.04,
  49401: 2.04,
  49406: 2.04,
  49413: 2.04,
  49419: 2.04,
  49424: 2.04,
  49429: 2.04,
  49434: 2.04,
  49439: 2.04,
  49448: 2.04,
  49451: 2.04,
  49453: 2.04,
  49456: 2.04,
  49457: 2.04,
  49459: 2.04,
  49477: 2.04,
  49479: 2.04,
  49492: 2.04,
  49497: 2.04,
  49504: 2.04,
  49509: 2.04,
  49525: 2.04,
  49536: 2.04,
  49545: 2.04,
  49549: 2.04,
  49565: 2.04,
  49577: 2.04,
  49584: 2.04,
  49586: 2.04,
  49593: 2.04,
  49594: 2.04,
  49596: 2.04,
  49597: 2.04,
  49599: 2.04,
  49610: 2.04,
  49624: 2.04,
  49626: 2.04,
  49632: 2.04,
  49635: 2.04,
  49637: 2.04,
  49638: 2.04,
  49661: 2.04,
  49681: 2.04,
  49685: 2.04,
  49688: 2.04,
  49692: 2.04,
  49696: 2.04,
  49699: 2.04,
  49716: 2.04,
  49733: 2.04,
  49740: 2.04,
  49744: 2.04,
  49751: 2.04,
  49757: 2.04,
  49762: 2.04,
  49767: 2.04,
  49770: 2.04,
  49774: 2.04,
  49777: 2.04,
  49779: 2.04,
  49808: 2.04,
  49809: 2.04,
  49811: 2.04,
  49824: 2.04,
  49828: 2.04,
  49832: 2.04,
  49835: 2.04,
  49838: 2.04,
  49843: 2.04,
  49844: 2.04,
  49846: 2.04,
  49847: 2.04,
  49849: 2.04,
  50126: 2.04,
  50127: 2.04,
  50129: 2.04,
  50169: 2.04,
  50170: 2.04,
  50171: 2.04,
  50181: 2.04,
  50189: 2.04,
  50226: 2.04,
  50259: 2.04,
  50321: 2.04,
  50354: 2.04,
  50374: 2.04,
  50389: 2.04,
  50667: 2.04,
  50668: 2.04,
  50670: 2.04,
  50672: 2.04,
  50674: 2.04,
  50676: 2.04,
  50677: 2.04,
  50678: 2.04,
  50679: 2.04,
  50733: 2.04,
  50735: 2.04,
  50737: 2.04,
  50739: 2.04,
  50765: 2.04,
  50767: 2.04,
  50769: 2.04,
  50823: 2.04,
  50825: 2.04,
  50827: 2.04,
  50829: 2.04,
  50858: 2.04,
  50859: 2.04,
  50931: 2.04,
  50933: 2.04,
  50935: 2.04,
  50937: 2.04,
  50939: 2.04,
  50968: 2.04,
  50969: 2.04,
  50996: 2.04,
  50997: 2.04,
  50999: 2.04,
  51061: 2.04,
  51063: 2.04,
  51065: 2.04,
  51067: 2.04,
  51069: 2.04,
  51103: 2.04,
  51105: 2.04,
  51107: 2.04,
  51109: 2.04,
  51143: 2.04,
  51145: 2.04,
  51147: 2.04,
  51149: 2.04,
  51371: 2.04,
  51373: 2.04,
  51375: 2.04,
  51377: 2.04,
  51379: 2.04,
  51381: 2.04,
  51399: 2.04,
  51427: 2.04,
  51429: 2.04,
  51465: 2.04,
  51467: 2.04,
  51469: 2.04,
  51491: 2.04,
  51503: 2.04,
  51515: 2.04,
  51519: 2.04,
  51545: 2.04,
  51570: 2.04,
  51580: 2.04,
  51588: 2.04,
  51597: 2.04,
  51598: 2.04,
  51643: 2.04,
  51645: 2.04,
  51647: 2.04,
  51674: 2.04,
  51688: 2.04,
  51702: 2.04,
  51709: 2.04,
  51766: 2.04,
  51789: 2.04,
  52062: 2.04,
  52064: 2.04,
  52066: 2.04,
  52068: 2.04,
  52070: 2.04,
  52072: 2.04,
  52074: 2.04,
  52076: 2.04,
  52078: 2.04,
  52080: 2.04,
  52134: 2.04,
  52146: 2.04,
  52152: 2.04,
  52156: 2.04,
  52159: 2.04,
  52222: 2.04,
  52223: 2.04,
  52224: 2.04,
  52249: 2.04,
  52349: 2.04,
  52351: 2.04,
  52353: 2.04,
  52355: 2.04,
  52372: 2.04,
  52379: 2.04,
  52382: 2.04,
  52385: 2.04,
  52388: 2.04,
  52391: 2.04,
  52393: 2.04,
  52396: 2.04,
  52399: 2.04,
  52428: 2.04,
  52441: 2.04,
  52445: 2.04,
  52457: 2.04,
  52459: 2.04,
  52477: 2.04,
  52499: 2.04,
  52511: 2.04,
  52525: 2.04,
  52531: 2.04,
  52538: 2.04,
  53111: 2.04,
  53113: 2.04,
  53115: 2.04,
  53117: 2.04,
  53119: 2.04,
  53121: 2.04,
  53123: 2.04,
  53125: 2.04,
  53127: 2.04,
  53129: 2.04,
  53173: 2.04,
  53175: 2.04,
  53177: 2.04,
  53179: 2.04,
  53225: 2.04,
  53227: 2.04,
  53229: 2.04,
  53332: 2.04,
  53340: 2.04,
  53343: 2.04,
  53347: 2.04,
  53359: 2.04,
  53424: 2.04,
  53426: 2.04,
  53474: 2.04,
  53489: 2.04,
  53498: 2.04,
  53501: 2.04,
  53505: 2.04,
  53506: 2.04,
  53507: 2.04,
  53508: 2.04,
  53518: 2.04,
  53520: 2.04,
  53533: 2.04,
  53534: 2.04,
  53539: 2.04,
  53545: 2.04,
  53547: 2.04,
  53557: 2.04,
  53560: 2.04,
  53562: 2.04,
  53567: 2.04,
  53572: 2.04,
  53577: 2.04,
  53578: 2.04,
  53579: 2.04,
  53604: 2.04,
  53619: 2.04,
  53639: 2.04,
  53721: 2.04,
  53757: 2.04,
  53773: 2.04,
  53783: 2.04,
  53797: 2.04,
  53804: 2.04,
  53809: 2.04,
  53819: 2.04,
  53840: 2.04,
  53842: 2.04,
  53844: 2.04,
  53859: 2.04,
  53879: 2.04,
  53881: 2.04,
  53894: 2.04,
  53902: 2.04,
  53909: 2.04,
  53913: 2.04,
  53919: 2.04,
  53925: 2.04,
  53937: 2.04,
  53940: 2.04,
  53945: 2.04,
  53947: 2.04,
  53949: 2.04,
  54290: 2.04,
  54292: 2.04,
  54293: 2.04,
  54294: 2.04,
  54295: 2.04,
  54296: 2.04,
  54298: 2.04,
  54306: 2.04,
  54308: 2.04,
  54309: 2.04,
  54310: 2.04,
  54311: 2.04,
  54313: 2.04,
  54314: 2.04,
  54316: 2.04,
  54317: 2.04,
  54318: 2.04,
  54320: 2.04,
  54329: 2.04,
  54331: 2.04,
  54332: 2.04,
  54338: 2.04,
  54340: 2.04,
  54341: 2.04,
  54343: 2.04,
  54344: 2.04,
  54346: 2.04,
  54347: 2.04,
  54349: 2.04,
  54411: 2.04,
  54413: 2.04,
  54421: 2.04,
  54422: 2.04,
  54424: 2.04,
  54426: 2.04,
  54427: 2.04,
  54429: 2.04,
  54439: 2.04,
  54441: 2.04,
  54450: 2.04,
  54451: 2.04,
  54453: 2.04,
  54455: 2.04,
  54456: 2.04,
  54457: 2.04,
  54459: 2.04,
  54470: 2.04,
  54472: 2.04,
  54483: 2.04,
  54484: 2.04,
  54486: 2.04,
  54487: 2.04,
  54492: 2.04,
  54497: 2.04,
  54498: 2.04,
  54516: 2.04,
  54518: 2.04,
  54523: 2.04,
  54524: 2.04,
  54526: 2.04,
  54528: 2.04,
  54529: 2.04,
  54531: 2.04,
  54533: 2.04,
  54534: 2.04,
  54536: 2.04,
  54538: 2.04,
  54539: 2.04,
  54550: 2.04,
  54552: 2.04,
  54558: 2.04,
  54568: 2.04,
  54570: 2.04,
  54574: 2.04,
  54576: 2.04,
  54578: 2.04,
  54579: 2.04,
  54584: 2.04,
  54585: 2.04,
  54586: 2.04,
  54587: 2.04,
  54589: 2.04,
  54595: 2.04,
  54597: 2.04,
  54608: 2.04,
  54610: 2.04,
  54611: 2.04,
  54612: 2.04,
  54614: 2.04,
  54616: 2.04,
  54617: 2.04,
  54619: 2.04,
  54634: 2.04,
  54636: 2.04,
  54646: 2.04,
  54647: 2.04,
  54649: 2.04,
  54655: 2.04,
  54657: 2.04,
  54662: 2.04,
  54664: 2.04,
  54666: 2.04,
  54668: 2.04,
  54669: 2.04,
  54673: 2.04,
  54675: 2.04,
  54687: 2.04,
  54689: 2.04,
  55116: 2.04,
  55118: 2.04,
  55120: 2.04,
  55122: 2.04,
  55124: 2.04,
  55126: 2.04,
  55127: 2.04,
  55128: 2.04,
  55129: 2.04,
  55130: 2.04,
  55131: 2.04,
  55218: 2.04,
  55232: 2.04,
  55234: 2.04,
  55237: 2.04,
  55239: 2.04,
  55246: 2.04,
  55252: 2.04,
  55257: 2.04,
  55262: 2.04,
  55263: 2.04,
  55268: 2.04,
  55270: 2.04,
  55271: 2.04,
  55276: 2.04,
  55278: 2.04,
  55283: 2.04,
  55286: 2.04,
  55288: 2.04,
  55291: 2.04,
  55294: 2.04,
  55296: 2.04,
  55299: 2.04,
  55411: 2.04,
  55413: 2.04,
  55422: 2.04,
  55424: 2.04,
  55425: 2.04,
  55430: 2.04,
  55432: 2.04,
  55435: 2.04,
  55437: 2.04,
  55442: 2.04,
  55444: 2.04,
  55450: 2.04,
  55452: 2.04,
  55457: 2.04,
  55459: 2.04,
  55469: 2.04,
  55471: 2.04,
  55481: 2.04,
  55483: 2.04,
  55487: 2.04,
  55490: 2.04,
  55491: 2.04,
  55494: 2.04,
  55496: 2.04,
  55497: 2.04,
  55499: 2.04,
  55543: 2.04,
  55545: 2.04,
  55546: 2.04,
  55559: 2.04,
  55566: 2.04,
  55568: 2.04,
  55569: 2.04,
  55571: 2.04,
  55576: 2.04,
  55578: 2.04,
  55583: 2.04,
  55585: 2.04,
  55590: 2.04,
  55592: 2.04,
  55593: 2.04,
  55595: 2.04,
  55596: 2.04,
  55597: 2.04,
  55599: 2.04,
  55606: 2.04,
  55608: 2.04,
  55618: 2.04,
  55619: 2.04,
  55621: 2.04,
  55624: 2.04,
  55626: 2.04,
  55627: 2.04,
  55629: 2.04,
  55743: 2.04,
  55756: 2.04,
  55758: 2.04,
  55765: 2.04,
  55767: 2.04,
  55768: 2.04,
  55774: 2.04,
  55776: 2.04,
  55777: 2.04,
  55779: 2.04,
  56068: 2.04,
  56070: 2.04,
  56072: 2.04,
  56073: 2.04,
  56075: 2.04,
  56076: 2.04,
  56077: 2.04,
  56112: 2.04,
  56130: 2.04,
  56132: 2.04,
  56133: 2.04,
  56154: 2.04,
  56170: 2.04,
  56179: 2.04,
  56182: 2.04,
  56191: 2.04,
  56203: 2.04,
  56204: 2.04,
  56206: 2.04,
  56218: 2.04,
  56220: 2.04,
  56235: 2.04,
  56237: 2.04,
  56242: 2.04,
  56244: 2.04,
  56249: 2.04,
  56253: 2.04,
  56254: 2.04,
  56269: 2.04,
  56271: 2.04,
  56276: 2.04,
  56281: 2.04,
  56283: 2.04,
  56288: 2.04,
  56290: 2.04,
  56291: 2.04,
  56294: 2.04,
  56295: 2.04,
  56299: 2.04,
  56305: 2.04,
  56307: 2.04,
  56316: 2.04,
  56317: 2.04,
  56321: 2.04,
  56322: 2.04,
  56323: 2.04,
  56329: 2.04,
  56330: 2.04,
  56332: 2.04,
  56333: 2.04,
  56335: 2.04,
  56337: 2.04,
  56338: 2.04,
  56340: 2.04,
  56341: 2.04,
  56346: 2.04,
  56348: 2.04,
  56349: 2.04,
  56355: 2.04,
  56357: 2.04,
  56368: 2.04,
  56370: 2.04,
  56377: 2.04,
  56379: 2.04,
  56410: 2.04,
  56412: 2.04,
  56414: 2.04,
  56422: 2.04,
  56424: 2.04,
  56427: 2.04,
  56428: 2.04,
  56457: 2.04,
  56459: 2.04,
  56462: 2.04,
  56470: 2.04,
  56472: 2.04,
  56477: 2.04,
  56479: 2.04,
  56564: 2.04,
  56566: 2.04,
  56567: 2.04,
  56575: 2.04,
  56579: 2.04,
  56581: 2.04,
  56584: 2.04,
  56587: 2.04,
  56588: 2.04,
  56589: 2.04,
  56593: 2.04,
  56594: 2.04,
  56598: 2.04,
  56599: 2.04,
  56626: 2.04,
  56630: 2.04,
  56637: 2.04,
  56642: 2.04,
  56645: 2.04,
  56648: 2.04,
  56651: 2.04,
  56653: 2.04,
  56656: 2.04,
  56659: 2.04,
  56727: 2.04,
  56729: 2.04,
  56736: 2.04,
  56743: 2.04,
  56745: 2.04,
  56746: 2.04,
  56751: 2.04,
  56753: 2.04,
  56754: 2.04,
  56759: 2.04,
  56761: 2.04,
  56766: 2.04,
  56767: 2.04,
  56769: 2.04,
  56812: 2.04,
  56814: 2.04,
  56818: 2.04,
  56820: 2.04,
  56821: 2.04,
  56823: 2.04,
  56825: 2.04,
  56826: 2.04,
  56828: 2.04,
  56829: 2.04,
  56841: 2.04,
  56843: 2.04,
  56850: 2.04,
  56856: 2.04,
  56858: 2.04,
  56859: 2.04,
  56861: 2.04,
  56862: 2.04,
  56864: 2.04,
  56865: 2.04,
  56867: 2.04,
  56869: 2.04,
  57072: 2.04,
  57074: 2.04,
  57076: 2.04,
  57078: 2.04,
  57080: 2.04,
  57223: 2.04,
  57234: 2.04,
  57250: 2.04,
  57258: 2.04,
  57271: 2.04,
  57290: 2.04,
  57299: 2.04,
  57319: 2.04,
  57334: 2.04,
  57339: 2.04,
  57368: 2.04,
  57392: 2.04,
  57399: 2.04,
  57413: 2.04,
  57439: 2.04,
  57462: 2.04,
  57482: 2.04,
  57489: 2.04,
  57518: 2.04,
  57520: 2.04,
  57537: 2.04,
  57539: 2.04,
  57548: 2.04,
  57555: 2.04,
  57562: 2.04,
  57567: 2.04,
  57572: 2.04,
  57577: 2.04,
  57578: 2.04,
  57580: 2.04,
  57581: 2.04,
  57583: 2.04,
  57584: 2.04,
  57586: 2.04,
  57587: 2.04,
  57589: 2.04,
  57610: 2.04,
  57612: 2.04,
  57614: 2.04,
  57627: 2.04,
  57629: 2.04,
  57632: 2.04,
  57635: 2.04,
  57636: 2.04,
  57638: 2.04,
  57639: 2.04,
  57641: 2.04,
  57642: 2.04,
  57644: 2.04,
  57645: 2.04,
  57647: 2.04,
  57648: 2.04,
  58089: 2.04,
  58091: 2.04,
  58093: 2.04,
  58095: 2.04,
  58097: 2.04,
  58099: 2.04,
  58119: 2.04,
  58135: 2.04,
  58239: 2.04,
  58256: 2.04,
  58285: 2.04,
  58300: 2.04,
  58313: 2.04,
  58332: 2.04,
  58339: 2.04,
  58452: 2.04,
  58453: 2.04,
  58454: 2.04,
  58455: 2.04,
  58456: 2.04,
  58507: 2.04,
  58509: 2.04,
  58511: 2.04,
  58513: 2.04,
  58515: 2.04,
  58540: 2.04,
  58553: 2.04,
  58566: 2.04,
  58579: 2.04,
  58636: 2.04,
  58638: 2.04,
  58640: 2.04,
  58642: 2.04,
  58644: 2.04,
  58675: 2.04,
  58706: 2.04,
  58708: 2.04,
  58710: 2.04,
  58730: 2.04,
  58739: 2.04,
  58762: 2.04,
  58769: 2.04,
  58791: 2.04,
  58802: 2.04,
  58809: 2.04,
  58840: 2.04,
  58849: 2.04,
  59063: 2.04,
  59065: 2.04,
  59067: 2.04,
  59069: 2.04,
  59071: 2.04,
  59073: 2.04,
  59075: 2.04,
  59077: 2.04,
  59174: 2.04,
  59192: 2.04,
  59199: 2.04,
  59227: 2.04,
  59229: 2.04,
  59269: 2.04,
  59302: 2.04,
  59320: 2.04,
  59329: 2.04,
  59348: 2.04,
  59368: 2.04,
  59379: 2.04,
  59387: 2.04,
  59394: 2.04,
  59399: 2.04,
  59423: 2.04,
  59425: 2.04,
  59427: 2.04,
  59439: 2.04,
  59457: 2.04,
  59469: 2.04,
  59494: 2.04,
  59505: 2.04,
  59510: 2.04,
  59514: 2.04,
  59519: 2.04,
  59555: 2.04,
  59556: 2.04,
  59557: 2.04,
  59558: 2.04,
  59581: 2.04,
  59590: 2.04,
  59597: 2.04,
  59602: 2.04,
  59609: 2.04,
  59755: 2.04,
  59757: 2.04,
  59759: 2.04,
  59821: 2.04,
  59823: 2.04,
  59846: 2.04,
  59872: 2.04,
  59889: 2.04,
  59909: 2.04,
  59929: 2.04,
  59939: 2.04,
  59955: 2.04,
  59964: 2.04,
  59969: 2.04,
  60306: 2.04,
  60308: 2.04,
  60310: 2.04,
  60311: 1.92,
  60312: 1.90,
  60313: 1.90,
  60314: 1.90,
  60315: 1.90,
  60316: 1.90,
  60318: 1.90,
  60320: 1.90,
  60322: 1.90,
  60323: 1.90,
  60325: 1.90,
  60326: 1.90,
  60327: 1.90,
  60329: 1.90,
  60385: 1.90,
  60386: 1.90,
  60388: 1.90,
  60389: 1.90,
  60431: 1.90,
  60433: 1.90,
  60435: 1.90,
  60437: 1.90,
  60438: 1.90,
  60439: 1.90,
  60486: 1.90,
  60487: 1.90,
  60488: 1.90,
  60489: 1.90,
  60528: 1.90,
  60529: 1.90,
  60549: 1.90,
  60594: 1.90,
  60596: 1.90,
  60598: 1.90,
  60599: 1.90,
  61118: 1.90,
  61130: 1.90,
  61137: 1.90,
  61138: 1.90,
  61169: 1.90,
  61184: 1.90,
  61191: 1.90,
  61194: 1.90,
  61197: 1.90,
  61200: 1.90,
  61203: 1.90,
  61206: 1.90,
  61209: 1.90,
  61231: 1.90,
  61239: 1.90,
  61250: 1.90,
  61267: 1.90,
  61273: 1.90,
  61276: 1.90,
  61279: 1.90,
  61348: 1.90,
  61350: 1.90,
  61352: 1.90,
  61381: 1.90,
  61389: 1.90,
  61440: 1.90,
  61449: 1.90,
  61462: 1.90,
  61476: 1.90,
  61479: 1.90,
  63065: 1.90,
  63067: 1.90,
  63069: 1.90,
  63071: 1.90,
  63073: 1.90,
  63075: 1.90,
  63110: 1.90,
  63128: 1.90,
  63150: 1.90,
  63165: 1.90,
  63179: 1.90,
  63225: 1.90,
  63263: 1.90,
  63303: 1.90,
  63322: 1.90,
  63329: 1.90,
  63450: 1.90,
  63452: 1.90,
  63454: 1.90,
  63456: 1.90,
  63457: 1.90,
  63477: 1.90,
  63486: 1.90,
  63500: 1.90,
  63505: 1.90,
  63512: 1.90,
  63517: 1.90,
  63526: 1.90,
  63533: 1.90,
  63538: 1.90,
  63543: 1.90,
  63546: 1.90,
  63549: 1.90,
  63571: 1.90,
  63579: 1.90,
  63584: 1.90,
  63589: 1.90,
  63594: 1.90,
  63599: 1.90,
  63607: 1.90,
  63619: 1.90,
  63628: 1.90,
  63633: 1.90,
  63636: 1.90,
  63637: 1.90,
  63639: 1.90,
  63654: 1.90,
  63667: 1.90,
  63674: 1.90,
  63679: 1.90,
  63683: 1.90,
  63688: 1.90,
  63691: 1.90,
  63694: 1.90,
  63695: 1.90,
  63697: 1.90,
  63699: 1.90,
  63739: 1.90,
  63741: 1.90,
  63743: 1.90,
  63755: 1.90,
  63762: 1.90,
  63768: 1.90,
  63773: 1.90,
  63776: 1.90,
  63785: 1.90,
  63791: 1.90,
  63796: 1.90,
  63801: 1.90,
  63808: 1.90,
  63811: 1.90,
  63814: 1.90,
  63820: 1.90,
  63825: 1.90,
  63826: 1.90,
  63828: 1.90,
  63829: 1.90,
  63831: 1.90,
  63834: 1.90,
  63839: 1.90,
  63840: 1.90,
  63843: 1.90,
  63846: 1.90,
  63849: 1.90,
  63853: 1.90,
  63856: 1.90,
  63857: 1.90,
  63860: 1.90,
  63863: 1.90,
  63864: 1.90,
  63867: 1.90,
  63868: 1.90,
  63869: 1.90,
  63871: 1.90,
  63872: 1.90,
  63874: 1.90,
  63875: 1.90,
  63877: 1.90,
  63879: 1.90,
  63897: 1.90,
  63906: 1.90,
  63911: 1.90,
  63916: 1.90,
  63920: 1.90,
  63924: 1.90,
  63925: 1.90,
  63927: 1.90,
  63928: 1.90,
  63930: 1.90,
  63931: 1.90,
  63933: 1.90,
  63934: 1.90,
  63936: 1.90,
  63937: 1.90,
  63939: 1.90,
  64283: 1.90,
  64285: 1.90,
  64287: 1.90,
  64289: 1.90,
  64291: 1.90,
  64293: 1.90,
  64295: 1.90,
  64297: 1.90,
  64319: 1.90,
  64331: 1.90,
  64342: 1.90,
  64347: 1.90,
  64354: 1.90,
  64367: 1.90,
  64372: 1.90,
  64380: 1.90,
  64385: 1.90,
  64390: 1.90,
  64395: 1.90,
  64397: 1.90,
  64401: 1.90,
  64404: 1.90,
  64405: 1.90,
  64407: 1.90,
  64409: 1.90,
  64521: 1.90,
  64546: 1.90,
  64560: 1.90,
  64569: 1.90,
  64572: 1.90,
  64579: 1.90,
  64584: 1.90,
  64589: 1.90,
  64625: 1.90,
  64646: 1.90,
  64653: 1.90,
  64658: 1.90,
  64665: 1.90,
  64668: 1.90,
  64673: 1.90,
  64678: 1.90,
  64683: 1.90,
  64686: 1.90,
  64689: 1.90,
  64711: 1.90,
  64720: 1.90,
  64732: 1.90,
  64739: 1.90,
  64743: 1.90,
  64747: 1.90,
  64750: 1.90,
  64753: 1.90,
  64754: 1.90,
  64756: 1.90,
  64757: 1.90,
  64760: 1.90,
  64807: 1.90,
  64823: 1.90,
  64832: 1.90,
  64839: 1.90,
  64846: 1.90,
  64850: 1.90,
  64853: 1.90,
  64859: 1.90,
  65183: 1.90,
  65185: 1.90,
  65187: 1.90,
  65189: 1.90,
  65191: 1.90,
  65193: 1.90,
  65195: 1.90,
  65197: 1.90,
  65199: 1.90,
  65201: 1.90,
  65203: 1.90,
  65205: 1.90,
  65207: 1.90,
  65232: 1.90,
  65239: 1.90,
  65307: 1.90,
  65321: 1.90,
  65326: 1.90,
  65329: 1.90,
  65343: 1.90,
  65344: 1.90,
  65345: 1.90,
  65346: 1.90,
  65347: 1.90,
  65366: 1.90,
  65375: 1.90,
  65385: 1.90,
  65388: 1.90,
  65391: 1.90,
  65396: 1.90,
  65399: 1.90,
  65428: 1.90,
  65439: 1.90,
  65451: 1.90,
  65462: 1.90,
  65468: 1.90,
  65474: 1.90,
  65479: 1.90,
  65510: 1.90,
  65520: 1.90,
  65527: 1.90,
  65529: 1.90,
  65549: 1.90,
  65550: 1.90,
  65551: 1.90,
  65552: 1.90,
  65553: 1.90,
  65554: 1.90,
  65555: 1.90,
  65556: 1.90,
  65558: 1.90,
  65582: 1.90,
  65589: 1.90,
  65594: 1.90,
  65597: 1.90,
  65599: 1.90,
  65604: 1.90,
  65606: 1.90,
  65611: 1.90,
  65614: 1.90,
  65618: 1.90,
  65620: 1.90,
  65623: 1.90,
  65624: 1.90,
  65626: 1.90,
  65627: 1.90,
  65629: 1.90,
  65719: 1.90,
  65760: 1.90,
  65779: 1.90,
  65795: 1.90,
  65812: 1.90,
  65817: 1.90,
  65824: 1.90,
  65830: 1.90,
  65835: 1.90,
  65843: 1.90,
  65929: 1.90,
  65931: 1.90,
  65933: 1.90,
  65934: 1.90,
  65936: 1.90,
  66111: 1.90,
  66113: 1.90,
  66115: 1.90,
  66117: 1.90,
  66119: 1.90,
  66121: 1.90,
  66123: 1.90,
  66125: 1.90,
  66126: 1.90,
  66127: 1.90,
  66128: 1.90,
  66129: 1.90,
  66130: 1.90,
  66131: 1.90,
  66132: 1.90,
  66133: 1.90,
  66265: 1.90,
  66271: 1.90,
  66280: 1.90,
  66287: 1.90,
  66292: 1.90,
  66299: 1.90,
  66333: 1.90,
  66346: 1.90,
  66352: 1.90,
  66359: 1.90,
  66386: 1.90,
  66399: 1.90,
  66424: 1.90,
  66440: 1.90,
  66450: 1.90,
  66453: 1.90,
  66459: 1.90,
  66482: 1.90,
  66484: 1.90,
  66497: 1.90,
  66500: 1.90,
  66501: 1.90,
  66503: 1.90,
  66504: 1.90,
  66506: 1.90,
  66507: 1.90,
  66509: 1.90,
  66538: 1.90,
  66539: 1.90,
  66540: 1.90,
  66557: 1.90,
  66564: 1.90,
  66571: 1.90,
  66578: 1.90,
  66583: 1.90,
  66589: 1.90,
  66606: 1.90,
  66620: 1.90,
  66625: 1.90,
  66629: 1.90,
  66636: 1.90,
  66640: 1.90,
  66646: 1.90,
  66649: 1.90,
  66663: 1.90,
  66679: 1.90,
  66687: 1.90,
  66693: 1.90,
  66701: 1.90,
  66706: 1.90,
  66709: 1.90,
  66740: 1.90,
  66763: 1.90,
  66773: 1.90,
  66780: 1.90,
  66787: 1.90,
  66793: 1.90,
  66798: 1.90,
  66802: 1.90,
  66806: 1.90,
  66809: 1.90,
  66822: 1.90,
  66839: 1.90,
  66849: 1.90,
  66851: 1.90,
  66862: 1.90,
  66869: 1.90,
  66871: 1.90,
  66877: 1.90,
  66879: 1.90,
  66882: 1.90,
  66885: 1.90,
  66887: 1.90,
  66892: 1.90,
  66894: 1.90,
  66901: 1.90,
  66903: 1.90,
  66904: 1.90,
  66907: 1.90,
  66909: 1.90,
  66914: 1.90,
  66916: 1.90,
  66917: 1.90,
  66919: 1.90,
  66953: 1.90,
  66954: 1.90,
  66955: 1.90,
  66957: 1.90,
  66969: 1.90,
  66976: 1.90,
  66978: 1.90,
  66981: 1.90,
  66987: 1.90,
  66989: 1.90,
  66994: 1.90,
  66996: 1.90,
  66999: 1.90,
  67059: 1.90,
  67061: 1.90,
  67063: 1.90,
  67065: 1.90,
  67067: 1.90,
  67069: 1.90,
  67071: 1.90,
  67098: 1.90,
  67105: 1.90,
  67112: 1.90,
  67117: 1.90,
  67122: 1.90,
  67125: 1.90,
  67126: 1.90,
  67127: 1.90,
  67133: 1.90,
  67134: 1.90,
  67136: 1.90,
  67141: 1.90,
  67146: 1.90,
  67147: 1.90,
  67149: 1.90,
  67150: 1.90,
  67152: 1.90,
  67157: 1.90,
  67158: 1.90,
  67159: 1.90,
  67161: 1.90,
  67165: 1.90,
  67166: 1.90,
  67167: 1.90,
  67169: 1.90,
  67227: 1.90,
  67229: 1.90,
  67240: 1.90,
  67245: 1.90,
  67246: 1.90,
  67251: 1.90,
  67256: 1.90,
  67258: 1.90,
  67259: 1.90,
  67269: 1.90,
  67271: 1.90,
  67273: 1.90,
  67278: 1.90,
  67280: 1.90,
  67281: 1.90,
  67283: 1.90,
  67292: 1.90,
  67294: 1.90,
  67295: 1.90,
  67297: 1.90,
  67304: 1.90,
  67305: 1.90,
  67307: 1.90,
  67308: 1.90,
  67310: 1.90,
  67311: 1.90,
  67316: 1.90,
  67317: 1.90,
  67319: 1.90,
  67346: 1.90,
  67354: 1.90,
  67360: 1.90,
  67361: 1.90,
  67363: 1.90,
  67365: 1.90,
  67366: 1.90,
  67368: 1.90,
  67373: 1.90,
  67374: 1.90,
  67376: 1.90,
  67377: 1.90,
  67378: 1.90,
  67433: 1.90,
  67434: 1.90,
  67435: 1.90,
  67454: 1.90,
  67459: 1.90,
  67466: 1.90,
  67468: 1.90,
  67471: 1.90,
  67472: 1.90,
  67473: 1.90,
  67475: 1.90,
  67480: 1.90,
  67482: 1.90,
  67483: 1.90,
  67487: 1.90,
  67489: 1.90,
  67547: 1.90,
  67549: 1.90,
  67550: 1.90,
  67551: 1.90,
  67574: 1.90,
  67575: 1.90,
  67577: 1.90,
  67578: 1.90,
  67580: 1.90,
  67582: 1.90,
  67583: 1.90,
  67585: 1.90,
  67586: 1.90,
  67587: 1.90,
  67590: 1.90,
  67591: 1.90,
  67592: 1.90,
  67593: 1.90,
  67595: 1.90,
  67596: 1.90,
  67598: 1.90,
  67599: 1.90,
  67655: 1.90,
  67657: 1.90,
  67659: 1.90,
  67661: 1.90,
  67663: 1.90,
  67677: 1.90,
  67678: 1.90,
  67680: 1.90,
  67681: 1.90,
  67685: 1.90,
  67686: 1.90,
  67688: 1.90,
  67691: 1.90,
  67693: 1.90,
  67697: 1.90,
  67699: 1.90,
  67700: 1.90,
  67701: 1.90,
  67705: 1.90,
  67706: 1.90,
  67707: 1.90,
  67714: 1.90,
  67715: 1.90,
  67716: 1.90,
  67718: 1.90,
  67722: 1.90,
  67724: 1.90,
  67725: 1.90,
  67727: 1.90,
  67728: 1.90,
  67729: 1.90,
  67731: 1.90,
  67732: 1.90,
  67734: 1.90,
  67735: 1.90,
  67737: 1.90,
  67742: 1.90,
  67744: 1.90,
  67745: 1.90,
  67746: 1.90,
  67748: 1.90,
  67749: 1.90,
  67752: 1.90,
  67753: 1.90,
  67754: 1.90,
  67756: 1.90,
  67757: 1.90,
  67759: 1.90,
  67806: 1.90,
  67808: 1.90,
  67811: 1.90,
  67813: 1.90,
  67814: 1.90,
  67816: 1.90,
  67817: 1.90,
  67819: 1.90,
  67821: 1.90,
  67822: 1.90,
  67823: 1.90,
  67824: 1.90,
  67826: 1.90,
  67827: 1.90,
  67829: 1.90,
  68159: 1.90,
  68161: 1.90,
  68163: 1.90,
  68165: 1.90,
  68167: 1.90,
  68169: 1.90,
  68199: 1.90,
  68219: 1.90,
  68229: 1.90,
  68239: 1.90,
  68259: 1.90,
  68305: 1.90,
  68307: 1.90,
  68309: 1.90,
  68519: 1.90,
  68526: 1.90,
  68535: 1.90,
  68542: 1.90,
  68549: 1.90,
  68623: 1.90,
  68642: 1.90,
  68647: 1.90,
  68649: 1.90,
  68723: 1.90,
  68753: 1.90,
  68766: 1.90,
  68775: 1.90,
  68782: 1.90,
  68789: 1.90,
  68794: 1.90,
  68799: 1.90,
  68804: 1.90,
  68809: 1.90,
  69115: 1.90,
  69117: 1.90,
  69118: 1.90,
  69120: 1.90,
  69121: 1.90,
  69123: 1.90,
  69124: 1.90,
  69126: 1.90,
  69151: 1.90,
  69168: 1.90,
  69181: 1.90,
  69190: 1.90,
  69198: 1.90,
  69207: 1.90,
  69214: 1.90,
  69221: 1.90,
  69226: 1.90,
  69231: 1.90,
  69234: 1.90,
  69239: 1.90,
  69242: 1.90,
  69245: 1.90,
  69250: 1.90,
  69251: 1.90,
  69253: 1.90,
  69254: 1.90,
  69256: 1.90,
  69257: 1.90,
  69259: 1.90,
  69412: 1.90,
  69427: 1.90,
  69429: 1.90,
  69434: 1.90,
  69436: 1.90,
  69437: 1.90,
  69439: 1.90,
  69469: 1.90,
  69483: 1.90,
  69488: 1.90,
  69493: 1.90,
  69502: 1.90,
  69509: 1.90,
  69514: 1.90,
  69517: 1.90,
  69518: 1.90,
  70173: 1.90,
  70174: 1.90,
  70176: 1.90,
  70178: 1.88,
  70180: 1.76,
  70182: 1.76,
  70184: 1.76,
  70186: 1.76,
  70188: 1.76,
  70190: 1.76,
  70191: 1.76,
  70192: 1.76,
  70193: 1.76,
  70195: 1.76,
  70197: 1.76,
  70199: 1.76,
  70327: 1.76,
  70329: 1.76,
  70372: 1.76,
  70374: 1.76,
  70376: 1.76,
  70378: 1.76,
  70435: 1.76,
  70437: 1.76,
  70439: 1.76,
  70469: 1.76,
  70499: 1.76,
  70563: 1.76,
  70565: 1.76,
  70567: 1.76,
  70569: 1.76,
  70597: 1.76,
  70599: 1.76,
  70619: 1.76,
  70629: 1.76,
  70734: 1.76,
  70736: 1.76,
  70771: 1.76,
  70794: 1.76,
  70806: 1.76,
  70825: 1.76,
  70839: 1.76,
  71032: 1.76,
  71034: 1.76,
  71063: 1.76,
  71065: 1.76,
  71067: 1.76,
  71069: 1.76,
  71083: 1.76,
  71088: 1.76,
  71093: 1.76,
  71101: 1.76,
  71106: 1.76,
  71111: 1.76,
  71116: 1.76,
  71120: 1.76,
  71126: 1.76,
  71131: 1.76,
  71134: 1.76,
  71139: 1.76,
  71144: 1.76,
  71149: 1.76,
  71154: 1.76,
  71155: 1.76,
  71157: 1.76,
  71159: 1.76,
  71229: 1.76,
  71254: 1.76,
  71263: 1.76,
  71272: 1.76,
  71277: 1.76,
  71282: 1.76,
  71287: 1.76,
  71292: 1.76,
  71296: 1.76,
  71297: 1.76,
  71299: 1.76,
  71332: 1.76,
  71334: 1.76,
  71336: 1.76,
  71364: 1.76,
  71384: 1.76,
  71394: 1.76,
  71397: 1.76,
  71404: 1.76,
  71409: 1.76,
  71522: 1.76,
  71540: 1.76,
  71543: 1.76,
  71546: 1.76,
  71549: 1.76,
  71554: 1.76,
  71560: 1.76,
  71563: 1.76,
  71566: 1.76,
  71570: 1.76,
  71573: 1.76,
  71576: 1.76,
  71577: 1.76,
  71579: 1.76,
  71634: 1.76,
  71636: 1.76,
  71638: 1.76,
  71640: 1.76,
  71642: 1.76,
  71665: 1.76,
  71672: 1.76,
  71679: 1.76,
  71686: 1.76,
  71691: 1.76,
  71696: 1.76,
  71701: 1.76,
  71706: 1.76,
  71711: 1.76,
  71717: 1.76,
  71720: 1.76,
  71723: 1.76,
  71726: 1.76,
  71729: 1.76,
  71732: 1.76,
  71735: 1.76,
  71737: 1.76,
  71739: 1.76,
  72070: 1.76,
  72072: 1.76,
  72074: 1.76,
  72076: 1.76,
  72108: 1.76,
  72116: 1.76,
  72119: 1.76,
  72124: 1.76,
  72127: 1.76,
  72131: 1.76,
  72135: 1.76,
  72138: 1.76,
  72141: 1.76,
  72144: 1.76,
  72145: 1.76,
  72147: 1.76,
  72149: 1.76,
  72160: 1.76,
  72172: 1.76,
  72175: 1.76,
  72178: 1.76,
  72181: 1.76,
  72184: 1.76,
  72186: 1.76,
  72189: 1.76,
  72202: 1.76,
  72213: 1.76,
  72218: 1.76,
  72221: 1.76,
  72224: 1.76,
  72226: 1.76,
  72227: 1.76,
  72229: 1.76,
  72250: 1.76,
  72270: 1.76,
  72275: 1.76,
  72280: 1.76,
  72285: 1.76,
  72290: 1.76,
  72293: 1.76,
  72294: 1.76,
  72296: 1.76,
  72297: 1.76,
  72299: 1.76,
  72336: 1.76,
  72348: 1.76,
  72351: 1.76,
  72355: 1.76,
  72356: 1.76,
  72358: 1.76,
  72359: 1.76,
  72361: 1.76,
  72362: 1.76,
  72364: 1.76,
  72365: 1.76,
  72367: 1.76,
  72369: 1.76,
  72379: 1.76,
  72393: 1.76,
  72401: 1.76,
  72406: 1.76,
  72411: 1.76,
  72414: 1.76,
  72415: 1.76,
  72417: 1.76,
  72419: 1.76,
  72458: 1.76,
  72459: 1.76,
  72461: 1.76,
  72469: 1.76,
  72474: 1.76,
  72475: 1.76,
  72477: 1.76,
  72479: 1.76,
  72488: 1.76,
  72501: 1.76,
  72505: 1.76,
  72510: 1.76,
  72511: 1.76,
  72513: 1.76,
  72514: 1.76,
  72516: 1.76,
  72517: 1.76,
  72519: 1.76,
  72525: 1.76,
  72531: 1.76,
  72532: 1.76,
  72534: 1.76,
  72535: 1.76,
  72537: 1.76,
  72539: 1.76,
  72555: 1.76,
  72574: 1.76,
  72581: 1.76,
  72582: 1.76,
  72584: 1.76,
  72585: 1.76,
  72587: 1.76,
  72589: 1.76,
  72622: 1.76,
  72631: 1.76,
  72636: 1.76,
  72639: 1.76,
  72644: 1.76,
  72649: 1.76,
  72654: 1.76,
  72655: 1.76,
  72657: 1.76,
  72658: 1.76,
  72660: 1.76,
  72661: 1.76,
  72663: 1.76,
  72664: 1.76,
  72666: 1.76,
  72667: 1.76,
  72669: 1.76,
  72760: 1.76,
  72762: 1.76,
  72764: 1.76,
  72766: 1.76,
  72768: 1.76,
  72770: 1.76,
  72793: 1.76,
  72800: 1.76,
  72805: 1.76,
  72810: 1.76,
  72813: 1.76,
  72818: 1.76,
  72820: 1.76,
  72827: 1.76,
  72829: 1.76,
  73033: 1.76,
  73035: 1.76,
  73037: 1.76,
  73054: 1.76,
  73061: 1.76,
  73066: 1.76,
  73072: 1.76,
  73079: 1.76,
  73084: 1.76,
  73087: 1.76,
  73092: 1.76,
  73095: 1.76,
  73098: 1.76,
  73099: 1.76,
  73101: 1.76,
  73102: 1.76,
  73104: 1.76,
  73105: 1.76,
  73107: 1.76,
  73108: 1.76,
  73110: 1.76,
  73111: 1.76,
  73113: 1.76,
  73114: 1.76,
  73116: 1.76,
  73117: 1.76,
  73119: 1.76,
  73207: 1.76,
  73230: 1.76,
  73235: 1.76,
  73240: 1.76,
  73249: 1.76,
  73252: 1.76,
  73257: 1.76,
  73262: 1.76,
  73265: 1.76,
  73266: 1.76,
  73268: 1.76,
  73269: 1.76,
  73271: 1.76,
  73272: 1.76,
  73274: 1.76,
  73275: 1.76,
  73277: 1.76,
  73278: 1.76,
  73312: 1.76,
  73326: 1.76,
  73329: 1.76,
  73333: 1.76,
  73337: 1.76,
  73340: 1.76,
  73342: 1.76,
  73344: 1.76,
  73345: 1.76,
  73347: 1.76,
  73349: 1.76,
  73430: 1.76,
  73431: 1.76,
  73432: 1.76,
  73433: 1.76,
  73434: 1.76,
  73441: 1.76,
  73447: 1.76,
  73450: 1.76,
  73453: 1.76,
  73457: 1.76,
  73460: 1.76,
  73463: 1.76,
  73466: 1.76,
  73467: 1.76,
  73469: 1.76,
  73479: 1.76,
  73485: 1.76,
  73486: 1.76,
  73488: 1.76,
  73489: 1.76,
  73491: 1.76,
  73492: 1.76,
  73494: 1.76,
  73495: 1.76,
  73497: 1.76,
  73499: 1.76,
  73525: 1.76,
  73527: 1.76,
  73529: 1.76,
  73540: 1.76,
  73547: 1.76,
  73550: 1.76,
  73553: 1.76,
  73557: 1.76,
  73560: 1.76,
  73563: 1.76,
  73565: 1.76,
  73566: 1.76,
  73568: 1.76,
  73569: 1.76,
  73571: 1.76,
  73572: 1.76,
  73574: 1.76,
  73575: 1.76,
  73577: 1.76,
  73579: 1.76,
  73614: 1.76,
  73630: 1.76,
  73635: 1.76,
  73642: 1.76,
  73650: 1.76,
  73655: 1.76,
  73660: 1.76,
  73663: 1.76,
  73666: 1.76,
  73667: 1.76,
  73669: 1.76,
  73728: 1.76,
  73730: 1.76,
  73732: 1.76,
  73733: 1.76,
  73734: 1.76,
  73760: 1.76,
  73765: 1.76,
  73770: 1.76,
  73773: 1.76,
  73776: 1.76,
  73779: 1.76,
  74072: 1.76,
  74074: 1.76,
  74076: 1.76,
  74078: 1.76,
  74080: 1.76,
  74081: 1.76,
  74172: 1.76,
  74177: 1.76,
  74182: 1.76,
  74189: 1.76,
  74193: 1.76,
  74196: 1.76,
  74199: 1.76,
  74206: 1.76,
  74211: 1.76,
  74214: 1.76,
  74219: 1.76,
  74223: 1.76,
  74226: 1.76,
  74229: 1.76,
  74232: 1.76,
  74235: 1.76,
  74238: 1.76,
  74239: 1.76,
  74243: 1.76,
  74245: 1.76,
  74246: 1.76,
  74248: 1.76,
  74249: 1.76,
  74251: 1.76,
  74252: 1.76,
  74254: 1.76,
  74255: 1.76,
  74257: 1.76,
  74259: 1.76,
  74321: 1.76,
  74336: 1.76,
  74343: 1.76,
  74348: 1.76,
  74354: 1.76,
  74357: 1.76,
  74360: 1.76,
  74363: 1.76,
  74366: 1.76,
  74369: 1.76,
  74372: 1.76,
  74374: 1.76,
  74376: 1.76,
  74379: 1.76,
  74382: 1.76,
  74385: 1.76,
  74388: 1.76,
  74389: 1.76,
  74391: 1.76,
  74392: 1.76,
  74394: 1.76,
  74395: 1.76,
  74397: 1.76,
  74399: 1.76,
  74405: 1.76,
  74417: 1.76,
  74420: 1.76,
  74423: 1.76,
  74424: 1.76,
  74426: 1.76,
  74427: 1.76,
  74429: 1.76,
  74523: 1.76,
  74532: 1.76,
  74535: 1.76,
  74538: 1.76,
  74541: 1.76,
  74542: 1.76,
  74544: 1.76,
  74545: 1.76,
  74547: 1.76,
  74549: 1.76,
  74564: 1.76,
  74572: 1.76,
  74575: 1.76,
  74579: 1.76,
  74582: 1.76,
  74585: 1.76,
  74586: 1.76,
  74589: 1.76,
  74592: 1.76,
  74594: 1.76,
  74595: 1.76,
  74597: 1.76,
  74599: 1.76,
  74613: 1.76,
  74626: 1.76,
  74629: 1.76,
  74632: 1.76,
  74635: 1.76,
  74638: 1.76,
  74639: 1.76,
  74653: 1.76,
  74670: 1.76,
  74673: 1.76,
  74676: 1.76,
  74677: 1.76,
  74679: 1.76,
  74706: 1.76,
  74722: 1.76,
  74731: 1.76,
  74736: 1.76,
  74740: 1.76,
  74743: 1.76,
  74744: 1.76,
  74746: 1.76,
  74747: 1.76,
  74749: 1.76,
  74821: 1.76,
  74831: 1.76,
  74834: 1.76,
  74838: 1.76,
  74842: 1.76,
  74847: 1.76,
  74850: 1.76,
  74855: 1.76,
  74858: 1.76,
  74861: 1.76,
  74862: 1.76,
  74864: 1.76,
  74865: 1.76,
  74867: 1.76,
  74869: 1.76,
  74889: 1.76,
  74906: 1.76,
  74909: 1.76,
  74912: 1.76,
  74915: 1.76,
  74918: 1.76,
  74921: 1.76,
  74924: 1.76,
  74925: 1.76,
  74927: 1.76,
  74928: 1.76,
  74930: 1.76,
  74931: 1.76,
  74933: 1.76,
  74934: 1.76,
  74936: 1.76,
  74937: 1.76,
  74939: 1.76,
  75015: 1.76,
  75031: 1.76,
  75038: 1.76,
  75045: 1.76,
  75050: 1.76,
  75053: 1.76,
  75056: 1.76,
  75057: 1.76,
  75059: 1.76,
  75172: 1.76,
  75173: 1.76,
  75175: 1.76,
  75177: 1.76,
  75179: 1.76,
  75180: 1.76,
  75181: 1.76,
  75196: 1.76,
  75203: 1.76,
  75210: 1.76,
  75217: 1.76,
  75223: 1.76,
  75228: 1.76,
  75233: 1.76,
  75236: 1.76,
  75239: 1.76,
  75242: 1.76,
  75245: 1.76,
  75248: 1.76,
  75249: 1.76,
  75305: 1.76,
  75323: 1.76,
  75328: 1.76,
  75331: 1.76,
  75334: 1.76,
  75335: 1.76,
  75337: 1.76,
  75339: 1.76,
  75365: 1.76,
  75378: 1.76,
  75382: 1.76,
  75385: 1.76,
  75387: 1.76,
  75389: 1.76,
  75391: 1.76,
  75392: 1.76,
  75394: 1.76,
  75395: 1.76,
  75397: 1.76,
  75399: 1.76,
  75417: 1.76,
  75428: 1.76,
  75433: 1.76,
  75438: 1.76,
  75443: 1.76,
  75446: 1.76,
  75447: 1.76,
  75449: 1.76,
  76131: 1.76,
  76133: 1.76,
  76135: 1.76,
  76137: 1.76,
  76139: 1.76,
  76149: 1.76,
  76185: 1.76,
  76187: 1.76,
  76189: 1.76,
  76199: 1.76,
  76227: 1.76,
  76228: 1.76,
  76229: 1.76,
  76275: 1.76,
  76287: 1.76,
  76297: 1.76,
  76307: 1.76,
  76316: 1.76,
  76327: 1.76,
  76332: 1.76,
  76337: 1.76,
  76344: 1.76,
  76351: 1.76,
  76356: 1.76,
  76359: 1.76,
  76437: 1.76,
  76448: 1.76,
  76456: 1.76,
  76461: 1.76,
  76467: 1.76,
  76470: 1.76,
  76473: 1.76,
  76474: 1.76,
  76476: 1.76,
  76477: 1.76,
  76479: 1.76,
  76530: 1.76,
  76532: 1.76,
  76534: 1.76,
  76547: 1.76,
  76549: 1.76,
  76571: 1.76,
  76593: 1.76,
  76596: 1.76,
  76597: 1.76,
  76599: 1.76,
  76646: 1.76,
  76661: 1.76,
  76669: 1.76,
  76676: 1.76,
  76684: 1.76,
  76689: 1.76,
  76694: 1.76,
  76698: 1.76,
  76703: 1.76,
  76706: 1.76,
  76707: 1.76,
  76709: 1.76,
  76726: 1.76,
  76744: 1.76,
  76751: 1.76,
  76756: 1.76,
  76761: 1.76,
  76764: 1.76,
  76767: 1.76,
  76768: 1.76,
  76770: 1.76,
  76771: 1.76,
  76773: 1.76,
  76774: 1.76,
  76776: 1.76,
  76777: 1.76,
  76779: 1.76,
  76829: 1.76,
  76831: 1.76,
  76833: 1.76,
  76835: 1.76,
  76846: 1.76,
  76848: 1.76,
  76855: 1.76,
  76857: 1.76,
  76863: 1.76,
  76865: 1.76,
  76870: 1.76,
  76872: 1.76,
  76877: 1.76,
  76879: 1.76,
  76887: 1.76,
  76889: 1.76,
  76891: 1.76,
  77652: 1.76,
  77654: 1.76,
  77656: 1.76,
  77694: 1.76,
  77704: 1.76,
  77709: 1.76,
  77716: 1.76,
  77723: 1.76,
  77728: 1.76,
  77731: 1.76,
  77736: 1.76,
  77740: 1.76,
  77743: 1.76,
  77746: 1.76,
  77749: 1.76,
  77756: 1.76,
  77761: 1.76,
  77767: 1.76,
  77770: 1.76,
  77773: 1.76,
  77776: 1.76,
  77781: 1.76,
  77784: 1.76,
  77787: 1.76,
  77790: 1.76,
  77791: 1.76,
  77793: 1.76,
  77794: 1.76,
  77796: 1.76,
  77797: 1.76,
  77799: 1.76,
  77815: 1.76,
  77830: 1.76,
  77833: 1.76,
  77836: 1.76,
  77839: 1.76,
  77855: 1.76,
  77866: 1.76,
  77871: 1.76,
  77876: 1.76,
  77880: 1.76,
  77883: 1.76,
  77886: 1.76,
  77887: 1.76,
  77889: 1.76,
  77933: 1.76,
  77948: 1.76,
  77955: 1.76,
  77960: 1.76,
  77963: 1.76,
  77966: 1.76,
  77971: 1.76,
  77972: 1.76,
  77974: 1.76,
  77975: 1.76,
  77977: 1.76,
  77978: 1.76,
  78048: 1.76,
  78050: 1.76,
  78052: 1.76,
  78054: 1.76,
  78056: 1.76,
  78073: 1.76,
  78078: 1.76,
  78083: 1.76,
  78086: 1.76,
  78087: 1.76,
  78089: 1.76,
  78098: 1.76,
  78112: 1.76,
  78120: 1.76,
  78126: 1.76,
  78132: 1.76,
  78136: 1.76,
  78141: 1.76,
  78144: 1.76,
  78147: 1.76,
  78148: 1.76,
  78166: 1.76,
  78176: 1.76,
  78183: 1.76,
  78187: 1.76,
  78194: 1.76,
  78199: 1.76,
  78224: 1.76,
  78234: 1.76,
  78239: 1.76,
  78244: 1.76,
  78247: 1.76,
  78250: 1.76,
  78253: 1.76,
  78256: 1.76,
  78259: 1.76,
  78262: 1.76,
  78266: 1.76,
  78267: 1.76,
  78269: 1.76,
  78315: 1.76,
  78333: 1.76,
  78337: 1.76,
  78343: 1.76,
  78345: 1.76,
  78351: 1.76,
  78354: 1.76,
  78355: 1.76,
  78357: 1.76,
  78359: 1.76,
  78462: 1.76,
  78464: 1.76,
  78465: 1.76,
  78467: 1.76,
  78476: 1.76,
  78479: 1.76,
  78532: 1.76,
  78549: 1.76,
  78554: 1.76,
  78559: 1.76,
  78564: 1.76,
  78567: 1.76,
  78570: 1.76,
  78573: 1.76,
  78576: 1.76,
  78579: 1.76,
  78580: 1.76,
  78582: 1.76,
  78583: 1.76,
  78585: 1.76,
  78586: 1.76,
  78588: 1.76,
  78589: 1.76,
  78591: 1.76,
  78592: 1.76,
  78594: 1.76,
  78595: 1.76,
  78597: 1.76,
  78598: 1.76,
  78600: 1.76,
  78601: 1.76,
  78603: 1.76,
  78604: 1.76,
  78606: 1.76,
  78607: 1.76,
  78609: 1.76,
  78628: 1.76,
  78647: 1.76,
  78652: 1.76,
  78655: 1.76,
  78658: 1.76,
  78661: 1.76,
  78662: 1.76,
  78664: 1.76,
  78665: 1.76,
  78667: 1.76,
  78669: 1.76,
  78713: 1.76,
  78727: 1.76,
  78730: 1.76,
  78733: 1.76,
  78736: 1.76,
  78737: 1.76,
  78739: 1.76,
  79098: 1.76,
  79100: 1.76,
  79102: 1.76,
  79104: 1.76,
  79106: 1.76,
  79108: 1.76,
  79110: 1.76,
  79111: 1.76,
  79112: 1.76,
  79114: 1.76,
  79115: 1.76,
  79117: 1.76,
  79183: 1.76,
  79189: 1.76,
  79194: 1.76,
  79199: 1.76,
  79206: 1.76,
  79211: 1.76,
  79215: 1.76,
  79219: 1.76,
  79224: 1.76,
  79227: 1.76,
  79232: 1.76,
  79235: 1.76,
  79238: 1.76,
  79241: 1.76,
  79244: 1.76,
  79249: 1.76,
  79252: 1.76,
  79254: 1.76,
  79256: 1.76,
  79258: 1.76,
  79261: 1.76,
  79263: 1.76,
  79268: 1.76,
  79271: 1.76,
  79274: 1.76,
  79276: 1.76,
  79279: 1.76,
  79280: 1.76,
  79282: 1.76,
  79283: 1.76,
  79285: 1.76,
  79286: 1.76,
  79288: 1.76,
  79289: 1.76,
  79291: 1.76,
  79292: 1.76,
  79294: 1.76,
  79295: 1.76,
  79297: 1.76,
  79299: 1.76,
  79312: 1.76,
  79331: 1.76,
  79336: 1.76,
  79341: 1.76,
  79346: 1.76,
  79348: 1.76,
  79350: 1.76,
  79353: 1.76,
  79356: 1.76,
  79359: 1.76,
  79361: 1.76,
  79362: 1.76,
  79364: 1.76,
  79365: 1.76,
  79367: 1.76,
  79369: 1.76,
  79379: 1.76,
  79395: 1.76,
  79400: 1.76,
  79410: 1.76,
  79415: 1.76,
  79418: 1.76,
  79423: 1.76,
  79424: 1.76,
  79426: 1.76,
  79427: 1.76,
  79429: 1.76,
  79539: 1.76,
  79540: 1.76,
  79541: 1.76,
  79576: 1.76,
  79585: 1.76,
  79588: 1.76,
  79589: 1.76,
  79591: 1.76,
  79592: 1.76,
  79594: 1.76,
  79595: 1.76,
  79597: 1.76,
  79599: 1.76,
  79618: 1.76,
  79639: 1.76,
  79650: 1.76,
  79664: 1.76,
  79669: 1.76,
  79674: 1.76,
  79677: 1.76,
  79682: 1.76,
  79685: 1.76,
  79686: 1.76,
  79688: 1.76,
  79689: 1.76,
  79692: 1.76,
  79694: 1.76,
  79695: 1.76,
  79713: 1.76,
  79725: 1.76,
  79730: 1.76,
  79733: 1.76,
  79736: 1.76,
  79737: 1.76,
  79739: 1.76,
  79761: 1.76,
  79771: 1.76,
  79774: 1.76,
  79777: 1.76,
  79780: 1.76,
  79787: 1.76,
  79790: 1.76,
  79793: 1.76,
  79798: 1.76,
  79801: 1.76,
  79802: 1.76,
  79804: 1.76,
  79805: 1.76,
  79807: 1.76,
  79809: 1.76,
  79822: 1.76,
  79837: 1.76,
  79843: 1.76,
  79848: 1.76,
  79853: 1.76,
  79856: 1.76,
  79859: 1.76,
  79862: 1.76,
  79865: 1.76,
  79868: 1.76,
  79871: 1.76,
  79872: 1.76,
  79874: 1.76,
  79875: 1.76,
  79877: 1.76,
  79879: 1.76,
  80331: 1.76,
  80333: 1.76,
  80335: 1.76,
  80336: 1.65,
  80337: 1.69,
  80339: 1.69,
  80469: 1.69,
  80538: 1.69,
  80539: 1.69,
  80634: 1.69,
  80636: 1.69,
  80637: 1.69,
  80638: 1.69,
  80639: 1.69,
  80686: 1.69,
  80687: 1.69,
  80689: 1.69,
  80796: 1.69,
  80797: 1.69,
  80798: 1.69,
  80799: 1.69,
  80801: 1.69,
  80802: 1.69,
  80803: 1.69,
  80804: 1.69,
  80805: 1.69,
  80807: 1.69,
  80809: 1.69,
  80933: 1.69,
  80935: 1.69,
  80937: 1.69,
  80939: 1.69,
  80992: 1.69,
  80993: 1.69,
  80995: 1.69,
  80997: 1.69,
  80999: 1.69,
  81241: 1.69,
  81243: 1.69,
  81245: 1.69,
  81247: 1.69,
  81248: 1.69,
  81249: 1.69,
  81369: 1.69,
  81371: 1.69,
  81373: 1.69,
  81375: 1.69,
  81377: 1.69,
  81379: 1.69,
  81475: 1.69,
  81476: 1.69,
  81477: 1.69,
  81479: 1.69,
  81539: 1.69,
  81541: 1.69,
  81543: 1.69,
  81545: 1.69,
  81547: 1.69,
  81549: 1.69,
  81667: 1.69,
  81669: 1.69,
  81671: 1.69,
  81673: 1.69,
  81675: 1.69,
  81677: 1.69,
  81679: 1.69,
  81735: 1.69,
  81737: 1.69,
  81739: 1.69,
  81825: 1.69,
  81827: 1.69,
  81829: 1.69,
  81925: 1.69,
  81927: 1.69,
  81929: 1.69,
  82008: 1.69,
  82024: 1.69,
  82031: 1.69,
  82041: 1.69,
  82049: 1.69,
  82054: 1.69,
  82057: 1.69,
  82061: 1.69,
  82064: 1.69,
  82065: 1.69,
  82067: 1.69,
  82069: 1.69,
  82110: 1.69,
  82131: 1.69,
  82140: 1.69,
  82152: 1.69,
  82166: 1.69,
  82178: 1.69,
  82194: 1.69,
  82205: 1.69,
  82211: 1.69,
  82216: 1.69,
  82223: 1.69,
  82229: 1.69,
  82234: 1.69,
  82237: 1.69,
  82239: 1.69,
  82256: 1.69,
  82266: 1.69,
  82269: 1.69,
  82272: 1.69,
  82275: 1.69,
  82276: 1.69,
  82278: 1.69,
  82279: 1.69,
  82281: 1.69,
  82284: 1.69,
  82285: 1.69,
  82287: 1.69,
  82288: 1.69,
  82290: 1.69,
  82291: 1.69,
  82293: 1.69,
  82294: 1.69,
  82296: 1.69,
  82297: 1.69,
  82299: 1.69,
  82319: 1.69,
  82327: 1.69,
  82335: 1.69,
  82340: 1.69,
  82343: 1.69,
  82346: 1.69,
  82347: 1.69,
  82349: 1.69,
  82362: 1.69,
  82377: 1.69,
  82380: 1.69,
  82383: 1.69,
  82386: 1.69,
  82387: 1.69,
  82389: 1.69,
  82390: 1.69,
  82392: 1.69,
  82393: 1.69,
  82395: 1.69,
  82396: 1.69,
  82398: 1.69,
  82399: 1.69,
  82401: 1.69,
  82402: 1.69,
  82404: 1.69,
  82405: 1.69,
  82407: 1.69,
  82409: 1.69,
  82418: 1.69,
  82431: 1.69,
  82432: 1.69,
  82433: 1.69,
  82435: 1.69,
  82436: 1.69,
  82438: 1.69,
  82439: 1.69,
  82441: 1.69,
  82442: 1.69,
  82444: 1.69,
  82445: 1.69,
  82447: 1.69,
  82449: 1.69,
  82467: 1.69,
  82475: 1.69,
  82481: 1.69,
  82487: 1.69,
  82488: 1.69,
  82490: 1.69,
  82491: 1.69,
  82493: 1.69,
  82494: 1.69,
  82496: 1.69,
  82497: 1.69,
  82499: 1.69,
  82515: 1.69,
  82538: 1.69,
  82541: 1.69,
  82544: 1.69,
  82547: 1.69,
  82549: 1.69,
  83022: 1.69,
  83024: 1.69,
  83026: 1.69,
  83043: 1.69,
  83052: 1.69,
  83059: 1.69,
  83064: 1.69,
  83071: 1.69,
  83075: 1.69,
  83080: 1.69,
  83083: 1.69,
  83088: 1.69,
  83093: 1.69,
  83098: 1.69,
  83101: 1.69,
  83104: 1.69,
  83109: 1.69,
  83112: 1.69,
  83115: 1.69,
  83119: 1.69,
  83122: 1.69,
  83123: 1.69,
  83125: 1.69,
  83126: 1.69,
  83128: 1.69,
  83129: 1.69,
  83131: 1.69,
  83132: 1.69,
  83134: 1.69,
  83135: 1.69,
  83137: 1.69,
  83139: 1.69,
  83224: 1.69,
  83229: 1.69,
  83233: 1.69,
  83236: 1.69,
  83242: 1.69,
  83246: 1.69,
  83250: 1.69,
  83253: 1.69,
  83254: 1.69,
  83256: 1.69,
  83257: 1.69,
  83259: 1.69,
  83278: 1.69,
  83301: 1.69,
  83308: 1.69,
  83313: 1.69,
  83317: 1.69,
  83324: 1.69,
  83329: 1.69,
  83334: 1.69,
  83339: 1.69,
  83342: 1.69,
  83346: 1.69,
  83349: 1.69,
  83352: 1.69,
  83355: 1.69,
  83358: 1.69,
  83361: 1.69,
  83362: 1.69,
  83364: 1.69,
  83365: 1.69,
  83367: 1.69,
  83368: 1.69,
  83370: 1.69,
  83371: 1.69,
  83373: 1.69,
  83374: 1.69,
  83376: 1.69,
  83377: 1.69,
  83379: 1.69,
  83395: 1.69,
  83404: 1.69,
  83410: 1.69,
  83413: 1.69,
  83416: 1.69,
  83417: 1.69,
  83435: 1.69,
  83451: 1.69,
  83454: 1.69,
  83457: 1.69,
  83458: 1.69,
  83471: 1.69,
  83483: 1.69,
  83486: 1.69,
  83487: 1.69,
  83512: 1.69,
  83527: 1.69,
  83530: 1.69,
  83533: 1.69,
  83536: 1.69,
  83539: 1.69,
  83543: 1.69,
  83544: 1.69,
  83546: 1.69,
  83547: 1.69,
  83549: 1.69,
  83550: 1.69,
  83553: 1.69,
  83555: 1.69,
  83556: 1.69,
  83558: 1.69,
  83559: 1.69,
  83561: 1.69,
  83562: 1.69,
  83564: 1.69,
  83567: 1.69,
  83569: 1.69,
  83607: 1.69,
  83620: 1.69,
  83623: 1.69,
  83624: 1.69,
  83626: 1.69,
  83627: 1.69,
  83629: 1.69,
  83646: 1.69,
  83661: 1.69,
  83666: 1.69,
  83670: 1.69,
  83671: 1.69,
  83673: 1.69,
  83674: 1.69,
  83676: 1.69,
  83677: 1.69,
  83679: 1.69,
  83684: 1.69,
  83700: 1.69,
  83703: 1.69,
  83707: 1.69,
  83708: 1.69,
  83714: 1.69,
  83727: 1.69,
  83730: 1.69,
  83734: 1.69,
  83735: 1.69,
  83737: 1.69,
  84028: 1.69,
  84030: 1.69,
  84032: 1.69,
  84034: 1.69,
  84036: 1.69,
  84048: 1.69,
  84051: 1.69,
  84056: 1.69,
  84061: 1.69,
  84066: 1.69,
  84069: 1.69,
  84072: 1.69,
  84076: 1.69,
  84079: 1.69,
  84082: 1.69,
  84085: 1.69,
  84088: 1.69,
  84089: 1.69,
  84091: 1.69,
  84092: 1.69,
  84094: 1.69,
  84095: 1.69,
  84097: 1.69,
  84098: 1.69,
  84100: 1.69,
  84101: 1.69,
  84103: 1.69,
  84104: 1.69,
  84106: 1.69,
  84107: 1.69,
  84109: 1.69,
  84130: 1.69,
  84137: 1.69,
  84140: 1.69,
  84144: 1.69,
  84149: 1.69,
  84152: 1.69,
  84155: 1.69,
  84160: 1.69,
  84163: 1.69,
  84164: 1.69,
  84166: 1.69,
  84168: 1.69,
  84169: 1.69,
  84171: 1.69,
  84172: 1.69,
  84174: 1.69,
  84175: 1.69,
  84177: 1.69,
  84178: 1.69,
  84180: 1.69,
  84181: 1.69,
  84183: 1.69,
  84184: 1.69,
  84186: 1.69,
  84187: 1.69,
  84189: 1.69,
  84307: 1.69,
  84323: 1.69,
  84326: 1.69,
  84329: 1.69,
  84332: 1.69,
  84333: 1.69,
  84335: 1.69,
  84337: 1.69,
  84339: 1.69,
  84347: 1.69,
  84359: 1.69,
  84364: 1.69,
  84367: 1.69,
  84371: 1.69,
  84375: 1.69,
  84378: 1.69,
  84381: 1.69,
  84384: 1.69,
  84385: 1.69,
  84387: 1.69,
  84389: 1.69,
  84405: 1.69,
  84416: 1.69,
  84419: 1.69,
  84424: 1.69,
  84427: 1.69,
  84428: 1.69,
  84431: 1.69,
  84432: 1.69,
  84434: 1.69,
  84435: 1.69,
  84437: 1.69,
  84439: 1.69,
  84453: 1.69,
  84478: 1.69,
  84489: 1.69,
  84494: 1.69,
  84503: 1.69,
  84508: 1.69,
  84513: 1.69,
  84518: 1.69,
  84524: 1.69,
  84529: 1.69,
  84533: 1.69,
  84539: 1.69,
  84543: 1.69,
  84544: 1.69,
  84546: 1.69,
  84547: 1.69,
  84549: 1.69,
  84550: 1.69,
  84552: 1.69,
  84553: 1.69,
  84555: 1.69,
  84556: 1.69,
  84558: 1.69,
  84559: 1.69,
  84561: 1.69,
  84562: 1.69,
  84564: 1.69,
  84565: 1.69,
  84567: 1.69,
  84568: 1.69,
  84570: 1.69,
  84571: 1.69,
  84573: 1.69,
  84574: 1.69,
  84576: 1.69,
  84577: 1.69,
  84579: 1.69,
  85049: 1.69,
  85051: 1.69,
  85053: 1.69,
  85055: 1.69,
  85057: 1.69,
  85072: 1.69,
  85077: 1.69,
  85080: 1.69,
  85084: 1.69,
  85088: 1.69,
  85092: 1.69,
  85095: 1.69,
  85098: 1.69,
  85101: 1.69,
  85104: 1.69,
  85107: 1.69,
  85110: 1.69,
  85111: 1.69,
  85113: 1.69,
  85114: 1.69,
  85116: 1.69,
  85117: 1.69,
  85119: 1.69,
  85120: 1.69,
  85122: 1.69,
  85123: 1.69,
  85125: 1.69,
  85126: 1.69,
  85128: 1.69,
  85129: 1.69,
  85131: 1.69,
  85132: 1.69,
  85134: 1.69,
  85135: 1.69,
  85137: 1.69,
  85139: 1.69,
  85221: 1.69,
  85229: 1.69,
  85232: 1.69,
  85235: 1.69,
  85238: 1.69,
  85241: 1.69,
  85244: 1.69,
  85247: 1.69,
  85250: 1.69,
  85253: 1.69,
  85254: 1.69,
  85256: 1.69,
  85258: 1.69,
  85259: 1.69,
  85276: 1.69,
  85283: 1.69,
  85290: 1.69,
  85293: 1.69,
  85296: 1.69,
  85298: 1.69,
  85301: 1.69,
  85302: 1.69,
  85304: 1.69,
  85305: 1.69,
  85307: 1.69,
  85309: 1.69,
  85354: 1.69,
  85356: 1.69,
  85368: 1.69,
  85375: 1.69,
  85376: 1.69,
  85386: 1.69,
  85391: 1.69,
  85395: 1.69,
  85399: 1.69,
  85402: 1.69,
  85405: 1.69,
  85406: 1.69,
  85408: 1.69,
  85410: 1.69,
  85411: 1.69,
  85413: 1.69,
  85414: 1.69,
  85416: 1.69,
  85417: 1.69,
  85419: 1.69,
  85435: 1.69,
  85445: 1.69,
  85447: 1.69,
  85452: 1.69,
  85456: 1.69,
  85457: 1.69,
  85459: 1.69,
  85461: 1.69,
  85462: 1.69,
  85464: 1.69,
  85465: 1.69,
  85467: 1.69,
  85469: 1.69,
  85521: 1.69,
  85540: 1.69,
  85551: 1.69,
  85560: 1.69,
  85567: 1.69,
  85570: 1.69,
  85579: 1.69,
  85586: 1.69,
  85591: 1.69,
  85598: 1.69,
  85599: 1.69,
  85604: 1.69,
  85609: 1.69,
  85614: 1.69,
  85617: 1.69,
  85622: 1.69,
  85625: 1.69,
  85630: 1.69,
  85635: 1.69,
  85640: 1.69,
  85643: 1.69,
  85646: 1.69,
  85649: 1.69,
  85652: 1.69,
  85653: 1.69,
  85656: 1.69,
  85658: 1.69,
  85659: 1.69,
  85661: 1.69,
  85662: 1.69,
  85664: 1.69,
  85665: 1.69,
  85667: 1.69,
  85669: 1.69,
  85716: 1.69,
  85737: 1.69,
  85748: 1.69,
  85757: 1.69,
  85764: 1.69,
  85774: 1.69,
  85777: 1.69,
  85778: 1.69,
  86150: 1.69,
  86152: 1.69,
  86153: 1.69,
  86154: 1.69,
  86156: 1.69,
  86157: 1.69,
  86159: 1.69,
  86161: 1.69,
  86163: 1.69,
  86165: 1.69,
  86167: 1.69,
  86169: 1.69,
  86179: 1.69,
  86199: 1.69,
  86316: 1.69,
  86343: 1.69,
  86356: 1.69,
  86368: 1.69,
  86381: 1.69,
  86391: 1.69,
  86399: 1.69,
  86405: 1.69,
  86415: 1.69,
  86420: 1.69,
  86424: 1.69,
  86438: 1.69,
  86441: 1.69,
  86444: 1.69,
  86447: 1.69,
  86450: 1.69,
  86453: 1.69,
  86456: 1.69,
  86459: 1.69,
  86462: 1.69,
  86465: 1.69,
  86470: 1.69,
  86473: 1.69,
  86476: 1.69,
  86477: 1.69,
  86479: 1.69,
  86480: 1.69,
  86482: 1.69,
  86483: 1.69,
  86485: 1.69,
  86486: 1.69,
  86488: 1.69,
  86489: 1.69,
  86491: 1.69,
  86492: 1.69,
  86494: 1.69,
  86495: 1.69,
  86497: 1.69,
  86498: 1.69,
  86500: 1.69,
  86502: 1.69,
  86504: 1.69,
  86505: 1.69,
  86507: 1.69,
  86508: 1.69,
  86510: 1.69,
  86511: 1.69,
  86513: 1.69,
  86514: 1.69,
  86517: 1.69,
  86519: 1.69,
  86529: 1.69,
  86551: 1.69,
  86554: 1.69,
  86556: 1.69,
  86558: 1.69,
  86559: 1.69,
  86561: 1.69,
  86562: 1.69,
  86564: 1.69,
  86565: 1.69,
  86567: 1.69,
  86568: 1.69,
  86570: 1.69,
  86571: 1.69,
  86573: 1.69,
  86574: 1.69,
  86576: 1.69,
  86577: 1.69,
  86579: 1.69,
  86609: 1.69,
  86633: 1.69,
  86637: 1.69,
  86641: 1.69,
  86643: 1.69,
  86647: 1.69,
  86650: 1.69,
  86653: 1.69,
  86655: 1.69,
  86657: 1.69,
  86660: 1.69,
  86663: 1.69,
  86666: 1.69,
  86668: 1.69,
  86669: 1.69,
  86672: 1.69,
  86673: 1.69,
  86674: 1.69,
  86675: 1.69,
  86676: 1.69,
  86678: 1.69,
  86679: 1.69,
  86681: 1.69,
  86682: 1.69,
  86684: 1.69,
  86685: 1.69,
  86687: 1.69,
  86688: 1.69,
  86690: 1.69,
  86692: 1.69,
  86694: 1.69,
  86695: 1.69,
  86697: 1.69,
  86698: 1.69,
  86700: 1.69,
  86701: 1.69,
  86703: 1.69,
  86704: 1.69,
  86706: 1.69,
  86707: 1.69,
  86709: 1.69,
  86720: 1.69,
  86732: 1.69,
  86733: 1.69,
  86735: 1.69,
  86736: 1.69,
  86738: 1.69,
  86739: 1.69,
  86741: 1.69,
  86742: 1.69,
  86744: 1.69,
  86745: 1.69,
  86747: 1.69,
  86748: 1.69,
  86750: 1.69,
  86751: 1.69,
  86753: 1.69,
  86754: 1.69,
  86756: 1.69,
  86757: 1.69,
  86759: 1.69,
  86807: 1.69,
  86825: 1.69,
  86830: 1.69,
  86833: 1.69,
  86836: 1.69,
  86842: 1.69,
  86845: 1.69,
  86850: 1.69,
  86853: 1.69,
  86854: 1.69,
  86856: 1.69,
  86857: 1.69,
  86859: 1.69,
  86860: 1.69,
  86862: 1.69,
  86863: 1.69,
  86865: 1.69,
  86866: 1.69,
  86868: 1.69,
  86869: 1.69,
  86871: 1.69,
  86872: 1.69,
  86874: 1.69,
  86875: 1.69,
  86877: 1.69,
  86879: 1.69,
  86899: 1.69,
  86911: 1.69,
  86916: 1.69,
  86919: 1.69,
  86920: 1.69,
  86922: 1.69,
  86923: 1.69,
  86925: 1.69,
  86926: 1.69,
  86928: 1.69,
  86929: 1.69,
  86931: 1.69,
  86932: 1.69,
  86934: 1.69,
  86935: 1.69,
  86937: 1.69,
  86938: 1.69,
  86940: 1.69,
  86941: 1.69,
  86943: 1.69,
  86944: 1.69,
  86946: 1.69,
  86947: 1.69,
  86949: 1.69,
  86956: 1.69,
  86971: 1.69,
  86972: 1.69,
  86974: 1.69,
  86975: 1.69,
  86977: 1.69,
  86978: 1.69,
  86980: 1.69,
  86981: 1.69,
  86983: 1.69,
  86984: 1.69,
  86986: 1.69,
  86987: 1.69,
  86989: 1.69,
  87435: 1.69,
  87437: 1.69,
  87439: 1.69,
  87448: 1.69,
  87452: 1.69,
  87459: 1.69,
  87463: 1.69,
  87466: 1.69,
  87471: 1.69,
  87474: 1.69,
  87477: 1.69,
  87480: 1.69,
  87484: 1.69,
  87487: 1.69,
  87488: 1.69,
  87490: 1.69,
  87491: 1.69,
  87493: 1.69,
  87494: 1.69,
  87496: 1.69,
  87497: 1.69,
  87499: 1.69,
  87509: 1.69,
  87527: 1.69,
  87534: 1.69,
  87538: 1.69,
  87541: 1.69,
  87544: 1.69,
  87545: 1.69,
  87547: 1.69,
  87549: 1.69,
  87561: 1.69,
  87567: 1.69,
  87568: 1.69,
  87569: 1.69,
  87600: 1.69,
  87616: 1.69,
  87629: 1.69,
  87634: 1.69,
  87637: 1.69,
  87640: 1.69,
  87642: 1.69,
  87645: 1.69,
  87647: 1.69,
  87648: 1.69,
  87650: 1.69,
  87651: 1.69,
  87653: 1.69,
  87654: 1.69,
  87656: 1.69,
  87657: 1.69,
  87659: 1.69,
  87660: 1.69,
  87662: 1.69,
  87663: 1.69,
  87665: 1.69,
  87666: 1.69,
  87668: 1.69,
  87669: 1.69,
  87671: 1.69,
  87672: 1.69,
  87674: 1.69,
  87675: 1.69,
  87677: 1.69,
  87679: 1.69,
  87700: 1.69,
  87719: 1.69,
  87724: 1.69,
  87727: 1.69,
  87730: 1.69,
  87733: 1.69,
  87734: 1.69,
  87736: 1.69,
  87737: 1.69,
  87739: 1.69,
  87740: 1.69,
  87742: 1.69,
  87743: 1.69,
  87745: 1.69,
  87746: 1.69,
  87748: 1.69,
  87749: 1.69,
  87751: 1.69,
  87752: 1.69,
  87754: 1.69,
  87755: 1.69,
  87757: 1.69,
  87758: 1.69,
  87760: 1.69,
  87761: 1.69,
  87763: 1.69,
  87764: 1.69,
  87766: 1.69,
  87767: 1.69,
  87769: 1.69,
  87770: 1.69,
  87772: 1.69,
  87773: 1.69,
  87775: 1.69,
  87776: 1.69,
  87778: 1.69,
  87779: 1.69,
  87781: 1.69,
  87782: 1.69,
  87784: 1.69,
  87785: 1.69,
  87787: 1.69,
  87789: 1.69,
  88045: 1.69,
  88046: 1.69,
  88048: 1.69,
  88069: 1.69,
  88074: 1.69,
  88079: 1.69,
  88085: 1.69,
  88090: 1.69,
  88094: 1.69,
  88097: 1.69,
  88099: 1.69,
  88131: 1.69,
  88138: 1.69,
  88142: 1.69,
  88145: 1.69,
  88147: 1.69,
  88149: 1.69,
  88161: 1.69,
  88167: 1.69,
  88171: 1.69,
  88175: 1.69,
  88178: 1.69,
  88179: 1.69,
  88212: 1.69,
  88213: 1.69,
  88214: 1.69,
  88239: 1.69,
  88250: 1.69,
  88255: 1.69,
  88260: 1.69,
  88263: 1.69,
  88267: 1.69,
  88271: 1.69,
  88273: 1.69,
  88276: 1.69,
  88279: 1.69,
  88281: 1.69,
  88284: 1.69,
  88285: 1.69,
  88287: 1.69,
  88289: 1.69,
  88299: 1.69,
  88316: 1.69,
  88317: 1.69,
  88319: 1.69,
  88326: 1.69,
  88339: 1.69,
  88348: 1.69,
  88353: 1.69,
  88356: 1.69,
  88361: 1.69,
  88364: 1.69,
  88367: 1.69,
  88368: 1.69,
  88370: 1.69,
  88371: 1.69,
  88373: 1.69,
  88374: 1.69,
  88376: 1.69,
  88377: 1.69,
  88379: 1.69,
  88400: 1.69,
  88410: 1.69,
  88416: 1.69,
  88422: 1.69,
  88427: 1.69,
  88430: 1.69,
  88433: 1.69,
  88436: 1.69,
  88437: 1.69,
  88441: 1.69,
  88444: 1.69,
  88447: 1.69,
  88448: 1.69,
  88450: 1.69,
  88451: 1.69,
  88453: 1.69,
  88454: 1.69,
  88456: 1.69,
  88457: 1.69,
  88459: 1.69,
  88471: 1.69,
  88477: 1.69,
  88480: 1.69,
  88481: 1.69,
  88483: 1.69,
  88484: 1.69,
  88486: 1.69,
  88487: 1.69,
  88489: 1.69,
  88499: 1.69,
  88512: 1.69,
  88515: 1.69,
  88518: 1.69,
  88521: 1.69,
  88524: 1.69,
  88525: 1.69,
  88527: 1.69,
  88529: 1.69,
  88605: 1.69,
  88630: 1.69,
  88631: 1.69,
  88633: 1.69,
  88634: 1.69,
  88636: 1.69,
  88637: 1.69,
  88639: 1.69,
  88662: 1.69,
  88677: 1.69,
  88682: 1.69,
  88690: 1.69,
  88693: 1.69,
  88696: 1.69,
  88697: 1.69,
  88699: 1.69,
  88709: 1.69,
  88718: 1.69,
  88719: 1.69,
  89073: 1.69,
  89075: 1.69,
  89077: 1.69,
  89079: 1.69,
  89081: 1.69,
  89129: 1.69,
  89134: 1.69,
  89143: 1.69,
  89150: 1.69,
  89155: 1.69,
  89160: 1.69,
  89165: 1.69,
  89168: 1.69,
  89171: 1.69,
  89173: 1.69,
  89174: 1.69,
  89176: 1.69,
  89177: 1.69,
  89179: 1.69,
  89180: 1.69,
  89182: 1.69,
  89183: 1.69,
  89185: 1.69,
  89186: 1.69,
  89188: 1.69,
  89189: 1.69,
  89191: 1.69,
  89192: 1.69,
  89194: 1.69,
  89195: 1.69,
  89197: 1.69,
  89198: 1.69,
  89231: 1.69,
  89233: 1.69,
  89250: 1.69,
  89257: 1.69,
  89264: 1.69,
  89269: 1.69,
  89275: 1.69,
  89278: 1.69,
  89281: 1.69,
  89284: 1.69,
  89287: 1.69,
  89290: 1.69,
  89291: 1.69,
  89293: 1.69,
  89294: 1.69,
  89296: 1.69,
  89297: 1.69,
  89299: 1.69,
  89312: 1.69,
  89331: 1.69,
  89335: 1.69,
  89340: 1.69,
  89343: 1.69,
  89344: 1.69,
  89346: 1.69,
  89347: 1.69,
  89349: 1.69,
  89350: 1.69,
  89352: 1.69,
  89353: 1.69,
  89355: 1.69,
  89356: 1.69,
  89358: 1.69,
  89359: 1.69,
  89361: 1.69,
  89362: 1.69,
  89364: 1.69,
  89365: 1.69,
  89367: 1.69,
  89368: 1.69,
  89407: 1.69,
  89415: 1.69,
  89420: 1.69,
  89423: 1.69,
  89426: 1.69,
  89428: 1.69,
  89429: 1.69,
  89431: 1.69,
  89434: 1.69,
  89435: 1.69,
  89437: 1.69,
  89438: 1.69,
  89440: 1.69,
  89441: 1.69,
  89443: 1.69,
  89446: 1.69,
  89447: 1.69,
  89518: 1.69,
  89520: 1.69,
  89522: 1.69,
  89537: 1.69,
  89542: 1.69,
  89547: 1.69,
  89551: 1.69,
  89555: 1.69,
  89558: 1.69,
  89561: 1.69,
  89564: 1.69,
  89567: 1.69,
  89568: 1.69,
  89584: 1.69,
  89597: 1.69,
  89601: 1.69,
  89604: 1.69,
  89605: 1.69,
  89607: 1.69,
  89608: 1.69,
  89610: 1.69,
  89611: 1.69,
  89613: 1.69,
  89614: 1.69,
  89616: 1.69,
  89617: 1.69,
  89619: 1.69,
  90402: 1.69,
  90403: 1.69,
  90408: 1.69,
  90409: 1.72,
  90411: 1.72,
  90419: 1.72,
  90425: 1.72,
  90427: 1.72,
  90429: 1.72,
  90431: 1.72,
  90439: 1.72,
  90441: 1.72,
  90443: 1.72,
  90449: 1.72,
  90451: 1.72,
  90453: 1.72,
  90455: 1.72,
  90459: 1.72,
  90461: 1.72,
  90469: 1.72,
  90471: 1.72,
  90473: 1.72,
  90475: 1.72,
  90478: 1.72,
  90480: 1.72,
  90482: 1.72,
  90489: 1.72,
  90491: 1.72,
  90513: 1.72,
  90518: 1.72,
  90522: 1.72,
  90530: 1.72,
  90537: 1.72,
  90542: 1.72,
  90547: 1.72,
  90552: 1.72,
  90556: 1.72,
  90559: 1.72,
  90562: 1.72,
  90571: 1.72,
  90574: 1.72,
  90579: 1.72,
  90584: 1.72,
  90587: 1.72,
  90592: 1.72,
  90596: 1.72,
  90599: 1.72,
  90602: 1.72,
  90607: 1.72,
  90610: 1.72,
  90613: 1.72,
  90614: 1.72,
  90616: 1.72,
  90617: 1.72,
  90619: 1.72,
  90762: 1.72,
  90763: 1.72,
  90765: 1.72,
  90766: 1.72,
  90768: 1.72,
  91052: 1.72,
  91054: 1.72,
  91056: 1.72,
  91058: 1.72,
  91074: 1.72,
  91077: 1.72,
  91080: 1.72,
  91083: 1.72,
  91085: 1.72,
  91086: 1.72,
  91088: 1.72,
  91090: 1.72,
  91091: 1.72,
  91093: 1.72,
  91094: 1.72,
  91096: 1.72,
  91097: 1.72,
  91099: 1.72,
  91126: 1.72,
  91154: 1.72,
  91161: 1.72,
  91166: 1.72,
  91171: 1.72,
  91174: 1.72,
  91177: 1.72,
  91180: 1.72,
  91183: 1.72,
  91186: 1.72,
  91187: 1.72,
  91189: 1.72,
  91207: 1.72,
  91217: 1.72,
  91220: 1.72,
  91224: 1.72,
  91227: 1.72,
  91230: 1.72,
  91233: 1.72,
  91235: 1.72,
  91236: 1.72,
  91238: 1.72,
  91239: 1.72,
  91241: 1.72,
  91242: 1.72,
  91244: 1.72,
  91245: 1.72,
  91247: 1.72,
  91249: 1.72,
  91257: 1.72,
  91275: 1.72,
  91278: 1.72,
  91281: 1.72,
  91282: 1.72,
  91284: 1.72,
  91286: 1.72,
  91287: 1.72,
  91289: 1.72,
  91301: 1.72,
  91315: 1.72,
  91320: 1.72,
  91322: 1.72,
  91325: 1.72,
  91327: 1.72,
  91330: 1.72,
  91332: 1.72,
  91334: 1.72,
  91336: 1.72,
  91338: 1.72,
  91341: 1.72,
  91344: 1.72,
  91346: 1.72,
  91347: 1.72,
  91349: 1.72,
  91350: 1.72,
  91352: 1.72,
  91353: 1.72,
  91355: 1.72,
  91356: 1.72,
  91358: 1.72,
  91359: 1.72,
  91361: 1.72,
  91362: 1.72,
  91364: 1.72,
  91365: 1.72,
  91367: 1.72,
  91369: 1.72,
  91413: 1.72,
  91438: 1.72,
  91443: 1.72,
  91448: 1.72,
  91452: 1.72,
  91456: 1.72,
  91459: 1.72,
  91460: 1.72,
  91462: 1.72,
  91463: 1.72,
  91465: 1.72,
  91466: 1.72,
  91468: 1.72,
  91469: 1.72,
  91471: 1.72,
  91472: 1.72,
  91474: 1.72,
  91475: 1.72,
  91477: 1.72,
  91478: 1.72,
  91480: 1.72,
  91481: 1.72,
  91483: 1.72,
  91484: 1.72,
  91486: 1.72,
  91487: 1.72,
  91489: 1.72,
  91522: 1.72,
  91541: 1.72,
  91550: 1.72,
  91555: 1.72,
  91560: 1.72,
  91564: 1.72,
  91567: 1.72,
  91572: 1.72,
  91575: 1.72,
  91578: 1.72,
  91580: 1.72,
  91583: 1.72,
  91586: 1.72,
  91587: 1.72,
  91589: 1.72,
  91590: 1.72,
  91592: 1.72,
  91593: 1.72,
  91595: 1.72,
  91596: 1.72,
  91598: 1.72,
  91599: 1.72,
  91601: 1.72,
  91602: 1.72,
  91604: 1.72,
  91605: 1.72,
  91607: 1.72,
  91608: 1.72,
  91610: 1.72,
  91611: 1.72,
  91613: 1.72,
  91614: 1.72,
  91616: 1.72,
  91617: 1.72,
  91619: 1.72,
  91620: 1.72,
  91622: 1.72,
  91623: 1.72,
  91625: 1.72,
  91626: 1.72,
  91628: 1.72,
  91629: 1.72,
  91631: 1.72,
  91632: 1.72,
  91634: 1.72,
  91635: 1.72,
  91637: 1.72,
  91639: 1.72,
  91710: 1.72,
  91717: 1.72,
  91719: 1.72,
  91720: 1.72,
  91722: 1.72,
  91723: 1.72,
  91725: 1.72,
  91726: 1.72,
  91728: 1.72,
  91729: 1.72,
  91731: 1.72,
  91732: 1.72,
  91734: 1.72,
  91735: 1.72,
  91737: 1.72,
  91738: 1.72,
  91740: 1.72,
  91741: 1.72,
  91743: 1.72,
  91744: 1.72,
  91746: 1.72,
  91747: 1.72,
  91749: 1.72,
  91757: 1.72,
  91781: 1.72,
  91785: 1.72,
  91788: 1.72,
  91790: 1.72,
  91792: 1.72,
  91793: 1.72,
  91795: 1.72,
  91796: 1.72,
  91798: 1.72,
  91799: 1.72,
  91801: 1.72,
  91802: 1.72,
  91804: 1.72,
  91805: 1.72,
  91807: 1.72,
  91809: 1.72,
  92224: 1.72,
  92237: 1.72,
  92242: 1.72,
  92245: 1.72,
  92249: 1.72,
  92253: 1.72,
  92256: 1.72,
  92259: 1.72,
  92260: 1.72,
  92262: 1.72,
  92263: 1.72,
  92265: 1.72,
  92266: 1.72,
  92268: 1.72,
  92269: 1.72,
  92271: 1.72,
  92272: 1.72,
  92274: 1.72,
  92275: 1.72,
  92277: 1.72,
  92278: 1.72,
  92280: 1.72,
  92281: 1.72,
  92283: 1.72,
  92284: 1.72,
  92286: 1.72,
  92287: 1.72,
  92289: 1.72,
  92318: 1.72,
  92331: 1.72,
  92334: 1.72,
  92339: 1.72,
  92342: 1.72,
  92345: 1.72,
  92348: 1.72,
  92353: 1.72,
  92355: 1.72,
  92358: 1.72,
  92360: 1.72,
  92361: 1.72,
  92363: 1.72,
  92364: 1.72,
  92366: 1.72,
  92367: 1.72,
  92369: 1.72,
  92421: 1.72,
  92431: 1.72,
  92436: 1.72,
  92439: 1.72,
  92442: 1.72,
  92444: 1.72,
  92445: 1.72,
  92447: 1.72,
  92449: 1.72,
  92507: 1.72,
  92521: 1.72,
  92526: 1.72,
  92533: 1.72,
  92536: 1.72,
  92539: 1.72,
  92540: 1.72,
  92542: 1.72,
  92543: 1.72,
  92545: 1.72,
  92546: 1.72,
  92548: 1.72,
  92549: 1.72,
  92551: 1.72,
  92552: 1.72,
  92554: 1.72,
  92555: 1.72,
  92557: 1.72,
  92559: 1.72,
  92637: 1.72,
  92648: 1.72,
  92655: 1.72,
  92660: 1.72,
  92665: 1.72,
  92670: 1.72,
  92676: 1.72,
  92681: 1.72,
  92685: 1.72,
  92690: 1.72,
  92693: 1.72,
  92694: 1.72,
  92696: 1.72,
  92697: 1.72,
  92699: 1.72,
  92700: 1.72,
  92702: 1.72,
  92703: 1.72,
  92705: 1.72,
  92706: 1.72,
  92708: 1.72,
  92709: 1.72,
  92711: 1.72,
  92712: 1.72,
  92714: 1.72,
  92715: 1.72,
  92717: 1.72,
  92718: 1.72,
  92720: 1.72,
  92721: 1.72,
  92723: 1.72,
  92724: 1.72,
  92726: 1.72,
  92727: 1.72,
  92729: 1.72,
  93047: 1.72,
  93049: 1.72,
  93051: 1.72,
  93053: 1.72,
  93055: 1.72,
  93057: 1.72,
  93059: 1.72,
  93073: 1.72,
  93077: 1.72,
  93080: 1.72,
  93083: 1.72,
  93086: 1.72,
  93087: 1.72,
  93089: 1.72,
  93090: 1.72,
  93092: 1.72,
  93093: 1.72,
  93095: 1.72,
  93096: 1.72,
  93098: 1.72,
  93099: 1.72,
  93101: 1.72,
  93102: 1.72,
  93104: 1.72,
  93105: 1.72,
  93107: 1.72,
  93109: 1.72,
  93128: 1.72,
  93133: 1.72,
  93138: 1.72,
  93142: 1.72,
  93149: 1.72,
  93152: 1.72,
  93155: 1.72,
  93158: 1.72,
  93161: 1.72,
  93164: 1.72,
  93167: 1.72,
  93170: 1.72,
  93173: 1.72,
  93176: 1.72,
  93177: 1.72,
  93179: 1.72,
  93180: 1.72,
  93182: 1.72,
  93183: 1.72,
  93185: 1.72,
  93186: 1.72,
  93188: 1.72,
  93189: 1.72,
  93191: 1.72,
  93192: 1.72,
  93194: 1.72,
  93195: 1.72,
  93197: 1.72,
  93199: 1.72,
  93309: 1.72,
  93326: 1.72,
  93333: 1.72,
  93336: 1.72,
  93339: 1.72,
  93342: 1.72,
  93343: 1.72,
  93345: 1.72,
  93346: 1.72,
  93348: 1.72,
  93349: 1.72,
  93351: 1.72,
  93352: 1.72,
  93354: 1.72,
  93356: 1.72,
  93358: 1.72,
  93359: 1.72,
  93413: 1.72,
  93426: 1.72,
  93437: 1.72,
  93444: 1.72,
  93449: 1.72,
  93453: 1.72,
  93455: 1.72,
  93458: 1.72,
  93462: 1.72,
  93464: 1.72,
  93466: 1.72,
  93468: 1.72,
  93470: 1.72,
  93471: 1.72,
  93473: 1.72,
  93474: 1.72,
  93476: 1.72,
  93477: 1.72,
  93479: 1.72,
  93480: 1.72,
  93482: 1.72,
  93483: 1.72,
  93485: 1.72,
  93486: 1.72,
  93488: 1.72,
  93489: 1.72,
  93491: 1.72,
  93492: 1.72,
  93494: 1.72,
  93495: 1.72,
  93497: 1.72,
  93499: 1.72,
  94032: 1.72,
  94034: 1.72,
  94036: 1.72,
  94051: 1.72,
  94060: 1.72,
  94065: 1.72,
  94072: 1.72,
  94078: 1.72,
  94081: 1.72,
  94086: 1.72,
  94089: 1.72,
  94094: 1.72,
  94099: 1.72,
  94104: 1.72,
  94107: 1.72,
  94110: 1.72,
  94113: 1.72,
  94116: 1.72,
  94118: 1.72,
  94121: 1.72,
  94124: 1.72,
  94127: 1.72,
  94130: 1.72,
  94133: 1.72,
  94136: 1.72,
  94137: 1.72,
  94139: 1.72,
  94140: 1.72,
  94142: 1.72,
  94143: 1.72,
  94145: 1.72,
  94146: 1.72,
  94148: 1.72,
  94149: 1.72,
  94151: 1.72,
  94152: 1.72,
  94154: 1.72,
  94157: 1.72,
  94158: 1.72,
  94160: 1.72,
  94161: 1.72,
  94163: 1.72,
  94164: 1.72,
  94166: 1.72,
  94167: 1.72,
  94169: 1.72,
  94209: 1.72,
  94227: 1.72,
  94234: 1.72,
  94239: 1.72,
  94244: 1.72,
  94249: 1.72,
  94250: 1.72,
  94252: 1.72,
  94253: 1.72,
  94255: 1.72,
  94256: 1.72,
  94258: 1.72,
  94259: 1.72,
  94261: 1.72,
  94262: 1.72,
  94264: 1.72,
  94265: 1.72,
  94267: 1.72,
  94269: 1.72,
  94315: 1.72,
  94327: 1.72,
  94330: 1.72,
  94333: 1.72,
  94336: 1.72,
  94339: 1.72,
  94342: 1.72,
  94344: 1.72,
  94345: 1.72,
  94347: 1.72,
  94348: 1.72,
  94350: 1.72,
  94351: 1.72,
  94353: 1.72,
  94354: 1.72,
  94356: 1.72,
  94357: 1.72,
  94359: 1.72,
  94360: 1.72,
  94362: 1.72,
  94363: 1.72,
  94365: 1.72,
  94366: 1.72,
  94368: 1.72,
  94369: 1.72,
  94371: 1.72,
  94372: 1.72,
  94374: 1.72,
  94375: 1.72,
  94377: 1.72,
  94379: 1.72,
  94405: 1.72,
  94419: 1.72,
  94424: 1.72,
  94428: 1.72,
  94431: 1.72,
  94436: 1.72,
  94437: 1.72,
  94439: 1.72,
  94447: 1.72,
  94469: 1.72,
  94474: 1.72,
  94481: 1.72,
  94486: 1.72,
  94491: 1.72,
  94496: 1.72,
  94501: 1.72,
  94505: 1.72,
  94508: 1.72,
  94513: 1.72,
  94518: 1.72,
  94522: 1.72,
  94526: 1.72,
  94527: 1.72,
  94529: 1.72,
  94530: 1.72,
  94532: 1.72,
  94533: 1.72,
  94535: 1.72,
  94536: 1.72,
  94538: 1.72,
  94539: 1.72,
  94541: 1.72,
  94542: 1.72,
  94544: 1.72,
  94545: 1.72,
  94547: 1.72,
  94548: 1.72,
  94550: 1.72,
  94551: 1.72,
  94553: 1.72,
  94554: 1.72,
  94556: 1.72,
  94557: 1.72,
  94559: 1.72,
  94560: 1.72,
  94562: 1.72,
  94563: 1.72,
  94566: 1.72,
  94568: 1.72,
  94569: 1.72,
  94571: 1.72,
  94572: 1.72,
  94574: 1.72,
  94575: 1.72,
  94577: 1.72,
  94579: 1.72,
  95028: 1.72,
  95030: 1.72,
  95032: 1.72,
  95100: 1.72,
  95111: 1.72,
  95119: 1.72,
  95126: 1.72,
  95131: 1.72,
  95138: 1.72,
  95145: 1.72,
  95152: 1.72,
  95158: 1.72,
  95163: 1.72,
  95168: 1.72,
  95173: 1.72,
  95176: 1.72,
  95179: 1.72,
  95180: 1.72,
  95182: 1.72,
  95183: 1.72,
  95185: 1.72,
  95186: 1.72,
  95188: 1.72,
  95189: 1.72,
  95191: 1.72,
  95192: 1.72,
  95194: 1.72,
  95195: 1.72,
  95197: 1.72,
  95199: 1.72,
  95213: 1.72,
  95233: 1.72,
  95234: 1.72,
  95236: 1.72,
  95237: 1.72,
  95239: 1.72,
  95326: 1.72,
  95336: 1.72,
  95339: 1.72,
  95346: 1.72,
  95349: 1.72,
  95352: 1.72,
  95355: 1.72,
  95356: 1.72,
  95358: 1.72,
  95359: 1.72,
  95361: 1.72,
  95362: 1.72,
  95364: 1.72,
  95365: 1.72,
  95367: 1.72,
  95369: 1.72,
  95444: 1.72,
  95445: 1.72,
  95447: 1.72,
  95448: 1.72,
  95460: 1.72,
  95463: 1.72,
  95466: 1.72,
  95469: 1.72,
  95473: 1.72,
  95478: 1.72,
  95482: 1.72,
  95485: 1.72,
  95488: 1.72,
  95490: 1.72,
  95491: 1.72,
  95493: 1.72,
  95494: 1.72,
  95496: 1.72,
  95497: 1.72,
  95499: 1.72,
  95500: 1.72,
  95502: 1.72,
  95503: 1.72,
  95505: 1.72,
  95506: 1.72,
  95508: 1.72,
  95509: 1.72,
  95511: 1.72,
  95512: 1.72,
  95514: 1.72,
  95515: 1.72,
  95517: 1.72,
  95519: 1.72,
  95615: 1.72,
  95632: 1.72,
  95643: 1.72,
  95652: 1.72,
  95659: 1.72,
  95666: 1.72,
  95671: 1.72,
  95676: 1.72,
  95679: 1.72,
  95680: 1.72,
  95682: 1.72,
  95683: 1.72,
  95685: 1.72,
  95686: 1.72,
  95688: 1.72,
  95689: 1.72,
  95691: 1.72,
  95692: 1.72,
  95694: 1.72,
  95695: 1.72,
  95697: 1.72,
  95698: 1.72,
  95700: 1.72,
  95701: 1.72,
  95703: 1.72,
  95704: 1.72,
  95706: 1.72,
  95707: 1.72,
  95709: 1.72,
  96047: 1.72,
  96049: 1.72,
  96050: 1.72,
  96052: 1.72,
  96103: 1.72,
  96106: 1.72,
  96110: 1.72,
  96114: 1.72,
  96117: 1.72,
  96120: 1.72,
  96123: 1.72,
  96126: 1.72,
  96129: 1.72,
  96132: 1.72,
  96135: 1.72,
  96138: 1.72,
  96142: 1.72,
  96145: 1.72,
  96146: 1.72,
  96148: 1.72,
  96149: 1.72,
  96151: 1.72,
  96152: 1.72,
  96154: 1.72,
  96155: 1.72,
  96157: 1.72,
  96158: 1.72,
  96160: 1.72,
  96161: 1.72,
  96163: 1.72,
  96164: 1.72,
  96166: 1.72,
  96167: 1.72,
  96169: 1.72,
  96170: 1.72,
  96172: 1.72,
  96173: 1.72,
  96175: 1.72,
  96176: 1.72,
  96178: 1.72,
  96179: 1.72,
  96181: 1.72,
  96182: 1.72,
  96184: 1.72,
  96185: 1.72,
  96187: 1.72,
  96188: 1.72,
  96190: 1.72,
  96191: 1.72,
  96193: 1.72,
  96194: 1.72,
  96196: 1.72,
  96197: 1.72,
  96199: 1.72,
  96215: 1.72,
  96224: 1.72,
  96231: 1.72,
  96237: 1.72,
  96242: 1.72,
  96247: 1.72,
  96250: 1.72,
  96253: 1.72,
  96257: 1.72,
  96260: 1.72,
  96264: 1.72,
  96268: 1.72,
  96269: 1.72,
  96271: 1.72,
  96272: 1.72,
  96274: 1.72,
  96275: 1.72,
  96277: 1.72,
  96279: 1.72,
  96317: 1.72,
  96328: 1.72,
  96332: 1.72,
  96337: 1.72,
  96342: 1.72,
  96346: 1.72,
  96349: 1.72,
  96352: 1.72,
  96355: 1.72,
  96358: 1.72,
  96361: 1.72,
  96364: 1.72,
  96365: 1.72,
  96367: 1.72,
  96369: 1.72,
  96450: 1.72,
  96465: 1.72,
  96472: 1.72,
  96476: 1.72,
  96479: 1.72,
  96482: 1.72,
  96484: 1.72,
  96486: 1.72,
  96487: 1.72,
  96489: 1.72,
  96515: 1.72,
  96523: 1.72,
  96524: 1.72,
  96528: 1.72,
  97070: 1.72,
  97072: 1.72,
  97074: 1.72,
  97076: 1.72,
  97078: 1.72,
  97080: 1.72,
  97082: 1.72,
  97084: 1.72,
  97199: 1.72,
  97204: 1.72,
  97209: 1.72,
  97215: 1.72,
  97218: 1.72,
  97222: 1.72,
  97225: 1.72,
  97228: 1.72,
  97230: 1.72,
  97232: 1.72,
  97234: 1.72,
  97236: 1.72,
  97237: 1.72,
  97239: 1.72,
  97241: 1.72,
  97243: 1.72,
  97244: 1.72,
  97246: 1.72,
  97247: 1.72,
  97249: 1.72,
  97250: 1.72,
  97252: 1.72,
  97253: 1.72,
  97255: 1.72,
  97256: 1.72,
  97258: 1.72,
  97259: 1.72,
  97261: 1.72,
  97262: 1.72,
  97264: 1.72,
  97265: 1.72,
  97267: 1.72,
  97268: 1.72,
  97270: 1.72,
  97271: 1.72,
  97273: 1.72,
  97274: 1.72,
  97276: 1.72,
  97277: 1.72,
  97279: 1.72,
  97280: 1.72,
  97282: 1.72,
  97283: 1.72,
  97285: 1.72,
  97286: 1.72,
  97288: 1.72,
  97289: 1.72,
  97291: 1.72,
  97292: 1.72,
  97294: 1.72,
  97295: 1.72,
  97297: 1.72,
  97299: 1.72,
  97318: 1.72,
  97320: 1.72,
  97332: 1.72,
  97334: 1.72,
  97337: 1.72,
  97340: 1.72,
  97342: 1.72,
  97346: 1.72,
  97348: 1.72,
  97350: 1.72,
  97353: 1.72,
  97355: 1.72,
  97357: 1.72,
  97359: 1.72,
  97421: 1.72,
  97422: 1.72,
  97424: 1.72,
  97437: 1.72,
  97440: 1.72,
  97447: 1.72,
  97450: 1.72,
  97453: 1.72,
  97456: 1.72,
  97461: 1.72,
  97464: 1.72,
  97469: 1.72,
  97475: 1.72,
  97478: 1.72,
  97483: 1.72,
  97486: 1.72,
  97488: 1.72,
  97490: 1.72,
  97491: 1.72,
  97493: 1.72,
  97494: 1.72,
  97496: 1.72,
  97497: 1.72,
  97499: 1.72,
  97500: 1.72,
  97502: 1.72,
  97503: 1.72,
  97505: 1.72,
  97506: 1.72,
  97508: 1.72,
  97509: 1.72,
  97511: 1.72,
  97513: 1.72,
  97514: 1.72,
  97516: 1.72,
  97517: 1.72,
  97519: 1.72,
  97520: 1.72,
  97522: 1.72,
  97523: 1.72,
  97525: 1.72,
  97526: 1.72,
  97528: 1.72,
  97529: 1.72,
  97531: 1.72,
  97532: 1.72,
  97534: 1.72,
  97535: 1.72,
  97537: 1.72,
  97539: 1.72,
  97616: 1.72,
  97618: 1.72,
  97631: 1.72,
  97633: 1.72,
  97638: 1.72,
  97640: 1.72,
  97645: 1.72,
  97647: 1.72,
  97650: 1.72,
  97653: 1.72,
  97654: 1.72,
  97656: 1.72,
  97657: 1.72,
  97659: 1.72,
  97688: 1.72,
  97702: 1.72,
  97705: 1.72,
  97708: 1.72,
  97711: 1.72,
  97714: 1.72,
  97717: 1.72,
  97720: 1.72,
  97723: 1.72,
  97724: 1.72,
  97725: 1.72,
  97727: 1.72,
  97729: 1.72,
  97737: 1.72,
  97753: 1.72,
  97762: 1.72,
  97769: 1.72,
  97772: 1.72,
  97773: 1.72,
  97775: 1.72,
  97776: 1.72,
  97778: 1.72,
  97779: 1.72,
  97780: 1.72,
  97782: 1.72,
  97783: 1.72,
  97785: 1.72,
  97786: 1.72,
  97788: 1.72,
  97789: 1.72,
  97791: 1.72,
  97792: 1.72,
  97794: 1.72,
  97795: 1.72,
  97797: 1.72,
  97799: 1.72,
  97816: 1.72,
  97828: 1.72,
  97833: 1.72,
  97834: 1.72,
  97836: 1.72,
  97837: 1.72,
  97839: 1.72,
  97840: 1.72,
  97842: 1.72,
  97843: 1.72,
  97845: 1.72,
  97846: 1.72,
  97848: 1.72,
  97849: 1.72,
  97851: 1.72,
  97852: 1.72,
  97854: 1.72,
  97855: 1.72,
  97857: 1.72,
  97859: 1.72,
  97877: 1.72,
  97892: 1.72,
  97896: 1.72,
  97900: 1.72,
  97901: 1.72,
  97903: 1.72,
  97904: 1.72,
  97906: 1.72,
  97907: 1.72,
  97909: 1.72,
  97922: 1.72,
  97941: 1.72,
  97944: 1.72,
  97947: 1.72,
  97950: 1.72,
  97953: 1.72,
  97956: 1.72,
  97957: 1.72,
  97959: 1.72,
  97980: 1.72,
  97990: 1.72,
  97993: 1.72,
  97996: 1.72,
  97999: 1.72,
  98527: 1.72,
  98528: 1.72,
  98529: 1.72,
  98530: 1.72,
  98544: 1.72,
  98547: 1.72,
  98553: 1.72,
  98559: 1.72,
  98574: 1.72,
  98587: 1.72,
  98590: 1.72,
  98593: 1.72,
  98596: 1.72,
  98597: 1.72,
  98617: 1.72,
  98630: 1.72,
  98631: 1.72,
  98634: 1.72,
  98639: 1.72,
  98646: 1.72,
  98660: 1.72,
  98663: 1.72,
  98666: 1.72,
  98667: 1.72,
  98669: 1.72,
  98673: 1.72,
  98693: 1.72,
  98694: 1.72,
  98701: 1.72,
  98716: 1.72,
  98724: 1.72,
  98743: 1.72,
  98744: 1.72,
  98746: 1.72,
  99084: 1.72,
  99085: 1.72,
  99086: 1.72,
  99087: 1.72,
  99089: 1.72,
  99090: 1.72,
  99091: 1.72,
  99092: 1.72,
  99094: 1.72,
  99095: 1.72,
  99096: 1.72,
  99097: 1.72,
  99098: 1.72,
  99099: 1.72,
  99100: 1.72,
  99102: 1.72,
  99189: 1.72,
  99192: 1.72,
  99195: 1.72,
  99198: 1.72,
  99310: 1.72,
  99326: 1.72,
  99330: 1.72,
  99331: 1.72,
  99334: 1.72,
  99338: 1.72,
  99423: 1.72,
  99425: 1.72,
  99427: 1.72,
  99428: 1.72,
  99438: 1.72,
  99439: 1.72,
  99441: 1.72,
  99444: 1.72,
  99448: 1.72,
  99510: 1.72,
  99518: 1.72,
  99610: 1.72,
  99625: 1.72,
  99628: 1.72,
  99631: 1.72,
  99634: 1.72,
  99636: 1.72,
  99638: 1.72,
  99706: 1.72,
  99707: 1.72,
  99713: 1.72,
  99718: 1.72,
  99734: 1.72,
  99735: 1.72,
  99752: 1.72,
  99755: 1.72,
  99759: 1.72,
  99765: 1.72,
  99768: 1.72,
  99817: 1.72,
  99819: 1.72,
  99820: 1.72,
  99826: 1.72,
  99830: 1.72,
  99831: 1.72,
  99834: 1.72,
  99837: 1.72,
  99842: 1.72,
  99846: 1.72,
  99848: 1.72,
  99867: 1.72,
  99869: 1.72,
  99880: 1.72,
  99885: 1.72,
  99887: 1.72,
  99891: 1.72,
  99894: 1.72,
  99897: 1.72,
  99947: 1.72,
  99955: 1.72,
  99958: 1.72,
  99974: 1.72,
  99976: 1.72,
  99986: 1.72,
  99988: 1.72,
  99991: 1.72,
  99994: 1.72,
  99996: 1.72,
  99998: 1.72,


  // Add more PLZ codes and their multipliers
};

// Define multipliers for Mietvariante C and D
var plzListCD = {
  1030: 356,
  1010: 367,
  1090: 372,
  1060: 347,
  1050: 344,
  1040: 356,
  1020: 364,
  1070: 351,
  1100: 343,
  1080: 354,
  1190: 394,
  1150: 346,
  1130: 345,
  1120: 336,
  1110: 366,
  1140: 369,
  1180: 361,
  1160: 355,
  1170: 366,
  1200: 373,
  1210: 390,
  1230: 336,
  1220: 378,
  1300: 373,
  2034: 552,
  2031: 517,
  2041: 543,
  2032: 528,
  2033: 537,
  2042: 544,
  2051: 572,
  2052: 561,
  2053: 565,
  2054: 566,
  2063: 565,
  2064: 564,
  2061: 566,
  2062: 577,
  2070: 583,
  2073: 591,
  2074: 578,
  2081: 609,
  2082: 628,
  2083: 623,
  2084: 619,
  2091: 643,
  2092: 644,
  2094: 669,
  2093: 651,
  2100: 413,
  2095: 666,
  2102: 421,
  2111: 443,
  2105: 439,
  2104: 440,
  2103: 419,
  2112: 463,
  2114: 477,
  2113: 465,
  2115: 490,
  2116: 499,
  2132: 529,
  2124: 480,
  2130: 522,
  2134: 545,
  2123: 461,
  2126: 496,
  2120: 437,
  2133: 549,
  2122: 433,
  2125: 483,
  2144: 554,
  2135: 584,
  2141: 549,
  2136: 570,
  2153: 537,
  2145: 559,
  2152: 530,
  2151: 524,
  2154: 547,
  2143: 538,
  2171: 561,
  2161: 554,
  2162: 565,
  2165: 566,
  2163: 589,
  2164: 599,
  2170: 531,
  2181: 543,
  2182: 537,
  2172: 568,
  2201: 421,
  2184: 546,
  2183: 535,
  2185: 516,
  2191: 474,
  2192: 503,
  2193: 505,
  2202: 430,
  2203: 427,
  2211: 421,
  2221: 445,
  2214: 436,
  2215: 446,
  2213: 431,
  2225: 515,
  2212: 422,
  2224: 486,
  2223: 471,
  2222: 458,
  2231: 420,
  2230: 438,
  2243: 495,
  2232: 400,
  2241: 447,
  2242: 459,
  2245: 510,
  2244: 500,
  2251: 477,
  2252: 466,
  2253: 452,
  2264: 561,
  2275: 579,
  2261: 464,
  2263: 557,
  2272: 557,
  2273: 562,
  2265: 568,
  2262: 479,
  2274: 595,
  2280: 426,
  2276: 567,
  2282: 426,
  2283: 438,
  2286: 444,
  2284: 447,
  2281: 395,
  2285: 430,
  2291: 456,
  2295: 471,
  2292: 478,
  2293: 477,
  2294: 494,
  2320: 367,
  2301: 406,
  2325: 343,
  2305: 464,
  2304: 428,
  2322: 361,
  2326: 357,
  2331: 334,
  2332: 337,
  2333: 341,
  2334: 319,
  2345: 321,
  2340: 321,
  2344: 325,
  2351: 309,
  2352: 296,
  2353: 296,
  2361: 320,
  2384: 362,
  2381: 364,
  2392: 328,
  2380: 334,
  2391: 356,
  2393: 357,
  2372: 342,
  2401: 392,
  2371: 330,
  2362: 317,
  2402: 413,
  2404: 446,
  2422: 505,
  2405: 473,
  2403: 435,
  2410: 476,
  2423: 525,
  2412: 487,
  2421: 508,
  2413: 515,
  2434: 352,
  2433: 400,
  2435: 340,
  2442: 317,
  2431: 403,
  2425: 439,
  2440: 329,
  2424: 435,
  2441: 329,
  2432: 383,
  2444: 330,
  2451: 334,
  2452: 360,
  2463: 406,
  2443: 339,
  2453: 380,
  2454: 365,
  2462: 371,
  2460: 442,
  2474: 497,
  2473: 479,
  2475: 406,
  2465: 455,
  2472: 494,
  2481: 320,
  2471: 457,
  2464: 427,
  2483: 307,
  2482: 315,
  2491: 275,
  2492: 256,
  2512: 275,
  2490: 264,
  2504: 268,
  2493: 240,
  2485: 291,
  2500: 276,
  2486: 273,
  2511: 290,
  2521: 296,
  2534: 314,
  2522: 287,
  2514: 285,
  2523: 285,
  2531: 315,
  2524: 277,
  2525: 269,
  2532: 313,
  2540: 273,
  2533: 439,
  2544: 259,
  2542: 261,
  2551: 266,
  2561: 255,
  2552: 259,
  2563: 290,
  2560: 267,
  2564: 313,
  2565: 296,
  2571: 319,
  2604: 242,
  2620: 197,
  2572: 336,
  2602: 271,
  2603: 252,
  2624: 199,
  2625: 185,
  2601: 247,
  2630: 223,
  2631: 221,
  2642: 244,
  2632: 183,
  2651: 257,
  2662: 340,
  2641: 252,
  2650: 241,
  2640: 224,
  2661: 328,
  2663: 339,
  2654: 270,
  2722: 221,
  2671: 238,
  2680: 253,
  2721: 222,
  2723: 238,
  2673: 254,
  2700: 212,
  2731: 207,
  2724: 245,
  2732: 213,
  2734: 251,
  2754: 253,
  2755: 264,
  2763: 286,
  2770: 300,
  2753: 241,
  2752: 229,
  2761: 290,
  2733: 242,
  2751: 241,
  2813: 147,
  2801: 222,
  2802: 200,
  2811: 200,
  2812: 191,
  2803: 216,
  2820: 200,
  2822: 200,
  2821: 221,
  2823: 187,
  2831: 175,
  2824: 180,
  2832: 168,
  2840: 149,
  2833: 183,
  2842: 138,
  2852: 110,
  2851: 127,
  2853: 117,
  2871: 116,
  2872: 105,
  2881: 183,
  2870: 122,
  2873: 137,
  3001: 387,
  2880: 155,
  3002: 380,
  3011: 388,
  3003: 386,
  2860: 117,
  3021: 414,
  3031: 412,
  3013: 384,
  3004: 407,
  3012: 377,
  3032: 440,
  3033: 431,
  3034: 454,
  3041: 472,
  3040: 459,
  3053: 360,
  3052: 449,
  3071: 480,
  3051: 503,
  3074: 392,
  3062: 467,
  3061: 461,
  3073: 382,
  3042: 484,
  3072: 493,
  3125: 546,
  3105: 520,
  3104: 519,
  3124: 566,
  3123: 557,
  3100: 515,
  3121: 540,
  3110: 540,
  3107: 538,
  3122: 565,
  3141: 532,
  3131: 542,
  3130: 535,
  3140: 519,
  3142: 499,
  3133: 552,
  3134: 559,
  3144: 410,
  3150: 416,
  3143: 510,
  3162: 374,
  3151: 519,
  3153: 413,
  3160: 396,
  3170: 352,
  3163: 369,
  3161: 388,
  3172: 392,
  3171: 360,
  3184: 451,
  3180: 414,
  3183: 404,
  3192: 369,
  3193: 374,
  3200: 522,
  3203: 430,
  3202: 431,
  3195: 409,
  3204: 454,
  3211: 476,
  3212: 456,
  3205: 541,
  3214: 494,
  3223: 463,
  3222: 439,
  3221: 478,
  3213: 481,
  3231: 537,
  3224: 465,
  3232: 545,
  3233: 569,
  3251: 663,
  3241: 603,
  3244: 595,
  3240: 583,
  3243: 580,
  3253: 606,
  3242: 611,
  3252: 619,
  3250: 643,
  3261: 665,
  3262: 683,
  3283: 518,
  3254: 615,
  3282: 636,
  3270: 683,
  3263: 703,
  3264: 710,
  3281: 615,
  3292: 527,
  3311: 695,
  3291: 707,
  3294: 474,
  3295: 505,
  3304: 661,
  3300: 692,
  3312: 714,
  3313: 728,
  3293: 509,
  3325: 660,
  3331: 723,
  3314: 733,
  3321: 700,
  3324: 676,
  3332: 738,
  3334: 625,
  3322: 676,
  3323: 670,
  3333: 741,
  3341: 745,
  3335: 607,
  3350: 743,
  3342: 636,
  3340: 765,
  3355: 784,
  3362: 702,
  3344: 609,
  3343: 610,
  3351: 772,
  3353: 756,
  3345: 572,
  3352: 772,
  3364: 695,
  3361: 728,
  3354: 735,
  3363: 709,
  3370: 637,
  3381: 610,
  3365: 730,
  3382: 555,
  3372: 719,
  3373: 626,
  3371: 641,
  3374: 619,
  3376: 666,
  3384: 564,
  3383: 565,
  3380: 599,
  3375: 620,
  3390: 570,
  3386: 551,
  3420: 415,
  3385: 534,
  3388: 541,
  3393: 607,
  3392: 576,
  3394: 601,
  3421: 423,
  3400: 410,
  3413: 405,
  3433: 413,
  3425: 496,
  3423: 441,
  3422: 427,
  3424: 443,
  3430: 486,
  3435: 519,
  3434: 407,
  3426: 446,
  3441: 493,
  3454: 559,
  3443: 415,
  3462: 501,
  3463: 493,
  3452: 500,
  3464: 469,
  3442: 502,
  3451: 492,
  3465: 520,
  3470: 528,
  3471: 552,
  3473: 553,
  3472: 541,
  3481: 540,
  3474: 517,
  3484: 543,
  3482: 548,
  3485: 552,
  3491: 567,
  3492: 553,
  3483: 542,
  3494: 560,
  3493: 556,
  3500: 578,
  3506: 566,
  3508: 561,
  3512: 583,
  3511: 584,
  3495: 571,
  3531: 683,
  3522: 662,
  3524: 697,
  3541: 630,
  3543: 665,
  3521: 634,
  3542: 640,
  3532: 668,
  3533: 697,
  3525: 705,
  3544: 658,
  3561: 571,
  3550: 571,
  3553: 599,
  3552: 609,
  3571: 595,
  3562: 589,
  3572: 620,
  3564: 585,
  3573: 614,
  3580: 609,
  3592: 646,
  3602: 619,
  3593: 639,
  3610: 626,
  3595: 635,
  3601: 600,
  3613: 675,
  3594: 661,
  3591: 616,
  3611: 645,
  3642: 576,
  3643: 603,
  3620: 620,
  3623: 663,
  3632: 690,
  3621: 604,
  3650: 645,
  3631: 668,
  3622: 639,
  3633: 707,
  3641: 605,
  3652: 597,
  3662: 639,
  3644: 586,
  3654: 637,
  3665: 687,
  3653: 606,
  3660: 607,
  3664: 673,
  3663: 653,
  3661: 625,
  3672: 623,
  3671: 624,
  3684: 688,
  3680: 646,
  3691: 673,
  3683: 668,
  3702: 484,
  3701: 502,
  3681: 654,
  3704: 508,
  3714: 557,
  3710: 528,
  3721: 552,
  3722: 560,
  3711: 532,
  3713: 564,
  3712: 546,
  3720: 541,
  3730: 572,
  3741: 591,
  3754: 641,
  3761: 640,
  3752: 602,
  3743: 564,
  3753: 640,
  3744: 586,
  3742: 613,
  3762: 657,
  3751: 590,
  3812: 678,
  3814: 665,
  3763: 663,
  3813: 683,
  3811: 671,
  3822: 708,
  3800: 655,
  3820: 677,
  3804: 677,
  3823: 720,
  3841: 685,
  3834: 723,
  3843: 728,
  3824: 694,
  3851: 741,
  3842: 715,
  3852: 731,
  3844: 754,
  3830: 693,
  3872: 748,
  3860: 736,
  3862: 753,
  3900: 686,
  3871: 752,
  3861: 742,
  3873: 758,
  3874: 777,
  3902: 711,
  3863: 774,
  3913: 709,
  3911: 764,
  3912: 724,
  3903: 702,
  3914: 694,
  3921: 792,
  3920: 777,
  3910: 723,
  3923: 752,
  3922: 772,
  3945: 738,
  3932: 757,
  3931: 747,
  3925: 795,
  3924: 748,
  3942: 721,
  3943: 734,
  3944: 720,
  3950: 755,
  3961: 767,
  3962: 813,
  4030: 808,
  3973: 825,
  4050: 808,
  3971: 808,
  3972: 808,
  3970: 786,
  4048: 856,
  4020: 840,
  4040: 857,
  4052: 809,
  4061: 826,
  4053: 802,
  4055: 790,
  4060: 838,
  4063: 821,
  4062: 840,
  4064: 825,
  4070: 836,
  4072: 847,
  4073: 838,
  4090: 947,
  4075: 819,
  4082: 855,
  4076: 819,
  4081: 864,
  4083: 888,
  4074: 861,
  4084: 891,
  4085: 896,
  4101: 865,
  4100: 871,
  4091: 963,
  4092: 972,
  4102: 889,
  4111: 877,
  4112: 890,
  4113: 877,
  4115: 895,
  4114: 889,
  4121: 911,
  4131: 914,
  4116: 906,
  4132: 933,
  4133: 950,
  4122: 921,
  4134: 937,
  4120: 909,
  4142: 929,
  4141: 949,
  4161: 988,
  4160: 971,
  4143: 935,
  4144: 957,
  4151: 949,
  4155: 980,
  4150: 942,
  4152: 939,
  4154: 963,
  4153: 964,
  4162: 983,
  4163: 993,
  4164: 1012,
  4170: 970,
  4171: 925,
  4174: 896,
  4172: 943,
  4180: 900,
  4175: 896,
  4173: 921,
  4191: 946,
  4181: 911,
  4190: 922,
  4192: 919,
  4182: 921,
  4183: 926,
  4193: 974,
  4201: 888,
  4202: 881,
  4184: 963,
  4203: 878,
  4210: 886,
  4209: 827,
  4213: 896,
  4211: 899,
  4221: 826,
  4204: 909,
  4222: 806,
  4212: 926,
  4223: 828,
  4224: 825,
  4225: 813,
  4232: 836,
  4242: 954,
  4230: 826,
  4240: 945,
  4252: 825,
  4262: 981,
  4261: 973,
  4251: 852,
  4281: 751,
  4263: 872,
  4264: 974,
  4273: 788,
  4271: 834,
  4272: 814,
  4274: 797,
  4280: 762,
  4283: 795,
  4282: 788,
  4310: 785,
  4291: 948,
  4284: 836,
  4292: 924,
  4293: 862,
  4294: 817,
  4311: 811,
  4303: 777,
  4300: 755,
  4331: 759,
  4312: 802,
  4323: 771,
  4320: 781,
  4324: 782,
  4322: 780,
  4342: 748,
  4341: 761,
  4332: 803,
  4343: 742,
  4351: 738,
  4352: 742,
  4364: 760,
  4363: 739,
  4362: 713,
  4360: 727,
  4381: 693,
  4382: 684,
  4371: 710,
  4372: 736,
  4391: 703,
  4392: 724,
  4407: 829,
  4400: 756,
  4431: 775,
  4421: 730,
  4432: 772,
  4441: 777,
  4442: 802,
  4443: 643,
  4451: 767,
  4460: 771,
  4481: 796,
  4452: 739,
  4453: 755,
  4461: 776,
  4464: 606,
  4463: 635,
  4462: 682,
  4482: 772,
  4470: 780,
  4491: 818,
  4490: 802,
  4483: 798,
  4484: 799,
  4493: 758,
  4501: 790,
  4492: 817,
  4511: 779,
  4521: 756,
  4502: 807,
  4540: 747,
  4532: 754,
  4522: 739,
  4533: 777,
  4523: 738,
  4531: 768,
  4550: 741,
  4542: 721,
  4541: 738,
  4551: 725,
  4553: 708,
  4552: 725,
  4560: 682,
  4554: 701,
  4563: 674,
  4564: 672,
  4565: 702,
  4562: 709,
  4572: 636,
  4571: 672,
  4574: 632,
  4575: 609,
  4581: 634,
  4573: 665,
  4582: 594,
  4580: 620,
  4593: 703,
  4592: 692,
  4591: 727,
  4595: 722,
  4594: 709,
  4611: 799,
  4596: 716,
  4613: 807,
  4612: 810,
  4600: 774,
  4614: 808,
  4615: 809,
  4616: 784,
  4622: 769,
  4621: 756,
  4631: 791,
  4623: 781,
  4642: 741,
  4624: 801,
  4625: 800,
  4633: 811,
  4641: 754,
  4650: 794,
  4632: 804,
  4643: 717,
  4645: 776,
  4644: 743,
  4654: 788,
  4653: 753,
  4651: 799,
  4655: 736,
  4652: 759,
  4661: 792,
  4656: 753,
  4662: 797,
  4663: 793,
  4671: 815,
  4672: 825,
  4673: 843,
  4674: 851,
  4675: 843,
  4664: 804,
  4676: 833,
  4680: 864,
  4681: 864,
  4682: 858,
  4694: 807,
  4693: 807,
  4692: 831,
  4690: 824,
  4691: 820,
  4701: 811,
  4702: 804,
  4707: 820,
  4710: 832,
  4712: 845,
  4714: 825,
  4713: 833,
  4716: 840,
  4715: 849,
  4721: 874,
  4723: 910,
  4720: 863,
  4722: 878,
  4724: 882,
  4725: 925,
  4731: 840,
  4730: 853,
  4732: 834,
  4733: 866,
  4741: 876,
  4742: 873,
  4743: 886,
  4751: 887,
  4761: 918,
  4752: 879,
  4754: 900,
  4755: 891,
  4772: 929,
  4760: 898,
  4762: 896,
  4771: 915,
  4770: 913,
  4753: 917,
  4782: 934,
  4773: 945,
  4775: 934,
  4774: 953,
  4780: 968,
  4776: 939,
  4783: 993,
  4785: 1023,
  4777: 940,
  4784: 1007,
  4786: 993,
  4791: 944,
  4792: 957,
  4793: 965,
  4801: 883,
  4812: 823,
  4800: 838,
  4794: 922,
  4810: 795,
  4814: 858,
  4813: 844,
  4802: 815,
  4816: 769,
  4817: 756,
  4821: 739,
  4820: 757,
  4823: 710,
  4822: 742,
  4824: 758,
  4825: 782,
  4831: 727,
  4845: 816,
  4840: 843,
  4841: 850,
  4842: 865,
  4843: 877,
  4844: 827,
  4849: 864,
  4846: 824,
  4851: 860,
  4850: 850,
  4853: 889,
  4852: 869,
  4860: 848,
  4854: 793,
  4861: 849,
  4863: 859,
  4864: 876,
  4865: 899,
  4866: 911,
  4870: 899,
  4871: 881,
  4872: 872,
  4880: 878,
  4881: 890,
  4873: 902,
  4882: 905,
  4890: 900,
  4891: 922,
  4892: 911,
  4893: 943,
  4894: 955,
  4903: 857,
  4901: 868,
  4902: 859,
  4904: 837,
  4911: 894,
  4910: 898,
  4906: 886,
  4922: 865,
  4924: 918,
  4912: 911,
  4920: 910,
  4941: 911,
  4921: 880,
  4925: 905,
  4923: 938,
  4932: 922,
  4931: 936,
  4933: 939,
  4926: 871,
  4952: 986,
  4943: 964,
  4942: 928,
  4950: 970,
  4951: 939,
  4961: 969,
  4962: 987,
  4963: 997,
  4970: 911,
  4983: 947,
  4982: 955,
  4971: 904,
  4974: 926,
  4975: 950,
  4972: 911,
  4973: 933,
  4980: 929,
  4981: 929,
  4984: 926,
  5020: 1005,
  5023: 994,
  5026: 1009,
  5081: 920,
  5071: 1023,
  5061: 1017,
  5082: 929,
  5084: 1039,
  5083: 923,
  5090: 1116,
  5092: 979,
  5091: 1127,
  5093: 974,
  5102: 1021,
  5101: 1006,
  5111: 1066,
  5110: 1050,
  5113: 1074,
  5112: 1059,
  5123: 1062,
  5114: 1055,
  5121: 1090,
  5124: 1093,
  5120: 1079,
  5122: 1077,
  5131: 1086,
  5132: 1097,
  5133: 1061,
  5141: 1079,
  5152: 1042,
  5134: 1045,
  5142: 1077,
  5144: 1051,
  5143: 1002,
  5145: 1037,
  5151: 1047,
  5161: 1007,
  5162: 1016,
  5163: 977,
  5164: 1021,
  5165: 1031,
  5166: 988,
  5202: 994,
  5221: 967,
  5201: 994,
  5203: 1011,
  5204: 936,
  5205: 970,
  5212: 936,
  5230: 991,
  5211: 954,
  5223: 990,
  5222: 983,
  5231: 991,
  5224: 996,
  5225: 976,
  5232: 984,
  5233: 1013,
  5241: 977,
  5242: 962,
  5270: 1004,
  5271: 1001,
  5251: 956,
  5252: 948,
  5261: 1015,
  5302: 975,
  5272: 998,
  5273: 956,
  5274: 1010,
  5280: 1013,
  5282: 1023,
  5301: 978,
  5323: 991,
  5310: 934,
  5300: 988,
  5303: 947,
  5324: 1009,
  5321: 979,
  5311: 917,
  5325: 969,
  5322: 976,
  5330: 835,
  5340: 815,
  5350: 800,
  5342: 842,
  5412: 918,
  5400: 898,
  5360: 806,
  5411: 898,
  5441: 809,
  5424: 904,
  5422: 911,
  5450: 837,
  5442: 772,
  5440: 863,
  5421: 910,
  5425: 1021,
  5423: 907,
  5431: 901,
  5451: 851,
  5521: 802,
  5452: 822,
  5500: 827,
  5511: 789,
  5453: 844,
  5524: 831,
  5522: 796,
  5523: 809,
  5505: 856,
  5532: 750,
  5531: 779,
  5541: 780,
  5550: 754,
  5552: 748,
  5542: 812,
  5562: 751,
  5561: 796,
  5563: 746,
  5570: 710,
  5571: 702,
  5581: 720,
  5572: 694,
  5582: 872,
  5585: 701,
  5573: 735,
  5575: 698,
  5574: 714,
  5580: 674,
  5583: 935,
  5584: 866,
  5600: 842,
  5620: 883,
  5591: 698,
  5592: 719,
  5602: 800,
  5603: 836,
  5612: 929,
  5630: 937,
  5611: 909,
  5621: 867,
  5622: 872,
  5632: 904,
  5640: 960,
  5645: 950,
  5651: 904,
  5660: 908,
  5652: 889,
  5661: 951,
  5662: 927,
  5671: 935,
  5672: 952,
  5700: 945,
  5721: 965,
  5724: 1025,
  5722: 982,
  5710: 980,
  5730: 1030,
  5723: 1039,
  5731: 1046,
  5753: 1008,
  5732: 1043,
  5751: 966,
  5733: 1057,
  5742: 1099,
  5752: 986,
  5741: 1094,
  5760: 938,
  5743: 1108,
  5754: 1034,
  5771: 965,
  5761: 929,
  6020: 1508,
  6060: 1485,
  6063: 1507,
  6065: 1507,
  6067: 1504,
  6069: 1490,
  6070: 1492,
  6068: 1485,
  6073: 1510,
  6071: 1508,
  6072: 1529,
  6074: 1512,
  6080: 1516,
  6075: 1518,
  6082: 1535,
  6083: 1558,
  6091: 1539,
  6092: 1550,
  6111: 1492,
  6100: 1571,
  6095: 1574,
  6094: 1565,
  6108: 1528,
  6112: 1490,
  6103: 1565,
  6113: 1499,
  6114: 1460,
  6105: 1602,
  6115: 1491,
  6116: 1456,
  6122: 1474,
  6121: 1473,
  6123: 1460,
  6130: 1446,
  6134: 1463,
  6133: 1503,
  6136: 1465,
  6135: 1461,
  6141: 1535,
  6150: 1602,
  6142: 1551,
  6162: 1528,
  6145: 1581,
  6143: 1559,
  6154: 1612,
  6161: 1519,
  6157: 1607,
  6156: 1599,
  6152: 1584,
  6170: 1561,
  6165: 1564,
  6173: 1562,
  6166: 1553,
  6167: 1571,
  6175: 1538,
  6176: 1529,
  6178: 1545,
  6181: 1581,
  6179: 1555,
  6183: 1614,
  6182: 1577,
  6200: 1421,
  6210: 1409,
  6184: 1601,
  6235: 1398,
  6212: 1434,
  6213: 1457,
  6220: 1422,
  6215: 1476,
  6222: 1433,
  6232: 1410,
  6230: 1401,
  6234: 1417,
  6233: 1389,
  6236: 1430,
  6240: 1386,
  6250: 1364,
  6241: 1376,
  6252: 1354,
  6262: 1421,
  6260: 1411,
  6261: 1410,
  6263: 1426,
  6264: 1461,
  6265: 1428,
  6272: 1469,
  6274: 1462,
  6273: 1442,
  6271: 1441,
  6275: 1449,
  6276: 1485,
  6278: 1172,
  6277: 1481,
  6280: 1497,
  6281: 1142,
  6283: 1506,
  6284: 1186,
  6292: 1521,
  6293: 1527,
  6290: 1531,
  6294: 1546,
  6300: 1352,
  6295: 1546,
  6305: 1364,
  6320: 1343,
  6306: 1360,
  6311: 1382,
  6313: 1412,
  6324: 1334,
  6321: 1337,
  6314: 1367,
  6322: 1333,
  6323: 1340,
  6334: 1323,
  6330: 1321,
  6336: 1330,
  6335: 1342,
  6341: 1314,
  6342: 1287,
  6352: 1220,
  6363: 1397,
  6343: 1252,
  6351: 1236,
  6346: 1236,
  6347: 1241,
  6344: 1220,
  6345: 1212,
  6353: 1213,
  6361: 1426,
  6371: 1084,
  6364: 1250,
  6365: 1252,
  6370: 1220,
  6372: 1202,
  6380: 1023,
  6383: 1174,
  6373: 1062,
  6384: 1152,
  6382: 1198,
  6391: 1013,
  6385: 1216,
  6402: 1571,
  6392: 1014,
  6404: 1573,
  6393: 1008,
  6405: 1605,
  6395: 983,
  6401: 1568,
  6403: 1591,
  6406: 1611,
  6410: 1585,
  6413: 1605,
  6408: 1565,
  6421: 1602,
  6414: 1622,
  6416: 1644,
  6422: 1624,
  6423: 1618,
  6424: 1659,
  6425: 1632,
  6426: 1673,
  6430: 1644,
  6432: 1655,
  6441: 1679,
  6433: 1673,
  6452: 1774,
  6450: 1762,
  6444: 1720,
  6456: 1786,
  6460: 1693,
  6463: 1669,
  6458: 1802,
  6462: 1683,
  6465: 1675,
  6464: 1708,
  6471: 1694,
  6473: 1694,
  6474: 1701,
  6481: 1755,
  6492: 1684,
  6500: 1717,
  6491: 1688,
  6493: 1675,
  6521: 1729,
  6522: 1739,
  6525: 1735,
  6524: 1791,
  6526: 1739,
  6527: 1750,
  6528: 1762,
  6541: 1773,
  6532: 1760,
  6531: 1763,
  6533: 1772,
  6553: 1764,
  6534: 1777,
  6542: 1794,
  6543: 1855,
  6544: 1823,
  6552: 1745,
  6561: 1790,
  6551: 1722,
  6555: 1780,
  6571: 1747,
  6562: 1818,
  6563: 1831,
  6572: 1758,
  6621: 1594,
  6574: 1771,
  6580: 1794,
  6604: 1642,
  6610: 1634,
  6591: 1739,
  6600: 1629,
  6611: 1605,
  6623: 1636,
  6622: 1621,
  6644: 1690,
  6633: 1581,
  6647: 1713,
  6645: 1690,
  6632: 1569,
  6650: 1728,
  6631: 1579,
  6646: 1711,
  6642: 1687,
  6651: 1706,
  6652: 1724,
  6670: 1666,
  6653: 1746,
  6655: 1771,
  6675: 1842,
  6654: 1755,
  6691: 1802,
  6672: 1672,
  6671: 1670,
  6673: 1771,
  6677: 1827,
  6682: 1612,
  6706: 1914,
  6700: 1893,
  6719: 2014,
  6708: 1937,
  6707: 1925,
  6713: 1919,
  6712: 1920,
  6710: 2038,
  6714: 1915,
  6721: 1939,
  6733: 1974,
  6722: 1950,
  6723: 1962,
  6751: 1873,
  6741: 1953,
  6731: 1972,
  6752: 1876,
  6754: 1848,
  6762: 1807,
  6763: 1828,
  6764: 1848,
  6780: 1947,
  6771: 1901,
  6774: 1944,
  6767: 1781,
  6791: 1959,
  6781: 1916,
  6782: 1932,
  6787: 1970,
  6812: 1970,
  6794: 1846,
  6793: 1957,
  6811: 1987,
  6800: 1981,
  6822: 2022,
  6830: 1998,
  6820: 2021,
  6824: 2019,
  6832: 1968,
  6835: 1977,
  6833: 1978,
  6834: 1994,
  6837: 1965,
  6836: 1992,
  6840: 1954,
  6842: 1963,
  6841: 1949,
  6845: 1948,
  6844: 1947,
  6850: 1922,
  6861: 1939,
  6858: 1921,
  6870: 1993,
  6863: 1985,
  6866: 1968,
  6874: 1989,
  6867: 1956,
  6881: 2010,
  6882: 2003,
  6883: 2030,
  6886: 2028,
  6884: 1979,
  6888: 1813,
  6900: 1902,
  6890: 1931,
  6912: 1877,
  6914: 1880,
  6921: 1899,
  6911: 1900,
  6923: 1906,
  6922: 1904,
  6933: 1946,
  6942: 1876,
  6941: 1886,
  6932: 1924,
  6934: 1943,
  6943: 1871,
  6992: 1873,
  6974: 1948,
  6991: 1863,
  6973: 1937,
  6971: 1920,
  6972: 1947,
  6951: 1959,
  6993: 1883,
  6952: 1882,
  7000: 296,
  7021: 278,
  6960: 1919,
  7023: 259,
  7011: 299,
  7012: 278,
  7020: 282,
  7013: 302,
  7022: 289,
  7024: 269,
  7025: 256,
  7031: 257,
  7032: 248,
  7052: 294,
  7034: 253,
  7033: 243,
  7042: 271,
  7035: 263,
  7041: 281,
  7051: 294,
  7053: 311,
  7081: 310,
  7062: 305,
  7061: 294,
  7063: 336,
  7064: 314,
  7072: 333,
  7071: 321,
  7083: 342,
  7082: 331,
  7091: 353,
  7092: 358,
  7123: 440,
  7111: 387,
  7093: 371,
  7132: 453,
  7100: 381,
  7152: 385,
  7121: 392,
  7142: 474,
  7162: 406,
  7143: 404,
  7141: 442,
  7131: 448,
  7122: 429,
  7151: 395,
  7201: 226,
  7161: 411,
  7163: 433,
  7302: 203,
  7210: 265,
  7222: 272,
  7221: 267,
  7203: 251,
  7202: 233,
  7212: 221,
  7321: 209,
  7332: 187,
  7223: 285,
  7311: 202,
  7304: 179,
  7331: 204,
  7322: 296,
  7301: 210,
  7323: 216,
  7312: 197,
  7374: 136,
  7343: 181,
  7341: 166,
  7350: 160,
  7344: 178,
  7373: 131,
  7372: 146,
  7342: 149,
  7361: 184,
  7421: 100,
  7371: 121,
  7411: 100,
  7422: 100,
  7400: 100,
  7410: 100,
  7431: 100,
  7412: 100,
  7425: 100,
  7423: 100,
  7432: 100,
  7433: 100,
  7434: 100,
  7442: 138,
  7435: 100,
  7441: 112,
  7461: 100,
  7472: 100,
  7453: 154,
  7471: 114,
  7463: 102,
  7464: 100,
  7443: 145,
  7452: 170,
  7451: 160,
  7444: 159,
  7522: 136,
  7473: 100,
  7474: 119,
  7502: 100,
  7512: 100,
  7511: 100,
  7501: 100,
  7503: 100,
  7532: 100,
  7531: 100,
  7521: 126,
  7544: 118,
  7534: 100,
  7533: 100,
  7537: 100,
  7543: 119,
  7536: 100,
  7535: 100,
  7550: 100,
  7546: 152,
  7551: 100,
  7542: 100,
  7552: 100,
  7540: 125,
  7545: 149,
  7574: 100,
  7562: 139,
  8010: 212,
  7561: 144,
  7564: 117,
  7553: 100,
  7571: 108,
  7554: 100,
  7572: 100,
  7563: 122,
  8044: 187,
  8041: 199,
  8047: 186,
  8046: 216,
  8036: 196,
  8020: 215,
  8042: 201,
  8043: 201,
  8045: 214,
  8051: 253,
  8053: 224,
  8054: 216,
  8052: 236,
  8073: 205,
  8055: 207,
  8061: 200,
  8072: 223,
  8074: 195,
  8076: 177,
  8063: 160,
  8062: 179,
  8071: 205,
  8075: 183,
  8081: 203,
  8083: 199,
  8082: 194,
  8077: 201,
  8114: 294,
  8093: 208,
  8101: 266,
  8091: 216,
  8102: 230,
  8092: 233,
  8103: 285,
  8112: 273,
  8111: 276,
  8113: 291,
  8132: 358,
  8131: 351,
  8122: 308,
  8120: 285,
  8121: 294,
  8142: 239,
  8151: 270,
  8153: 327,
  8124: 319,
  8152: 289,
  8143: 242,
  8130: 331,
  8144: 231,
  8141: 224,
  8160: 182,
  8164: 200,
  8162: 219,
  8163: 230,
  8190: 104,
  8171: 227,
  8172: 132,
  8183: 100,
  8191: 114,
  8182: 103,
  8184: 106,
  8181: 166,
  8192: 113,
  8200: 139,
  8224: 100,
  8225: 100,
  8234: 100,
  8211: 100,
  8212: 100,
  8221: 100,
  8223: 100,
  8222: 100,
  8230: 100,
  8233: 100,
  8250: 100,
  8240: 100,
  8232: 100,
  8242: 100,
  8251: 100,
  8241: 100,
  8244: 100,
  8252: 100,
  8263: 100,
  8243: 100,
  8253: 105,
  8271: 100,
  8254: 104,
  8264: 100,
  8280: 104,
  8262: 100,
  8261: 112,
  8255: 113,
  8265: 100,
  8273: 100,
  8293: 100,
  8295: 100,
  8274: 100,
  8272: 100,
  8282: 125,
  8283: 100,
  8291: 100,
  8301: 167,
  8322: 141,
  8313: 100,
  8323: 182,
  8311: 136,
  8294: 100,
  8321: 146,
  8302: 168,
  8312: 105,
  8292: 100,
  8332: 149,
  8344: 172,
  8324: 168,
  8334: 131,
  8341: 190,
  8330: 141,
  8343: 176,
  8345: 199,
  8333: 124,
  8354: 178,
  8342: 177,
  8350: 139,
  8353: 163,
  8361: 129,
  8362: 109,
  8352: 128,
  8383: 168,
  8384: 183,
  8355: 199,
  8401: 220,
  8380: 157,
  8382: 149,
  8385: 197,
  8402: 242,
  8411: 262,
  8410: 259,
  8403: 263,
  8412: 239,
  8422: 241,
  8421: 227,
  8413: 282,
  8441: 322,
  8424: 304,
  8423: 310,
  8430: 289,
  8434: 274,
  8431: 287,
  8435: 298,
  8442: 315,
  8451: 303,
  8443: 304,
  8444: 290,
  8452: 319,
  8463: 352,
  8472: 305,
  8453: 332,
  8462: 324,
  8455: 353,
  8471: 317,
  8454: 345,
  8483: 214,
  8482: 225,
  8493: 201,
  8490: 220,
  8473: 328,
  8484: 221,
  8480: 343,
  8461: 317,
  8481: 333,
  8492: 212,
  8501: 235,
  8502: 241,
  8504: 265,
  8521: 280,
  8505: 276,
  8511: 263,
  8503: 263,
  8523: 289,
  8522: 297,
  8510: 266,
  8544: 329,
  8530: 345,
  8542: 316,
  8541: 333,
  8543: 320,
  8524: 289,
  8552: 352,
  8553: 380,
  8551: 346,
  8561: 258,
  8554: 402,
  8562: 254,
  8565: 264,
  8572: 311,
  8570: 283,
  8563: 281,
  8584: 360,
  8564: 275,
  8573: 344,
  8582: 302,
  8580: 313,
  8611: 413,
  8583: 323,
  8592: 354,
  8614: 178,
  8593: 337,
  8623: 299,
  8616: 133,
  8591: 336,
  8605: 262,
  8600: 377,
  8612: 458,
  8621: 314,
  8622: 315,
  8624: 296,
  8634: 374,
  8635: 397,
  8641: 259,
  8632: 446,
  8630: 431,
  8636: 305,
  8644: 235,
  8652: 240,
  8642: 249,
  8654: 137,
  8650: 233,
  8643: 206,
  8662: 197,
  8653: 187,
  8663: 223,
  8661: 214,
  8680: 289,
  8673: 154,
  8674: 146,
  8670: 187,
  8671: 163,
  8672: 153,
  8665: 305,
  8664: 226,
  8693: 346,
  8684: 272,
  8691: 317,
  8694: 412,
  8712: 405,
  8682: 298,
  8685: 272,
  8692: 319,
  8700: 406,
  8715: 399,
  8713: 386,
  8714: 387,
  8720: 438,
  8741: 468,
  8723: 421,
  8733: 425,
  8724: 432,
  8732: 438,
  8734: 453,
  8731: 474,
  8742: 438,
  8740: 444,
  8750: 471,
  8761: 497,
  8763: 545,
  8773: 399,
  8753: 466,
  8754: 485,
  8755: 490,
  8756: 503,
  8762: 531,
  8764: 554,
  8770: 384,
  8765: 547,
  8772: 411,
  8790: 456,
  8774: 422,
  8782: 478,
  8781: 450,
  8775: 441,
  8783: 486,
  8784: 500,
  8785: 525,
  8794: 423,
  8793: 396,
  8813: 574,
  8811: 545,
  8792: 397,
  8786: 649,
  8795: 514,
  8812: 560,
  8800: 516,
  8822: 515,
  8841: 560,
  8832: 595,
  8833: 546,
  8842: 572,
  8820: 571,
  8831: 570,
  8852: 608,
  8843: 594,
  8844: 617,
  8853: 620,
  8861: 614,
  8903: 553,
  8854: 666,
  8862: 650,
  8863: 661,
  8913: 562,
  8850: 600,
  8864: 689,
  8900: 543,
  8920: 479,
  8904: 563,
  8912: 590,
  8921: 524,
  8922: 541,
  8924: 500,
  8932: 606,
  8934: 674,
  8931: 529,
  8933: 586,
  8911: 537,
  8923: 541,
  8940: 567,
  8942: 592,
  8943: 606,
  8953: 668,
  8950: 590,
  8951: 605,
  8952: 607,
  8954: 624,
  8960: 635,
  8961: 689,
  8966: 667,
  8962: 655,
  8967: 687,
  8974: 723,
  8965: 679,
  8983: 639,
  8973: 734,
  8972: 711,
  8984: 674,
  8971: 734,
  8970: 702,
  8993: 694,
  8982: 637,
  8990: 670,
  9062: 592,
  8992: 709,
  9061: 576,
  9020: 553,
  9063: 578,
  9100: 483,
  9072: 607,
  9065: 558,
  9082: 616,
  9064: 527,
  9073: 595,
  9081: 605,
  9071: 592,
  9074: 612,
  9102: 511,
  9103: 494,
  9130: 520,
  9132: 538,
  9112: 458,
  9111: 472,
  9123: 532,
  9121: 502,
  9113: 469,
  9125: 503,
  9131: 544,
  9122: 507,
  9150: 503,
  9155: 496,
  9133: 532,
  9135: 570,
  9142: 528,
  9141: 517,
  9143: 513,
  9163: 653,
  9173: 573,
  9161: 584,
  9162: 604,
  9170: 600,
  9210: 599,
  9231: 639,
  9232: 672,
  9182: 683,
  9181: 641,
  9183: 702,
  9300: 632,
  9184: 656,
  9201: 593,
  9212: 616,
  9313: 556,
  9220: 624,
  9241: 648,
  9312: 506,
  9311: 627,
  9321: 491,
  9323: 588,
  9334: 480,
  9314: 539,
  9330: 497,
  9322: 507,
  9335: 446,
  9341: 523,
  9342: 541,
  9343: 567,
  9344: 574,
  9361: 543,
  9360: 520,
  9363: 583,
  9346: 701,
  9345: 579,
  9362: 563,
  9372: 541,
  9371: 521,
  9412: 425,
  9376: 476,
  9400: 397,
  9374: 489,
  9411: 422,
  9413: 418,
  9375: 495,
  9373: 491,
  9421: 443,
  9422: 453,
  9441: 380,
  9461: 385,
  9431: 421,
  9423: 489,
  9451: 352,
  9462: 392,
  9470: 449,
  9472: 482,
  9473: 433,
  9463: 416,
  9433: 435,
  9521: 673,
  9500: 695,
  9504: 681,
  9520: 673,
  9524: 657,
  9523: 666,
  9530: 723,
  9531: 741,
  9535: 644,
  9536: 643,
  9542: 702,
  9541: 681,
  9555: 592,
  9546: 706,
  9544: 725,
  9545: 743,
  9552: 644,
  9551: 656,
  9556: 614,
  9554: 619,
  9560: 617,
  9562: 643,
  9543: 704,
  9563: 678,
  9570: 640,
  9564: 681,
  9572: 692,
  9571: 679,
  9581: 688,
  9584: 701,
  9580: 671,
  9565: 710,
  9582: 694,
  9583: 680,
  9611: 733,
  9586: 683,
  9585: 693,
  9587: 692,
  9602: 720,
  9612: 745,
  9613: 737,
  9601: 716,
  9614: 760,
  9615: 764,
  9620: 798,
  9633: 858,
  9623: 761,
  9622: 819,
  9624: 780,
  9631: 822,
  9632: 845,
  9654: 934,
  9634: 846,
  9635: 855,
  9640: 890,
  9652: 917,
  9651: 899,
  9655: 966,
  9653: 923,
  9713: 739,
  9702: 748,
  9701: 770,
  9712: 729,
  9710: 713,
  9711: 737,
  9721: 708,
  9714: 764,
  9772: 902,
  9722: 693,
  9773: 919,
  9754: 879,
  9762: 866,
  9771: 871,
  9761: 861,
  9751: 832,
  9753: 838,
  9816: 849,
  9813: 800,
  9812: 809,
  9815: 841,
  9782: 926,
  9800: 763,
  9781: 914,
  9811: 798,
  9805: 799,
  9842: 964,
  9833: 921,
  9814: 809,
  9843: 975,
  9821: 859,
  9831: 902,
  9841: 957,
  9822: 888,
  9844: 1030,
  9832: 924,
  9851: 775,
  9872: 807,
  9853: 806,
  9852: 824,
  9854: 852,
  9863: 854,
  9862: 878,
  9900: 964,
  9871: 789,
  9861: 847,
  9873: 755,
  9907: 954,
  9903: 970,
  9904: 989,
  9905: 968,
  9906: 940,
  9908: 967,
  9919: 1042,
  9942: 976,
  9941: 1058,
  9909: 974,
  9912: 1034,
  9932: 1083,
  9920: 1046,
  9913: 1028,
  9911: 1009,
  9918: 1032,
  9931: 1055,
  9971: 1059,
  9943: 972,
  9951: 1014,
  9952: 1009,
  9981: 1053,
  9954: 1022,
  9990: 989,
  9962: 1058,
  9974: 1094,
  9963: 1092,
  9972: 1073,
  9991: 948,
  9992: 950,
  94501: 1073,
  94505: 1179,
  94508: 1095,
  94513: 1118,
  94518: 1149,
  94522: 1192,
  94526: 1155,
  94527: 1167,
  94529: 1056,
  94530: 1125,
  94532: 1080,
  94533: 1140,
  94535: 1075,
  94536: 1141,
  94538: 1074,
  94539: 1158,
  94541: 1115,
  94542: 1039,
  94544: 1084,
  94545: 1126,
  94547: 1084,
  95032: 1814,
  95100: 1747,
  95111: 1782,
  95119: 1896,
  95126: 1778,
  95131: 1907,
  95138: 1910,
  95145: 1808,
  95152: 1876,
  95158: 1757,
  95163: 1757,
  95168: 1739,
  95173: 1758,
  95176: 1828,
  95179: 1914,
  95180: 1872,
  95182: 1798,
  95183: 1828,
  95185: 1805,
  95186: 1721,
  94137: 1017,
  94139: 1012,
  94140: 1031,
  94142: 1103,
  94143: 1124,
  94145: 1057,
  94146: 1131,
  94148: 968,
  94149: 1002,
  94151: 1145,
  94152: 974,
  94154: 1061,
  94157: 1104,
  94158: 1158,
  94160: 1120,
  94161: 1048,
  94163: 1098,
  94164: 1004,
  94166: 1057,
  94167: 990,
  94169: 1095,
  94209: 1190,
  94227: 1226,
  94372: 1247,
  94374: 1184,
  94375: 1247,
  94377: 1218,
  94379: 1230,
  94405: 1227,
  94419: 1155,
  94424: 1112,
  94428: 1138,
  94431: 1217,
  94436: 1129,
  94437: 1240,
  94439: 1110,
  94447: 1150,
  94469: 1145,
  94474: 1070,
  94481: 1125,
  94486: 1128,
  94491: 1107,
  94496: 1038,
  94548: 1136,
  94550: 1093,
  94551: 1147,
  94553: 1177,
  94554: 1137,
  94556: 1138,
  94557: 1112,
  94559: 1187,
  94560: 1151,
  94562: 1182,
  94563: 1181,
  94566: 1159,
  94568: 1142,
  94569: 1170,
  94571: 1135,
  94572: 1135,
  94574: 1183,
  94575: 1069,
  94577: 1101,
  94579: 1099,
  95028: 1825,
  95030: 1827,
  93471: 1246,
  93473: 1343,
  93474: 1279,
  93476: 1275,
  93477: 1355,
  93479: 1277,
  93480: 1284,
  93482: 1336,
  93483: 1328,
  93485: 1287,
  93486: 1327,
  93488: 1358,
  93489: 1297,
  93491: 1338,
  93492: 1383,
  93494: 1327,
  93495: 1334,
  93497: 1313,
  93499: 1292,
  94032: 1013,
  94034: 1029,
  94036: 1019,
  94051: 1083,
  95188: 1884,
  95189: 1832,
  95191: 1841,
  95192: 1902,
  95194: 1793,
  95195: 1737,
  95197: 1890,
  95199: 1725,
  95213: 1861,
  95233: 1892,
  95234: 1781,
  95236: 1845,
  95237: 1779,
  95239: 1787,
  95326: 1849,
  95336: 1858,
  95339: 1823,
  95346: 1848,
  95349: 1840,
  95352: 1859,
  95355: 1875,
  95356: 1870,
  95358: 1848,
  94060: 984,
  94065: 1096,
  94072: 956,
  94078: 1125,
  94081: 998,
  94086: 1009,
  94089: 1023,
  94094: 982,
  94099: 999,
  94104: 1074,
  94107: 972,
  94110: 969,
  94113: 1042,
  94116: 1067,
  94118: 1019,
  94121: 1042,
  94124: 1062,
  94127: 991,
  94130: 981,
  94133: 1084,
  94136: 1047,
  94234: 1227,
  94239: 1188,
  94244: 1208,
  94249: 1233,
  94250: 1203,
  94252: 1263,
  94253: 1165,
  94255: 1221,
  94256: 1237,
  94258: 1177,
  94259: 1166,
  94261: 1152,
  94262: 1217,
  94264: 1210,
  94265: 1194,
  94267: 1247,
  94269: 1176,
  94315: 1222,
  94327: 1207,
  94330: 1207,
  94333: 1264,
  94336: 1200,
  94339: 1254,
  94342: 1185,
  94344: 1255,
  94345: 1274,
  94347: 1230,
  94348: 1240,
  94350: 1243,
  94351: 1228,
  94353: 1227,
  94354: 1221,
  94356: 1231,
  94357: 1268,
  94359: 1261,
  94360: 1228,
  94362: 1206,
  94363: 1237,
  94365: 1230,
  94366: 1196,
  94368: 1250,
  94369: 1250,
  94371: 1254,
  95359: 1850,
  95361: 1843,
  95362: 1845,
  95364: 1831,
  95365: 1868,
  95367: 1820,
  95369: 1838,
  95444: 1771,
  95445: 1775,
  95447: 1758,
  95448: 1773,
  95460: 1811,
  95463: 1794,
  95466: 1706,
  95469: 1668,
  95473: 1745,
  95478: 1652,
  95482: 1830,
  95485: 1721,
  95488: 1794,
  96269: 1875,
  96271: 1885,
  96272: 1880,
  96274: 1849,
  96275: 1879,
  96277: 1914,
  96279: 1904,
  96317: 1939,
  96328: 1902,
  96332: 1964,
  96337: 2012,
  96342: 1948,
  96346: 1893,
  96349: 1911,
  96352: 1916,
  96355: 2002,
  96358: 1978,
  96361: 1996,
  96364: 1886,
  96365: 1939,
  96367: 1958,
  96369: 1884,
  95632: 1718,
  95643: 1652,
  95652: 1680,
  95659: 1710,
  95666: 1659,
  95671: 1663,
  95676: 1654,
  95679: 1695,
  95680: 1712,
  95682: 1683,
  95683: 1688,
  95685: 1631,
  95686: 1751,
  95688: 1659,
  95689: 1664,
  95691: 1731,
  95692: 1682,
  95694: 1695,
  95695: 1694,
  95697: 1736,
  95698: 1683,
  95700: 1678,
  95701: 1669,
  97204: 1938,
  97209: 1921,
  97215: 1818,
  97218: 1891,
  97222: 1911,
  97225: 1951,
  97228: 1879,
  97230: 1905,
  97232: 1935,
  97234: 1923,
  97236: 1892,
  97237: 1985,
  97239: 1860,
  97241: 1914,
  97243: 1866,
  97244: 1962,
  97246: 1893,
  97247: 1885,
  97249: 1927,
  97250: 1931,
  97252: 1893,
  97253: 1929,
  96146: 1726,
  96148: 1795,
  96149: 1788,
  96151: 1825,
  96152: 1773,
  96154: 1786,
  96155: 1736,
  96157: 1815,
  96158: 1746,
  96160: 1785,
  96161: 1814,
  96163: 1771,
  96164: 1784,
  96166: 1858,
  96167: 1836,
  96169: 1813,
  96170: 1814,
  96172: 1722,
  96173: 1804,
  96175: 1759,
  96176: 1863,
  96178: 1725,
  96179: 1800,
  96181: 1819,
  97255: 1866,
  97256: 1931,
  97258: 1842,
  97259: 1961,
  97261: 1927,
  97262: 1925,
  97264: 1968,
  97265: 1957,
  97267: 1957,
  97268: 1951,
  97270: 1932,
  97271: 1936,
  97273: 1900,
  97274: 1941,
  97276: 1922,
  97277: 1984,
  97279: 1880,
  97280: 1963,
  97282: 1946,
  97283: 1881,
  97285: 1879,
  95490: 1773,
  95491: 1738,
  95493: 1767,
  95494: 1747,
  95496: 1754,
  95497: 1791,
  95499: 1797,
  95500: 1789,
  95502: 1804,
  95503: 1750,
  95505: 1682,
  95506: 1637,
  95508: 1660,
  95509: 1822,
  95511: 1759,
  95512: 1825,
  95514: 1657,
  95515: 1780,
  95517: 1692,
  95519: 1663,
  95615: 1691,
  96182: 1805,
  96184: 1834,
  96185: 1772,
  96187: 1837,
  96188: 1818,
  96190: 1840,
  96191: 1807,
  96193: 1735,
  96194: 1787,
  96196: 1837,
  96197: 1867,
  96199: 1806,
  96215: 1865,
  96224: 1881,
  96231: 1843,
  96237: 1882,
  96242: 1897,
  96247: 1875,
  96250: 1826,
  96253: 1875,
  96257: 1892,
  96260: 1870,
  96264: 1882,
  96268: 1916,
  96450: 1898,
  96465: 1912,
  96472: 1912,
  96476: 1959,
  96479: 1888,
  96482: 1893,
  96484: 1934,
  96486: 1933,
  96487: 1905,
  96489: 1889,
  96515: 1964,
  96523: 1989,
  96524: 1948,
  96528: 1949,
  97070: 1898,
  97072: 1905,
  97074: 1894,
  97076: 1894,
  97078: 1897,
  97080: 1914,
  97082: 1919,
  97084: 1917,
  97199: 1919,
  95703: 1635,
  95704: 1680,
  95706: 1723,
  95707: 1713,
  95709: 1734,
  96047: 1762,
  96049: 1764,
  96050: 1753,
  96052: 1768,
  96103: 1780,
  96106: 1855,
  96110: 1789,
  96114: 1736,
  96117: 1772,
  96120: 1793,
  96123: 1771,
  96126: 1894,
  96129: 1744,
  96132: 1756,
  96135: 1777,
  96138: 1752,
  96142: 1810,
  96145: 1864,
  97286: 1900,
  97288: 1882,
  97289: 1960,
  97291: 1931,
  97292: 1955,
  97294: 1899,
  97295: 1931,
  97297: 1943,
  97299: 1918,
  97318: 1854,
  97320: 1864,
  97332: 1867,
  97334: 1862,
  97337: 1863,
  97340: 1916,
  97342: 1877,
  97346: 1809,
  97348: 1857,
  97350: 1848,
  97353: 1815,
  97355: 1819,
  97357: 1827,
  97359: 1845,
  97421: 1927,
  97422: 1932,
  97424: 1930,
  97437: 1870,
  97440: 1955,
  97447: 1858,
  97450: 1952,
  97453: 1915,
  97456: 1939,
  97461: 1897,
  97464: 1937,
  97469: 1908,
  97475: 1845,
  97478: 1856,
  97483: 1831,
  97486: 1872,
  97488: 1954,
  97490: 1966,
  97491: 1940,
  97493: 1940,
  97494: 1926,
  97496: 1885,
  97497: 1858,
  97499: 1890,
  97500: 1829,
  97502: 1953,
  97503: 1899,
  97505: 1956,
  97506: 1931,
  97508: 1881,
  97618: 2069,
  97631: 1935,
  97633: 1963,
  97638: 2086,
  97640: 2095,
  97645: 2106,
  97647: 2127,
  97892: 2015,
  97896: 2050,
  97900: 2025,
  97901: 2064,
  97903: 2069,
  97904: 2064,
  97906: 2041,
  97907: 2027,
  97909: 2053,
  97922: 2003,
  97941: 1990,
  97944: 2061,
  97947: 1997,
  97950: 2017,
  97953: 2006,
  97956: 2005,
  97957: 1968,
  97959: 1988,
  97980: 1966,
  97990: 1925,
  97509: 1885,
  97511: 1841,
  97513: 1883,
  97514: 1830,
  97516: 1823,
  97517: 1999,
  97519: 1894,
  97520: 1901,
  97522: 1850,
  97523: 1896,
  97525: 1894,
  97526: 1919,
  97528: 1914,
  97529: 1864,
  97531: 1885,
  97532: 1961,
  97534: 1959,
  97535: 1975,
  97537: 1899,
  97539: 1887,
  97616: 2045,
  97729: 1990,
  97737: 2011,
  97753: 1975,
  97762: 2023,
  97769: 2089,
  97772: 2104,
  97773: 2078,
  97775: 2044,
  97776: 1986,
  97778: 2071,
  97779: 2078,
  97780: 1994,
  97782: 2064,
  97783: 2056,
  97785: 2109,
  97786: 2115,
  97788: 2032,
  97789: 2082,
  97791: 2119,
  97792: 2082,
  97794: 2025,
  97795: 2081,
  97797: 2053,
  97799: 2118,
  97816: 2061,
  97650: 2134,
  97653: 2128,
  97654: 2072,
  97656: 2099,
  97657: 2086,
  97659: 2078,
  97688: 2017,
  97702: 2031,
  97705: 2043,
  97708: 2044,
  97711: 2013,
  97714: 1985,
  97717: 2003,
  97720: 2012,
  97723: 2043,
  97724: 2031,
  97725: 2014,
  97727: 2012,
  97993: 1849,
  97996: 1899,
  97999: 1981,
  98527: 2030,
  98528: 2069,
  98529: 2044,
  98530: 2066,
  98544: 2068,
  98547: 2091,
  98553: 2011,
  98559: 2083,
  98574: 2128,
  98587: 2093,
  98590: 2172,
  97828: 2007,
  97833: 2117,
  97834: 1984,
  97836: 2019,
  97837: 1979,
  97839: 2018,
  97840: 2017,
  97842: 1998,
  97843: 2109,
  97845: 2038,
  97846: 2084,
  97848: 2107,
  97849: 2039,
  97851: 2027,
  97852: 2025,
  97854: 1990,
  97855: 1987,
  97857: 1978,
  97859: 2115,
  97877: 2024,
  98593: 2138,
  98596: 2172,
  98597: 2162,
  98617: 2124,
  98630: 2028,
  98631: 2101,
  98634: 2149,
  98639: 2124,
  98646: 2004,
  98660: 2042,
  98663: 1907,
  98666: 2006,
  98667: 2009,
  98669: 1972,
  98673: 1958,
  98693: 2116,
  98694: 2148,
  98701: 2071,
  98716: 2107,
  98724: 2018,
  98743: 2024,
  98744: 2057,
  98746: 2039,
  99084: 2230,
  99085: 2235,
  99086: 2248,
  99087: 2257,
  99089: 2253,
  99090: 2229,
  99091: 2245,
  99092: 2235,
  99094: 2234,
  99095: 2259,
  99096: 2219,
  99097: 2230,
  99098: 2229,
  99099: 2232,
  99100: 2276,
  99102: 2218,
  99189: 2250,
  99192: 2210,
  99334: 2190,
  99338: 2137,
  99423: 2192,
  99425: 2187,
  99427: 2195,
  99428: 2199,
  99438: 2200,
  99439: 2241,
  99441: 2171,
  99195: 2276,
  99198: 2212,
  99310: 2164,
  99326: 2166,
  99330: 2115,
  99331: 2102,
  99817: 2249,
  99819: 2350,
  99820: 2333,
  99826: 2365,
  99830: 2399,
  99831: 2362,
  99834: 2408,
  99837: 2274,
  99842: 2217,
  99846: 2207,
  99848: 2318,
  99867: 2172,
  99869: 2159,
  99444: 2172,
  99448: 2191,
  99510: 2201,
  99518: 2159,
  99610: 2301,
  99625: 2334,
  99628: 2246,
  99631: 2312,
  99634: 2296,
  99636: 2263,
  99638: 2335,
  99706: 2336,
  99707: 2302,
  99713: 2365,
  99718: 2322,
  99734: 2335,
  99735: 2369,
  99752: 2393,
  99755: 2385,
  99759: 2401,
  99765: 2332,
  99768: 2359,
  99880: 2281,
  99885: 2127,
  99887: 2143,
  99891: 2179,
  99894: 2165,
  99897: 2156,
  99947: 2324,
  99955: 2316,
  99958: 2299,
  99974: 2390,
  99976: 2421,
  99986: 2390,
  99988: 2426,
  99991: 2352,
  99994: 2355,
  99996: 2400,
  99998: 2376,
  74937: 2143,
  74939: 2121,
  75015: 2105,
  75031: 2120,
  75038: 2118,
  75045: 2109,
  75050: 2087,
  75053: 2112,
  75056: 2136,
  75057: 2147,
  75059: 2143,
  75172: 2059,
  75173: 2057,
  75175: 2049,
  75177: 2064,
  75179: 2078,
  75180: 2072,
  75181: 2046,
  75196: 2098,
  75203: 2095,
  75210: 2094,
  76846: 2311,
  76848: 2304,
  76855: 2282,
  76857: 2278,
  76461: 2187,
  76467: 2181,
  76470: 2190,
  76473: 2218,
  76474: 2174,
  76476: 2196,
  76477: 2192,
  76479: 2200,
  76530: 2230,
  76532: 2208,
  76534: 2249,
  76547: 2219,
  76549: 2219,
  76571: 2212,
  76593: 2250,
  76596: 2253,
  76597: 2238,
  76599: 2237,
  76646: 2218,
  76661: 2222,
  76669: 2164,
  76676: 2220,
  76684: 2132,
  76689: 2204,
  76694: 2208,
  76829: 2243,
  76831: 2226,
  76833: 2258,
  76835: 2263,
  74850: 2112,
  74855: 2071,
  74858: 2150,
  74861: 2035,
  74862: 2100,
  74864: 2119,
  74865: 2080,
  74867: 2119,
  74869: 2158,
  74889: 2095,
  74906: 2070,
  74909: 2134,
  74912: 2071,
  74915: 2124,
  74918: 2120,
  74921: 2103,
  74924: 2093,
  74925: 2139,
  74927: 2136,
  74928: 2085,
  74930: 2098,
  74931: 2153,
  74933: 2133,
  74934: 2148,
  74936: 2079,
  76698: 2194,
  76703: 2149,
  76706: 2242,
  76707: 2202,
  76709: 2173,
  76726: 2264,
  76744: 2208,
  76751: 2185,
  76756: 2273,
  76761: 2211,
  76764: 2197,
  76767: 2181,
  76768: 2196,
  76770: 2207,
  76771: 2214,
  76773: 2208,
  76774: 2208,
  76776: 2194,
  76777: 2200,
  76779: 2209,
  75217: 2094,
  75223: 2054,
  75228: 2079,
  75233: 2026,
  75236: 2089,
  75239: 2079,
  75242: 2044,
  75245: 2079,
  75248: 2074,
  75249: 2067,
  75305: 2103,
  75323: 2117,
  75328: 2083,
  75331: 2084,
  75334: 2117,
  75335: 2136,
  75337: 2126,
  75339: 2117,
  75365: 2070,
  75378: 2052,
  75382: 2032,
  75385: 2077,
  76187: 2159,
  76189: 2158,
  76199: 2134,
  76227: 2137,
  76228: 2116,
  76229: 2147,
  76275: 2146,
  76287: 2162,
  76297: 2170,
  76307: 2123,
  76316: 2173,
  76327: 2115,
  76332: 2150,
  76337: 2117,
  76344: 2182,
  76351: 2235,
  76356: 2166,
  76359: 2151,
  76437: 2197,
  76448: 2170,
  76456: 2196,
  74653: 1948,
  74670: 1969,
  74673: 1951,
  74676: 1953,
  74677: 1977,
  74679: 1975,
  74706: 2084,
  74722: 2074,
  74731: 2074,
  74736: 2037,
  74740: 2085,
  74743: 2097,
  74744: 2035,
  74746: 2057,
  74747: 2060,
  74749: 2058,
  74821: 2104,
  74831: 2069,
  74834: 2124,
  74838: 2138,
  74842: 2082,
  74847: 2092,
  75387: 2064,
  75389: 2087,
  75391: 2017,
  75392: 2023,
  75394: 2070,
  75395: 2022,
  75397: 2025,
  75399: 2077,
  75417: 2075,
  75428: 2069,
  75433: 2088,
  75438: 2096,
  75443: 2076,
  75446: 2039,
  75447: 2099,
  75449: 2039,
  76131: 2141,
  76133: 2142,
  76135: 2140,
  76137: 2138,
  76139: 2146,
  76149: 2151,
  76185: 2151,
  76891: 2291,
  77652: 2321,
  77654: 2334,
  77656: 2326,
  77694: 2335,
  77704: 2330,
  77709: 2290,
  77716: 2406,
  77723: 2362,
  77728: 2361,
  77731: 2312,
  77736: 2394,
  77740: 2382,
  77743: 2350,
  77746: 2332,
  77749: 2345,
  77756: 2298,
  77761: 2257,
  77767: 2314,
  77770: 2337,
  76889: 2250,
  77889: 2318,
  77933: 2387,
  77948: 2362,
  77955: 2412,
  77960: 2412,
  77963: 2378,
  77966: 2399,
  77971: 2392,
  77972: 2403,
  77974: 2386,
  77975: 2404,
  77977: 2408,
  77978: 2448,
  78048: 2263,
  78050: 2247,
  78052: 2255,
  78054: 2228,
  78056: 2222,
  78073: 2259,
  78078: 2207,
  78083: 2220,
  78086: 2246,
  78087: 2262,
  78089: 2262,
  76863: 2224,
  76865: 2222,
  76870: 2197,
  76872: 2214,
  76877: 2240,
  76879: 2274,
  76887: 2247,
  78733: 2229,
  78736: 2154,
  78737: 2170,
  78739: 2216,
  79098: 2495,
  79100: 2503,
  79102: 2498,
  79104: 2497,
  79106: 2493,
  79108: 2471,
  79110: 2493,
  79111: 2489,
  79112: 2500,
  79114: 2491,
  79115: 2495,
  79117: 2435,
  79183: 2509,
  79189: 2529,
  79194: 2479,
  79199: 2422,
  79206: 2535,
  79211: 2489,
  79215: 2330,
  78098: 2314,
  78112: 2284,
  78120: 2305,
  78126: 2222,
  78132: 2277,
  78136: 2326,
  78141: 2320,
  78144: 2239,
  78147: 2283,
  78148: 2323,
  78166: 2268,
  78176: 2309,
  78183: 2281,
  78187: 2282,
  78194: 2281,
  78199: 2288,
  78224: 2124,
  78234: 2115,
  78239: 2128,
  78244: 2128,
  78247: 2114,
  78250: 2146,
  78253: 2088,
  78256: 2090,
  77773: 2211,
  77776: 2209,
  77781: 2379,
  77784: 2410,
  77787: 2407,
  77790: 2392,
  77791: 2352,
  77793: 2284,
  77794: 2345,
  77796: 2326,
  77797: 2351,
  77799: 2340,
  77815: 2254,
  77830: 2258,
  77833: 2257,
  77836: 2248,
  77839: 2256,
  77855: 2268,
  77866: 2280,
  77871: 2288,
  77876: 2293,
  77880: 2268,
  77883: 2298,
  77886: 2271,
  77887: 2299,
  78259: 2104,
  78262: 2144,
  78266: 2148,
  78267: 2122,
  78269: 2112,
  78315: 2099,
  78333: 2061,
  78337: 2152,
  78343: 2151,
  78345: 2131,
  78351: 2044,
  78354: 2030,
  78355: 1967,
  78357: 2085,
  78359: 2073,
  78462: 2079,
  78464: 1998,
  78465: 2014,
  78467: 2087,
  78476: 2120,
  78479: 2106,
  78532: 2127,
  78549: 2229,
  78554: 2224,
  78600: 2211,
  78601: 2205,
  78603: 2213,
  78604: 2274,
  78606: 2267,
  78607: 2239,
  78609: 2230,
  78628: 2203,
  78647: 2222,
  78652: 2213,
  78655: 2203,
  78658: 2182,
  78661: 2169,
  78662: 2168,
  78664: 2204,
  78665: 2217,
  78667: 2190,
  78669: 2214,
  78713: 2216,
  78727: 2154,
  78730: 2244,
  78559: 2179,
  78564: 2175,
  78567: 2020,
  78570: 2034,
  78573: 2264,
  78576: 2113,
  78579: 2008,
  78580: 2198,
  78582: 2235,
  78583: 2189,
  78585: 2192,
  78586: 2162,
  78588: 2227,
  78589: 2242,
  78591: 2241,
  78592: 2196,
  78594: 2248,
  78595: 2257,
  78597: 2020,
  78598: 2203,
  79286: 2495,
  79288: 2493,
  79289: 2519,
  79291: 2491,
  79292: 2509,
  79294: 2514,
  79295: 2559,
  79297: 2339,
  79299: 2511,
  79312: 2459,
  79331: 2449,
  79336: 2423,
  79341: 2432,
  79346: 2459,
  79348: 2463,
  79350: 2473,
  79353: 2445,
  79356: 2463,
  79359: 2436,
  79361: 2466,
  79362: 2443,
  79364: 2439,
  79365: 2416,
  79367: 2428,
  79219: 2541,
  79224: 2481,
  79227: 2503,
  79232: 2473,
  79235: 2479,
  79238: 2525,
  79241: 2491,
  79244: 2555,
  79249: 2502,
  79252: 2428,
  79254: 2446,
  79256: 2409,
  79258: 2524,
  79261: 2517,
  79263: 2348,
  79268: 2474,
  79271: 2417,
  79274: 2395,
  79276: 2461,
  79279: 2476,
  79280: 2507,
  79282: 2554,
  79283: 2542,
  79285: 2506,
  79369: 2439,
  79379: 2583,
  79395: 2561,
  79400: 2516,
  79410: 2595,
  79415: 2600,
  79418: 2595,
  79423: 2543,
  79424: 2582,
  79426: 2567,
  79427: 2534,
  79429: 2627,
  79539: 2501,
  79540: 2478,
  79541: 2504,
  79576: 2475,
  79585: 2467,
  79588: 2499,
  79589: 2490,
  79591: 2487,
  79592: 2495,
  79594: 2456,
  79595: 2497,
  79597: 2503,
  79599: 2503,
  79853: 2371,
  79856: 2374,
  79859: 2380,
  79862: 2439,
  79865: 2383,
  79868: 2393,
  79871: 2353,
  79872: 2428,
  79874: 2383,
  79875: 2464,
  79877: 2329,
  79879: 2330,
  80331: 1399,
  80333: 1348,
  80335: 1412,
  80336: 1401,
  80337: 1398,
  80339: 1404,
  80469: 1396,
  80538: 1343,
  80539: 1344,
  80634: 1410,
  80636: 1411,
  80637: 1368,
  81673: 1388,
  81675: 1340,
  81677: 1337,
  81679: 1339,
  81735: 1389,
  81737: 1377,
  81739: 1380,
  81825: 1333,
  81827: 1337,
  81829: 1322,
  81925: 1345,
  81927: 1340,
  81929: 1337,
  82008: 1370,
  82024: 1364,
  82031: 1382,
  82041: 1374,
  82049: 1394,
  80638: 1374,
  80639: 1415,
  80686: 1409,
  80687: 1406,
  80689: 1413,
  80796: 1354,
  80797: 1364,
  80798: 1350,
  80799: 1348,
  80801: 1353,
  80802: 1352,
  80803: 1351,
  80804: 1352,
  80805: 1354,
  80807: 1356,
  80809: 1362,
  80933: 1369,
  80935: 1370,
  80937: 1368,
  80939: 1355,
  80992: 1370,
  80993: 1388,
  80995: 1385,
  80997: 1398,
  80999: 1388,
  79736: 2421,
  79737: 2447,
  79739: 2412,
  79761: 2263,
  79771: 2219,
  79774: 2319,
  79777: 2393,
  79780: 2354,
  79787: 2236,
  79790: 2270,
  79793: 2234,
  79798: 2179,
  79801: 2245,
  79802: 2203,
  79804: 2305,
  79805: 2372,
  79807: 2223,
  79809: 2317,
  79822: 2351,
  79837: 2447,
  79843: 2318,
  79848: 2344,
  79618: 2446,
  79639: 2444,
  79650: 2427,
  79664: 2417,
  79669: 2471,
  79674: 2423,
  79677: 2445,
  79682: 2460,
  79685: 2479,
  79686: 2425,
  79688: 2448,
  79689: 2452,
  79692: 2469,
  79694: 2439,
  79695: 2458,
  79713: 2402,
  79725: 2408,
  79730: 2409,
  79733: 2434,
  81241: 1421,
  81243: 1411,
  81245: 1405,
  81247: 1404,
  81248: 1406,
  81249: 1405,
  81369: 1402,
  81371: 1396,
  81373: 1401,
  81375: 1410,
  81377: 1410,
  81379: 1403,
  81475: 1415,
  81476: 1413,
  81477: 1411,
  81479: 1409,
  81539: 1389,
  81541: 1391,
  81543: 1391,
  81545: 1392,
  81547: 1388,
  81549: 1385,
  81667: 1389,
  81669: 1384,
  81671: 1385,
  82054: 1351,
  82057: 1427,
  82061: 1417,
  82064: 1394,
  82065: 1399,
  82067: 1413,
  82069: 1409,
  82110: 1420,
  82131: 1439,
  82140: 1423,
  82152: 1424,
  82166: 1426,
  82178: 1426,
  82194: 1408,
  82205: 1456,
  82211: 1491,
  82216: 1439,
  82299: 1495,
  82319: 1466,
  82327: 1464,
  82335: 1440,
  82340: 1482,
  82343: 1474,
  82346: 1499,
  82347: 1449,
  82349: 1439,
  82362: 1475,
  82377: 1396,
  82380: 1486,
  82383: 1498,
  82386: 1461,
  82387: 1410,
  82389: 1490,
  82390: 1459,
  82392: 1414,
  82223: 1428,
  82229: 1479,
  82234: 1454,
  82237: 1466,
  82239: 1432,
  82256: 1440,
  82266: 1474,
  82269: 1526,
  82272: 1484,
  82275: 1443,
  82276: 1470,
  82278: 1484,
  82279: 1482,
  82281: 1474,
  82284: 1473,
  82285: 1473,
  82287: 1463,
  82288: 1474,
  82290: 1458,
  82291: 1458,
  82293: 1487,
  82294: 1468,
  82296: 1458,
  82297: 1499,
  82393: 1411,
  82395: 1430,
  82396: 1524,
  82398: 1466,
  82399: 1529,
  82401: 1502,
  82402: 1428,
  82404: 1403,
  82405: 1501,
  82407: 1522,
  82409: 1517,
  82418: 1442,
  82431: 1411,
  82432: 1448,
  82433: 1476,
  82435: 1492,
  82436: 1439,
  82438: 1462,
  83364: 1083,
  83365: 1140,
  83367: 1071,
  83368: 1157,
  83370: 1168,
  83362: 1097,
  82538: 1393,
  82541: 1418,
  82544: 1378,
  82547: 1402,
  82549: 1388,
  83022: 1231,
  83024: 1247,
  83026: 1227,
  83043: 1265,
  83052: 1270,
  83059: 1245,
  83064: 1233,
  83071: 1227,
  83075: 1254,
  83080: 1301,
  83083: 1202,
  83088: 1292,
  83093: 1199,
  83098: 1261,
  83101: 1203,
  83104: 1280,
  83109: 1261,
  83112: 1181,
  83115: 1218,
  83119: 1183,
  83122: 1215,
  83123: 1246,
  83125: 1184,
  83126: 1291,
  83128: 1213,
  83129: 1197,
  83131: 1232,
  83132: 1185,
  83134: 1232,
  83135: 1273,
  83137: 1228,
  83139: 1216,
  83224: 1158,
  83229: 1190,
  83233: 1161,
  83236: 1138,
  83242: 1199,
  83246: 1165,
  83250: 1157,
  83253: 1185,
  83371: 1165,
  83373: 1098,
  83374: 1147,
  83376: 1158,
  83377: 1115,
  83379: 1097,
  83395: 1015,
  83404: 1027,
  83410: 1056,
  83413: 1077,
  83416: 1031,
  83417: 1068,
  83435: 1058,
  83451: 1040,
  83454: 1055,
  83457: 1050,
  83458: 1076,
  83471: 933,
  82439: 1418,
  82441: 1443,
  82442: 1486,
  82444: 1424,
  82445: 1467,
  82447: 1432,
  82449: 1457,
  82467: 1505,
  82475: 1592,
  82481: 1503,
  82487: 1511,
  82488: 1523,
  82490: 1567,
  82491: 1528,
  82493: 1526,
  82494: 1479,
  82496: 1476,
  82497: 1516,
  82499: 1474,
  82515: 1395,
  83254: 1184,
  83256: 1174,
  83257: 1174,
  83259: 1180,
  83278: 1114,
  83301: 1150,
  83308: 1181,
  83313: 1110,
  83317: 1054,
  83324: 1125,
  83329: 1104,
  83334: 1100,
  83339: 1150,
  83342: 1200,
  83346: 1118,
  83349: 1127,
  83352: 1182,
  83355: 1133,
  83358: 1162,
  83361: 1194,
  83546: 1206,
  83547: 1237,
  83549: 1247,
  83550: 1302,
  83553: 1279,
  83555: 1218,
  83483: 973,
  83486: 1107,
  83487: 943,
  83512: 1244,
  83527: 1230,
  83530: 1224,
  83533: 1254,
  83536: 1215,
  83539: 1270,
  83543: 1292,
  83544: 1255,
  83556: 1239,
  83558: 1239,
  83559: 1198,
  83561: 1261,
  83562: 1236,
  83564: 1230,
  83567: 1208,
  83569: 1253,
  83607: 1323,
  83620: 1292,
  83623: 1350,
  83624: 1334,
  83626: 1304,
  83627: 1330,
  83629: 1289,
  83646: 1357,
  83661: 1467,
  84028: 1329,
  84030: 1329,
  84032: 1338,
  84034: 1349,
  84036: 1250,
  84048: 1413,
  84051: 1312,
  84056: 1380,
  84061: 1312,
  84066: 1363,
  84069: 1386,
  84072: 1451,
  84076: 1384,
  84079: 1365,
  84082: 1306,
  84085: 1403,
  84088: 1351,
  84089: 1473,
  84091: 1405,
  84166: 1317,
  84168: 1205,
  84169: 1250,
  84171: 1242,
  84172: 1392,
  84174: 1385,
  84175: 1192,
  84177: 1247,
  84178: 1220,
  84180: 1268,
  84181: 1240,
  84183: 1282,
  84184: 1354,
  84186: 1268,
  84187: 1277,
  84189: 1197,
  84307: 1106,
  84323: 1138,
  84326: 1122,
  84329: 1095,
  84332: 1099,
  84333: 1129,
  84335: 1111,
  84092: 1311,
  84094: 1453,
  84095: 1348,
  84097: 1377,
  84098: 1345,
  84100: 1296,
  84101: 1368,
  84103: 1287,
  84104: 1410,
  84106: 1383,
  84107: 1347,
  84109: 1287,
  84130: 1265,
  84137: 1206,
  84140: 1158,
  84144: 1229,
  84149: 1209,
  84152: 1271,
  84155: 1200,
  84160: 1190,
  84163: 1175,
  84164: 1248,
  84428: 1204,
  84431: 1171,
  84432: 1252,
  84434: 1267,
  84435: 1241,
  84437: 1193,
  84439: 1250,
  84453: 1142,
  84478: 1172,
  84489: 1077,
  84494: 1158,
  84503: 1100,
  84508: 1102,
  84513: 1119,
  84518: 1147,
  84524: 1104,
  84529: 1105,
  84533: 1066,
  84337: 1096,
  84339: 1128,
  84347: 1060,
  84359: 1030,
  84364: 1036,
  84367: 1062,
  84371: 1060,
  84375: 1030,
  84378: 1072,
  84381: 1078,
  84384: 1043,
  84385: 1071,
  84387: 1041,
  84389: 1072,
  84405: 1217,
  84416: 1237,
  84419: 1193,
  84424: 1249,
  84427: 1227,
  85111: 1662,
  85113: 1633,
  85114: 1646,
  85116: 1645,
  85117: 1634,
  85119: 1501,
  85120: 1601,
  85122: 1648,
  85123: 1581,
  85125: 1507,
  85126: 1485,
  85128: 1639,
  85129: 1508,
  85131: 1563,
  85132: 1589,
  85134: 1510,
  85135: 1562,
  85137: 1557,
  85139: 1611,
  85221: 1389,
  85229: 1434,
  85232: 1420,
  85235: 1455,
  85238: 1442,
  84571: 1105,
  84573: 1166,
  84574: 1171,
  84576: 1113,
  84577: 1120,
  84579: 1131,
  85049: 1608,
  85051: 1585,
  85053: 1580,
  85055: 1596,
  85057: 1597,
  85072: 1569,
  85077: 1516,
  85080: 1625,
  85084: 1555,
  85088: 1497,
  85092: 1530,
  85095: 1488,
  85098: 1518,
  85101: 1605,
  85104: 1485,
  85107: 1561,
  85110: 1504,
  84539: 1158,
  84543: 1104,
  84544: 1183,
  84546: 1173,
  84547: 1098,
  84549: 1157,
  84550: 1149,
  84552: 1134,
  84553: 1135,
  84555: 1193,
  84556: 1107,
  84558: 1143,
  84559: 1177,
  84561: 1090,
  84562: 1161,
  84564: 1180,
  84565: 1152,
  84567: 1085,
  84568: 1127,
  84570: 1130,
  83666: 1323,
  83670: 1376,
  83671: 1418,
  83673: 1392,
  83674: 1354,
  83676: 1421,
  83677: 1333,
  83679: 1351,
  83684: 1329,
  83700: 1358,
  83703: 1316,
  83707: 1329,
  83708: 1362,
  83714: 1291,
  83727: 1306,
  83730: 1273,
  83734: 1296,
  83735: 1309,
  83737: 1274,
  67822: 2441,
  67823: 2479,
  67824: 2469,
  67826: 2478,
  67827: 2460,
  67744: 2512,
  67745: 2509,
  67746: 2522,
  67748: 2519,
  67749: 2504,
  67752: 2477,
  67753: 2482,
  67754: 2482,
  67756: 2489,
  67586: 2366,
  67587: 2373,
  67590: 2321,
  67591: 2319,
  67592: 2330,
  67593: 2337,
  67595: 2344,
  67596: 2351,
  67598: 2337,
  67599: 2327,
  67655: 2404,
  67657: 2395,
  67659: 2414,
  67661: 2440,
  67663: 2408,
  67677: 2378,
  67368: 2252,
  67373: 2221,
  67374: 2228,
  67376: 2236,
  67377: 2251,
  67378: 2262,
  67433: 2296,
  67434: 2309,
  67435: 2265,
  67454: 2253,
  67459: 2229,
  67466: 2316,
  67468: 2338,
  67471: 2353,
  67472: 2341,
  67678: 2404,
  67680: 2395,
  67681: 2398,
  67685: 2440,
  67686: 2444,
  67688: 2428,
  67691: 2399,
  67693: 2381,
  67697: 2403,
  67699: 2431,
  67700: 2467,
  67701: 2456,
  67757: 2462,
  67759: 2456,
  67806: 2437,
  67808: 2415,
  67473: 2312,
  67475: 2341,
  67480: 2330,
  67482: 2271,
  67483: 2257,
  67487: 2320,
  67489: 2271,
  67547: 2305,
  67549: 2320,
  67550: 2322,
  67551: 2312,
  67574: 2337,
  67575: 2360,
  67577: 2364,
  67578: 2367,
  67580: 2357,
  67582: 2349,
  67583: 2361,
  67585: 2363,
  67705: 2449,
  67706: 2449,
  67707: 2449,
  67714: 2480,
  67715: 2464,
  67716: 2473,
  67718: 2469,
  67722: 2407,
  67724: 2424,
  67725: 2392,
  67727: 2405,
  67728: 2394,
  67729: 2406,
  67731: 2434,
  67732: 2445,
  67734: 2441,
  67735: 2446,
  67737: 2457,
  67742: 2505,
  67811: 2433,
  67813: 2415,
  67814: 2412,
  67816: 2378,
  67817: 2412,
  67819: 2406,
  67821: 2471,
  69190: 2149,
  69198: 2230,
  69207: 2174,
  69214: 2192,
  69221: 2212,
  69226: 2152,
  69231: 2140,
  69234: 2128,
  69239: 2177,
  69242: 2152,
  69245: 2149,
  69250: 2184,
  69251: 2160,
  69253: 2254,
  69254: 2151,
  69256: 2136,
  69257: 2150,
  69259: 2245,
  69412: 2161,
  69427: 2114,
  69429: 2138,
  69434: 2187,
  67829: 2505,
  68159: 2238,
  68161: 2229,
  68163: 2224,
  68165: 2225,
  68167: 2233,
  68169: 2246,
  68199: 2218,
  68219: 2206,
  68229: 2212,
  68239: 2219,
  68259: 2236,
  68305: 2254,
  68307: 2267,
  68309: 2240,
  68519: 2255,
  68526: 2218,
  68535: 2220,
  68542: 2233,
  68549: 2232,
  68623: 2280,
  68642: 2296,
  71126: 2041,
  71131: 2046,
  71134: 2002,
  71139: 1993,
  71144: 1958,
  71149: 2051,
  71154: 2007,
  71155: 2003,
  71157: 2005,
  71159: 2058,
  71229: 1991,
  71254: 2008,
  71263: 2016,
  71272: 1996,
  71277: 1999,
  71282: 2028,
  71287: 2017,
  71292: 2019,
  71296: 2018,
  71297: 2020,
  71299: 2025,
  68647: 2328,
  68649: 2328,
  68723: 2193,
  68753: 2194,
  68766: 2192,
  68775: 2191,
  68782: 2208,
  68789: 2159,
  68794: 2209,
  68799: 2169,
  68804: 2190,
  68809: 2185,
  69115: 2193,
  69117: 2169,
  69118: 2171,
  69120: 2206,
  69121: 2213,
  69123: 2202,
  69124: 2188,
  69126: 2173,
  69151: 2164,
  69168: 2144,
  69181: 2174,
  70736: 1988,
  70771: 1943,
  70794: 1931,
  70806: 1990,
  70825: 2016,
  70839: 1987,
  71032: 1985,
  71034: 1987,
  71063: 1974,
  71065: 1960,
  71067: 1993,
  71069: 1988,
  71083: 2026,
  71088: 2004,
  71093: 2021,
  71101: 1985,
  71106: 2000,
  71111: 1974,
  71116: 2005,
  71120: 2004,
  69436: 2173,
  69437: 2121,
  69439: 2126,
  69469: 2236,
  69483: 2303,
  69488: 2262,
  69493: 2225,
  69502: 2252,
  69509: 2268,
  69514: 2257,
  69517: 2252,
  69518: 2268,
  70173: 1959,
  70174: 1960,
  70176: 1962,
  70178: 1958,
  70180: 1957,
  70182: 1957,
  70184: 1944,
  70186: 1951,
  70188: 1961,
  70190: 1962,
  70191: 1965,
  70192: 1987,
  71332: 1978,
  71334: 1992,
  71336: 2012,
  71364: 2008,
  71384: 1992,
  71394: 1958,
  71397: 2005,
  71404: 1993,
  71409: 2003,
  71522: 2031,
  71540: 2005,
  71543: 1994,
  71546: 2091,
  71549: 2041,
  71554: 2034,
  71560: 1999,
  71563: 2021,
  71566: 2026,
  71570: 2010,
  71573: 2031,
  71576: 2025,
  71577: 1980,
  71579: 2015,
  71634: 2034,
  71636: 2022,
  71638: 2002,
  71640: 2006,
  71642: 2007,
  71665: 2058,
  71672: 2035,
  71679: 2030,
  71686: 1999,
  71691: 2041,
  71696: 2025,
  71701: 2022,
  71706: 2034,
  71711: 2073,
  70193: 1980,
  70195: 1981,
  70197: 1980,
  70199: 1955,
  70327: 1951,
  70329: 1946,
  70372: 1963,
  70374: 1970,
  70376: 1972,
  70378: 1974,
  70435: 1977,
  70437: 1981,
  70439: 2016,
  70469: 2013,
  70499: 1992,
  70563: 1961,
  70565: 1947,
  70567: 1942,
  70569: 1966,
  70597: 1945,
  70599: 1932,
  70619: 1937,
  70629: 1920,
  70734: 1969,
  71717: 2058,
  71720: 2064,
  71723: 2069,
  71726: 2083,
  71729: 2031,
  71732: 2041,
  71735: 2029,
  71737: 2034,
  71739: 2056,
  72070: 2035,
  72072: 2032,
  72074: 2017,
  72076: 2029,
  72108: 2059,
  72116: 2071,
  72119: 2038,
  72124: 1995,
  72127: 2035,
  72131: 2054,
  72135: 2003,
  72138: 2006,
  72141: 1990,
  72144: 2043,
  72145: 2076,
  72147: 2049,
  72149: 2075,
  72160: 2111,
  72172: 2138,
  72175: 2161,
  72178: 2137,
  72181: 2111,
  72184: 2084,
  72186: 2102,
  72189: 2121,
  72202: 2066,
  72213: 2105,
  72218: 2039,
  72221: 2086,
  72224: 2073,
  72226: 2106,
  72227: 2093,
  72365: 2158,
  72367: 2156,
  72369: 2155,
  72379: 2081,
  72393: 1971,
  72401: 2126,
  72406: 2099,
  72411: 2073,
  72414: 2098,
  72415: 2102,
  72417: 1981,
  72419: 1960,
  72458: 2000,
  72459: 2021,
  72461: 2005,
  72469: 2037,
  72474: 1987,
  72475: 1981,
  72477: 2001,
  72479: 2009,
  72488: 1946,
  72501: 1940,
  72229: 2074,
  72250: 2167,
  72270: 2200,
  72275: 2204,
  72280: 2147,
  72285: 2111,
  72290: 2159,
  72293: 2141,
  72294: 2129,
  72296: 2142,
  72297: 2136,
  72299: 2115,
  72336: 2116,
  72348: 2153,
  72351: 2122,
  72355: 2146,
  72356: 2147,
  72358: 2144,
  72359: 2136,
  72361: 2159,
  72362: 2175,
  72364: 2169,
  73329: 1799,
  73333: 1807,
  73337: 1814,
  73340: 1772,
  73342: 1827,
  73344: 1831,
  73345: 1804,
  73347: 1818,
  73349: 1813,
  73430: 1875,
  73431: 1850,
  73432: 1833,
  73433: 1858,
  73434: 1885,
  73441: 1757,
  73240: 1896,
  73249: 1905,
  73252: 1890,
  73257: 1901,
  73262: 1919,
  73265: 1871,
  73266: 1867,
  73268: 1880,
  73269: 1890,
  73271: 1853,
  73272: 1861,
  73274: 1878,
  73275: 1860,
  73277: 1879,
  73278: 1868,
  73312: 1790,
  73326: 1833,
  73092: 1855,
  73095: 1870,
  73098: 1878,
  73099: 1905,
  73101: 1848,
  73102: 1856,
  73104: 1891,
  73105: 1846,
  73107: 1859,
  73108: 1849,
  73110: 1859,
  73111: 1808,
  73113: 1845,
  73114: 1825,
  73116: 1859,
  73117: 1886,
  73119: 1852,
  73207: 1918,
  73230: 1869,
  73235: 1857,
  72810: 2046,
  72813: 1895,
  72818: 1923,
  72820: 1938,
  72827: 2013,
  72829: 1906,
  73033: 1871,
  73035: 1865,
  73037: 1847,
  73054: 1839,
  73061: 1909,
  73066: 1884,
  73072: 1828,
  73079: 1820,
  73084: 1830,
  73087: 1842,
  72631: 1923,
  72636: 1901,
  72639: 1902,
  72644: 1890,
  72649: 1915,
  72654: 1935,
  72655: 1929,
  72657: 1939,
  72658: 1930,
  72660: 1891,
  72661: 1929,
  72663: 1922,
  72664: 1909,
  72666: 1922,
  72667: 1935,
  72669: 1897,
  72760: 2009,
  72762: 1936,
  72764: 1926,
  72766: 1955,
  72768: 1958,
  72770: 1942,
  72793: 1937,
  72800: 1933,
  72805: 1915,
  73447: 1827,
  73450: 1750,
  73453: 1898,
  73457: 1871,
  73460: 1866,
  73463: 1851,
  73466: 1842,
  73467: 1744,
  73469: 1727,
  73479: 1892,
  73485: 1767,
  72505: 1941,
  72510: 1985,
  72511: 1949,
  72513: 1959,
  72514: 1960,
  72516: 1913,
  72517: 1926,
  72519: 1977,
  72525: 1844,
  72531: 1897,
  72532: 1880,
  72534: 1905,
  72535: 1809,
  72537: 1852,
  72539: 1931,
  72555: 1941,
  72574: 1866,
  72581: 1894,
  72582: 1867,
  72584: 1883,
  72585: 1936,
  72587: 1873,
  72589: 1822,
  72622: 1911,
  73486: 1944,
  73488: 1880,
  73489: 1886,
  73491: 1879,
  73492: 1866,
  73494: 1895,
  73495: 1884,
  73497: 1783,
  73499: 1870,
  73525: 1917,
  73527: 1913,
  73529: 1903,
  73540: 1863,
  73547: 1948,
  73550: 1873,
  73553: 1954,
  73557: 1927,
  73560: 1889,
  73563: 1876,
  73565: 1944,
  73566: 1848,
  73568: 1925,
  73569: 1919,
  73571: 1908,
  73572: 1889,
  73574: 1898,
  73575: 1906,
  73577: 1928,
  73579: 1910,
  73614: 1914,
  73630: 2002,
  73635: 1947,
  73642: 1980,
  73650: 1945,
  73655: 1964,
  74249: 1986,
  74251: 2019,
  74252: 2071,
  74254: 2046,
  74255: 2040,
  74257: 2033,
  74259: 2000,
  74321: 2047,
  74336: 2079,
  74343: 2082,
  74348: 2056,
  74354: 2080,
  74357: 2095,
  74360: 2039,
  74363: 2097,
  74366: 2080,
  74369: 2087,
  74372: 2065,
  74374: 2150,
  74376: 2074,
  74379: 2077,
  74585: 1869,
  74586: 1885,
  74589: 1839,
  74592: 1867,
  74594: 1839,
  74595: 1917,
  74597: 1866,
  74599: 1844,
  74613: 1957,
  74626: 1982,
  74629: 1974,
  74632: 1939,
  74635: 1923,
  74638: 1937,
  74639: 1959,
  74081: 2058,
  74172: 2030,
  74177: 2041,
  74182: 1997,
  74189: 2017,
  74193: 2075,
  74196: 2005,
  74199: 2039,
  74206: 2049,
  74211: 2068,
  74214: 1999,
  74219: 2034,
  74223: 2048,
  74226: 2064,
  74229: 2013,
  74232: 2033,
  74235: 2030,
  74238: 1994,
  74239: 1982,
  74243: 1982,
  74245: 2015,
  74246: 1997,
  74248: 2017,
  74382: 2059,
  74385: 2071,
  74388: 2049,
  74389: 2095,
  74391: 2097,
  74392: 2074,
  74394: 2071,
  74395: 2061,
  74397: 2108,
  74399: 2087,
  74405: 1940,
  74417: 1962,
  74420: 1973,
  74423: 1916,
  74424: 1905,
  74426: 1919,
  74427: 1984,
  74429: 1944,
  74523: 1915,
  74532: 1875,
  74535: 1968,
  74538: 1951,
  74541: 1897,
  74542: 1911,
  74544: 1959,
  74545: 1939,
  74547: 1919,
  74549: 1886,
  74564: 1854,
  74572: 1883,
  74575: 1876,
  74579: 1857,
  74582: 1883,
  73660: 1974,
  73663: 2024,
  73666: 1934,
  73667: 2026,
  73669: 1930,
  73728: 1933,
  73730: 1930,
  73732: 1943,
  73733: 1942,
  73734: 1924,
  73760: 1926,
  73765: 1914,
  73770: 1918,
  73773: 1936,
  73776: 1918,
  73779: 1915,
  74072: 2032,
  74074: 2041,
  74076: 2027,
  74078: 2040,
  74080: 2045,
  54558: 2729,
  54568: 2768,
  54570: 2763,
  54533: 2755,
  54534: 2762,
  54536: 2610,
  54538: 2639,
  54539: 2647,
  54550: 2724,
  54552: 2705,
  54589: 2801,
  54595: 2811,
  54597: 2806,
  54608: 2831,
  54497: 2594,
  54498: 2661,
  54516: 2656,
  54518: 2677,
  54610: 2789,
  54611: 2825,
  54612: 2781,
  54614: 2793,
  54616: 2837,
  54617: 2860,
  54619: 2851,
  54574: 2786,
  54576: 2759,
  54578: 2768,
  54579: 2757,
  54584: 2784,
  54585: 2795,
  54586: 2796,
  54587: 2781,
  54523: 2720,
  54524: 2677,
  54526: 2684,
  54528: 2669,
  54529: 2710,
  54531: 2733,
  54634: 2748,
  54636: 2755,
  54646: 2795,
  54647: 2735,
  54649: 2778,
  55234: 2350,
  55237: 2386,
  55239: 2370,
  55246: 2308,
  55252: 2304,
  55257: 2331,
  55262: 2344,
  55263: 2347,
  55268: 2339,
  55270: 2340,
  55271: 2347,
  55276: 2347,
  54655: 2747,
  54675: 2821,
  54687: 2814,
  54689: 2835,
  55116: 2313,
  55118: 2316,
  55120: 2324,
  55122: 2321,
  55124: 2333,
  55126: 2332,
  55127: 2334,
  55128: 2320,
  55296: 2335,
  55299: 2327,
  55411: 2389,
  55413: 2407,
  55422: 2446,
  55424: 2408,
  55425: 2430,
  55430: 2497,
  55432: 2496,
  55435: 2373,
  55437: 2384,
  54657: 2725,
  54662: 2749,
  54664: 2750,
  54666: 2778,
  54668: 2801,
  54669: 2801,
  55129: 2316,
  55130: 2309,
  55131: 2312,
  55218: 2354,
  55232: 2369,
  55278: 2382,
  55283: 2337,
  55286: 2378,
  55288: 2367,
  55291: 2353,
  55294: 2312,
  54673: 2842,
  55442: 2436,
  55444: 2445,
  55450: 2407,
  55452: 2426,
  55457: 2401,
  55459: 2412,
  55469: 2488,
  55471: 2509,
  55481: 2513,
  55483: 2544,
  55569: 2490,
  55571: 2479,
  55576: 2382,
  55578: 2383,
  55583: 2444,
  55585: 2447,
  55590: 2509,
  55592: 2516,
  55593: 2437,
  55595: 2450,
  55487: 2536,
  55490: 2509,
  55491: 2549,
  55494: 2469,
  55496: 2476,
  55497: 2460,
  55499: 2482,
  55543: 2431,
  55545: 2428,
  55546: 2438,
  55559: 2425,
  55566: 2477,
  55568: 2514,
  55606: 2513,
  55608: 2531,
  55618: 2505,
  55619: 2532,
  55621: 2515,
  55624: 2562,
  55626: 2577,
  55627: 2501,
  55596: 2459,
  55597: 2404,
  55599: 2407,
  55629: 2522,
  55743: 2561,
  55756: 2560,
  55758: 2583,
  55765: 2572,
  55767: 2596,
  56242: 2503,
  56244: 2514,
  56290: 2524,
  56291: 2500,
  56294: 2602,
  55768: 2561,
  55774: 2579,
  55776: 2554,
  55777: 2539,
  55779: 2555,
  56068: 2551,
  56070: 2545,
  56072: 2550,
  56073: 2544,
  56075: 2543,
  56076: 2533,
  56077: 2524,
  56112: 2547,
  56283: 2531,
  56288: 2512,
  56203: 2504,
  56204: 2517,
  56206: 2508,
  56218: 2542,
  56220: 2593,
  56235: 2494,
  56237: 2496,
  56249: 2529,
  56253: 2596,
  56254: 2595,
  56269: 2539,
  56271: 2533,
  56276: 2538,
  56281: 2516,
  56130: 2512,
  56132: 2535,
  56133: 2524,
  56154: 2543,
  56170: 2538,
  56179: 2520,
  56182: 2521,
  56191: 2516,
  56295: 2574,
  56299: 2573,
  56305: 2545,
  56307: 2526,
  56316: 2541,
  56317: 2531,
  56321: 2560,
  56322: 2567,
  56323: 2561,
  56329: 2487,
  56330: 2579,
  56332: 2563,
  56333: 2564,
  56335: 2499,
  56337: 2502,
  56338: 2485,
  56340: 2469,
  56341: 2481,
  56346: 2478,
  56348: 2456,
  56349: 2432,
  56355: 2421,
  56357: 2443,
  56377: 2446,
  56379: 2432,
  56410: 2473,
  56412: 2433,
  56368: 2418,
  56370: 2460,
  56414: 2456,
  56422: 2479,
  56424: 2469,
  56427: 2492,
  56428: 2476,
  56457: 2482,
  56459: 2505,
  56462: 2491,
  56470: 2523,
  56472: 2506,
  56477: 2484,
  56479: 2468,
  56564: 2549,
  56566: 2551,
  56567: 2564,
  56575: 2553,
  56579: 2562,
  56581: 2565,
  19273: 2743,
  19322: 2650,
  19336: 2736,
  19339: 2718,
  19348: 2725,
  19306: 2801,
  19309: 2705,
  19230: 2910,
  19243: 2896,
  19246: 2938,
  19249: 2928,
  19258: 2990,
  19260: 2940,
  19357: 2767,
  19370: 2761,
  19372: 2805,
  19217: 2998,
  19374: 2800,
  19376: 2722,
  19386: 2782,
  19395: 2726,
  19399: 2788,
  19406: 2860,
  19294: 2887,
  19300: 2795,
  19303: 2917,
  19288: 2849,
  19412: 2933,
  19417: 2951,
  21391: 2992,
  21394: 2969,
  21395: 3084,
  21397: 2838,
  21398: 2849,
  21400: 2842,
  21401: 2834,
  21403: 2850,
  21406: 2836,
  21407: 2838,
  21409: 2969,
  21423: 3006,
  21435: 3007,
  21436: 3069,
  21438: 2977,
  21439: 2997,
  21441: 2976,
  21442: 2963,
  21444: 2983,
  21035: 3115,
  21037: 3135,
  21039: 3141,
  21073: 3032,
  21075: 3035,
  21077: 3025,
  21079: 3027,
  21107: 3042,
  21109: 3038,
  21129: 3067,
  21147: 3050,
  21149: 3052,
  21217: 3029,
  21218: 3008,
  21220: 2993,
  21224: 3036,
  21227: 3022,
  21228: 3016,
  21244: 2999,
  21255: 2987,
  21493: 3004,
  21502: 3047,
  21509: 3066,
  21514: 2992,
  21360: 3000,
  21365: 2870,
  21368: 2725,
  21369: 2710,
  21371: 2726,
  21376: 2955,
  21379: 2867,
  21380: 2897,
  21382: 2883,
  21385: 2932,
  21386: 2960,
  21388: 2938,
  20095: 3104,
  20097: 3099,
  20099: 3100,
  20144: 3112,
  20146: 3108,
  20148: 3107,
  20149: 3110,
  20249: 3111,
  20251: 3113,
  20253: 3111,
  20255: 3086,
  20257: 3086,
  20259: 3114,
  20354: 3104,
  20355: 3107,
  20357: 3111,
  20359: 3110,
  20457: 3119,
  20459: 3109,
  20535: 3091,
  20537: 3100,
  20539: 3114,
  21029: 3088,
  21031: 3080,
  21033: 3096,
  21643: 3081,
  21644: 3057,
  21646: 3060,
  21647: 3062,
  21649: 3073,
  21680: 3142,
  21682: 3149,
  21683: 3158,
  21684: 3138,
  21698: 3090,
  21702: 3063,
  21706: 3188,
  21709: 3176,
  21710: 3190,
  21712: 3205,
  21714: 3168,
  21717: 3108,
  21720: 3128,
  21516: 3008,
  21521: 3066,
  21522: 2880,
  21524: 3060,
  21526: 3076,
  21527: 3063,
  21529: 3072,
  21614: 3080,
  21629: 3061,
  21635: 3089,
  21640: 3103,
  21641: 3094,
  21445: 2988,
  21447: 3047,
  21449: 3014,
  21465: 3058,
  21481: 3043,
  21483: 3017,
  21256: 2973,
  21258: 2999,
  21259: 2974,
  21261: 2960,
  21266: 2985,
  21271: 2971,
  21272: 2938,
  21274: 2957,
  21279: 3051,
  21335: 2840,
  21337: 2858,
  21339: 2854,
  21354: 2776,
  21357: 2883,
  21358: 3008,
  22393: 3109,
  22395: 3120,
  22397: 3126,
  22399: 3120,
  22415: 3119,
  22417: 3127,
  22419: 3111,
  22453: 3118,
  22455: 3102,
  22457: 3096,
  22459: 3097,
  22523: 3087,
  22525: 3076,
  22527: 3082,
  22529: 3086,
  22547: 3081,
  22549: 3083,
  22559: 3096,
  22587: 3090,
  22589: 3082,
  22605: 3069,
  22607: 3071,
  22609: 3083,
  22761: 3073,
  22763: 3069,
  22946: 3054,
  22949: 3122,
  22952: 3058,
  22955: 3075,
  22956: 3054,
  22958: 3041,
  22959: 3063,
  22961: 3074,
  22962: 3073,
  22964: 3074,
  22965: 3074,
  22967: 3090,
  22969: 3042,
  23552: 3159,
  23554: 3192,
  23556: 3182,
  23558: 3173,
  23560: 3083,
  23562: 3144,
  23564: 3156,
  22765: 3071,
  22767: 3076,
  22769: 3077,
  22844: 3145,
  22846: 3120,
  22848: 3105,
  22850: 3115,
  22851: 3168,
  22869: 3088,
  22880: 3109,
  22885: 3074,
  22889: 3159,
  22926: 3111,
  22927: 3101,
  22929: 3025,
  22941: 3098,
  22115: 3091,
  22117: 3080,
  22119: 3082,
  22143: 3093,
  22145: 3083,
  22147: 3093,
  22149: 3092,
  22159: 3095,
  22175: 3101,
  22177: 3101,
  22179: 3097,
  22297: 3110,
  22299: 3107,
  22301: 3104,
  22303: 3107,
  22305: 3097,
  22307: 3101,
  22309: 3104,
  22335: 3118,
  22337: 3118,
  22339: 3117,
  22359: 3107,
  22391: 3113,
  21723: 3151,
  21726: 3113,
  21727: 3109,
  21729: 3244,
  21730: 3330,
  21732: 3352,
  21734: 3236,
  21737: 3217,
  21739: 3115,
  21745: 3151,
  21755: 3193,
  21756: 3172,
  21762: 3268,
  21763: 3274,
  21765: 3225,
  21769: 3123,
  23779: 3368,
  23795: 3158,
  23812: 3186,
  23813: 3187,
  23815: 3217,
  23816: 3144,
  21770: 3244,
  21772: 3230,
  21775: 3216,
  21776: 3215,
  21781: 3313,
  21782: 3289,
  21785: 3303,
  21787: 3340,
  21789: 3300,
  22041: 3095,
  22043: 3083,
  22045: 3083,
  22047: 3088,
  22049: 3097,
  22081: 3096,
  22083: 3101,
  22085: 3100,
  22087: 3099,
  22089: 3095,
  22111: 3093,
  22113: 3097,
  23629: 3236,
  23669: 3226,
  23683: 3239,
  23684: 3249,
  23689: 3226,
  23701: 3272,
  23714: 3321,
  23715: 3284,
  23717: 3299,
  23719: 3256,
  23730: 3280,
  23738: 3314,
  23743: 3320,
  23744: 3307,
  23746: 3343,
  23747: 3350,
  23749: 3337,
  23758: 3345,
  23769: 3419,
  23774: 3368,
  23775: 3391,
  23777: 3356,
  23566: 3140,
  23568: 3146,
  23569: 3159,
  23570: 3180,
  23611: 3205,
  23617: 3218,
  23619: 3151,
  23623: 3246,
  23626: 3211,
  23627: 3132,
  23628: 3064,
  23883: 2999,
  23896: 3019,
  23898: 3090,
  23899: 2971,
  23909: 3036,
  23911: 2991,
  23919: 3055,
  23923: 3125,
  23845: 3160,
  23847: 3102,
  23858: 3132,
  23860: 3119,
  23936: 3051,
  23942: 3119,
  23946: 3100,
  23818: 3165,
  23820: 3225,
  23821: 3175,
  23823: 3223,
  23824: 3207,
  23826: 3163,
  23827: 3188,
  23829: 3163,
  23843: 3113,
  23863: 3135,
  23866: 3159,
  23867: 3130,
  23869: 3120,
  23879: 3001,
  23881: 2999,
  23970: 2980,
  23972: 3000,
  23974: 3000,
  23992: 2966,
  23948: 3086,
  23966: 3019,
  23968: 3011,
  23996: 2949,
  23999: 3017,
  24103: 3287,
  24105: 3303,
  24106: 3306,
  24107: 3301,
  24109: 3328,
  24111: 3292,
  24113: 3292,
  24114: 3287,
  24116: 3292,
  24118: 3303,
  24119: 3293,
  24143: 3284,
  24145: 3273,
  24146: 3284,
  24147: 3284,
  24148: 3290,
  24149: 3297,
  24159: 3318,
  24161: 3317,
  24211: 3267,
  24214: 3333,
  24217: 3343,
  24582: 3273,
  24589: 3288,
  24594: 3303,
  24340: 3390,
  24351: 3419,
  24354: 3388,
  24357: 3391,
  24358: 3390,
  24360: 3385,
  24361: 3370,
  24220: 3272,
  24222: 3292,
  24223: 3280,
  24226: 3317,
  24229: 3339,
  24232: 3304,
  24235: 3327,
  24250: 3237,
  24251: 3339,
  24253: 3305,
  24254: 3291,
  24256: 3301,
  24257: 3331,
  24259: 3319,
  24306: 3261,
  24321: 3362,
  24326: 3239,
  24327: 3343,
  24329: 3277,
  24395: 3477,
  24398: 3434,
  24399: 3456,
  24401: 3485,
  24402: 3512,
  24404: 3473,
  24405: 3497,
  24407: 3457,
  24409: 3463,
  24534: 3234,
  24536: 3256,
  24537: 3241,
  24539: 3227,
  24558: 3174,
  24568: 3167,
  24576: 3194,
  24238: 3300,
  24239: 3315,
  24241: 3284,
  24242: 3331,
  24244: 3327,
  24245: 3259,
  24247: 3299,
  24248: 3301,
  24363: 3358,
  24364: 3403,
  24366: 3389,
  24367: 3401,
  24369: 3413,
  24376: 3450,
  24392: 3493,
  24647: 3248,
  24649: 3205,
  24768: 3355,
  24782: 3362,
  24783: 3352,
  24784: 3355,
  24787: 3361,
  24790: 3351,
  24791: 3368,
  24793: 3312,
  24794: 3357,
  24805: 3394,
  24806: 3380,
  24808: 3331,
  24809: 3377,
  24811: 3375,
  24813: 3336,
  24814: 3380,
  24816: 3318,
  24817: 3387,
  24819: 3331,
  24837: 3438,
  24848: 3397,
  24850: 3424,
  24852: 3488,
  24855: 3447,
  24857: 3421,
  24860: 3467,
  24861: 3434,
  24598: 3213,
  24601: 3227,
  24610: 3205,
  24613: 3269,
  24616: 3234,
  24619: 3196,
  24620: 3234,
  24622: 3293,
  24623: 3223,
  24625: 3244,
  24963: 3476,
  24966: 3517,
  24969: 3527,
  24972: 3540,
  24975: 3508,
  24976: 3501,
  24977: 3545,
  24980: 3534,
  24983: 3510,
  24986: 3484,
  24988: 3478,
  24989: 3542,
  24626: 3213,
  24628: 3176,
  24629: 3163,
  24631: 3295,
  24632: 3174,
  24634: 3244,
  24635: 3183,
  24637: 3229,
  24638: 3213,
  24640: 3193,
  24641: 3176,
  24643: 3185,
  24644: 3275,
  24646: 3304,
  24796: 3344,
  24797: 3387,
  24799: 3404,
  24800: 3389,
  24802: 3305,
  24803: 3384,
  24863: 3450,
  24864: 3462,
  24866: 3407,
  24867: 3413,
  24869: 3447,
  24870: 3428,
  24872: 3430,
  24873: 3487,
  24876: 3442,
  24878: 3418,
  24879: 3443,
  24881: 3446,
  24882: 3452,
  24884: 3398,
  24885: 3460,
  24887: 3441,
  24888: 3478,
  24890: 3458,
  24891: 3481,
  24893: 3464,
  24894: 3456,
  24896: 3452,
  24897: 3481,
  24899: 3460,
  24937: 3509,
  24939: 3515,
  24941: 3503,
  24943: 3510,
  24944: 3519,
  24955: 3517,
  24960: 3536,
  24991: 3492,
  24992: 3489,
  24994: 3536,
  24996: 3534,
  24997: 3490,
  24999: 3523,
  25335: 3179,
  25336: 3168,
  25337: 3158,
  25348: 3240,
  25355: 3198,
  25358: 3188,
  25361: 3211,
  25364: 3200,
  25365: 3173,
  25368: 3181,
  25370: 3181,
  25371: 3191,
  25373: 3147,
  25376: 3232,
  25377: 3204,
  25379: 3231,
  25421: 3110,
  25436: 3135,
  25451: 3140,
  25462: 3111,
  25469: 3095,
  25474: 3110,
  25479: 3138,
  25482: 3116,
  25485: 3158,
  25486: 3147,
  25488: 3123,
  25489: 3146,
  25491: 3135,
  25492: 3137,
  25494: 3132,
  25495: 3137,
  25497: 3137,
  25499: 3131,
  25524: 3240,
  25541: 3312,
  25548: 3248,
  25551: 3261,
  25554: 3261,
  25557: 3310,
  25569: 3234,
  25572: 3286,
  25573: 3272,
  25575: 3302,
  25576: 3280,
  25578: 3224,
  25579: 3254,
  25581: 3287,
  25582: 3253,
  25560: 3277,
  25563: 3224,
  25566: 3202,
  25584: 3291,
  25585: 3308,
  25587: 3229,
  25588: 3250,
  25590: 3312,
  25591: 3247,
  25593: 3313,
  25594: 3270,
  25596: 3279,
  25597: 3225,
  25599: 3247,
  25693: 3320,
  25704: 3375,
  25709: 3339,
  25712: 3336,
  25715: 3305,
  25718: 3366,
  25719: 3340,
  25721: 3305,
  25724: 3330,
  25725: 3299,
  25727: 3321,
  25729: 3342,
  25746: 3359,
  25761: 3411,
  25764: 3395,
  25767: 3326,
  25797: 3379,
  25799: 3358,
  25813: 3473,
  25821: 3541,
  25826: 3463,
  25832: 3430,
  25836: 3446,
  25779: 3385,
  25782: 3350,
  25785: 3348,
  25786: 3366,
  25788: 3387,
  25791: 3382,
  25792: 3387,
  25794: 3368,
  25795: 3377,
  25770: 3360,
  25774: 3419,
  25776: 3432,
  25840: 3444,
  25842: 3579,
  25845: 3545,
  25849: 3609,
  25850: 3485,
  25885: 3469,
  25887: 3474,
  25889: 3462,
  25899: 3625,
  25917: 3569,
  25920: 3598,
  25923: 3603,
  25852: 3594,
  25853: 3526,
  25855: 3501,
  25856: 3516,
  25858: 3559,
  25859: 3671,
  25860: 3510,
  25862: 3542,
  25863: 3680,
  25864: 3526,
  25866: 3483,
  25869: 3633,
  25870: 3438,
  25872: 3460,
  25873: 3479,
  25876: 3436,
  25878: 3423,
  25879: 3417,
  25881: 3467,
  25882: 3446,
  25884: 3493,
  25924: 3653,
  25926: 3580,
  25927: 3633,
  25938: 3680,
  25946: 3707,
  25980: 3725,
  25992: 3817,
  25996: 3731,
  25997: 3762,
  25999: 3738,
  26121: 3116,
  26122: 3103,
  26123: 3113,
  26125: 3114,
  26127: 3116,
  26129: 3111,
  26131: 3109,
  26133: 3107,
  26135: 3093,
  26160: 3152,
  26169: 3213,
  26180: 3145,
  26188: 3146,
  26197: 3098,
  26203: 3137,
  26209: 3080,
  26215: 3147,
  26219: 3183,
  26316: 3183,
  26340: 3217,
  26345: 3209,
  26349: 3181,
  26382: 3252,
  26384: 3265,
  26386: 3258,
  26388: 3258,
  26389: 3246,
  26409: 3297,
  26419: 3243,
  26427: 3332,
  26532: 3382,
  26548: 3486,
  26553: 3360,
  26556: 3363,
  26603: 3293,
  26605: 3283,
  26607: 3339,
  26624: 3361,
  26629: 3252,
  26632: 3319,
  26639: 3248,
  26655: 3180,
  26670: 3221,
  26676: 3222,
  26683: 3206,
  26689: 3235,
  26721: 3338,
  26723: 3348,
  26434: 3298,
  26441: 3274,
  26446: 3250,
  26452: 3227,
  26487: 3343,
  26489: 3343,
  26506: 3417,
  26524: 3430,
  26529: 3382,
  26725: 3332,
  26736: 3376,
  26757: 3586,
  26759: 3355,
  26789: 3273,
  26802: 3278,
  26810: 3307,
  26817: 3289,
  26826: 3361,
  26831: 3338,
  26835: 3273,
  26842: 3282,
  26844: 3298,
  26845: 3258,
  26847: 3250,
  26849: 3242,
  26871: 3351,
  26892: 3318,
  26897: 3230,
  26899: 3330,
  26901: 3235,
  26903: 3257,
  26904: 3267,
  26906: 3308,
  26907: 3287,
  26909: 3347,
  26919: 3165,
  26931: 3108,
  26935: 3137,
  26936: 3152,
  26937: 3162,
  26939: 3158,
  26954: 3146,
  26969: 3182,
  27336: 2848,
  27337: 2900,
  27339: 2988,
  27356: 2926,
  27367: 2936,
  27374: 2858,
  27383: 2959,
  27386: 2893,
  27389: 2931,
  27259: 2919,
  27283: 2884,
  27299: 2896,
  27305: 2898,
  27308: 2844,
  27313: 2905,
  27318: 2923,
  27321: 2922,
  27324: 2879,
  27327: 2923,
  27330: 2876,
  27333: 2861,
  27211: 2946,
  27232: 2898,
  27239: 2965,
  27243: 3036,
  27245: 2912,
  27246: 2872,
  27248: 2938,
  27249: 2883,
  27251: 2933,
  27252: 2904,
  27254: 2875,
  27257: 2922,
  27580: 3150,
  27607: 3193,
  27612: 3106,
  27616: 3119,
  27619: 3152,
  27624: 3192,
  27628: 3092,
  27639: 3217,
  27711: 3040,
  27721: 3019,
  27726: 3049,
  27729: 3058,
  27749: 3017,
  27751: 3014,
  27753: 3024,
  27755: 3015,
  27777: 3035,
  27793: 3063,
  27798: 3074,
  27801: 3072,
  27404: 2992,
  27412: 2995,
  27419: 3025,
  27432: 3082,
  27442: 3060,
  27446: 3046,
  27449: 3074,
  27472: 3239,
  27474: 3238,
  27476: 3245,
  27478: 3251,
  27568: 3149,
  27570: 3141,
  27572: 3118,
  27574: 3128,
  27576: 3142,
  27578: 3147,
  27804: 3085,
  27809: 3035,
  28195: 2990,
  28197: 3005,
  28199: 2981,
  28201: 2976,
  28203: 2973,
  28205: 2972,
  28207: 2964,
  28209: 2971,
  28211: 2968,
  28213: 2970,
  28215: 2986,
  28217: 2986,
  28219: 2987,
  28237: 3004,
  28239: 3000,
  28259: 3004,
  28277: 2975,
  28279: 2970,
  28307: 2944,
  28309: 2962,
  28325: 2946,
  28327: 2956,
  28329: 2964,
  28355: 2960,
  28357: 2974,
  28359: 2973,
  28717: 3019,
  28719: 3008,
  28755: 3034,
  28757: 3034,
  28759: 3028,
  28777: 3057,
  28779: 3048,
  28790: 3044,
  28816: 3000,
  28832: 2919,
  28844: 2982,
  28857: 2931,
  28865: 2988,
  28870: 2957,
  28876: 2941,
  28879: 2986,
  29221: 2678,
  29223: 2687,
  29225: 2735,
  29227: 2679,
  29229: 2695,
  "01067": 1684,
  "01069": 1675,
  "01097": 1689,
  "01099": 1756,
  "01108": 1750,
  "01109": 1732,
  "01127": 1692,
  "01129": 1726,
  "01139": 1719,
  "01156": 1721,
  "01157": 1715,
  "01159": 1680,
  "01169": 1703,
  "01187": 1675,
  "01189": 1671,
  "01217": 1671,
  "01219": 1668,
  "01237": 1660,
  "01239": 1659,
  "01257": 1654,
  "01259": 1660,
  "01277": 1670,
  "01279": 1666,
  "01307": 1685,
  "01309": 1677,
  "01833": 1700,
  "01844": 1733,
  "01847": 1668,
  "01848": 1708,
  "01855": 1680,
  "01877": 1733,
  "01896": 1733,
  "01900": 1722,
  "01904": 1757,
  "01945": 1858,
  "01968": 1881,
  "01979": 1862,
  "01983": 1910,
  "01987": 1861,
  "01990": 1823,
  "01993": 1872,
  "01994": 1888,
  "01996": 1890,
  "01998": 1882,
  "02625": 1769,
  "02627": 1737,
  "02708": 1707,
  "02727": 1679,
  "02730": 1685,
  "02733": 1740,
  "02736": 1710,
  "02739": 1671,
  "02742": 1703,
  "02747": 1670,
  "02748": 1673,
  "02763": 1637,
  "01778": 1576,
  "01796": 1641,
  "01809": 1634,
  "01814": 1658,
  "01816": 1602,
  "01819": 1609,
  "01824": 1602,
  "01825": 1618,
  "01829": 1675,
  "02633": 1761,
  "02681": 1770,
  "02689": 1691,
  "02692": 1763,
  "02694": 1793,
  "02699": 1842,
  "01591": 1880,
  "01594": 1852,
  "01609": 1884,
  "01612": 1866,
  "01616": 1889,
  "01619": 1879,
  "01623": 1808,
  "01640": 1743,
  "01662": 1760,
  "01665": 1730,
  "01683": 1759,
  "01689": 1775,
  "01705": 1692,
  "01723": 1708,
  "01728": 1664,
  "01731": 1669,
  "01734": 1692,
  "01737": 1731,
  "01738": 1724,
  "01744": 1633,
  "01762": 1637,
  "01768": 1637,
  "01773": 1585,
  "01774": 1656,
  "01776": 1607,
  "01324": 1700,
  "01326": 1674,
  "01328": 1685,
  "01445": 1733,
  "01454": 1710,
  "01458": 1759,
  "01465": 1756,
  "01468": 1755,
  "01471": 1758,
  "01477": 1701,
  "01558": 1812,
  "01561": 1804,
  "01587": 1871,
  "01589": 1819,
  "01906": 1767,
  "01909": 1710,
  "01917": 1799,
  "01920": 1753,
  "01936": 1792,
  "03099": 2056,
  "03103": 1937,
  "03116": 1954,
  "03119": 1940,
  "03130": 1995,
  "03149": 2141,
  "03159": 1916,
  "03172": 2168,
  "03185": 2124,
  "03197": 2159,
  "02979": 1961,
  "02991": 1911,
  "02994": 1845,
  "02997": 1838,
  "02999": 1863,
  "03042": 2090,
  "03044": 2091,
  "03046": 2086,
  "03048": 2079,
  "03050": 2079,
  "03051": 2082,
  "03052": 2101,
  "03053": 2106,
  "03054": 2104,
  "03055": 2096,
  "03058": 2105,
  "03096": 2051,
  "02779": 1654,
  "02782": 1669,
  "02785": 1634,
  "02788": 1638,
  "02791": 1651,
  "02794": 1666,
  "02796": 1648,
  "02797": 1647,
  "02799": 1658,
  "02826": 1716,
  "02827": 1706,
  "02828": 1721,
  "02829": 1718,
  "02894": 1715,
  "02899": 1666,
  "04279": 1993,
  "04288": 1958,
  "04289": 1966,
  "04299": 1963,
  "04315": 1971,
  "04316": 1957,
  "04317": 1976,
  "04318": 1974,
  "04319": 1959,
  "04328": 1962,
  "04329": 1957,
  "04347": 1968,
  "04349": 1967,
  "04356": 1980,
  "04357": 1972,
  "04416": 1983,
  "04420": 2022,
  "04425": 1967,
  "04435": 2009,
  "04442": 2004,
  "04451": 1949,
  "04463": 1966,
  "04509": 2039,
  "04519": 1999,
  "04523": 2030,
  "04539": 1943,
  "04552": 1892,
  "04564": 1991,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04565": 1919,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04567": 1948,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04571": 1917,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04575": 1913,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04600": 1903,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04603": 1867,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04610": 1932,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04613": 1933,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04617": 1921,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04618": 1838,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04626": 2003,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04639": 1861,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04643": 1856,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04651": 1920,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04654": 1865,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04668": 1891,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "04680": 1885,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03246": 1961,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03249": 1983,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "03253": 1996,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04103": 1983,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04105": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04107": 2003,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04109": 2005,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04129": 1994,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04155": 1998,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04157": 1992,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04158": 1997,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04159": 2015,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04177": 2011,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04178": 2024,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04179": 2015,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04205": 2024,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04207": 2018,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04209": 2027,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04229": 2004,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04249": 2016,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04275": 2000,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "04277": 1993,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02906": 1791,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02923": 1759,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02929": 1795,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02943": 1850,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02953": 1882,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02956": 1821,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02957": 1866,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02959": 1900,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "02977": 1876,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03205": 1957,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03222": 2041,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03226": 2021,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03229": 1938,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "03238": 1944,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04683": 1927,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04687": 1901,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04703": 1856,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04720": 1802,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04736": 1838,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04741": 1799,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04746": 1847,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04749": 1824,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04758": 1879,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04769": 1852,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04774": 1894,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04779": 1888,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04808": 1926,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04821": 1930,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04824": 1933,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04827": 1943,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04895": 1970,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04910": 1891,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04916": 1993,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04924": 1942,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04828": 1932,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04838": 1983,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04849": 2013,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04860": 1975,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04861": 1942,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04862": 1988,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04874": 1933,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04880": 2006,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04886": 2001,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04889": 1937,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04932": 1858,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04934": 1885,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04936": 2082,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "04938": 1956,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06108": 2077,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06110": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06112": 2080,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06114": 2075,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06116": 2053,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06118": 2076,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "06120": 2087,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04928": 1869,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "04931": 1932,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06268": 2200,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06279": 2199,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06295": 2172,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06308": 2199,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06311": 2191,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06313": 2187,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06317": 2168,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06333": 2228,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06343": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06347": 2209,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06366": 2148,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06369": 2133,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06385": 2169,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06386": 2146,
  "06458": 2322,
  "06463": 2275,
  "06464": 2265,
  "06466": 2279,
  "06467": 2268,
  "06469": 2266,
  "06484": 2307,
  "06485": 2337,
  "06493": 2340,
  "06502": 2360,
  "06526": 2253,
  "06528": 2302,
  "06536": 2280,
  "06122": 2087,
  "06124": 2089,
  "06126": 2091,
  "06128": 2087,
  "06130": 2085,
  "06132": 2068,
  "06179": 2142,
  "06184": 2041,
  "06188": 2072,
  "06193": 2119,
  "06198": 2104,
  "06217": 2087,
  "06231": 2073,
  "06237": 2080,
  "06242": 2097,
  "06246": 2111,
  "06249": 2117,
  "06255": 2129,
  "06258": 2060,
  "06259": 2085,
  "06388": 2146,
  "06406": 2173,
  "06408": 2200,
  "06420": 2142,
  "06425": 2182,
  "06429": 2208,
  "06449": 2241,
  "06456": 2205,
  "06861": 2188,
  "06862": 2215,
  "06868": 2224,
  "06869": 2215,
  "06886": 2210,
  "06888": 2136,
  "06889": 2253,
  "06895": 2119,
  "06901": 2116,
  "06905": 2097,
  "06917": 2074,
  "06925": 2048,
  "07318": 2051,
  "07330": 2039,
  "07333": 2093,
  "07338": 2005,
  "07343": 1972,
  "07349": 1966,
  "07356": 1954,
  "07366": 1904,
  "07368": 1997,
  "06537": 2291,
  "06542": 2220,
  "06543": 2296,
  "06556": 2254,
  "06567": 2286,
  "06571": 2261,
  "06577": 2352,
  "06618": 2171,
  "06628": 2165,
  "06632": 2237,
  "06636": 2219,
  "06638": 2278,
  "06642": 2258,
  "06647": 2248,
  "06648": 2188,
  "06667": 2182,
  "06679": 2188,
  "06682": 2152,
  "06686": 2037,
  "06688": 2073,
  "06711": 2170,
  "06712": 2162,
  "06721": 2141,
  "06722": 2151,
  "06729": 1980,
  "06749": 2093,
  "06766": 2103,
  "06772": 2134,
  "06773": 2105,
  "06774": 2077,
  "06779": 2149,
  "06780": 2094,
  "06785": 2163,
  "06792": 2093,
  "06794": 2080,
  "06796": 2066,
  "06800": 2119,
  "06803": 2106,
  "06808": 2085,
  "06809": 2048,
  "06842": 2139,
  "06844": 2164,
  "06846": 2155,
  "06847": 2148,
  "06849": 2137,
  "07381": 2045,
  "07387": 2059,
  "07389": 2050,
  "07407": 2133,
  "07422": 2086,
  "07646": 2076,
  "07570": 2048,
  "07580": 2017,
  "07586": 2103,
  "07589": 2055,
  "07607": 2094,
  "07613": 2116,
  "07616": 2099,
  "07619": 2121,
  "07629": 2063,
  "07639": 2075,
  "07743": 2138,
  "07745": 2121,
  "07747": 2109,
  "07749": 2127,
  "07751": 2109,
  "07768": 2065,
  "07426": 2087,
  "07427": 2107,
  "07429": 2102,
  "07545": 2080,
  "07546": 2032,
  "07548": 2079,
  "07549": 2074,
  "07551": 2082,
  "07552": 2109,
  "07554": 2120,
  "07557": 2062,
  "07819": 2026,
  "07907": 1969,
  "07919": 1916,
  "07922": 1889,
  "07924": 1980,
  "07774": 2125,
  "07778": 2141,
  "07806": 2019,
  "08396": 1837,
  "08412": 2003,
  "08427": 1980,
  "08428": 2022,
  "08451": 2029,
  "08459": 2020,
  "08468": 1947,
  "08485": 1945,
  "08491": 1939,
  "08496": 1962,
  "08499": 1940,
  "08523": 1885,
  "08525": 1887,
  "08527": 1878,
  "08112": 1989,
  "08115": 1984,
  "08118": 1763,
  "08132": 2021,
  "08134": 1999,
  "08141": 2002,
  "08144": 1970,
  "08147": 1980,
  "08209": 1962,
  "08223": 1935,
  "08228": 1948,
  "08233": 1926,
  "08236": 1941,
  "08237": 1971,
  "08239": 1918,
  "08248": 1789,
  "08258": 1817,
  "08261": 1855,
  "08262": 1795,
  "08267": 1771,
  "08280": 1745,
  "08289": 1760,
  "08294": 1740,
  "08297": 1727,
  "08304": 1787,
  "08309": 1765,
  "08315": 1732,
  "08321": 1761,
  "08324": 1749,
  "08328": 1985,
  "08340": 1727,
  "08344": 1724,
  "08349": 1731,
  "08352": 1710,
  "08359": 1722,
  "08371": 1959,
  "08373": 1947,
  "08393": 1957,
  "07926": 1867,
  "07927": 1866,
  "07929": 1954,
  "07937": 1942,
  "07950": 2021,
  "07952": 1932,
  "07955": 2015,
  "07957": 1985,
  "07958": 2010,
  "07973": 1961,
  "07980": 2018,
  "07985": 1930,
  "07987": 2002,
  "08056": 1988,
  "08058": 2001,
  "08060": 1996,
  "08062": 1987,
  "08064": 1979,
  "08066": 1999,
  "08107": 1993,
  "08529": 1902,
  "08538": 1868,
  "08539": 1906,
  "08541": 1898,
  "08543": 1923,
  "08547": 1904,
  "08548": 1903,
  "08606": 1832,
  "08626": 1829,
  "08645": 1797,
  "08648": 1762,
  "09111": 1734,
  "09112": 1734,
  "09113": 1739,
  "09114": 1860,
  "09116": 1758,
  "09117": 1752,
  "09119": 1743,
  "09120": 1736,
  "09122": 1741,
  "09123": 1738,
  "09125": 1729,
  "09126": 1726,
  "09127": 1723,
  "09128": 1720,
  "09130": 1733,
  "09131": 1743,
  "09212": 1805,
  "09217": 1793,
  "09221": 1746,
  "09224": 1763,
  "09228": 1754,
  "09232": 1780,
  "09235": 1736,
  "09236": 1853,
  "09241": 1784,
  "09243": 1793,
  "09244": 1851,
  "09247": 1874,
  "09249": 1888,
  "09306": 1848,
  "09322": 1811,
  "09326": 1861,
  "09328": 1825,
  "09337": 1817,
  "09350": 1786,
  "09353": 1776,
  "09355": 1774,
  "09356": 1931,
  "09366": 1749,
  "09376": 1763,
  "09380": 1736,
  "09385": 1762,
  "09387": 1765,
  "09390": 1723,
  "09392": 1712,
  "09394": 1774,
  "09399": 1756,
  "09405": 1688,
  "09419": 1701,
  "09423": 1705,
  "09427": 1691,
  "09429": 1657,
  "09430": 1678,
  "09432": 1671,
  "09434": 1682,
  "09437": 1691,
  "09439": 1699,
  "09456": 1658,
  "09465": 1675,
  "09468": 1698,
  "09471": 1655,
  "09474": 1689,
  "09477": 1641,
  "09481": 1705,
  "09484": 1687,
  "09487": 1682,
  "09488": 1666,
  "09496": 1629,
  "09509": 1676,
  "09514": 1680,
  "09518": 1640,
  "09526": 1668,
  "09544": 1619,
  "09548": 1612,
  "09557": 1740,
  "09569": 1835,
  "09573": 1710,
  "09575": 1721,
  "09577": 1745,
  "09579": 1711,
  "09599": 1689,
  "09600": 1753,
  "09603": 1788,
  "09618": 1714,
  "09619": 1658,
  "09623": 1641,
  "09627": 1677,
  "09629": 1745,
  "09633": 1761,
  29640: 2936,
  29643: 2872,
  29646: 2903,
  29649: 2870,
  29664: 2820,
  29683: 2818,
  29690: 2764,
  29693: 2791,
  29699: 2820,
  30159: 2699,
  30161: 2690,
  30163: 2694,
  30165: 2694,
  29556: 2721,
  29559: 2692,
  29562: 2703,
  29565: 2797,
  29571: 2676,
  29574: 2786,
  29575: 2799,
  29576: 2772,
  29578: 2760,
  29579: 2758,
  29581: 2748,
  29582: 2787,
  29584: 2793,
  29585: 2788,
  29587: 2794,
  29588: 2765,
  29590: 2756,
  29591: 2788,
  29593: 2758,
  29594: 2679,
  29597: 2696,
  29599: 2778,
  29614: 2868,
  29633: 2895,
  31249: 2622,
  31275: 2623,
  31303: 2693,
  31311: 2631,
  31319: 2653,
  31515: 2747,
  31535: 2772,
  31542: 2769,
  31547: 2799,
  31552: 2784,
  31553: 2798,
  31555: 2769,
  31556: 2786,
  31558: 2767,
  31559: 2762,
  31582: 2809,
  31592: 2839,
  31595: 2878,
  31600: 2868,
  31603: 2906,
  31604: 2850,
  31606: 2894,
  30167: 2698,
  30169: 2696,
  30171: 2691,
  30173: 2687,
  30175: 2690,
  30177: 2683,
  30179: 2685,
  30419: 2712,
  30449: 2701,
  30451: 2725,
  30453: 2724,
  30455: 2709,
  30457: 2704,
  30459: 2698,
  30519: 2686,
  30521: 2689,
  30539: 2682,
  30559: 2668,
  30625: 2686,
  30627: 2675,
  30629: 2674,
  30655: 2672,
  30657: 2678,
  30659: 2666,
  30669: 2699,
  31608: 2826,
  31609: 2837,
  31613: 2852,
  31618: 2848,
  31619: 2840,
  31621: 2854,
  31622: 2831,
  31623: 2823,
  31626: 2837,
  31627: 2832,
  31628: 2823,
  31629: 2824,
  31632: 2794,
  31633: 2827,
  31634: 2820,
  31636: 2790,
  31637: 2796,
  31638: 2810,
  31655: 2800,
  31675: 2858,
  31683: 2850,
  31688: 2813,
  31691: 2824,
  31693: 2821,
  29465: 2627,
  29468: 2610,
  29471: 2682,
  29472: 2669,
  29473: 2694,
  29475: 2656,
  29476: 2645,
  29478: 2692,
  29479: 2637,
  29481: 2675,
  29482: 2627,
  29484: 2655,
  29485: 2601,
  29487: 2619,
  29488: 2594,
  29490: 2718,
  29491: 2623,
  29493: 2675,
  29494: 2633,
  29496: 2650,
  29497: 2610,
  29499: 2678,
  29525: 2743,
  29549: 2782,
  29553: 2799,
  29303: 2738,
  29308: 2796,
  29313: 2738,
  29320: 2754,
  29323: 2763,
  29328: 2745,
  29331: 2665,
  29336: 2720,
  29339: 2663,
  29342: 2661,
  29345: 2718,
  29348: 2691,
  29351: 2662,
  29352: 2711,
  29353: 2656,
  29355: 2667,
  29356: 2635,
  29358: 2648,
  29359: 2694,
  29361: 2682,
  29362: 2637,
  30823: 2715,
  30826: 2719,
  30827: 2717,
  30851: 2684,
  30853: 2691,
  30855: 2711,
  30880: 2698,
  30890: 2754,
  30900: 2720,
  30916: 2674,
  30926: 2740,
  30938: 2702,
  30952: 2716,
  30966: 2709,
  30974: 2743,
  30982: 2709,
  30989: 2730,
  31008: 2684,
  31020: 2711,
  31028: 2679,
  31036: 2645,
  31061: 2607,
  31073: 2622,
  31079: 2597,
  31084: 2591,
  31089: 2642,
  31134: 2632,
  31135: 2624,
  31137: 2637,
  31139: 2645,
  31141: 2627,
  31157: 2670,
  31162: 2585,
  31167: 2552,
  31171: 2658,
  31174: 2618,
  31177: 2639,
  31180: 2654,
  31185: 2598,
  31188: 2596,
  31191: 2655,
  31195: 2557,
  31199: 2605,
  31224: 2578,
  31226: 2605,
  31228: 2593,
  31234: 2578,
  31241: 2607,
  31246: 2580,
  29364: 2635,
  29365: 2669,
  29367: 2656,
  29369: 2626,
  29378: 2618,
  29379: 2607,
  29386: 2638,
  29389: 2665,
  29392: 2614,
  29393: 2632,
  29394: 2662,
  29396: 2608,
  29399: 2611,
  29410: 2560,
  29413: 2653,
  29416: 2562,
  29439: 2612,
  29451: 2653,
  29456: 2675,
  29459: 2632,
  29462: 2595,
  31698: 2786,
  31699: 2777,
  31700: 2784,
  31702: 2790,
  31707: 2838,
  31708: 2844,
  31710: 2831,
  31711: 2836,
  31712: 2816,
  31714: 2804,
  31715: 2809,
  31717: 2808,
  31718: 2816,
  31719: 2823,
  31737: 2868,
  31749: 2810,
  31785: 2765,
  31787: 2859,
  31789: 2755,
  31812: 2756,
  31832: 2706,
  31840: 2834,
  31848: 2805,
  33333: 2808,
  33334: 2803,
  33335: 2795,
  33378: 2837,
  33397: 2765,
  33415: 2759,
  33428: 2876,
  33442: 2856,
  33449: 2783,
  33602: 2810,
  33604: 2813,
  33605: 2805,
  33607: 2811,
  33609: 2821,
  33611: 2820,
  33613: 2820,
  33615: 2813,
  33617: 2811,
  33619: 2820,
  33647: 2803,
  33649: 2803,
  33659: 2783,
  33689: 2773,
  33699: 2807,
  32423: 2876,
  32425: 2902,
  32427: 2886,
  32429: 2892,
  32457: 2863,
  32469: 2852,
  32479: 2912,
  32545: 2882,
  32547: 2893,
  32549: 2897,
  32584: 2879,
  32602: 2866,
  32609: 2909,
  32657: 2778,
  32676: 2716,
  32683: 2760,
  32689: 2890,
  32694: 2766,
  32699: 2784,
  32756: 2742,
  32758: 2791,
  32760: 2727,
  32791: 2792,
  32805: 2718,
  32816: 2721,
  32825: 2733,
  32832: 2759,
  32839: 2705,
  33014: 2669,
  33034: 2649,
  33039: 2680,
  33098: 2691,
  33100: 2685,
  33102: 2707,
  33104: 2712,
  33106: 2692,
  33129: 2730,
  33142: 2689,
  33154: 2701,
  33161: 2746,
  33165: 2634,
  33175: 2706,
  33178: 2673,
  33181: 2643,
  33184: 2671,
  33189: 2751,
  33330: 2820,
  33332: 2814,
  31855: 2789,
  31860: 2727,
  31863: 2722,
  31867: 2784,
  31868: 2755,
  32049: 2854,
  32051: 2857,
  32052: 2843,
  32105: 2849,
  32107: 2828,
  32108: 2859,
  32120: 2866,
  32130: 2869,
  32139: 2874,
  32257: 2883,
  32278: 2888,
  32289: 2911,
  32312: 2917,
  32339: 2940,
  32351: 3025,
  32361: 2928,
  32369: 2940,
  34225: 2444,
  34233: 2471,
  34246: 2479,
  34253: 2449,
  34260: 2474,
  34266: 2455,
  34270: 2480,
  34277: 2433,
  34281: 2422,
  34286: 2424,
  34289: 2514,
  34292: 2495,
  34295: 2433,
  34298: 2479,
  34302: 2422,
  34305: 2439,
  34308: 2470,
  34311: 2469,
  34314: 2499,
  34317: 2501,
  34320: 2451,
  34323: 2381,
  34497: 2537,
  34508: 2600,
  34513: 2490,
  34516: 2525,
  34519: 2626,
  34537: 2463,
  34549: 2466,
  34560: 2429,
  34576: 2361,
  34582: 2409,
  34587: 2399,
  34590: 2398,
  34593: 2360,
  34596: 2441,
  34599: 2412,
  34613: 2383,
  34621: 2388,
  34626: 2335,
  34628: 2358,
  34630: 2412,
  34632: 2433,
  34633: 2299,
  33719: 2808,
  33729: 2835,
  33739: 2834,
  33758: 2749,
  33775: 2871,
  33790: 2833,
  33803: 2818,
  33813: 2775,
  33818: 2793,
  33824: 2859,
  33829: 2867,
  34117: 2466,
  34119: 2470,
  34121: 2469,
  34123: 2452,
  34125: 2467,
  34127: 2468,
  34128: 2477,
  34130: 2477,
  34131: 2489,
  34132: 2473,
  34134: 2458,
  34212: 2417,
  34637: 2350,
  34639: 2333,
  35037: 2454,
  35039: 2465,
  35041: 2466,
  35043: 2462,
  35066: 2568,
  35075: 2474,
  35080: 2496,
  35083: 2495,
  35085: 2454,
  35088: 2543,
  35091: 2471,
  35094: 2476,
  35096: 2434,
  35099: 2546,
  35102: 2451,
  35104: 2595,
  35108: 2555,
  35110: 2507,
  35112: 2424,
  35114: 2450,
  35116: 2557,
  35117: 2514,
  34326: 2412,
  34327: 2430,
  34329: 2469,
  34346: 2537,
  34355: 2488,
  34359: 2531,
  34369: 2533,
  34376: 2508,
  34379: 2507,
  34385: 2592,
  34388: 2560,
  34393: 2512,
  34396: 2547,
  34399: 2603,
  34414: 2570,
  34431: 2621,
  34434: 2628,
  34439: 2606,
  34454: 2580,
  34466: 2528,
  34471: 2559,
  34474: 2587,
  34477: 2578,
  34479: 2537,
  35415: 2343,
  35418: 2385,
  35423: 2334,
  35428: 2382,
  35435: 2398,
  35440: 2367,
  35444: 2411,
  35447: 2383,
  35452: 2387,
  35457: 2402,
  35460: 2405,
  35463: 2360,
  35466: 2415,
  35469: 2409,
  35510: 2339,
  35516: 2328,
  35519: 2322,
  35576: 2396,
  35578: 2387,
  35579: 2400,
  35580: 2397,
  35581: 2377,
  35582: 2380,
  35583: 2389,
  35584: 2397,
  36214: 2419,
  36217: 2374,
  36219: 2348,
  36251: 2285,
  36266: 2375,
  36269: 2251,
  36272: 2256,
  36275: 2277,
  36277: 2264,
  36280: 2307,
  36282: 2263,
  36284: 2292,
  36286: 2313,
  36287: 2264,
  36289: 2343,
  36304: 2321,
  36318: 2267,
  36320: 2368,
  36323: 2279,
  36325: 2369,
  36326: 2351,
  36119: 2169,
  36124: 2138,
  36129: 2131,
  36132: 2250,
  36137: 2200,
  36142: 2200,
  36145: 2196,
  36148: 2180,
  36151: 2219,
  36154: 2209,
  36157: 2146,
  36160: 2186,
  36163: 2161,
  36166: 2242,
  36167: 2214,
  36169: 2260,
  36179: 2316,
  36199: 2341,
  36205: 2428,
  36208: 2413,
  36211: 2363,
  35119: 2518,
  35216: 2528,
  35232: 2500,
  35236: 2541,
  35239: 2521,
  35260: 2400,
  35274: 2502,
  35279: 2377,
  35282: 2503,
  35285: 2532,
  35287: 2474,
  35288: 2519,
  35305: 2408,
  35315: 2440,
  35321: 2359,
  35325: 2385,
  35327: 2283,
  35329: 2383,
  35390: 2384,
  35392: 2376,
  35394: 2369,
  35396: 2391,
  35398: 2368,
  35410: 2326,
  35719: 2505,
  35745: 2452,
  35753: 2459,
  35756: 2471,
  35759: 2477,
  35764: 2445,
  35767: 2472,
  35768: 2486,
  35781: 2466,
  35789: 2363,
  35792: 2447,
  35794: 2469,
  35796: 2384,
  35799: 2451,
  36037: 2177,
  36039: 2189,
  36041: 2179,
  36043: 2172,
  36088: 2207,
  36093: 2180,
  36100: 2183,
  36103: 2185,
  36110: 2231,
  36115: 2159,
  35585: 2413,
  35586: 2399,
  35606: 2412,
  35614: 2428,
  35619: 2382,
  35625: 2367,
  35630: 2430,
  35633: 2390,
  35638: 2439,
  35641: 2399,
  35644: 2426,
  35647: 2357,
  35649: 2463,
  35683: 2478,
  35684: 2488,
  35685: 2484,
  35686: 2473,
  35687: 2461,
  35688: 2470,
  35689: 2474,
  35690: 2493,
  35708: 2500,
  35713: 2505,
  35716: 2521,
  37136: 2511,
  37139: 2579,
  37154: 2630,
  37170: 2670,
  37176: 2597,
  37181: 2614,
  37186: 2644,
  37191: 2514,
  37194: 2599,
  37197: 2474,
  37199: 2487,
  37213: 2535,
  37214: 2520,
  37215: 2553,
  37216: 2550,
  37217: 2537,
  37218: 2519,
  37235: 2448,
  37242: 2498,
  37247: 2468,
  37249: 2563,
  37269: 2435,
  36457: 2224,
  36460: 2237,
  36466: 2207,
  36469: 2218,
  37073: 2570,
  37075: 2593,
  37077: 2588,
  37079: 2570,
  37081: 2563,
  37083: 2573,
  37085: 2581,
  37115: 2498,
  37120: 2583,
  37124: 2565,
  37127: 2534,
  37130: 2520,
  37133: 2555,
  36329: 2336,
  36341: 2247,
  36355: 2248,
  36358: 2261,
  36364: 2220,
  36367: 2230,
  36369: 2259,
  36381: 2156,
  36391: 2141,
  36396: 2233,
  36399: 2224,
  36404: 2244,
  36414: 2304,
  36419: 2242,
  36433: 2202,
  36448: 2192,
  36452: 2178,
  36456: 2179,
  37276: 2447,
  37281: 2425,
  37284: 2462,
  37287: 2445,
  37290: 2472,
  37293: 2368,
  37296: 2423,
  37297: 2487,
  37299: 2400,
  37308: 2498,
  37318: 2505,
  37327: 2449,
  37339: 2461,
  37345: 2425,
  37351: 2477,
  37355: 2448,
  37359: 2454,
  37412: 2453,
  37431: 2427,
  37434: 2480,
  37441: 2407,
  37444: 2503,
  37445: 2398,
  37520: 2486,
  37539: 2516,
  37574: 2677,
  37581: 2570,
  37586: 2707,
  37589: 2587,
  37603: 2668,
  37619: 2708,
  37620: 2690,
  37627: 2733,
  37632: 2664,
  38108: 2523,
  38110: 2532,
  38112: 2535,
  38114: 2539,
  38116: 2555,
  38118: 2540,
  38120: 2542,
  38122: 2521,
  38124: 2521,
  38126: 2528,
  38154: 2485,
  38159: 2566,
  38162: 2500,
  38165: 2516,
  38170: 2483,
  38173: 2533,
  37633: 2682,
  37635: 2673,
  37639: 2674,
  37640: 2693,
  37642: 2683,
  37643: 2685,
  37647: 2687,
  37649: 2684,
  37671: 2644,
  37688: 2604,
  37691: 2627,
  37696: 2682,
  37697: 2590,
  37699: 2617,
  38100: 2534,
  38102: 2531,
  38104: 2530,
  38106: 2533,
  38312: 2479,
  38315: 2453,
  38319: 2478,
  38321: 2518,
  38322: 2468,
  38324: 2495,
  38325: 2462,
  38327: 2470,
  38329: 2487,
  38350: 2428,
  38364: 2451,
  38368: 2447,
  38372: 2439,
  38373: 2444,
  38375: 2454,
  38176: 2558,
  38179: 2540,
  38226: 2548,
  38228: 2561,
  38229: 2506,
  38239: 2526,
  38259: 2503,
  38268: 2560,
  38271: 2535,
  38272: 2583,
  38274: 2535,
  38275: 2517,
  38277: 2532,
  38279: 2535,
  38300: 2506,
  38302: 2515,
  38304: 2504,
  38557: 2545,
  38559: 2601,
  38640: 2465,
  38642: 2459,
  38644: 2475,
  38667: 2448,
  38678: 2520,
  38685: 2496,
  38690: 2436,
  38700: 2429,
  38704: 2488,
  38707: 2484,
  38709: 2534,
  38723: 2530,
  38729: 2512,
  38820: 2339,
  38822: 2351,
  38376: 2455,
  38378: 2444,
  38379: 2438,
  38381: 2424,
  38382: 2436,
  38384: 2470,
  38387: 2469,
  38440: 2525,
  38442: 2531,
  38444: 2508,
  38446: 2493,
  38448: 2552,
  38458: 2483,
  38459: 2469,
  38461: 2496,
  38462: 2496,
  38464: 2470,
  38465: 2598,
  38467: 2570,
  38468: 2574,
  38470: 2580,
  38471: 2518,
  38473: 2558,
  38474: 2583,
  38476: 2552,
  38477: 2545,
  38479: 2535,
  38486: 2511,
  38489: 2553,
  38518: 2589,
  38524: 2578,
  38527: 2545,
  38528: 2562,
  38530: 2562,
  38531: 2555,
  38533: 2553,
  38536: 2600,
  38539: 2615,
  38542: 2589,
  38543: 2575,
  38547: 2546,
  38550: 2554,
  38551: 2563,
  38553: 2553,
  38554: 2536,
  38556: 2553,
  38828: 2317,
  38829: 2327,
  38835: 2431,
  38836: 2408,
  38877: 2418,
  38879: 2417,
  38889: 2344,
  38895: 2363,
  38899: 2385,
  39104: 2307,
  39106: 2314,
  39108: 2308,
  39110: 2311,
  39112: 2301,
  39114: 2303,
  39116: 2291,
  39118: 2296,
  39120: 2283,
  39122: 2284,
  39124: 2317,
  39126: 2352,
  38838: 2396,
  38855: 2375,
  38871: 2409,
  38875: 2399,
  39221: 2267,
  39240: 2254,
  39245: 2311,
  39249: 2266,
  39261: 2212,
  39264: 2238,
  39279: 2302,
  39288: 2402,
  39291: 2287,
  39128: 2337,
  39130: 2318,
  39164: 2342,
  39167: 2313,
  39171: 2302,
  39175: 2343,
  39179: 2337,
  39217: 2309,
  39218: 2279,
  39343: 2379,
  39345: 2387,
  39317: 2449,
  39319: 2504,
  39326: 2363,
  39340: 2369,
  39356: 2439,
  39359: 2452,
  39307: 2493,
  12309: 2212,
  12347: 2221,
  12349: 2221,
  12351: 2213,
  12353: 2212,
  12355: 2195,
  12357: 2204,
  12359: 2216,
  12435: 2225,
  12437: 2215,
  12439: 2213,
  12459: 2216,
  12487: 2205,
  12489: 2203,
  12524: 2197,
  12526: 2188,
  12527: 2202,
  12529: 2189,
  12555: 2224,
  12557: 2214,
  12559: 2227,
  12587: 2223,
  12589: 2272,
  12619: 2238,
  12621: 2232,
  10405: 2246,
  10407: 2244,
  10409: 2246,
  10435: 2249,
  10437: 2250,
  10439: 2370,
  10551: 2281,
  10553: 2275,
  10555: 2257,
  10557: 2255,
  10559: 2282,
  10585: 2268,
  10587: 2270,
  10589: 2272,
  10623: 2254,
  10625: 2257,
  10627: 2257,
  10629: 2259,
  10707: 2253,
  10709: 2259,
  10711: 2256,
  10713: 2251,
  10715: 2249,
  10717: 2249,
  10719: 2256,
  12057: 2219,
  12059: 2224,
  12099: 2227,
  12101: 2231,
  12103: 2238,
  12105: 2230,
  12107: 2225,
  12109: 2231,
  12157: 2244,
  12159: 2244,
  12161: 2248,
  12163: 2248,
  12165: 2252,
  12167: 2267,
  12169: 2240,
  12203: 2267,
  12205: 2264,
  12207: 2257,
  12209: 2257,
  12247: 2263,
  12249: 2259,
  12277: 2222,
  12279: 2256,
  12305: 2217,
  12307: 2215,
  12623: 2235,
  12627: 2296,
  12629: 2301,
  12679: 2305,
  12681: 2247,
  12683: 2225,
  12685: 2238,
  12687: 2306,
  12689: 2316,
  13051: 2333,
  13053: 2244,
  13055: 2242,
  13057: 2320,
  13059: 2332,
  13086: 2251,
  13088: 2250,
  13089: 2364,
  13125: 2338,
  13127: 2348,
  13129: 2341,
  13156: 2367,
  13158: 2360,
  13159: 2358,
  13187: 2363,
  13189: 2366,
  14467: 2278,
  14469: 2294,
  14471: 2291,
  14473: 2289,
  14476: 2312,
  14478: 2276,
  14480: 2263,
  14482: 2269,
  14513: 2247,
  14532: 2251,
  14542: 2320,
  14547: 2321,
  14548: 2287,
  14550: 2344,
  14552: 2277,
  14554: 2274,
  14558: 2259,
  14612: 2348,
  14621: 2311,
  14624: 2417,
  14641: 2434,
  13347: 2287,
  13349: 2284,
  13351: 2280,
  13353: 2281,
  13355: 2251,
  13357: 2262,
  13359: 2289,
  13403: 2283,
  13405: 2277,
  13407: 2287,
  13409: 2290,
  13435: 2293,
  13437: 2290,
  13439: 2294,
  13465: 2305,
  13467: 2299,
  13469: 2301,
  13503: 2302,
  13505: 2300,
  13507: 2290,
  13509: 2289,
  13581: 2284,
  13583: 2291,
  13585: 2287,
  13587: 2295,
  10777: 2248,
  10779: 2246,
  10781: 2248,
  10783: 2248,
  10785: 2248,
  10787: 2252,
  10789: 2252,
  10823: 2244,
  10825: 2244,
  10827: 2242,
  10829: 2242,
  10961: 2235,
  10963: 2243,
  10965: 2240,
  10967: 2231,
  10969: 2237,
  10997: 2233,
  10999: 2232,
  12043: 2225,
  12045: 2227,
  12047: 2229,
  12049: 2224,
  12051: 2220,
  12053: 2223,
  12055: 2224,
  "09634": 1759,
  "09638": 1665,
  "09648": 1833,
  "09661": 1816,
  "09669": 1834,
  10115: 2257,
  10117: 2247,
  10119: 2246,
  10178: 2244,
  10179: 2237,
  10243: 2237,
  10245: 2230,
  10247: 2236,
  10249: 2240,
  10315: 2234,
  10317: 2228,
  10318: 2223,
  10319: 2227,
  10365: 2237,
  10367: 2236,
  10369: 2241,
  13589: 2298,
  13591: 2342,
  13593: 2332,
  13595: 2332,
  13597: 2278,
  13599: 2282,
  13627: 2274,
  13629: 2274,
  14050: 2265,
  14052: 2316,
  14053: 2277,
  14055: 2320,
  14057: 2310,
  14059: 2264,
  14089: 2328,
  14109: 2288,
  14129: 2280,
  14163: 2289,
  14165: 2259,
  14167: 2263,
  14169: 2268,
  14193: 2294,
  14195: 2271,
  14197: 2250,
  14199: 2255,
  14656: 2414,
  14662: 2496,
  14669: 2351,
  14712: 2473,
  14715: 2457,
  14727: 2446,
  14728: 2530,
  14770: 2389,
  14772: 2394,
  14774: 2414,
  14776: 2385,
  14778: 2409,
  14822: 2307,
  14823: 2258,
  14827: 2279,
  14828: 2302,
  14913: 2138,
  14929: 2308,
  14943: 2186,
  14947: 2165,
  14959: 2261,
  14974: 2228,
  15377: 2333,
  15378: 2261,
  15517: 2278,
  15518: 2303,
  15526: 2200,
  15528: 2242,
  15537: 2243,
  15562: 2266,
  15566: 2266,
  15569: 2261,
  15711: 2160,
  15712: 2200,
  15713: 2210,
  15732: 2183,
  15868: 2130,
  15890: 2219,
  15898: 2263,
  15907: 2038,
  15910: 2056,
  15913: 2084,
  15926: 2000,
  15326: 2258,
  15328: 2298,
  15344: 2294,
  15345: 2319,
  15366: 2281,
  15370: 2277,
  15374: 2314,
  15738: 2185,
  15741: 2150,
  15745: 2178,
  15746: 2117,
  15748: 2135,
  15749: 2151,
  15754: 2213,
  15755: 2105,
  15757: 2108,
  15806: 2182,
  15827: 2196,
  15831: 2211,
  15834: 2191,
  15837: 2137,
  15838: 2156,
  15848: 2135,
  15859: 2206,
  15864: 2183,
  15936: 2063,
  15938: 2072,
  16225: 2421,
  16227: 2410,
  16230: 2450,
  16244: 2397,
  16247: 2452,
  16248: 2503,
  14979: 2241,
  15230: 2231,
  15232: 2228,
  15234: 2229,
  15236: 2212,
  15295: 2233,
  15299: 2196,
  15306: 2367,
  15320: 2372,
  15324: 2413,
  16259: 2427,
  16269: 2363,
  16278: 2493,
  16303: 2546,
  16306: 2603,
  16307: 2636,
  16321: 2337,
  16341: 2331,
  16348: 2386,
  16356: 2317,
  14789: 2446,
  14793: 2338,
  14797: 2338,
  14798: 2424,
  14806: 2303,
  16359: 2382,
  16515: 2384,
  16540: 2390,
  16547: 2372,
  16548: 2381,
  16552: 2372,
  16556: 2380,
  16559: 2420,
  16562: 2389,
  16567: 2366,
  16727: 2423,
  16761: 2313,
  16766: 2473,
  16767: 2409,
  16775: 2515,
  16792: 2467,
  16798: 2552,
  16816: 2520,
  16818: 2515,
  16827: 2557,
  16831: 2559,
  16833: 2496,
  16845: 2576,
  16835: 2515,
  16837: 2610,
  17039: 2790,
  17087: 2791,
  17089: 2821,
  17091: 2820,
  17111: 2862,
  17121: 2937,
  17126: 2846,
  17129: 2858,
  17139: 2863,
  17153: 2836,
  17154: 2897,
  17159: 2910,
  17166: 2844,
  17168: 2902,
  17094: 2770,
  17098: 2722,
  17099: 2738,
  17109: 2877,
  16866: 2650,
  16868: 2579,
  16909: 2611,
  16928: 2665,
  16945: 2687,
  16949: 2703,
  17033: 2764,
  17034: 2762,
  17036: 2746,
  17179: 3005,
  17192: 2772,
  17194: 2800,
  17207: 2703,
  17235: 2607,
  17237: 2636,
  17248: 2740,
  17252: 2757,
  17255: 2610,
  17258: 2628,
  17268: 2577,
  17309: 2627,
  17321: 2666,
  17322: 2669,
  17326: 2612,
  17328: 2585,
  17329: 2617,
  17335: 2661,
  17337: 2649,
  17348: 2646,
  17349: 2695,
  17209: 2712,
  17213: 2722,
  17214: 2744,
  17217: 2675,
  17219: 2695,
  17390: 2793,
  17391: 2831,
  17392: 2761,
  17398: 2731,
  17406: 2825,
  17506: 2865,
  17509: 2940,
  18055: 2929,
  18057: 2950,
  18059: 2929,
  18069: 2971,
  18106: 2962,
  18107: 2963,
  18109: 2962,
  18119: 2970,
  18146: 2937,
  18147: 2951,
  17358: 2681,
  17367: 2715,
  17373: 2724,
  17375: 2741,
  17379: 2682,
  17389: 2753,
  17419: 2765,
  17424: 2778,
  17429: 2862,
  17438: 2933,
  17440: 2814,
  17449: 2966,
  17279: 2589,
  17291: 2572,
  17454: 2962,
  17459: 2882,
  17489: 2890,
  17491: 2898,
  17493: 2904,
  17495: 2885,
  17498: 2913,
  18181: 2990,
  18182: 2954,
  18184: 2927,
  18190: 2963,
  18195: 2959,
  18196: 2901,
  18198: 2946,
  18209: 2984,
  18211: 2979,
  18225: 3038,
  18230: 3038,
  18246: 2910,
  18249: 2893,
  18258: 2905,
  18299: 2907,
  18311: 2990,
  18314: 3041,
  18317: 3028,
  18320: 3060,
  18334: 3007,
  18337: 2997,
  18347: 2998,
  18356: 3070,
  18374: 3144,
  18375: 3073,
  18551: 3116,
  18556: 3174,
  18569: 3098,
  18573: 3041,
  18574: 3033,
  18581: 3094,
  18586: 3143,
  18273: 2857,
  18276: 2820,
  18279: 2833,
  18292: 2790,
  18233: 3033,
  18236: 3007,
  18239: 2980,
  18609: 3117,
  19053: 2893,
  19055: 2918,
  19057: 2909,
  19059: 2895,
  19061: 2887,
  19063: 2875,
  19065: 2880,
  19067: 2911,
  19069: 2926,
  19071: 2921,
  18469: 3018,
  18507: 2933,
  18510: 2983,
  18513: 2954,
  18516: 2908,
  18519: 2970,
  18528: 3069,
  18546: 3140,
  18435: 3006,
  18437: 2994,
  18439: 2993,
  18442: 3015,
  18445: 3021,
  18461: 2982,
  18465: 2992,
  19073: 2897,
  19075: 2883,
  19077: 2828,
  19079: 2850,
  19086: 2858,
  19089: 2830,
  19205: 2960,
  19209: 2948,
  19217: 2998,
  39359: 2452,
  39365: 2390,
  39387: 2353,
  39393: 2402,
  39397: 2324,
  39418: 2225,
  39435: 2288,
  39638: 2455,
  39646: 2492,
  39649: 2503,
  40210: 2831,
  40211: 2834,
  40212: 2832,
  40213: 2833,
  40215: 2829,
  40217: 2830,
  40219: 2836,
  40221: 2836,
  40223: 2829,
  40225: 2826,
  40227: 2830,
  40229: 2813,
  40231: 2821,
  40233: 2823,
  40235: 2824,
  40237: 2829,
  40239: 2861,
  40468: 2860,
  40470: 2862,
  40472: 2834,
  40474: 2866,
  44137: 2828,
  44139: 2819,
  44141: 2825,
  44143: 2830,
  44145: 2835,
  44147: 2852,
  44149: 2841,
  44225: 2819,
  44227: 2836,
  44229: 2818,
  44263: 2827,
  44265: 2812,
  44267: 2810,
  44269: 2815,
  44287: 2814,
  44289: 2817,
  44309: 2833,
  44319: 2877,
  44328: 2836,
  44329: 2857,
  44339: 2848,
  44357: 2859,
  44359: 2860,
  44369: 2852,
  44379: 2845,
  40789: 2792,
  40822: 2829,
  40878: 2840,
  40880: 2856,
  40882: 2838,
  40883: 2862,
  40885: 2857,
  41061: 2916,
  41063: 2920,
  41065: 2881,
  41066: 2941,
  41068: 2920,
  41069: 2912,
  41169: 2933,
  41179: 2917,
  41189: 2895,
  41199: 2889,
  41236: 2911,
  41238: 2873,
  41239: 2905,
  41334: 2975,
  41352: 2866,
  41363: 2890,
  41366: 2950,
  41372: 2970,
  39596: 2549,
  39606: 2568,
  39615: 2598,
  39619: 2598,
  39624: 2514,
  39628: 2511,
  39629: 2525,
  40476: 2868,
  40477: 2837,
  40479: 2835,
  40489: 2869,
  40545: 2837,
  40547: 2842,
  40549: 2843,
  40589: 2830,
  40591: 2820,
  40593: 2807,
  40595: 2793,
  40597: 2818,
  40599: 2815,
  40625: 2835,
  40627: 2805,
  40629: 2825,
  40667: 2852,
  40668: 2893,
  40670: 2866,
  40699: 2805,
  40721: 2809,
  40723: 2787,
  40724: 2805,
  40764: 2775,
  39439: 2194,
  39443: 2228,
  39444: 2226,
  39446: 2254,
  39448: 2281,
  39517: 2445,
  39524: 2526,
  39539: 2638,
  39576: 2467,
  39579: 2492,
  39590: 2499,
  41379: 2978,
  41460: 2836,
  41462: 2850,
  41464: 2836,
  41466: 2842,
  41468: 2838,
  41469: 2825,
  41470: 2812,
  41472: 2842,
  41515: 2832,
  41516: 2840,
  41517: 2856,
  41539: 2791,
  41540: 2788,
  41541: 2811,
  41542: 2804,
  41564: 2859,
  41569: 2815,
  41747: 2939,
  41748: 2939,
  41749: 2949,
  41751: 2940,
  41812: 2891,
  41836: 2945,
  41844: 2946,
  41849: 2960,
  42103: 2839,
  42105: 2842,
  42107: 2848,
  42109: 2848,
  42111: 2853,
  42113: 2841,
  42115: 2835,
  42117: 2834,
  42119: 2843,
  42275: 2856,
  42277: 2861,
  42279: 2858,
  42281: 2858,
  42283: 2853,
  42285: 2856,
  42287: 2852,
  42289: 2845,
  42327: 2840,
  42329: 2822,
  42349: 2847,
  42369: 2837,
  42389: 2853,
  42399: 2835,
  42477: 2746,
  42489: 2857,
  42499: 2742,
  42549: 2880,
  42551: 2867,
  42553: 2860,
  42555: 2869,
  42579: 2852,
  42651: 2803,
  42653: 2824,
  42655: 2797,
  42657: 2796,
  42659: 2811,
  42697: 2788,
  42699: 2784,
  42719: 2818,
  42781: 2810,
  42799: 2780,
  42853: 2824,
  42855: 2823,
  42857: 2818,
  42859: 2808,
  42897: 2823,
  42899: 2823,
  42929: 2796,
  44135: 2824,
  45219: 2886,
  45239: 2880,
  45257: 2881,
  45259: 2892,
  45276: 2903,
  45277: 2896,
  45279: 2911,
  45289: 2895,
  45307: 2911,
  45309: 2910,
  45326: 2902,
  45327: 2950,
  45329: 2937,
  45355: 2914,
  45356: 2929,
  45357: 2922,
  45359: 2909,
  45468: 2874,
  45470: 2882,
  45472: 2887,
  45473: 2902,
  45475: 2900,
  45476: 2889,
  45478: 2878,
  45479: 2867,
  44388: 2848,
  44532: 2861,
  44534: 2867,
  44536: 2853,
  44575: 2867,
  44577: 2849,
  44579: 2872,
  44581: 2877,
  44623: 2947,
  44625: 2938,
  44627: 2879,
  44628: 2877,
  44629: 2886,
  44649: 2955,
  44651: 2950,
  44652: 2944,
  44653: 2950,
  44787: 2863,
  44789: 2859,
  44791: 2923,
  44793: 2871,
  44795: 2863,
  44797: 2909,
  44799: 2856,
  44801: 2911,
  44803: 2915,
  44805: 2927,
  44807: 2928,
  44809: 2879,
  44866: 2884,
  44867: 2885,
  44869: 2881,
  44879: 2912,
  44892: 2842,
  44894: 2919,
  45127: 2892,
  45128: 2889,
  45130: 2888,
  45131: 2885,
  45133: 2884,
  45134: 2889,
  45136: 2892,
  45138: 2895,
  45139: 2899,
  45141: 2905,
  45143: 2897,
  45144: 2891,
  45145: 2889,
  45147: 2888,
  45149: 2878,
  45481: 2860,
  45525: 2898,
  45527: 2892,
  45529: 2901,
  45549: 2872,
  45657: 2966,
  45659: 2975,
  45661: 2975,
  45663: 2893,
  45665: 2894,
  45699: 2962,
  45701: 2982,
  45711: 2891,
  45721: 3019,
  45731: 2880,
  45739: 2894,
  45768: 2986,
  45770: 2994,
  45772: 3007,
  45879: 2956,
  45881: 2951,
  45883: 2949,
  45884: 2895,
  45886: 2889,
  45888: 2970,
  45889: 2965,
  45891: 2965,
  45892: 2972,
  45894: 2962,
  45896: 2970,
  45897: 2968,
  45899: 2953,
  45964: 2953,
  45966: 2951,
  45968: 2947,
  46045: 2896,
  46047: 2902,
  46049: 2900,
  46117: 2913,
  46119: 2917,
  46145: 2918,
  46147: 2916,
  46149: 2908,
  46236: 2936,
  46238: 2927,
  46240: 2938,
  46242: 2923,
  46244: 2947,
  46282: 2968,
  46284: 2977,
  46286: 3011,
  46325: 3047,
  46342: 3062,
  46348: 3011,
  46354: 3086,
  46359: 3031,
  46395: 3033,
  46397: 3040,
  46399: 3032,
  46414: 3052,
  46419: 3044,
  46446: 3084,
  46459: 3056,
  46483: 2985,
  46485: 2979,
  46487: 3001,
  46499: 3006,
  46509: 3014,
  46514: 2996,
  46519: 2988,
  46535: 2924,
  46537: 2945,
  46539: 2943,
  46562: 2947,
  46569: 2961,
  47051: 2879,
  47053: 2881,
  47055: 2879,
  47057: 2877,
  47058: 2880,
  47059: 2896,
  47119: 2899,
  47137: 2893,
  47138: 2891,
  47139: 2914,
  47166: 2905,
  47167: 2913,
  47169: 2909,
  47178: 2927,
  47179: 2914,
  47198: 2910,
  47199: 2928,
  47226: 2889,
  47228: 2908,
  47229: 2911,
  47239: 2905,
  47249: 2879,
  47259: 2875,
  47269: 2866,
  47279: 2878,
  47441: 2920,
  47443: 2916,
  47445: 2936,
  47447: 2926,
  47475: 2960,
  47495: 2949,
  47506: 2939,
  47509: 2952,
  47533: 3101,
  47546: 3082,
  47551: 3067,
  47559: 3107,
  47574: 3066,
  47589: 3033,
  47608: 3001,
  47623: 3047,
  47624: 3026,
  47625: 3017,
  47626: 3037,
  47627: 3026,
  47638: 3003,
  47647: 2972,
  47652: 3055,
  47661: 2992,
  47665: 3016,
  47669: 2993,
  47798: 2918,
  47799: 2906,
  47800: 2900,
  47802: 2908,
  47803: 2914,
  47804: 2927,
  47805: 2915,
  47807: 2910,
  47809: 2898,
  47829: 2898,
  47839: 2959,
  47877: 2923,
  47906: 2973,
  47918: 2943,
  47929: 2980,
  48143: 3005,
  48145: 3014,
  48147: 3025,
  48149: 3023,
  48151: 2998,
  48153: 3000,
  48155: 3014,
  48157: 3064,
  48159: 3022,
  48161: 3012,
  48163: 2977,
  48165: 2985,
  48167: 2976,
  48231: 2910,
  48249: 3059,
  48268: 3043,
  48282: 3049,
  48291: 2949,
  48301: 3025,
  48308: 2995,
  48317: 2962,
  48324: 2949,
  48329: 3042,
  48336: 2900,
  48341: 3036,
  48346: 2946,
  48351: 2965,
  48356: 3056,
  48361: 2881,
  48366: 3058,
  48369: 3024,
  48429: 3045,
  48431: 3073,
  48432: 3091,
  49176: 2892,
  49179: 2973,
  49186: 2905,
  49191: 2946,
  49196: 2894,
  49201: 2867,
  49205: 2949,
  49214: 2877,
  49219: 2912,
  49324: 2891,
  49326: 2888,
  49328: 2887,
  49356: 3060,
  49377: 3132,
  49393: 3108,
  49401: 3041,
  49406: 2959,
  49413: 3091,
  49419: 2959,
  49424: 3094,
  49429: 3094,
  49434: 3045,
  49439: 3088,
  48455: 3132,
  48465: 3097,
  48477: 3024,
  48480: 3074,
  48485: 3088,
  48488: 3096,
  48493: 3109,
  48496: 3041,
  48499: 3082,
  48527: 3151,
  48529: 3143,
  48531: 3148,
  48565: 3088,
  48599: 3162,
  48607: 3158,
  48612: 3082,
  48619: 3121,
  48624: 3084,
  48629: 3172,
  48653: 3073,
  48683: 3111,
  48691: 3124,
  48703: 3094,
  48712: 3067,
  48720: 3104,
  48727: 3063,
  48734: 3047,
  48739: 3102,
  49074: 2935,
  49076: 2953,
  49078: 2941,
  49080: 2936,
  49082: 2926,
  49084: 2928,
  49086: 2927,
  49088: 2953,
  49090: 2959,
  49124: 2910,
  49134: 2965,
  49143: 2932,
  49152: 3000,
  49163: 2996,
  49170: 2942,
  49448: 3019,
  49451: 3071,
  49453: 2966,
  49456: 3115,
  49457: 2993,
  49459: 3036,
  49477: 2999,
  49479: 2998,
  49492: 2980,
  49497: 2996,
  49504: 2971,
  49509: 3021,
  49525: 2951,
  49536: 2919,
  49545: 2981,
  49549: 3011,
  49565: 3007,
  49577: 3059,
  49584: 3084,
  49586: 3050,
  49593: 3055,
  49594: 3037,
  49596: 3065,
  49597: 3036,
  49599: 3040,
  49610: 3099,
  49624: 3124,
  49626: 3108,
  49632: 3114,
  49635: 3083,
  49744: 3179,
  49751: 3212,
  49757: 3170,
  49762: 3294,
  49767: 3219,
  49770: 3149,
  49774: 3171,
  49777: 3200,
  49779: 3275,
  49808: 3179,
  49809: 3125,
  49811: 3134,
  49824: 3249,
  49847: 3213,
  49849: 3213,
  50126: 2818,
  50127: 2811,
  50129: 2797,
  50169: 2790,
  50170: 2816,
  50171: 2808,
  50181: 2852,
  50189: 2819,
  50226: 2768,
  50259: 2786,
  50321: 2747,
  50354: 2773,
  50374: 2803,
  50389: 2710,
  50667: 2730,
  50668: 2732,
  50670: 2734,
  50672: 2742,
  50674: 2732,
  50676: 2728,
  50677: 2732,
  50678: 2729,
  50679: 2723,
  49637: 3102,
  49638: 3081,
  49661: 3155,
  49681: 3157,
  49685: 3110,
  49688: 3144,
  49692: 3136,
  49696: 3182,
  49699: 3211,
  49716: 3232,
  49733: 3251,
  49740: 3147,
  49828: 3187,
  49832: 3107,
  49835: 3144,
  49838: 3143,
  49843: 3198,
  49844: 3153,
  49846: 3226,
  50733: 2734,
  50735: 2741,
  50737: 2743,
  50739: 2746,
  50765: 2772,
  50767: 2759,
  50769: 2776,
  50823: 2739,
  50825: 2745,
  50827: 2752,
  50829: 2760,
  50858: 2760,
  50859: 2769,
  50931: 2735,
  50933: 2767,
  50935: 2748,
  50937: 2741,
  50939: 2743,
  50968: 2730,
  50969: 2737,
  50996: 2733,
  50997: 2741,
  50999: 2739,
  51061: 2736,
  51063: 2726,
  51065: 2720,
  51067: 2724,
  51069: 2730,
  51103: 2723,
  51105: 2716,
  51107: 2700,
  51109: 2704,
  51143: 2698,
  51145: 2695,
  51147: 2701,
  51149: 2704,
  51371: 2778,
  51373: 2743,
  51375: 2749,
  51377: 2754,
  51379: 2753,
  51381: 2761,
  51399: 2767,
  51427: 2713,
  51429: 2727,
  51465: 2732,
  51467: 2751,
  51469: 2735,
  51491: 2721,
  53506: 2703,
  53507: 2663,
  53508: 2677,
  53518: 2701,
  53520: 2733,
  51503: 2684,
  51515: 2761,
  51519: 2762,
  51545: 2697,
  51570: 2610,
  51580: 2644,
  51588: 2692,
  51597: 2631,
  51598: 2598,
  51643: 2690,
  51645: 2678,
  51647: 2672,
  51674: 2683,
  51688: 2718,
  51702: 2663,
  51709: 2688,
  51766: 2695,
  51789: 2723,
  52062: 2921,
  52064: 2932,
  52066: 2933,
  52068: 2922,
  52070: 2916,
  52072: 2933,
  52074: 2935,
  53177: 2703,
  53179: 2654,
  53225: 2673,
  53227: 2646,
  53229: 2639,
  53332: 2708,
  53340: 2726,
  53343: 2669,
  53347: 2715,
  53359: 2734,
  53424: 2630,
  53426: 2636,
  53474: 2652,
  53489: 2622,
  53498: 2606,
  53501: 2717,
  53505: 2725,
  53534: 2712,
  53539: 2728,
  53545: 2621,
  53547: 2586,
  53557: 2595,
  52428: 2860,
  52441: 2906,
  52445: 2868,
  52457: 2897,
  52459: 2862,
  52477: 2913,
  52499: 2922,
  52511: 2953,
  52525: 2962,
  52531: 2929,
  52538: 2982,
  53111: 2681,
  53113: 2693,
  53115: 2692,
  53117: 2681,
  53119: 2686,
  53121: 2690,
  53123: 2703,
  53125: 2710,
  53127: 2701,
  53129: 2695,
  53173: 2695,
  53175: 2693,
  52076: 2938,
  52078: 2922,
  52080: 2907,
  52134: 2926,
  52146: 2914,
  52152: 2927,
  52156: 2949,
  52159: 2963,
  52222: 2899,
  52223: 2910,
  52224: 2908,
  52249: 2888,
  52349: 2858,
  52351: 2857,
  52353: 2846,
  52355: 2884,
  52372: 2876,
  52379: 2865,
  52382: 2844,
  52385: 2880,
  52388: 2830,
  52391: 2865,
  52393: 2899,
  52396: 2882,
  52399: 2833,
  53844: 2679,
  53859: 2692,
  53879: 2762,
  53881: 2756,
  53894: 2839,
  53902: 2775,
  53909: 2839,
  53913: 2740,
  53919: 2778,
  53925: 2886,
  53937: 2886,
  53940: 2846,
  53945: 2798,
  53947: 2829,
  53949: 2813,
  54290: 2726,
  54292: 2722,
  54293: 2710,
  54294: 2737,
  54295: 2726,
  54296: 2713,
  54298: 2755,
  53533: 2741,
  54306: 2738,
  54308: 2758,
  54309: 2736,
  54310: 2770,
  54311: 2740,
  54313: 2731,
  54314: 2693,
  54316: 2666,
  54317: 2664,
  54318: 2684,
  54320: 2676,
  54329: 2708,
  54331: 2705,
  54332: 2754,
  54338: 2700,
  54340: 2719,
  54341: 2680,
  54343: 2711,
  54344: 2697,
  54346: 2679,
  54347: 2708,
  54349: 2694,
  54411: 2628,
  54413: 2651,
  54492: 2628,
  54497: 2594,
  53560: 2603,
  53562: 2593,
  53567: 2602,
  53572: 2617,
  53577: 2571,
  53578: 2596,
  53579: 2624,
  53604: 2605,
  53619: 2624,
  53639: 2611,
  53721: 2651,
  53757: 2650,
  53773: 2636,
  53783: 2639,
  53797: 2679,
  53804: 2712,
  53809: 2686,
  53819: 2693,
  53840: 2664,
  53842: 2698,
  54426: 2692,
  54427: 2652,
  54429: 2662,
  54439: 2782,
  54441: 2742,
  54450: 2733,
  54451: 2722,
  54453: 2793,
  54455: 2728,
  54456: 2761,
  54457: 2794,
  54459: 2759,
  54470: 2620,
  54472: 2600,
  54483: 2571,
  54484: 2636,
  54486: 2624,
  54487: 2638,
  54421: 2637,
  54422: 2623,
  54424: 2630,
  56729: 2643,
  56736: 2612,
  56743: 2609,
  56825: 2687,
  56826: 2698,
  56828: 2679,
  56829: 2654,
  56841: 2592,
  56843: 2565,
  56850: 2577,
  56856: 2585,
  56858: 2570,
  56761: 2624,
  56766: 2690,
  56767: 2675,
  56769: 2679,
  56812: 2672,
  56642: 2586,
  56645: 2579,
  56648: 2593,
  56651: 2647,
  56653: 2599,
  56656: 2591,
  56659: 2609,
  56727: 2644,
  56754: 2640,
  56759: 2658,
  56859: 2603,
  56861: 2602,
  56862: 2597,
  56864: 2621,
  56865: 2554,
  56584: 2540,
  56587: 2546,
  56588: 2575,
  56589: 2576,
  56593: 2548,
  56594: 2541,
  56598: 2600,
  56599: 2573,
  56626: 2576,
  56630: 2586,
  56637: 2590,
  56814: 2656,
  56818: 2654,
  56820: 2589,
  56821: 2616,
  56823: 2670,
  56867: 2563,
  56869: 2564,
  57072: 2562,
  57074: 2550,
  57076: 2572,
  57078: 2581,
  57080: 2547,
  57223: 2598,
  57234: 2529,
  57250: 2573,
  57258: 2576,
  57271: 2613,
  57290: 2543,
  57299: 2519,
  57319: 2617,
  57334: 2571,
  57339: 2620,
  57368: 2697,
  57392: 2742,
  57399: 2635,
  56745: 2648,
  56746: 2654,
  56751: 2595,
  56753: 2613,
  57647: 2507,
  57648: 2536,
  58089: 2819,
  58091: 2771,
  58093: 2781,
  58095: 2776,
  58097: 2777,
  58099: 2782,
  58119: 2772,
  58135: 2778,
  58239: 2796,
  58256: 2767,
  58285: 2878,
  58300: 2897,
  58313: 2822,
  58332: 2857,
  58339: 2745,
  58452: 2900,
  58453: 2840,
  58454: 2829,
  58455: 2906,
  58456: 2898,
  58507: 2707,
  57537: 2582,
  57539: 2603,
  57548: 2595,
  57555: 2569,
  57562: 2551,
  57567: 2537,
  57572: 2597,
  57577: 2592,
  57413: 2711,
  57439: 2644,
  57462: 2633,
  57482: 2615,
  57489: 2628,
  57518: 2574,
  57520: 2537,
  57629: 2555,
  57632: 2572,
  57635: 2599,
  57614: 2547,
  57627: 2541,
  57578: 2546,
  57580: 2562,
  57581: 2630,
  57583: 2538,
  57584: 2576,
  57586: 2545,
  57587: 2610,
  57589: 2593,
  57610: 2559,
  57612: 2573,
  57636: 2572,
  57638: 2588,
  57639: 2543,
  57641: 2564,
  57642: 2510,
  57644: 2552,
  57645: 2554,
  58849: 2708,
  59063: 2854,
  59065: 2854,
  59067: 2862,
  59069: 2840,
  59071: 2835,
  59073: 2851,
  59075: 2930,
  59077: 2908,
  59174: 2879,
  59192: 2904,
  59199: 2848,
  59227: 2864,
  59229: 2843,
  59269: 2825,
  59302: 2882,
  59320: 2899,
  59329: 2782,
  59348: 2983,
  59368: 2929,
  59379: 2888,
  59387: 2946,
  59394: 2947,
  59399: 2913,
  59423: 2853,
  58509: 2713,
  58511: 2699,
  58513: 2712,
  58515: 2703,
  58540: 2666,
  58553: 2716,
  58566: 2686,
  58579: 2726,
  58636: 2808,
  58638: 2812,
  58640: 2819,
  58642: 2788,
  58644: 2766,
  58675: 2820,
  58706: 2834,
  58708: 2847,
  58710: 2801,
  58730: 2862,
  58739: 2825,
  58762: 2737,
  58769: 2744,
  58791: 2725,
  58802: 2771,
  58809: 2759,
  58840: 2704,
  60385: 2221,
  60386: 2221,
  60388: 2245,
  60389: 2233,
  60431: 2246,
  60433: 2242,
  60435: 2241,
  60437: 2257,
  60438: 2251,
  60439: 2255,
  60486: 2249,
  60487: 2267,
  60488: 2261,
  60489: 2255,
  60528: 2227,
  60529: 2240,
  60549: 2233,
  60594: 2215,
  60596: 2229,
  60598: 2231,
  60599: 2225,
  61118: 2250,
  61130: 2247,
  61137: 2242,
  61138: 2236,
  61169: 2300,
  61184: 2265,
  61191: 2293,
  61194: 2260,
  61197: 2258,
  61200: 2347,
  61203: 2275,
  61206: 2276,
  61209: 2278,
  61231: 2321,
  61239: 2321,
  61250: 2321,
  61267: 2311,
  61273: 2301,
  61276: 2341,
  61279: 2338,
  63589: 2169,
  63594: 2215,
  63599: 2154,
  63607: 2275,
  63619: 2169,
  63628: 2255,
  63633: 2264,
  63636: 2270,
  63637: 2091,
  63639: 2070,
  63654: 2267,
  63667: 2297,
  63674: 2246,
  63679: 2286,
  63683: 2286,
  63688: 2278,
  63691: 2270,
  63694: 2233,
  63695: 2258,
  63697: 2310,
  63699: 2296,
  63739: 2105,
  63322: 2215,
  63329: 2238,
  63450: 2194,
  63452: 2206,
  63454: 2194,
  63456: 2182,
  63457: 2186,
  63477: 2229,
  63486: 2212,
  63500: 2153,
  63505: 2211,
  63512: 2179,
  63517: 2210,
  63526: 2200,
  63533: 2138,
  63538: 2181,
  63543: 2213,
  63546: 2227,
  63549: 2221,
  63571: 2253,
  63579: 2155,
  63584: 2247,
  61348: 2267,
  61350: 2282,
  61352: 2259,
  61381: 2282,
  61389: 2314,
  61440: 2278,
  61449: 2268,
  61462: 2301,
  61476: 2288,
  61479: 2317,
  63065: 2199,
  63067: 2214,
  63069: 2213,
  63071: 2197,
  63073: 2188,
  63075: 2202,
  63110: 2167,
  63128: 2187,
  63150: 2195,
  63165: 2197,
  63179: 2176,
  63225: 2232,
  63263: 2212,
  63303: 2216,
  63741: 2116,
  63743: 2113,
  63755: 2177,
  63762: 2153,
  63768: 2101,
  63773: 2102,
  63776: 2123,
  63785: 2188,
  63791: 2139,
  63796: 2173,
  63801: 2133,
  63808: 2100,
  63811: 2129,
  63814: 2125,
  63820: 2107,
  63825: 2128,
  63826: 2141,
  63828: 2130,
  63829: 2126,
  63831: 2125,
  63834: 2135,
  59872: 2779,
  59889: 2741,
  59909: 2728,
  59929: 2680,
  59939: 2670,
  59955: 2645,
  59964: 2630,
  59969: 2584,
  60306: 2222,
  60308: 2253,
  60310: 2220,
  60311: 2218,
  60312: 2220,
  60313: 2223,
  60314: 2219,
  60315: 2386,
  60316: 2219,
  60318: 2234,
  60320: 2237,
  60322: 2237,
  60323: 2270,
  60325: 2256,
  60326: 2262,
  60327: 2234,
  60329: 2232,
  59425: 2860,
  59427: 2866,
  59439: 2819,
  59457: 2816,
  59469: 2807,
  59494: 2778,
  59505: 2759,
  59510: 2818,
  59514: 2808,
  59519: 2788,
  59555: 2743,
  59556: 2754,
  59557: 2754,
  59558: 2740,
  59581: 2770,
  59590: 2711,
  59597: 2738,
  59602: 2716,
  59609: 2737,
  59755: 2845,
  59757: 2855,
  59759: 2858,
  59821: 2832,
  59823: 2822,
  59846: 2744,
  63839: 2113,
  63840: 2111,
  63843: 2160,
  63846: 2105,
  63849: 2106,
  63853: 2199,
  63856: 2084,
  63857: 2084,
  63860: 2070,
  63863: 2092,
  63864: 2114,
  63867: 2121,
  63868: 2171,
  63869: 2096,
  63871: 2109,
  63872: 2087,
  63874: 2077,
  63875: 2074,
  63877: 2103,
  63879: 2060,
  63897: 2085,
  63906: 2123,
  63911: 2121,
  63916: 2117,
  63920: 2089,
  63924: 2090,
  63925: 2133,
  63927: 2066,
  63928: 2075,
  63930: 2042,
  63931: 2116,
  63933: 2108,
  63934: 2113,
  63936: 2096,
  63937: 2110,
  63939: 2201,
  64283: 2232,
  64285: 2232,
  64287: 2232,
  64289: 2243,
  64291: 2250,
  64293: 2288,
  64295: 2290,
  65468: 2303,
  65474: 2289,
  65479: 2260,
  65510: 2340,
  65520: 2376,
  65527: 2313,
  65529: 2367,
  65549: 2403,
  65550: 2408,
  65551: 2404,
  65552: 2410,
  65553: 2421,
  65554: 2419,
  65555: 2413,
  65556: 2413,
  65558: 2415,
  64572: 2302,
  64579: 2309,
  64584: 2334,
  64589: 2338,
  64625: 2284,
  64646: 2280,
  64653: 2279,
  64658: 2288,
  64665: 2310,
  64668: 2276,
  64673: 2297,
  64678: 2309,
  64683: 2285,
  64686: 2301,
  64689: 2316,
  64711: 2180,
  64720: 2175,
  64732: 2182,
  64739: 2234,
  64743: 2180,
  64747: 2218,
  64750: 2215,
  64753: 2258,
  64297: 2315,
  64319: 2313,
  64331: 2266,
  64342: 2326,
  64347: 2298,
  64354: 2226,
  64367: 2325,
  64372: 2232,
  64380: 2211,
  64385: 2276,
  64390: 2246,
  64395: 2258,
  64397: 2261,
  64401: 2238,
  64404: 2325,
  64405: 2248,
  64407: 2262,
  64409: 2235,
  64521: 2294,
  64546: 2249,
  64560: 2329,
  64569: 2282,
  64754: 2162,
  64756: 2205,
  64757: 2188,
  64760: 2196,
  64807: 2226,
  64823: 2190,
  64832: 2158,
  64839: 2217,
  64846: 2207,
  64850: 2168,
  64853: 2204,
  64859: 2181,
  65183: 2309,
  65185: 2307,
  65187: 2306,
  65189: 2305,
  65191: 2307,
  65193: 2313,
  65195: 2325,
  65197: 2315,
  65199: 2323,
  65201: 2321,
  65203: 2308,
  65205: 2304,
  65207: 2311,
  65626: 2425,
  65627: 2442,
  65629: 2422,
  65719: 2288,
  65760: 2261,
  65779: 2298,
  65795: 2263,
  65812: 2280,
  65817: 2315,
  65824: 2274,
  65830: 2263,
  65835: 2269,
  65843: 2267,
  65929: 2250,
  65931: 2258,
  65933: 2260,
  65934: 2258,
  65936: 2252,
  66111: 2595,
  66113: 2598,
  66115: 2607,
  66117: 2599,
  66119: 2592,
  66121: 2592,
  65582: 2429,
  65589: 2438,
  65594: 2437,
  65597: 2380,
  65599: 2450,
  65604: 2416,
  65606: 2406,
  65611: 2391,
  65614: 2426,
  65618: 2386,
  65620: 2443,
  65623: 2401,
  65624: 2422,
  66123: 2578,
  66125: 2578,
  66126: 2617,
  66127: 2625,
  66128: 2609,
  66129: 2593,
  66130: 2619,
  66131: 2582,
  66132: 2593,
  66133: 2584,
  66265: 2598,
  66271: 2611,
  66280: 2577,
  66287: 2567,
  66292: 2608,
  66299: 2553,
  66333: 2640,
  66346: 2615,
  66352: 2633,
  66359: 2637,
  66386: 2549,
  66399: 2584,
  66424: 2517,
  66440: 2558,
  66450: 2522,
  65232: 2363,
  65239: 2285,
  65307: 2371,
  65321: 2394,
  65326: 2385,
  65329: 2384,
  65343: 2336,
  65344: 2330,
  65345: 2338,
  65346: 2346,
  65347: 2346,
  65366: 2375,
  65375: 2366,
  65385: 2395,
  65388: 2353,
  65391: 2445,
  65396: 2321,
  65399: 2338,
  65428: 2269,
  65439: 2277,
  65451: 2247,
  65462: 2298,
  66453: 2592,
  66459: 2528,
  66482: 2558,
  66484: 2414,
  66497: 2420,
  66500: 2580,
  66501: 2516,
  66503: 2412,
  66504: 2400,
  66506: 2531,
  66507: 2518,
  66509: 2396,
  66538: 2538,
  66539: 2532,
  66540: 2548,
  66557: 2592,
  66564: 2555,
  66571: 2612,
  66578: 2562,
  66583: 2548,
  66589: 2579,
  66606: 2559,
  66620: 2607,
  66625: 2580,
  66629: 2544,
  66636: 2640,
  66640: 2563,
  66646: 2600,
  66649: 2572,
  66663: 2689,
  66679: 2674,
  66687: 2630,
  66693: 2709,
  66701: 2674,
  66706: 2745,
  66709: 2647,
  66740: 2657,
  66763: 2648,
  66773: 2621,
  66780: 2671,
  66787: 2639,
  66793: 2614,
  66798: 2674,
  66802: 2671,
  66806: 2635,
  66809: 2649,
  66822: 2620,
  66839: 2636,
  66849: 2467,
  66851: 2456,
  66862: 2447,
  66869: 2511,
  66871: 2520,
  66877: 2455,
  66879: 2466,
  66882: 2467,
  66885: 2507,
  66887: 2501,
  66892: 2476,
  66894: 2486,
  66901: 2489,
  66903: 2520,
  66917: 2498,
  66919: 2495,
  66953: 2369,
  66954: 2396,
  66955: 2372,
  66957: 2397,
  66904: 2501,
  66907: 2478,
  66909: 2515,
  66914: 2500,
  66916: 2523,
  66969: 2363,
  66976: 2373,
  66978: 2373,
  66981: 2354,
  66987: 2520,
  66989: 2386,
  66994: 2315,
  66996: 2328,
  67259: 2293,
  67269: 2313,
  67271: 2318,
  67273: 2301,
  67278: 2324,
  67280: 2335,
  67281: 2310,
  67283: 2329,
  67292: 2386,
  66999: 2339,
  67059: 2246,
  67061: 2242,
  67063: 2256,
  67065: 2236,
  67067: 2238,
  67069: 2287,
  67071: 2264,
  67098: 2304,
  67105: 2221,
  67112: 2245,
  67117: 2233,
  67122: 2243,
  67125: 2241,
  67126: 2251,
  67127: 2260,
  67133: 2267,
  67134: 2268,
  67136: 2265,
  67141: 2227,
  67146: 2292,
  67147: 2293,
  67149: 2260,
  67150: 2265,
  67152: 2285,
  67157: 2290,
  67158: 2271,
  67159: 2279,
  67161: 2281,
  67165: 2223,
  67166: 2213,
  67167: 2282,
  67169: 2295,
  67227: 2288,
  67229: 2286,
  67240: 2292,
  67245: 2272,
  67246: 2295,
  67251: 2287,
  67256: 2277,
  67258: 2289,
  67308: 2338,
  67310: 2336,
  67311: 2345,
  67316: 2347,
  67317: 2352,
  67319: 2342,
  67346: 2216,
  67354: 2216,
  67360: 2254,
  67361: 2256,
  67363: 2259,
  67365: 2238,
  67366: 2250,
  67294: 2373,
  67295: 2366,
  67297: 2367,
  67304: 2359,
  67305: 2347,
  67307: 2366,
  86477: 1561,
  86479: 1657,
  86480: 1680,
  86482: 1557,
  86483: 1653,
  86485: 1578,
  86486: 1567,
  86488: 1695,
  86489: 1698,
  86491: 1696,
  86492: 1504,
  86494: 1580,
  86495: 1483,
  86497: 1578,
  86498: 1718,
  86500: 1586,
  86502: 1601,
  86504: 1504,
  86505: 1639,
  86507: 1533,
  86508: 1543,
  86510: 1484,
  86511: 1507,
  85617: 1301,
  85622: 1314,
  85625: 1307,
  85630: 1391,
  85635: 1383,
  85640: 1379,
  85643: 1269,
  85646: 1289,
  85649: 1344,
  85652: 1315,
  85653: 1354,
  85656: 1269,
  85658: 1363,
  85659: 1273,
  85661: 1282,
  85662: 1367,
  85664: 1260,
  85665: 1327,
  85667: 1335,
  85669: 1266,
  85462: 1310,
  85464: 1299,
  85465: 1394,
  85467: 1291,
  85469: 1257,
  85521: 1367,
  85540: 1328,
  85551: 1320,
  85560: 1281,
  85567: 1323,
  85570: 1289,
  85579: 1374,
  85586: 1298,
  85591: 1392,
  85598: 1394,
  85599: 1304,
  85604: 1315,
  85609: 1330,
  85614: 1334,
  85304: 1447,
  85305: 1456,
  85307: 1432,
  85309: 1558,
  85354: 1455,
  85356: 1431,
  85368: 1383,
  85375: 1382,
  85376: 1388,
  85386: 1471,
  85391: 1413,
  85716: 1376,
  85737: 1343,
  85748: 1357,
  85757: 1384,
  85764: 1367,
  85774: 1344,
  85777: 1412,
  85778: 1395,
  86150: 1536,
  86152: 1533,
  86153: 1531,
  86154: 1536,
  86156: 1538,
  86157: 1549,
  86159: 1536,
  86161: 1542,
  86163: 1532,
  86165: 1521,
  86167: 1526,
  86169: 1524,
  86179: 1548,
  86199: 1579,
  86316: 1507,
  86513: 1666,
  86514: 1593,
  86517: 1601,
  86519: 1685,
  86529: 1625,
  86551: 1508,
  86554: 1582,
  86556: 1544,
  86558: 1582,
  86559: 1468,
  86561: 1505,
  86562: 1631,
  86564: 1599,
  86565: 1549,
  86567: 1477,
  86568: 1554,
  86570: 1538,
  86571: 1628,
  86573: 1500,
  86574: 1565,
  86576: 1509,
  86577: 1486,
  86579: 1592,
  86609: 1641,
  86633: 1628,
  85395: 1469,
  85399: 1326,
  85402: 1472,
  85405: 1413,
  85406: 1448,
  85408: 1375,
  85410: 1407,
  85411: 1426,
  85413: 1394,
  85414: 1473,
  85416: 1406,
  85417: 1436,
  85419: 1390,
  85435: 1290,
  85445: 1313,
  85447: 1286,
  85452: 1308,
  85456: 1299,
  85457: 1275,
  85459: 1314,
  85461: 1270,
  86343: 1527,
  86356: 1545,
  86368: 1544,
  86381: 1678,
  86391: 1549,
  86399: 1608,
  86405: 1570,
  86415: 1501,
  86420: 1566,
  86424: 1612,
  86438: 1511,
  86441: 1590,
  86444: 1529,
  86447: 1566,
  86450: 1615,
  86453: 1502,
  86456: 1552,
  86459: 1583,
  86462: 1553,
  86465: 1579,
  86470: 1653,
  86473: 1634,
  86476: 1672,
  86637: 1605,
  86641: 1632,
  86643: 1666,
  86647: 1615,
  86650: 1692,
  86653: 1678,
  86655: 1665,
  86657: 1672,
  86660: 1651,
  86663: 1619,
  86666: 1672,
  86668: 1614,
  86669: 1636,
  86672: 1581,
  86673: 1635,
  86674: 1587,
  86675: 1659,
  86676: 1602,
  86678: 1605,
  86679: 1599,
  86681: 1672,
  85241: 1398,
  85244: 1423,
  85247: 1415,
  85250: 1486,
  85253: 1458,
  85254: 1434,
  85256: 1431,
  85258: 1446,
  85259: 1441,
  85276: 1467,
  85283: 1509,
  85290: 1491,
  85293: 1449,
  85296: 1522,
  85298: 1460,
  85301: 1447,
  85302: 1484,
  86920: 1594,
  86922: 1501,
  86923: 1512,
  86925: 1585,
  86926: 1488,
  86928: 1524,
  86929: 1537,
  86931: 1528,
  86932: 1543,
  86934: 1573,
  86935: 1567,
  86937: 1544,
  86938: 1492,
  86940: 1522,
  86941: 1497,
  86943: 1538,
  86944: 1570,
  86946: 1561,
  86947: 1526,
  86949: 1503,
  86956: 1540,
  86682: 1632,
  86684: 1611,
  86685: 1680,
  86687: 1652,
  86688: 1658,
  86690: 1619,
  86692: 1608,
  86694: 1652,
  86695: 1591,
  86697: 1648,
  86698: 1620,
  86700: 1695,
  86701: 1645,
  86703: 1705,
  86704: 1694,
  86706: 1616,
  86707: 1588,
  86709: 1711,
  86720: 1715,
  86732: 1729,
  86733: 1691,
  86735: 1728,
  86842: 1597,
  86845: 1613,
  86850: 1599,
  86853: 1588,
  86854: 1585,
  86856: 1600,
  86857: 1574,
  86859: 1557,
  86860: 1581,
  86862: 1584,
  86863: 1611,
  86865: 1636,
  86866: 1616,
  86868: 1630,
  86869: 1597,
  86871: 1603,
  86872: 1629,
  86874: 1620,
  86875: 1580,
  86877: 1646,
  86879: 1582,
  86899: 1549,
  86911: 1523,
  86916: 1546,
  86919: 1507,
  86971: 1513,
  86972: 1545,
  86974: 1614,
  86975: 1560,
  86977: 1544,
  86978: 1612,
  86980: 1547,
  86981: 1602,
  86983: 1546,
  86984: 1548,
  86986: 1547,
  86987: 1555,
  86989: 1523,
  87435: 1727,
  87437: 1712,
  87439: 1733,
  87448: 1762,
  87452: 1794,
  87459: 1738,
  87463: 1765,
  87466: 1768,
  87471: 1740,
  87474: 1760,
  87477: 1756,
  87567: 2386,
  87568: 2386,
  87569: 2386,
  87600: 1622,
  87616: 1667,
  87629: 1602,
  87634: 1687,
  87637: 1703,
  87640: 1650,
  87642: 1574,
  87645: 1575,
  87647: 1687,
  87648: 1670,
  87650: 1642,
  87651: 1665,
  87653: 1654,
  87654: 1643,
  87656: 1605,
  87657: 1703,
  87659: 1720,
  87660: 1624,
  87480: 1793,
  87484: 1724,
  87487: 1743,
  87488: 1709,
  87490: 1717,
  87491: 2386,
  87493: 1733,
  87494: 1714,
  87496: 1696,
  87497: 1781,
  87499: 1703,
  87509: 1803,
  87527: 1812,
  87534: 1839,
  87538: 1830,
  87541: 1837,
  87544: 1839,
  87545: 1804,
  87547: 1812,
  87549: 1802,
  87561: 1860,
  87662: 1611,
  87663: 1686,
  87665: 1618,
  87666: 1613,
  87668: 1601,
  87669: 1595,
  87671: 1670,
  87672: 1581,
  87674: 1659,
  87675: 1669,
  87677: 1628,
  87679: 1614,
  87700: 1693,
  87719: 1622,
  87724: 1692,
  87727: 1706,
  87730: 1741,
  87733: 1660,
  87734: 1696,
  87736: 1712,
  87737: 1706,
  87739: 1662,
  87740: 1698,
  87742: 1626,
  87743: 1680,
  87745: 1651,
  87746: 1652,
  87748: 1716,
  87749: 1682,
  87751: 1708,
  87752: 1671,
  87754: 1641,
  87755: 1688,
  87757: 1649,
  87758: 1736,
  87760: 1692,
  87761: 1671,
  87763: 1732,
  87764: 1744,
  87766: 1690,
  87767: 1690,
  87769: 1650,
  86736: 1755,
  86738: 1707,
  86739: 1718,
  86741: 1738,
  86742: 1758,
  86744: 1735,
  86745: 1703,
  86747: 1736,
  86748: 1743,
  86750: 1717,
  86751: 1692,
  86753: 1692,
  86754: 1721,
  86756: 1704,
  86757: 1727,
  86759: 1707,
  86807: 1567,
  86825: 1606,
  86830: 1626,
  86833: 1612,
  86836: 1584,
  87770: 1686,
  87772: 1648,
  87773: 1725,
  87775: 1640,
  87776: 1668,
  87778: 1633,
  87779: 1685,
  87781: 1670,
  87782: 1646,
  87784: 1661,
  87785: 1717,
  87787: 1705,
  87789: 1722,
  88045: 1927,
  88046: 1920,
  88048: 1935,
  88069: 1868,
  88074: 1880,
  88079: 1898,
  88085: 1908,
  88178: 1842,
  88179: 1870,
  88212: 1871,
  88213: 1888,
  88214: 1871,
  88239: 1825,
  88250: 1882,
  88255: 1841,
  88260: 1824,
  88263: 1908,
  88267: 1832,
  88271: 1929,
  88273: 1912,
  88276: 1883,
  88279: 1828,
  88281: 1869,
  88284: 1863,
  88285: 1855,
  88287: 1857,
  88289: 1854,
  88299: 1762,
  88316: 1811,
  88317: 1735,
  88319: 1728,
  88451: 1737,
  88453: 1735,
  88454: 1792,
  88456: 1802,
  88457: 1722,
  88459: 1715,
  88471: 1801,
  88477: 1814,
  88480: 1783,
  88481: 1761,
  88483: 1790,
  88484: 1749,
  88486: 1746,
  88487: 1810,
  88489: 1802,
  88499: 1898,
  88512: 1902,
  88515: 1920,
  88518: 1876,
  88521: 1871,
  88524: 1885,
  88525: 1863,
  88527: 1880,
  88090: 1961,
  88094: 1907,
  88097: 1912,
  88099: 1845,
  88131: 1875,
  88138: 1858,
  88142: 1884,
  88145: 1836,
  88147: 1864,
  88149: 1889,
  88161: 1852,
  88167: 1812,
  88171: 1863,
  88175: 1903,
  88326: 1848,
  88339: 1817,
  88348: 1865,
  88353: 1786,
  88356: 1902,
  88361: 1888,
  88364: 1806,
  88367: 1900,
  88368: 1818,
  88370: 1903,
  88371: 1845,
  88373: 1926,
  88374: 1902,
  88376: 1892,
  88377: 1941,
  88379: 1911,
  88400: 1786,
  88410: 1796,
  88416: 1752,
  88422: 1837,
  88427: 1825,
  88430: 1747,
  88433: 1841,
  88436: 1793,
  88437: 1778,
  88441: 1806,
  88444: 1777,
  88447: 1836,
  88448: 1859,
  88450: 1720,
  89077: 1748,
  89079: 1753,
  89081: 1735,
  89129: 1711,
  89134: 1757,
  89143: 1777,
  89150: 1798,
  89155: 1783,
  89160: 1746,
  89165: 1788,
  89168: 1695,
  89171: 1753,
  89173: 1760,
  89174: 1743,
  88529: 1892,
  88605: 1972,
  88630: 1927,
  88631: 1999,
  88633: 1958,
  88634: 2045,
  88636: 1944,
  88637: 2000,
  88639: 1948,
  88662: 2030,
  88677: 1965,
  88682: 1956,
  88690: 1995,
  88693: 1930,
  88696: 2032,
  88697: 1975,
  88699: 1966,
  88709: 1978,
  88718: 1985,
  88719: 1973,
  89073: 1734,
  89075: 1727,
  89352: 1666,
  89353: 1636,
  89355: 1653,
  89356: 1629,
  89358: 1645,
  89359: 1663,
  89361: 1608,
  89362: 1651,
  89364: 1647,
  89365: 1624,
  89367: 1669,
  89368: 1622,
  89407: 1647,
  89415: 1674,
  89420: 1627,
  89423: 1664,
  89426: 1662,
  89428: 1719,
  89429: 1711,
  89431: 1683,
  89434: 1650,
  89435: 1657,
  89437: 1693,
  89438: 1618,
  89176: 1700,
  89177: 1727,
  89179: 1733,
  89180: 1799,
  89182: 1716,
  89183: 1725,
  89185: 1793,
  89186: 1768,
  89188: 1783,
  89189: 1734,
  89191: 1784,
  89192: 1724,
  89194: 1780,
  89195: 1765,
  89197: 1739,
  89198: 1734,
  89231: 1735,
  89233: 1728,
  89250: 1759,
  89257: 1777,
  89264: 1773,
  89269: 1768,
  89275: 1709,
  89278: 1690,
  89281: 1746,
  89284: 1695,
  89287: 1766,
  89290: 1790,
  89291: 1711,
  89293: 1750,
  89294: 1721,
  89296: 1766,
  89297: 1699,
  89299: 1793,
  89312: 1665,
  89331: 1631,
  89335: 1675,
  89340: 1682,
  89343: 1632,
  89344: 1634,
  89346: 1693,
  89347: 1662,
  89349: 1633,
  89350: 1643,
  90427: 1649,
  90429: 1625,
  90431: 1628,
  90439: 1624,
  90441: 1619,
  90443: 1621,
  90449: 1625,
  90451: 1616,
  90453: 1619,
  90455: 1609,
  90459: 1624,
  90461: 1617,
  90469: 1609,
  90471: 1607,
  90473: 1593,
  90475: 1575,
  90478: 1603,
  90480: 1601,
  90482: 1599,
  90489: 1612,
  90491: 1607,
  90513: 1643,
  90518: 1555,
  90522: 1634,
  90530: 1616,
  90537: 1575,
  90542: 1636,
  90547: 1633,
  90552: 1605,
  90556: 1671,
  90559: 1553,
  90562: 1627,
  90571: 1593,
  90574: 1654,
  90579: 1687,
  90584: 1583,
  90587: 1670,
  90592: 1565,
  90596: 1637,
  90599: 1700,
  90602: 1563,
  90607: 1602,
  90610: 1556,
  90613: 1673,
  90614: 1659,
  90616: 1712,
  89597: 1850,
  89601: 1798,
  89604: 1813,
  89605: 1804,
  89607: 1855,
  89608: 1815,
  89610: 1792,
  89611: 1855,
  89613: 1867,
  89614: 1816,
  89616: 1846,
  89617: 1847,
  89619: 1851,
  90402: 1608,
  90403: 1616,
  90408: 1623,
  90409: 1616,
  90411: 1616,
  90419: 1632,
  90425: 1627,
  90617: 1685,
  90619: 1728,
  90762: 1638,
  90763: 1634,
  90765: 1664,
  90766: 1650,
  90768: 1651,
  91052: 1652,
  91054: 1657,
  91056: 1653,
  91058: 1644,
  91074: 1665,
  91077: 1656,
  91080: 1654,
  91083: 1674,
  91085: 1692,
  91086: 1677,
  91359: 1685,
  91361: 1697,
  91362: 1719,
  91364: 1741,
  91365: 1712,
  91367: 1644,
  91369: 1704,
  91413: 1738,
  91438: 1777,
  91443: 1778,
  91448: 1707,
  91452: 1694,
  91456: 1736,
  91459: 1710,
  91460: 1758,
  91462: 1718,
  91463: 1750,
  91465: 1785,
  91466: 1719,
  91468: 1742,
  91469: 1699,
  91471: 1770,
  91472: 1754,
  89440: 1657,
  89441: 1685,
  89443: 1663,
  89446: 1676,
  89447: 1700,
  89518: 1785,
  89520: 1793,
  89522: 1776,
  89537: 1766,
  89542: 1755,
  89547: 1761,
  89551: 1818,
  89555: 1806,
  89558: 1792,
  89561: 1711,
  89564: 1785,
  89567: 1700,
  89568: 1701,
  89584: 1834,
  91474: 1761,
  91475: 1722,
  91477: 1786,
  91478: 1797,
  91480: 1773,
  91481: 1764,
  91483: 1797,
  91484: 1777,
  91486: 1728,
  91487: 1744,
  91489: 1698,
  91522: 1738,
  91541: 1848,
  91550: 1843,
  91555: 1796,
  91560: 1685,
  91564: 1676,
  91567: 1748,
  91572: 1749,
  91575: 1693,
  91578: 1774,
  91580: 1685,
  91583: 1809,
  91224: 1595,
  91227: 1574,
  91230: 1582,
  91233: 1608,
  91235: 1661,
  91236: 1541,
  91238: 1583,
  91239: 1590,
  91241: 1638,
  91242: 1607,
  91244: 1612,
  91245: 1626,
  91247: 1649,
  91249: 1577,
  91257: 1700,
  91275: 1627,
  91278: 1722,
  91281: 1667,
  91282: 1671,
  91284: 1685,
  91286: 1680,
  91287: 1662,
  91289: 1724,
  91088: 1662,
  91090: 1688,
  91091: 1680,
  91093: 1681,
  91094: 1683,
  91096: 1665,
  91097: 1691,
  91099: 1681,
  91126: 1625,
  91154: 1663,
  91161: 1563,
  91166: 1689,
  91171: 1541,
  91174: 1711,
  91177: 1591,
  91180: 1599,
  91183: 1668,
  91186: 1645,
  91187: 1681,
  91189: 1651,
  91207: 1607,
  91217: 1593,
  91220: 1620,
  91586: 1699,
  91587: 1820,
  91589: 1758,
  91590: 1717,
  91592: 1794,
  91593: 1786,
  91595: 1728,
  91596: 1775,
  91598: 1767,
  91599: 1788,
  91601: 1800,
  91602: 1816,
  91604: 1752,
  91605: 1794,
  91607: 1849,
  91608: 1791,
  91610: 1828,
  91611: 1744,
  91613: 1788,
  91614: 1788,
  91616: 1844,
  91617: 1769,
  91619: 1750,
  91620: 1816,
  91622: 1736,
  91301: 1695,
  91315: 1712,
  91320: 1726,
  91322: 1659,
  91325: 1705,
  91327: 1719,
  91330: 1724,
  91332: 1768,
  91334: 1714,
  91336: 1701,
  91338: 1649,
  91341: 1688,
  91344: 1759,
  91346: 1748,
  91347: 1786,
  91349: 1676,
  91350: 1701,
  91352: 1725,
  91353: 1697,
  91355: 1649,
  91356: 1711,
  91358: 1708,
  91735: 1738,
  91737: 1752,
  91738: 1738,
  91740: 1793,
  91741: 1738,
  91743: 1780,
  91744: 1818,
  91746: 1742,
  91747: 1797,
  91749: 1799,
  91757: 1764,
  91781: 1732,
  91785: 1700,
  91788: 1622,
  91790: 1617,
  91792: 1715,
  91793: 1740,
  91795: 1708,
  91796: 1723,
  91798: 1718,
  91799: 1708,
  91801: 1757,
  91623: 1703,
  91625: 1815,
  91626: 1827,
  91628: 1814,
  91629: 1724,
  91631: 1821,
  91632: 1773,
  91634: 1781,
  91635: 1798,
  91637: 1801,
  91639: 1715,
  91710: 1761,
  91717: 1793,
  91719: 1787,
  91720: 1721,
  91722: 1766,
  91723: 1760,
  91725: 1779,
  91726: 1802,
  91728: 1778,
  91729: 1703,
  91731: 1791,
  91732: 1721,
  91734: 1711,
  91802: 1758,
  91804: 1716,
  91805: 1712,
  91807: 1617,
  91809: 1692,
  92224: 1524,
  92237: 1561,
  92242: 1558,
  92245: 1514,
  92249: 1595,
  92253: 1533,
  92256: 1549,
  92259: 1574,
  92260: 1555,
  92262: 1548,
  92263: 1498,
  92265: 1581,
  92266: 1497,
  92268: 1610,
  92269: 1488,
  92271: 1580,
  92272: 1534,
  92274: 1572,
  93047: 1326,
  93049: 1344,
  93051: 1336,
  93053: 1322,
  93055: 1316,
  93057: 1330,
  93059: 1328,
  93073: 1309,
  93077: 1369,
  93080: 1344,
  93083: 1316,
  93086: 1259,
  93087: 1332,
  93089: 1321,
  93090: 1285,
  93092: 1303,
  93093: 1312,
  93095: 1325,
  93096: 1328,
  93098: 1308,
  93099: 1258,
  93101: 1341,
  93102: 1289,
  93104: 1279,
  92696: 1617,
  92697: 1608,
  92699: 1563,
  92700: 1616,
  92702: 1566,
  92703: 1628,
  92705: 1549,
  92706: 1536,
  92708: 1583,
  92709: 1457,
  92711: 1594,
  92712: 1551,
  92714: 1585,
  92715: 1600,
  92717: 1639,
  92718: 1558,
  92720: 1595,
  92721: 1594,
  92723: 1527,
  92724: 1626,
  92726: 1594,
  92727: 1578,
  92729: 1569,
  92546: 1482,
  92548: 1482,
  92549: 1421,
  92551: 1478,
  92552: 1437,
  92554: 1401,
  92555: 1531,
  92557: 1405,
  92559: 1399,
  92637: 1562,
  92648: 1558,
  92655: 1619,
  92660: 1583,
  92665: 1579,
  92670: 1615,
  92676: 1638,
  92681: 1632,
  92685: 1599,
  92690: 1608,
  92693: 1441,
  92694: 1550,
  92361: 1528,
  92363: 1472,
  92364: 1489,
  92366: 1461,
  92367: 1498,
  92369: 1515,
  92421: 1456,
  92431: 1385,
  92436: 1380,
  92439: 1397,
  92442: 1451,
  92444: 1368,
  92445: 1362,
  92447: 1421,
  92449: 1436,
  92507: 1490,
  92521: 1464,
  92526: 1415,
  92533: 1523,
  92536: 1498,
  92539: 1419,
  92540: 1519,
  92542: 1414,
  92543: 1507,
  92545: 1430,
  92275: 1605,
  92277: 1481,
  92278: 1573,
  92280: 1517,
  92281: 1594,
  92283: 1516,
  92284: 1534,
  92286: 1460,
  92287: 1453,
  92289: 1541,
  92318: 1510,
  92331: 1443,
  92334: 1519,
  92339: 1489,
  92342: 1535,
  92345: 1452,
  92348: 1532,
  92353: 1549,
  92355: 1468,
  92358: 1465,
  92360: 1528,
  93105: 1318,
  93107: 1344,
  93109: 1290,
  93128: 1394,
  93133: 1428,
  93138: 1363,
  93142: 1398,
  93149: 1370,
  93152: 1363,
  93155: 1408,
  93158: 1415,
  93161: 1344,
  93164: 1393,
  93167: 1285,
  93170: 1322,
  93173: 1348,
  93176: 1419,
  93177: 1313,
  93179: 1297,
  93180: 1373,
  93182: 1399,
  93183: 1391,
  93185: 1282,
  93186: 1364,
  93188: 1387,
  93189: 1345,
  93191: 1287,
  93192: 1331,
  93194: 1324,
  93195: 1380,
  93197: 1360,
  93199: 1306,
  93309: 1399,
  93326: 1431,
  93333: 1465,
  93336: 1456,
  93339: 1433,
  93342: 1380,
  93343: 1410,
  93345: 1388,
  93346: 1395,
  93348: 1430,
  93349: 1498,
  93351: 1404,
  93352: 1400,
  93354: 1438,
  93356: 1372,
  93358: 1419,
  93359: 1409,
  93413: 1301,
  93426: 1308,
  93437: 1354,
  93444: 1267,
  93449: 1362,
  93453: 1316,
  93455: 1274,
  93458: 1365,
  93462: 1290,
  93464: 1389,
  93466: 1283,
  93468: 1264,
  93470: 1306,
  // Add more PLZ codes and their multipliers
};
